export const langdict = {
	"code": 200,
	"success": true,
	"data": [
		{
			"textKey": "telemetry",
			"classify": "option",
			"zhCn": "遥测",
			"zhTw": "遙測",
			"enUs": "telemetry",
			"thTh": "การวัดระยะไกล",
			"idId": "Telemetri",
			"esMx": "Telemetría",
			"viVi": "Đo từ xa",
			"ptPt": "Telemetria"
		},
		{
			"textKey": "distantCommunication",
			"classify": "option",
			"zhCn": "遥信",
			"zhTw": "遙信",
			"enUs": "remote letter",
			"thTh": "จดหมายระยะไกล",
			"idId": "Surat jarak jauh",
			"esMx": "Carta remota",
			"viVi": "Chữ xa",
			"ptPt": "Carta remota"
		},
		{
			"textKey": "remoteControl",
			"classify": "option",
			"zhCn": "遥控",
			"zhTw": "遙控",
			"enUs": "remote control",
			"thTh": "รีโมทคอนโทรล",
			"idId": "Remote kontrol",
			"esMx": "Control remoto",
			"viVi": "Điều khiển từ xa",
			"ptPt": "Controle remoto"
		},
		{
			"textKey": "remoteAdjust",
			"classify": "option",
			"zhCn": "遥调",
			"zhTw": "遙調",
			"enUs": "Remote adjustment",
			"thTh": "ปรับระยะไกล",
			"idId": "Jarak Jauh",
			"esMx": "Ajuste remoto",
			"viVi": "Điều chỉnh từ xa",
			"ptPt": "Remoto"
		},
		{
			"textKey": "generally",
			"classify": "option",
			"zhCn": "一般",
			"zhTw": "一般",
			"enUs": "General",
			"thTh": "ทั่วไป",
			"idId": "Umum",
			"esMx": "General",
			"viVi": "Nói chung",
			"ptPt": "Geral"
		},
		{
			"textKey": "serious",
			"classify": "option",
			"zhCn": "严重",
			"zhTw": "嚴重",
			"enUs": "Serious",
			"thTh": "รุนแรง",
			"idId": "Serius",
			"esMx": "Grave",
			"viVi": "Nghiêm trọng",
			"ptPt": "Grave"
		},
		{
			"textKey": "urgent",
			"classify": "option",
			"zhCn": "紧急",
			"zhTw": "緊急",
			"enUs": "Emergency",
			"thTh": "ฉุกเฉิน",
			"idId": "Darurat",
			"esMx": "URGENTE",
			"viVi": "Khẩn cấp",
			"ptPt": "Emergência"
		},
		{
			"textKey": "signalStatus",
			"classify": "option",
			"zhCn": "信号状态",
			"zhTw": "信號狀態",
			"enUs": "Signal status",
			"thTh": "สถานะสัญญาณ",
			"idId": "Status sinyal",
			"esMx": "Estado de la señal",
			"viVi": "Trạng thái tín hiệu",
			"ptPt": "Estado do sinal"
		},
		{
			"textKey": "theMoreCapped",
			"classify": "option",
			"zhCn": "越上限",
			"zhTw": "越上限",
			"enUs": "the upper limit",
			"thTh": "ขีดจำกัดบน",
			"idId": "Semakin banyak batas atas",
			"esMx": "El límite superior",
			"viVi": "Giới hạn trên",
			"ptPt": "Quanto maior o limite"
		},
		{
			"textKey": "exceedTheUpperLimit",
			"classify": "option",
			"zhCn": "越上上限",
			"zhTw": "越上上限",
			"enUs": "the upper limit",
			"thTh": "เกินขีดจำกัดบน",
			"idId": "Batas atas",
			"esMx": "Más alto",
			"viVi": "Giới hạn trên",
			"ptPt": "Quanto mais alto o limite superior"
		},
		{
			"textKey": "beyondTheLowerLimit",
			"classify": "option",
			"zhCn": "越下限",
			"zhTw": "越下限",
			"enUs": "the lower limit",
			"thTh": "ขีดจำกัดล่าง",
			"idId": "Semakin rendah",
			"esMx": "Cuanto más bajo",
			"viVi": "Giới hạn thấp hơn",
			"ptPt": "Quanto mais baixo o limite"
		},
		{
			"textKey": "lowerbounds",
			"classify": "option",
			"zhCn": "越下下限",
			"zhTw": "越下下限",
			"enUs": "lower limit",
			"thTh": "ขีดจำกัดล่าง",
			"idId": "Semakin rendah batas bawah",
			"esMx": "Límite inferior",
			"viVi": "Giới hạn thấp hơn",
			"ptPt": "Quanto mais baixo o limite inferior"
		},
		{
			"textKey": "deviceInterrupted",
			"classify": "option",
			"zhCn": "设备通讯中断",
			"zhTw": "設備通訊中斷",
			"enUs": "Device communication interruption",
			"thTh": "การสื่อสารของอุปกรณ์ขัดข้อง",
			"idId": "Gangguan komunikasi peralatan",
			"esMx": "Interrupción de la comunicación del equipo",
			"viVi": "Liên lạc thiết bị bị gián đoạn",
			"ptPt": "Interrupção da comunicação do dispositivo"
		},
		{
			"textKey": "yearly",
			"classify": "option",
			"zhCn": "年报",
			"zhTw": "年報",
			"enUs": "Annual Report",
			"thTh": "รายงานประจำปี",
			"idId": "Laporan tahunan",
			"esMx": "Informe anual",
			"viVi": "Báo cáo thường niên",
			"ptPt": "Relatório anual"
		},
		{
			"textKey": "selectDate",
			"classify": "label",
			"zhCn": "选择日期",
			"zhTw": "選擇日期",
			"enUs": "Select date",
			"thTh": "เลือกวันที่",
			"idId": "Memilih tanggal",
			"esMx": "Seleccionar fecha",
			"viVi": "Chọn ngày",
			"ptPt": "Escolha uma data"
		},
		{
			"textKey": "time",
			"classify": "table",
			"zhCn": "时间",
			"zhTw": "時間",
			"enUs": "Time",
			"thTh": "เวลา",
			"idId": "Waktu",
			"esMx": "Tiempo",
			"viVi": "Thời gian",
			"ptPt": "Tempo"
		},
		{
			"textKey": "permissionConfig",
			"classify": "btn",
			"zhCn": "权限配置",
			"zhTw": "權限配置",
			"enUs": "Permission configuration",
			"thTh": "การกำหนดค่าสิทธิ์",
			"idId": "Konfigurasi izin",
			"esMx": "Configuración de permisos",
			"viVi": "Cấu hình quyền",
			"ptPt": "Configuração de permissões"
		},
		{
			"textKey": "delete",
			"classify": "btn",
			"zhCn": "删除",
			"zhTw": "刪除",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "Eliminar",
			"viVi": "Xóa",
			"ptPt": "Excluir"
		},
		{
			"textKey": "superiorRole",
			"classify": "label",
			"zhCn": "上级角色",
			"zhTw": "上級角色",
			"enUs": "Superior Role",
			"thTh": "บทบาทที่เหนือกว่า",
			"idId": "Peran atasan",
			"esMx": "Personaje superior",
			"viVi": "Vai trò cấp trên",
			"ptPt": "Papel superior"
		},
		{
			"textKey": "project",
			"classify": "label",
			"zhCn": "项目",
			"zhTw": "項目",
			"enUs": "Project",
			"thTh": "โครงการ",
			"idId": "Proyek",
			"esMx": "Proyecto",
			"viVi": "Dự án",
			"ptPt": "Projeto"
		},
		{
			"textKey": "gateway",
			"classify": "label",
			"zhCn": "网关",
			"zhTw": "網關",
			"enUs": "Gateway",
			"thTh": "เกตเวย์",
			"idId": "Gateway",
			"esMx": "Puerta de enlace",
			"viVi": "Cổng",
			"ptPt": "Gateway"
		},
		{
			"textKey": "device",
			"classify": "label",
			"zhCn": "设备",
			"zhTw": "設備",
			"enUs": "Equipment",
			"thTh": "อุปกรณ์",
			"idId": "Peralatan",
			"esMx": "Equipo",
			"viVi": "Thiết bị",
			"ptPt": "Equipamento"
		},
		{
			"textKey": "alarmStartTime",
			"classify": "label",
			"zhCn": "告警开始时间",
			"zhTw": "告警開始時間",
			"enUs": "Alarm start time",
			"thTh": "เวลาเริ่มต้นการแจ้งเตือน",
			"idId": "Waktu mulai alarm",
			"esMx": "Hora de inicio de alarma",
			"viVi": "Thời gian bắt đầu cảnh báo",
			"ptPt": "Hora de início do alarme"
		},
		{
			"textKey": "recoveryTime",
			"classify": "label",
			"zhCn": "恢复时间",
			"zhTw": "恢復時間",
			"enUs": "Recovery time",
			"thTh": "เวลาการกู้คืน",
			"idId": "Waktu pemulihan",
			"esMx": "Tiempo de recuperación",
			"viVi": "Thời gian phục hồi",
			"ptPt": "Tempo de recuperação"
		},
		{
			"textKey": "alarmLevel",
			"classify": "label",
			"zhCn": "告警等级",
			"zhTw": "告警等級",
			"enUs": "Alarm level",
			"thTh": "ระดับการเตือน",
			"idId": "Tingkat alarm",
			"esMx": "Nivel de alarma",
			"viVi": "Mức cảnh báo",
			"ptPt": "Nível de alerta"
		},
		{
			"textKey": "alarmContent",
			"classify": "table",
			"zhCn": "告警内容",
			"zhTw": "告警內容",
			"enUs": "Alarm content",
			"thTh": "เนื้อหาการเตือน",
			"idId": "Konten alarm",
			"esMx": "Contenido de alarma",
			"viVi": "Nội dung cảnh báo",
			"ptPt": "Conteúdo de alarme"
		},
		{
			"textKey": "export",
			"classify": "btn",
			"zhCn": "导出",
			"zhTw": "導出",
			"enUs": "Export",
			"thTh": "ส่งออก",
			"idId": "Ekspor",
			"esMx": "Exportar",
			"viVi": "Xuất",
			"ptPt": "Exportar"
		},
		{
			"textKey": "orderProcessing",
			"classify": "btn",
			"zhCn": "工单处理",
			"zhTw": "工單處理",
			"enUs": "Work Order Processing",
			"thTh": "การประมวลผลใบสั่งงาน",
			"idId": "Pemrosesan pesanan kerja",
			"esMx": "Procesamiento de órdenes de trabajo",
			"viVi": "Xử lý đơn hàng công việc",
			"ptPt": "Processamento de folha de trabalho"
		},
		{
			"textKey": "reportClassification",
			"classify": "btn",
			"zhCn": "报表分类",
			"zhTw": "報表分類",
			"enUs": "Report Classification",
			"thTh": "การจัดประเภทรายงาน",
			"idId": "Klasifikasi laporan",
			"esMx": "Clasificación de informes",
			"viVi": "Phân loại báo cáo",
			"ptPt": "Classificação de relatórios"
		},
		{
			"textKey": "addClassify",
			"classify": "btn",
			"zhCn": "添加分类",
			"zhTw": "添加分類",
			"enUs": "Add Category",
			"thTh": "เพิ่มหมวดหมู่",
			"idId": "Tambahkan klasifikasi",
			"esMx": "Añadir categoría",
			"viVi": "Thêm danh mục",
			"ptPt": "Adicionar uma classificação"
		},
		{
			"textKey": "addReport",
			"classify": "btn",
			"zhCn": "添加报表",
			"zhTw": "添加報表",
			"enUs": "Add Report",
			"thTh": "เพิ่มรายงาน",
			"idId": "Menambahkan laporan",
			"esMx": "Agregar un informe",
			"viVi": "Thêm báo cáo",
			"ptPt": "Adicionar um relatório"
		},
		{
			"textKey": "editReport",
			"classify": "btn",
			"zhCn": "编辑报表",
			"zhTw": "編輯報表",
			"enUs": "Edit Report",
			"thTh": "แก้ไขรายงาน",
			"idId": "Mengedit laporan",
			"esMx": "Edición de informes",
			"viVi": "Chỉnh sửa báo cáo",
			"ptPt": "Editar um relatório"
		},
		{
			"textKey": "deleteReport",
			"classify": "btn",
			"zhCn": "删除报表",
			"zhTw": "刪除報表",
			"enUs": "Delete Report",
			"thTh": "ลบรายงาน",
			"idId": "Menghapus laporan",
			"esMx": "Eliminar informes",
			"viVi": "Xóa báo cáo",
			"ptPt": "Excluir um relatório"
		},
		{
			"textKey": "editClassify",
			"classify": "btn",
			"zhCn": "编辑分类",
			"zhTw": "編輯分類",
			"enUs": "Edit Category",
			"thTh": "แก้ไขหมวดหมู่",
			"idId": "Mengedit kategori",
			"esMx": "Edición de categorías",
			"viVi": "Chỉnh sửa phân loại",
			"ptPt": "Editar a classificação"
		},
		{
			"textKey": "deleteClassify",
			"classify": "btn",
			"zhCn": "删除分类",
			"zhTw": "刪除分類",
			"enUs": "Delete Classification",
			"thTh": "ลบหมวดหมู่",
			"idId": "Hapus klasifikasi",
			"esMx": "Eliminar categorías",
			"viVi": "Xóa phân loại",
			"ptPt": "Excluir uma classificação"
		},
		{
			"textKey": "assetsType",
			"classify": "label",
			"zhCn": "资产类别",
			"zhTw": "資產類別",
			"enUs": "Asset Category",
			"thTh": "ประเภทสินทรัพย์",
			"idId": "Kategori Aset",
			"esMx": "Clases de activos",
			"viVi": "Loại tài sản",
			"ptPt": "Classe de ativos"
		},
		{
			"textKey": "serviceArea",
			"classify": "label",
			"zhCn": "服务区域",
			"zhTw": "服務區域",
			"enUs": "Service Area",
			"thTh": "พื้นที่ให้บริการ",
			"idId": "Area layanan",
			"esMx": "Área de servicio",
			"viVi": "Khu vực dịch vụ",
			"ptPt": "Área de serviço"
		},
		{
			"textKey": "deviceName",
			"classify": "table",
			"zhCn": "设备名称",
			"zhTw": "設備名稱",
			"enUs": "Equipment Name",
			"thTh": "ชื่ออุปกรณ์",
			"idId": "Nama Perangkat",
			"esMx": "Nombre del dispositivo",
			"viVi": "Tên thiết bị",
			"ptPt": "Nome do dispositivo"
		},
		{
			"textKey": "installAddress",
			"classify": "table",
			"zhCn": "安装地址",
			"zhTw": "安裝地址",
			"enUs": "Installation Address",
			"thTh": "ที่อยู่การติดตั้ง",
			"idId": "Alamat instalasi",
			"esMx": "Dirección de instalación",
			"viVi": "Địa chỉ lắp đặt",
			"ptPt": "Endereço de instalação"
		},
		{
			"textKey": "area",
			"classify": "table",
			"zhCn": "面积",
			"zhTw": "面積",
			"enUs": "Area",
			"thTh": "พื้นที่",
			"idId": "Area",
			"esMx": "Área",
			"viVi": "Diện tích",
			"ptPt": "Área"
		},
		{
			"textKey": "installDate",
			"classify": "table",
			"zhCn": "安装日期",
			"zhTw": "安裝日期",
			"enUs": "Installation Date",
			"thTh": "วันที่ติดตั้ง",
			"idId": "Tanggal instalasi",
			"esMx": "Fecha de instalación",
			"viVi": "Ngày cài đặt",
			"ptPt": "Data de instalação"
		},
		{
			"textKey": "validDate",
			"classify": "table",
			"zhCn": "有效日期",
			"zhTw": "有效日期",
			"enUs": "Effective Date",
			"thTh": "วันที่มีผล",
			"idId": "Tanggal efektif",
			"esMx": "Fecha válida",
			"viVi": "Ngày hợp lệ",
			"ptPt": "Data de validade"
		},
		{
			"textKey": "fourRemoteType",
			"classify": "label",
			"zhCn": "四遥类型",
			"zhTw": "四遙類型",
			"enUs": "four remote type",
			"thTh": "สี่ประเภทระยะไกล",
			"idId": "Tipe Empat Jarak Jauh",
			"esMx": "Tipo de cuatro remotos",
			"viVi": "Loại hình bốn điều khiển từ xa",
			"ptPt": "Quatro tipos remotos"
		},
		{
			"textKey": "ifSave",
			"classify": "table",
			"zhCn": "是否存储",
			"zhTw": "是否存儲",
			"enUs": "Whether to store",
			"thTh": "จัดเก็บหรือไม่",
			"idId": "Apakah Penyimpanan",
			"esMx": "Ya sea para almacenar",
			"viVi": "Có lưu trữ không",
			"ptPt": "Se é armazenado"
		},
		{
			"textKey": "projectId",
			"classify": "table",
			"zhCn": "项目ID",
			"zhTw": "項目ID",
			"enUs": "Project ID",
			"thTh": "โครงการ ID",
			"idId": "ID proyek",
			"esMx": "ID de proyecto",
			"viVi": "ID dự án",
			"ptPt": "ID do projeto"
		},
		{
			"textKey": "dataItemId",
			"classify": "table",
			"zhCn": "数据项ID",
			"zhTw": "數據項ID",
			"enUs": "Data Item ID",
			"thTh": "ID รายการข้อมูล",
			"idId": "ID item data",
			"esMx": "ID de elemento de datos",
			"viVi": "ID mục dữ liệu",
			"ptPt": "ID do item de dados"
		},
		{
			"textKey": "sort",
			"classify": "table",
			"zhCn": "排序",
			"zhTw": "排序",
			"enUs": "Sort",
			"thTh": "เรียงลำดับ",
			"idId": "Menyortir",
			"esMx": "Ordenar",
			"viVi": "Sắp xếp",
			"ptPt": "Ordenação"
		},
		{
			"textKey": "factor",
			"classify": "table",
			"zhCn": "计算因子",
			"zhTw": "計算因子",
			"enUs": "calculation factor",
			"thTh": "ปัจจัยการคำนวณ",
			"idId": "Faktor perhitungan",
			"esMx": "Factores de cálculo",
			"viVi": "Tính toán yếu tố",
			"ptPt": "Fatores de cálculo"
		},
		{
			"textKey": "enName",
			"classify": "label",
			"zhCn": "英文名称",
			"zhTw": "英文名稱",
			"enUs": "English Name",
			"thTh": "ชื่อภาษาอังกฤษ",
			"idId": "Nama dalam bahasa Inggris",
			"esMx": "Nombre en inglés",
			"viVi": "Tên tiếng anh",
			"ptPt": "Nome em inglês"
		},
		{
			"textKey": "localName",
			"classify": "label",
			"zhCn": "本地名称",
			"zhTw": "本地名稱",
			"enUs": "Local Name",
			"thTh": "ชื่อท้องถิ่น",
			"idId": "Nama Lokal",
			"esMx": "Nombre local",
			"viVi": "Tên địa phương",
			"ptPt": "Nome local"
		},
		{
			"textKey": "measurePointData",
			"classify": "btn",
			"zhCn": "测量点数据",
			"zhTw": "測量點數據",
			"enUs": "Measurement point data",
			"thTh": "ข้อมูลจุดวัด",
			"idId": "Data titik pengukuran",
			"esMx": "Datos de puntos de medición",
			"viVi": "Dữ liệu điểm đo",
			"ptPt": "Dados do ponto de medição"
		},
		{
			"textKey": "gatewayId",
			"classify": "table",
			"zhCn": "网关ID",
			"zhTw": "網關ID",
			"enUs": "Gateway ID",
			"thTh": "เกตเวย์ ID",
			"idId": "ID gateway",
			"esMx": "ID de puerta de enlace",
			"viVi": "ID cổng",
			"ptPt": "ID do gateway"
		},
		{
			"textKey": "gatewayName",
			"classify": "table",
			"zhCn": "网关名称",
			"zhTw": "網關名稱",
			"enUs": "Gateway Name",
			"thTh": "ชื่อเกตเวย์",
			"idId": "Nama Gateway",
			"esMx": "Nombre de la puerta de enlace",
			"viVi": "Tên cổng",
			"ptPt": "Nome do gateway"
		},
		{
			"textKey": "modelId",
			"classify": "table",
			"zhCn": "模型ID",
			"zhTw": "模型ID",
			"enUs": "Model ID",
			"thTh": "รุ่น ID",
			"idId": "ID model",
			"esMx": "ID del modelo",
			"viVi": "ID mô hình",
			"ptPt": "ID do modelo"
		},
		{
			"textKey": "alarmConfig",
			"classify": "btn",
			"zhCn": "报警设置",
			"zhTw": "報警設置",
			"enUs": "Alarm Settings",
			"thTh": "การตั้งค่าการเตือนภัย",
			"idId": "Pengaturan alarm",
			"esMx": "Configuración de alarma",
			"viVi": "Thiết lập báo động",
			"ptPt": "Configurações de alarme"
		},
		{
			"textKey": "passwordReset",
			"classify": "btn",
			"zhCn": "密码重置",
			"zhTw": "密碼重置",
			"enUs": "Password Reset",
			"thTh": "รีเซ็ตรหัสผ่าน",
			"idId": "Atur ulang kata sandi",
			"esMx": "Restablecimiento de contraseña",
			"viVi": "Đặt lại mật khẩu",
			"ptPt": "Redefinição de senha"
		},
		{
			"textKey": "edit",
			"classify": "btn",
			"zhCn": "编辑",
			"zhTw": "編輯",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Mengedit",
			"esMx": "Edición",
			"viVi": "Chỉnh sửa",
			"ptPt": "Editar"
		},
		{
			"textKey": "view",
			"classify": "btn",
			"zhCn": "查看",
			"zhTw": "查看",
			"enUs": "View",
			"thTh": "ดู",
			"idId": "Lihat",
			"esMx": "Ver",
			"viVi": "Xem",
			"ptPt": "Veja"
		},
		{
			"textKey": "addNew",
			"classify": "btn",
			"zhCn": "新增",
			"zhTw": "新增",
			"enUs": "New",
			"thTh": "เพิ่มใหม่",
			"idId": "Baru",
			"esMx": "Añadido",
			"viVi": "Thêm",
			"ptPt": "Adicionado"
		},
		{
			"textKey": "submit",
			"classify": "btn",
			"zhCn": "提交",
			"zhTw": "提交",
			"enUs": "Submission",
			"thTh": "ส่ง",
			"idId": "Pengajuan",
			"esMx": "Presentar",
			"viVi": "Gửi",
			"ptPt": "Enmissão"
		},
		{
			"textKey": "cancel",
			"classify": "btn",
			"zhCn": "取消",
			"zhTw": "取消",
			"enUs": "Cancel",
			"thTh": "ยกเลิก",
			"idId": "Pembatalan",
			"esMx": "Cancelación",
			"viVi": "Hủy bỏ",
			"ptPt": "Cancelamento"
		},
		{
			"textKey": "capacity",
			"classify": "label",
			"zhCn": "容量",
			"zhTw": "容量",
			"enUs": "Capacity",
			"thTh": "ความจุ",
			"idId": "Kapasitas",
			"esMx": "Capacidad",
			"viVi": "Công suất",
			"ptPt": "Capacidade"
		},
		{
			"textKey": "menuRemark",
			"classify": "label",
			"zhCn": "菜单备注",
			"zhTw": "菜單備註",
			"enUs": "Menu Remarks",
			"thTh": "หมายเหตุเมนู",
			"idId": "Menu Catatan",
			"esMx": "Notas del menú",
			"viVi": "Ghi chú thực đơn",
			"ptPt": "Observações do menu"
		},
		{
			"textKey": "preMenu",
			"classify": "label",
			"zhCn": "上级菜单",
			"zhTw": "上級菜單",
			"enUs": "Superior Menu",
			"thTh": "เมนูที่เหนือกว่า",
			"idId": "Menu unggul",
			"esMx": "Menú superior",
			"viVi": "Thực đơn cao cấp",
			"ptPt": "Menu superior"
		},
		{
			"textKey": "menuType",
			"classify": "label",
			"zhCn": "菜单类型",
			"zhTw": "菜單類型",
			"enUs": "Menu Type",
			"thTh": "ประเภทเมนู",
			"idId": "Jenis menu",
			"esMx": "Tipo de menú",
			"viVi": "Loại thực đơn",
			"ptPt": "Tipo de menu"
		},
		{
			"textKey": "ifCache",
			"classify": "label",
			"zhCn": "是否缓存",
			"zhTw": "是否緩存",
			"enUs": "Whether to cache",
			"thTh": "แคชหรือไม่",
			"idId": "Apakah Cache",
			"esMx": "Ya sea para almacenar en caché",
			"viVi": "Có bộ nhớ cache không",
			"ptPt": "Se é cache"
		},
		{
			"textKey": "dictRemark",
			"classify": "label",
			"zhCn": "字典备注",
			"zhTw": "字典備註",
			"enUs": "Dictionary remarks",
			"thTh": "หมายเหตุพจนานุกรม",
			"idId": "Catatan kamus",
			"esMx": "Observaciones del diccionario",
			"viVi": "Ghi chú từ điển",
			"ptPt": "Notas do dicionário"
		},
		{
			"textKey": "menu",
			"classify": "label",
			"zhCn": "菜单",
			"zhTw": "菜單",
			"enUs": "Menu",
			"thTh": "เมนู",
			"idId": "Menu",
			"esMx": "Menú",
			"viVi": "Thực đơn",
			"ptPt": "Menu"
		},
		{
			"textKey": "button",
			"classify": "label",
			"zhCn": "按钮",
			"zhTw": "按鈕",
			"enUs": "Button",
			"thTh": "ปุ่ม",
			"idId": "Tombol",
			"esMx": "Botón",
			"viVi": "Nút",
			"ptPt": "Botão"
		},
		{
			"textKey": "no",
			"classify": "label",
			"zhCn": "否",
			"zhTw": "否",
			"enUs": "No",
			"thTh": "ไม่ใช่",
			"idId": "Tidak.",
			"esMx": "No.",
			"viVi": "Không.",
			"ptPt": "Não."
		},
		{
			"textKey": "yes",
			"classify": "label",
			"zhCn": "是",
			"zhTw": "是",
			"enUs": "Yes",
			"thTh": "ใช่",
			"idId": "Ya",
			"esMx": "Sí.",
			"viVi": "Là",
			"ptPt": "Sim"
		},
		{
			"textKey": "positionDesc",
			"classify": "label",
			"zhCn": "岗位描述",
			"zhTw": "崗位描述",
			"enUs": "Job Description",
			"thTh": "รายละเอียดงาน",
			"idId": "Deskripsi pekerjaan",
			"esMx": "Descripción del puesto",
			"viVi": "Mô tả công việc",
			"ptPt": "Descrição do trabalho"
		},
		{
			"textKey": "remark",
			"classify": "label",
			"zhCn": "备注",
			"zhTw": "備註",
			"enUs": "Remarks",
			"thTh": "หมายเหตุ",
			"idId": "Catatan",
			"esMx": "Observaciones",
			"viVi": "Ghi chú",
			"ptPt": "Observações"
		},
		{
			"textKey": "superiorOrg",
			"classify": "label",
			"zhCn": "上级机构",
			"zhTw": "上級機構",
			"enUs": "Superior institutions",
			"thTh": "สถาบันที่เหนือกว่า",
			"idId": "Lembaga induk",
			"esMx": "Órgano superior",
			"viVi": "Cơ quan cấp trên",
			"ptPt": "Instituições superiores"
		},
		{
			"textKey": "baseInfo",
			"classify": "label",
			"zhCn": "基础信息",
			"zhTw": "基礎信息",
			"enUs": "Basic information",
			"thTh": "ข้อมูลพื้นฐาน",
			"idId": "Informasi dasar",
			"esMx": "Información básica",
			"viVi": "Thông tin cơ bản",
			"ptPt": "Informações básicas"
		},
		{
			"textKey": "tenantOf",
			"classify": "label",
			"zhCn": "所属租户",
			"zhTw": "所屬租戶",
			"enUs": "Tenant",
			"thTh": "ผู้เช่า",
			"idId": "Penyewa",
			"esMx": "Inquilino",
			"viVi": "Người thuê nhà",
			"ptPt": "Inquilino"
		},
		{
			"textKey": "loginAccount",
			"classify": "label",
			"zhCn": "登录账号",
			"zhTw": "登錄賬號",
			"enUs": "Login Account",
			"thTh": "เข้าสู่ระบบบัญชี",
			"idId": "Masuk ke akun",
			"esMx": "Cuenta de inicio de sesión",
			"viVi": "Đăng nhập tài khoản",
			"ptPt": "Faça login na conta"
		},
		{
			"textKey": "detailInfo",
			"classify": "label",
			"zhCn": "详细信息",
			"zhTw": "詳細信息",
			"enUs": "Details",
			"thTh": "รายละเอียด",
			"idId": "Informasi detail",
			"esMx": "Detalles",
			"viVi": "Thông tin chi tiết",
			"ptPt": "Detalhes"
		},
		{
			"textKey": "userNickName",
			"classify": "label",
			"zhCn": "用户昵称",
			"zhTw": "用戶暱稱",
			"enUs": "User Nickname",
			"thTh": "ชื่อเล่นผู้ใช้",
			"idId": "Nama panggilan pengguna",
			"esMx": "Apodo de usuario",
			"viVi": "Biệt hiệu người dùng",
			"ptPt": "Apelido do usuário"
		},
		{
			"textKey": "userName",
			"classify": "label",
			"zhCn": "用户姓名",
			"zhTw": "用戶姓名",
			"enUs": "User Name",
			"thTh": "ชื่อผู้ใช้",
			"idId": "Nama Pengguna",
			"esMx": "Nombre del usuario",
			"viVi": "Tên người dùng",
			"ptPt": "Nome do usuário"
		},
		{
			"textKey": "phoneNumber",
			"classify": "label",
			"zhCn": "手机号码",
			"zhTw": "手機號碼",
			"enUs": "Mobile phone number",
			"thTh": "หมายเลขโทรศัพท์มือถือ",
			"idId": "Nomor ponsel",
			"esMx": "Número de teléfono móvil",
			"viVi": "Số điện thoại di động",
			"ptPt": "Número de celular"
		},
		{
			"textKey": "email",
			"classify": "label",
			"zhCn": "电子邮箱",
			"zhTw": "電子郵箱",
			"enUs": "Email",
			"thTh": "อีเมล์",
			"idId": "Email",
			"esMx": "Correo electrónico",
			"viVi": "Hộp thư điện tử",
			"ptPt": "E-mail"
		},
		{
			"textKey": "userGender",
			"classify": "label",
			"zhCn": "用户性别",
			"zhTw": "用戶性別",
			"enUs": "User Gender",
			"thTh": "เพศผู้ใช้",
			"idId": "Jenis kelamin pengguna",
			"esMx": "Sexo del usuario",
			"viVi": "Giới tính người dùng",
			"ptPt": "Gênero do usuário"
		},
		{
			"textKey": "userBirthday",
			"classify": "label",
			"zhCn": "用户生日",
			"zhTw": "用戶生日",
			"enUs": "User's birthday",
			"thTh": "วันเกิดของผู้ใช้",
			"idId": "Ulang Tahun Pengguna",
			"esMx": "Cumpleaños del usuario",
			"viVi": "Sinh nhật người dùng",
			"ptPt": "Aniversário do usuário"
		},
		{
			"textKey": "abilityInfo",
			"classify": "label",
			"zhCn": "责任信息",
			"zhTw": "責任信息",
			"enUs": "Liability Information",
			"thTh": "ข้อมูลความรับผิดชอบ",
			"idId": "Informasi Tanggung Jawab",
			"esMx": "Información de responsabilidad",
			"viVi": "Thông tin trách nhiệm",
			"ptPt": "Informação de responsabilidade"
		},
		{
			"textKey": "userNumber",
			"classify": "label",
			"zhCn": "用户编号",
			"zhTw": "用戶編號",
			"enUs": "User Number",
			"thTh": "หมายเลขผู้ใช้",
			"idId": "Nomor pengguna",
			"esMx": "Número de usuario",
			"viVi": "Số người dùng",
			"ptPt": "Número de usuário"
		},
		{
			"textKey": "roleOf",
			"classify": "label",
			"zhCn": "所属角色",
			"zhTw": "所屬角色",
			"enUs": "Role",
			"thTh": "บทบาท",
			"idId": "Karakter yang dimiliki",
			"esMx": "Rol",
			"viVi": "Vai trò của",
			"ptPt": "Função"
		},
		{
			"textKey": "deptOf",
			"classify": "label",
			"zhCn": "所属部门",
			"zhTw": "所屬部門",
			"enUs": "Department",
			"thTh": "แผนก",
			"idId": "Departemen",
			"esMx": "Departamento",
			"viVi": "Bộ phận trực thuộc",
			"ptPt": "Departamentos afiliados"
		},
		{
			"textKey": "positionOf",
			"classify": "label",
			"zhCn": "所属岗位",
			"zhTw": "所屬崗位",
			"enUs": "Position",
			"thTh": "ตำแหน่ง",
			"idId": "Posisi",
			"esMx": "Puesto",
			"viVi": "Vị trí",
			"ptPt": "Posição"
		},
		{
			"textKey": "projectInfo",
			"classify": "label",
			"zhCn": "项目信息",
			"zhTw": "項目信息",
			"enUs": "Project Information",
			"thTh": "ข้อมูลโครงการ",
			"idId": "Informasi Proyek",
			"esMx": "Información del proyecto",
			"viVi": "Thông tin dự án",
			"ptPt": "Informações do projeto"
		},
		{
			"textKey": "projectName",
			"classify": "label",
			"zhCn": "项目名称",
			"zhTw": "項目名稱",
			"enUs": "Project Name",
			"thTh": "ชื่อโครงการ",
			"idId": "Nama Proyek",
			"esMx": "Nombre del proyecto",
			"viVi": "Tên dự án",
			"ptPt": "Nome do projeto"
		},
		{
			"textKey": "areaSelect",
			"classify": "label",
			"zhCn": "区域选择",
			"zhTw": "區域選擇",
			"enUs": "Area selection",
			"thTh": "การเลือกพื้นที่",
			"idId": "Pemilihan daerah",
			"esMx": "Selección de área",
			"viVi": "Lựa chọn khu vực",
			"ptPt": "Seleção de área"
		},
		{
			"textKey": "responseAddress",
			"classify": "label",
			"zhCn": "通讯地址",
			"zhTw": "通訊地址",
			"enUs": "Correspondence Address",
			"thTh": "ที่อยู่ทางไปรษณีย์",
			"idId": "Alamat komunikasi",
			"esMx": "Dirección de correspondencia",
			"viVi": "Địa chỉ liên lạc",
			"ptPt": "Endereço de correspondência"
		},
		{
			"textKey": "orgOf",
			"classify": "label",
			"zhCn": "所属机构",
			"zhTw": "所屬機構",
			"enUs": "Institution",
			"thTh": "สถาบันในเครือ",
			"idId": "Afiliasi",
			"esMx": "Institución",
			"viVi": "Tổ chức trực thuộc",
			"ptPt": "Instituições afiliadas"
		},
		{
			"textKey": "longitude",
			"classify": "label",
			"zhCn": "经度",
			"zhTw": "經度",
			"enUs": "Longitude",
			"thTh": "ลองจิจูด",
			"idId": "Garis bujur",
			"esMx": "Longitud",
			"viVi": "Kinh độ",
			"ptPt": "Longitude"
		},
		{
			"textKey": "latitude",
			"classify": "label",
			"zhCn": "纬度",
			"zhTw": "緯度",
			"enUs": "Latitude",
			"thTh": "ละติจูด",
			"idId": "Lintang",
			"esMx": "Latitud",
			"viVi": "Vĩ độ",
			"ptPt": "Latitude"
		},
		{
			"textKey": "meta",
			"classify": "label",
			"zhCn": "描述",
			"zhTw": "描述",
			"enUs": "Description",
			"thTh": "คำอธิบาย",
			"idId": "Deskripsi",
			"esMx": "Descripción",
			"viVi": "Mô tả",
			"ptPt": "Descrição"
		},
		{
			"textKey": "name",
			"classify": "label",
			"zhCn": "名称",
			"zhTw": "名稱",
			"enUs": "Name",
			"thTh": "ชื่อ",
			"idId": "Nama",
			"esMx": "Nombre",
			"viVi": "Tên",
			"ptPt": "Nome"
		},
		{
			"textKey": "unit",
			"classify": "label",
			"zhCn": "单位",
			"zhTw": "單位",
			"enUs": "Unit",
			"thTh": "หน่วย",
			"idId": "Unit",
			"esMx": "Unidad",
			"viVi": "Đơn vị",
			"ptPt": "Unidades"
		},
		{
			"textKey": "gatewayInfo",
			"classify": "label",
			"zhCn": "网关信息",
			"zhTw": "網關信息",
			"enUs": "Gateway Information",
			"thTh": "ข้อมูลเกตเวย์",
			"idId": "Informasi Gateway",
			"esMx": "Información de la puerta de enlace",
			"viVi": "Cổng thông tin",
			"ptPt": "Informações do gateway"
		},
		{
			"textKey": "dictKey",
			"classify": "label",
			"zhCn": "字典键值",
			"zhTw": "字典鍵值",
			"enUs": "Dictionary Key Value",
			"thTh": "ค่าคีย์พจนานุกรม",
			"idId": "Nilai kunci kamus",
			"esMx": "Valor de la clave del diccionario",
			"viVi": "Giá trị khóa từ điển",
			"ptPt": "Valor de chave de dicionário"
		},
		{
			"textKey": "protocol",
			"classify": "label",
			"zhCn": "协议",
			"zhTw": "協議",
			"enUs": "Agreement",
			"thTh": "ข้อตกลง",
			"idId": "Perjanjian",
			"esMx": "Acuerdo",
			"viVi": "Giao thức",
			"ptPt": "Acordo"
		},
		{
			"textKey": "preSetVal",
			"classify": "tips",
			"zhCn": "预设值",
			"zhTw": "預設值",
			"enUs": "Preset Value",
			"thTh": "ค่าที่ตั้งไว้ล่วงหน้า",
			"idId": "Nilai preset",
			"esMx": "Valor preestablecido",
			"viVi": "Giá trị mặc định",
			"ptPt": "Valores predefinidos"
		},
		{
			"textKey": "currentVal",
			"classify": "tips",
			"zhCn": "当前值",
			"zhTw": "當前值",
			"enUs": "Current Value",
			"thTh": "ค่าปัจจุบัน",
			"idId": "Nilai saat ini",
			"esMx": "Valor actual",
			"viVi": "Giá trị hiện tại",
			"ptPt": "Valor atual"
		},
		{
			"textKey": "import",
			"classify": "btn",
			"zhCn": "导入",
			"zhTw": "導入",
			"enUs": "Import",
			"thTh": "นำเข้า",
			"idId": "Impor",
			"esMx": "Importar",
			"viVi": "Nhập",
			"ptPt": "Importação"
		},
		{
			"textKey": "debug",
			"classify": "btn",
			"zhCn": "调度",
			"zhTw": "調度",
			"enUs": "Scheduling",
			"thTh": "การตั้งเวลา",
			"idId": "Penjadwalan",
			"esMx": "Programación",
			"viVi": "Công văn",
			"ptPt": "Despacho"
		},
		{
			"textKey": "addSubLevel",
			"classify": "btn",
			"zhCn": "新增下级",
			"zhTw": "新增下級",
			"enUs": "Add Child",
			"thTh": "เพิ่มผู้ใต้บังคับบัญชา",
			"idId": "Tambahkan bawahan",
			"esMx": "Añadido subordinado",
			"viVi": "Thêm cấp dưới",
			"ptPt": "Novos subordinados"
		},
		{
			"textKey": "download",
			"classify": "btn",
			"zhCn": "下载",
			"zhTw": "下載",
			"enUs": "Download",
			"thTh": "ดาวน์โหลด",
			"idId": "Unduh",
			"esMx": "Descargar",
			"viVi": "Tải về",
			"ptPt": "Download"
		},
		{
			"textKey": "dataSource",
			"classify": "btn",
			"zhCn": "数据源 ",
			"zhTw": "數據源",
			"enUs": "Data Source",
			"thTh": "แหล่งข้อมูล",
			"idId": "Sumber Data",
			"esMx": "Fuente de datos",
			"viVi": "Nguồn dữ liệu",
			"ptPt": "Fonte de dados"
		},
		{
			"textKey": "productPack",
			"classify": "btn",
			"zhCn": "产品包",
			"zhTw": "產品包",
			"enUs": "Product Package",
			"thTh": "กระเป๋าสินค้า",
			"idId": "Paket produk",
			"esMx": "Paquete de productos",
			"viVi": "Gói sản phẩm",
			"ptPt": "Pacote de produtos"
		},
		{
			"textKey": "alarm",
			"classify": "tips",
			"zhCn": "告警",
			"zhTw": "告警",
			"enUs": "Alarm",
			"thTh": "สัญญาณเตือน",
			"idId": "Alarm",
			"esMx": "Alerta",
			"viVi": "Cảnh báo",
			"ptPt": "Alerta"
		},
		{
			"textKey": "startTime",
			"classify": "label",
			"zhCn": "开始时间",
			"zhTw": "開始時間",
			"enUs": "Start Time",
			"thTh": "เวลาเริ่มต้น",
			"idId": "Waktu mulai",
			"esMx": "Hora de inicio",
			"viVi": "Thời gian bắt đầu",
			"ptPt": "Hora de início"
		},
		{
			"textKey": "alarmType",
			"classify": "table",
			"zhCn": "告警类别",
			"zhTw": "告警類別",
			"enUs": "Alarm category",
			"thTh": "ประเภทการเตือน",
			"idId": "Kategori alarm",
			"esMx": "Categoría de alarma",
			"viVi": "Danh mục cảnh báo",
			"ptPt": "Categoria de aviso"
		},
		{
			"textKey": "alarmLevel",
			"classify": "table",
			"zhCn": "告警等级",
			"zhTw": "告警等級",
			"enUs": "Alarm level",
			"thTh": "ระดับการเตือน",
			"idId": "Tingkat alarm",
			"esMx": "Nivel de alarma",
			"viVi": "Mức cảnh báo",
			"ptPt": "Nível de alerta"
		},
		{
			"textKey": "threshold",
			"classify": "table",
			"zhCn": "阀值",
			"zhTw": "閥值",
			"enUs": "threshold",
			"thTh": "ค่าวาล์ว",
			"idId": "Nilai katup",
			"esMx": "Valor de la válvula",
			"viVi": "Giá trị van",
			"ptPt": "Valor da válvula"
		},
		{
			"textKey": "parentAreaNum",
			"classify": "label",
			"zhCn": "父区划编号",
			"zhTw": "父區劃編號",
			"enUs": "Parent Zone Number",
			"thTh": "หมายเลขการแบ่งผู้ปกครอง",
			"idId": "Nomor divisi induk",
			"esMx": "Número de división del padre",
			"viVi": "Số phân vùng cha",
			"ptPt": "Número da divisão pai"
		},
		{
			"textKey": "parentAreaName",
			"classify": "label",
			"zhCn": "父区划名称",
			"zhTw": "父區劃名稱",
			"enUs": "Parent Zone Name",
			"thTh": "ชื่อการแบ่งเขตหลัก",
			"idId": "Nama Divisi Induk",
			"esMx": "Nombre de la división principal",
			"viVi": "Tên bộ phận cha",
			"ptPt": "Nome da divisão pai"
		},
		{
			"textKey": "areaNum",
			"classify": "label",
			"zhCn": "区划编号",
			"zhTw": "區劃編號",
			"enUs": "Zoning No.",
			"thTh": "หมายเลขการแบ่งเขต",
			"idId": "Nomor pembagian",
			"esMx": "Número de división",
			"viVi": "Số phân vùng",
			"ptPt": "Número de divisão"
		},
		{
			"textKey": "areaName",
			"classify": "label",
			"zhCn": "区划名称",
			"zhTw": "區劃名稱",
			"enUs": "Division Name",
			"thTh": "ชื่อการแบ่งเขต",
			"idId": "Nama zonasi",
			"esMx": "Nombre de la división",
			"viVi": "Tên khu vực",
			"ptPt": "Nome da divisão"
		},
		{
			"textKey": "areaLevel",
			"classify": "label",
			"zhCn": "区划等级",
			"zhTw": "區劃等級",
			"enUs": "Division Grade",
			"thTh": "ระดับการแบ่งเขต",
			"idId": "Tingkat zonasi",
			"esMx": "Nivel de zonificación",
			"viVi": "Cấp phân vùng",
			"ptPt": "Nível de divisão"
		},
		{
			"textKey": "areaSort",
			"classify": "label",
			"zhCn": "区划排序",
			"zhTw": "區劃排序",
			"enUs": "Division sorting",
			"thTh": "การเรียงลำดับการแบ่งเขต",
			"idId": "Pengurutan zonasi",
			"esMx": "Orden de zonificación",
			"viVi": "Sắp xếp phân vùng",
			"ptPt": "Classificação por zoneamento"
		},
		{
			"textKey": "areaRemark",
			"classify": "label",
			"zhCn": "区划备注",
			"zhTw": "區劃備註",
			"enUs": "Zoning Remarks",
			"thTh": "หมายเหตุการแบ่งเขต",
			"idId": "Catatan zonasi",
			"esMx": "Observaciones de zonificación",
			"viVi": "Ghi chú phân vùng",
			"ptPt": "Observações de zoneamento"
		},
		{
			"textKey": "organization",
			"classify": "label",
			"zhCn": "组织机构",
			"zhTw": "組織機構",
			"enUs": "Organization",
			"thTh": "องค์กร",
			"idId": "Organisasi",
			"esMx": "Organización",
			"viVi": "Cơ quan tổ chức",
			"ptPt": "Organização"
		},
		{
			"textKey": "tenantNum",
			"classify": "label",
			"zhCn": "租户编号",
			"zhTw": "租戶編號",
			"enUs": "Tenant Number",
			"thTh": "หมายเลขผู้เช่า",
			"idId": "Nomor Penyewa",
			"esMx": "Número de inquilino",
			"viVi": "Số người thuê nhà",
			"ptPt": "Número do inquilino"
		},
		{
			"textKey": "inputTenantNum",
			"classify": "tips",
			"zhCn": "请输入租户编号",
			"zhTw": "請輸入租戶編號",
			"enUs": "Please enter tenant number",
			"thTh": "กรุณากรอกหมายเลขผู้เช่า",
			"idId": "Silakan masukkan nomor penyewa",
			"esMx": "Introduzca el número de inquilino",
			"viVi": "Vui lòng nhập số người thuê",
			"ptPt": "Por favor, insira o número do inquilino"
		},
		{
			"textKey": "inputUserName",
			"classify": "tips",
			"zhCn": "请输入用户姓名",
			"zhTw": "請輸入用戶姓名",
			"enUs": "Please enter user name",
			"thTh": "กรุณากรอกชื่อผู้ใช้",
			"idId": "Masukkan nama pengguna",
			"esMx": "Por favor ingrese el nombre de usuario",
			"viVi": "Vui lòng nhập tên người dùng",
			"ptPt": "Por favor, insira o nome do usuário"
		},
		{
			"textKey": "accountName",
			"classify": "label",
			"zhCn": "账号名称",
			"zhTw": "賬號名稱",
			"enUs": "Account Name",
			"thTh": "ชื่อบัญชี",
			"idId": "Nama akun",
			"esMx": "Nombre de la cuenta",
			"viVi": "Tên tài khoản",
			"ptPt": "Nome da conta"
		},
		{
			"textKey": "accountPassword",
			"classify": "label",
			"zhCn": "账号密码",
			"zhTw": "賬號密碼",
			"enUs": "Account password",
			"thTh": "รหัสผ่านบัญชี",
			"idId": "Kata sandi akun",
			"esMx": "Contraseña de la cuenta",
			"viVi": "Mật khẩu tài khoản",
			"ptPt": "Senha da conta"
		},
		{
			"textKey": "inputAccountPassword",
			"classify": "tips",
			"zhCn": "请输入账号密码",
			"zhTw": "請輸入賬號密碼",
			"enUs": "Please enter the account password",
			"thTh": "กรุณากรอกรหัสผ่านบัญชี",
			"idId": "Masukkan kata sandi akun",
			"esMx": "Ingrese la contraseña de la cuenta",
			"viVi": "Vui lòng nhập mật khẩu tài khoản",
			"ptPt": "Insira a senha da conta"
		},
		{
			"textKey": "inputConfirmPassword",
			"classify": "tips",
			"zhCn": "请输入确认密码",
			"zhTw": "請輸入確認密碼",
			"enUs": "Please enter confirmation password",
			"thTh": "โปรดป้อนรหัสผ่านยืนยัน",
			"idId": "Silakan masukkan kata sandi konfirmasi",
			"esMx": "Ingrese la contraseña de confirmación",
			"viVi": "Vui lòng nhập mật khẩu xác nhận",
			"ptPt": "Insira a senha de confirmação"
		},
		{
			"textKey": "superiorDict",
			"classify": "label",
			"zhCn": "上级字典",
			"zhTw": "上級字典",
			"enUs": "Superior Dictionary",
			"thTh": "พจนานุกรมที่เหนือกว่า",
			"idId": "Kamus tingkat tinggi",
			"esMx": "Diccionario superior",
			"viVi": "Từ điển cấp trên",
			"ptPt": "Dicionário superior"
		},
		{
			"textKey": "dictSort",
			"classify": "label",
			"zhCn": "字典排序",
			"zhTw": "字典排序",
			"enUs": "Dictionary Sort",
			"thTh": "การเรียงลำดับพจนานุกรม",
			"idId": "Pengurutan kamus",
			"esMx": "Ordenar diccionario",
			"viVi": "Sắp xếp từ điển",
			"ptPt": "Classificação de dicionário"
		},
		{
			"textKey": "inputDictSort",
			"classify": "tips",
			"zhCn": "请输入字典排序",
			"zhTw": "請輸入字典排序",
			"enUs": "Please enter a dictionary sort",
			"thTh": "โปรดป้อนการเรียงลำดับพจนานุกรม",
			"idId": "Silakan masukkan pengurutan kamus",
			"esMx": "Ingrese la clasificación del diccionario",
			"viVi": "Vui lòng nhập sắp xếp từ điển",
			"ptPt": "Por favor, insira o dicionário de classificação"
		},
		{
			"textKey": "inputDictEnName",
			"classify": "tips",
			"zhCn": "请输入字典英文名称",
			"zhTw": "請輸入字典英文名稱",
			"enUs": "Please enter English dictionary name",
			"thTh": "โปรดป้อนชื่อภาษาอังกฤษในพจนานุกรม",
			"idId": "Silakan masukkan nama kamus bahasa Inggris",
			"esMx": "Introduzca el nombre en inglés del diccionario",
			"viVi": "Vui lòng nhập từ điển tên tiếng Anh",
			"ptPt": "Por favor, insira o nome em inglês do dicionário"
		},
		{
			"textKey": "inputDictLocalName",
			"classify": "tips",
			"zhCn": "请输入字典本地名称",
			"zhTw": "請輸入字典本地名稱",
			"enUs": "Please enter a dictionary local name",
			"thTh": "โปรดป้อนชื่อท้องถิ่นของพจนานุกรม",
			"idId": "Masukkan nama lokal kamus",
			"esMx": "Introduzca el nombre local del diccionario",
			"viVi": "Vui lòng nhập tên địa phương từ điển",
			"ptPt": "Por favor, insira o nome local do dicionário"
		},
		{
			"textKey": "inputTenantId",
			"classify": "tips",
			"zhCn": "请输入租户ID",
			"zhTw": "請輸入租戶ID",
			"enUs": "Please enter Tenant ID",
			"thTh": "กรุณากรอก ID ผู้เช่า",
			"idId": "Silakan masukkan ID penyewa",
			"esMx": "Introduzca el ID del inquilino",
			"viVi": "Vui lòng nhập ID người thuê",
			"ptPt": "Por favor, insira o ID do inquilino"
		},
		{
			"textKey": "leaseSixLength",
			"classify": "tips",
			"zhCn": "密码长度最少为6位",
			"zhTw": "密碼長度最少為6位",
			"enUs": "Minimum password length of 6 digits",
			"thTh": "ความยาวรหัสผ่านอย่างน้อย6หลัก",
			"idId": "Panjang kata sandi minimal 6 digit",
			"esMx": "La longitud de la contraseña es de al menos 6 dígitos",
			"viVi": "Độ dài mật khẩu ít nhất là 6 chữ số",
			"ptPt": "O comprimento da senha é de pelo menos 6 bits"
		},
		{
			"textKey": "inputLoginPassword",
			"classify": "tips",
			"zhCn": "请输入登录密码",
			"zhTw": "請輸入登錄密碼",
			"enUs": "Please enter your login password",
			"thTh": "กรุณากรอกรหัสผ่านเข้าสู่ระบบ",
			"idId": "Masukkan kata sandi masuk",
			"esMx": "Ingrese la contraseña de inicio de sesión",
			"viVi": "Vui lòng nhập mật khẩu đăng nhập",
			"ptPt": "Insira a senha de login"
		},
		{
			"textKey": "inputRoleName",
			"classify": "tips",
			"zhCn": "请输入角色名称",
			"zhTw": "請輸入角色名稱",
			"enUs": "Please enter a role name",
			"thTh": "โปรดป้อนชื่อตัวละคร",
			"idId": "Masukkan nama karakter",
			"esMx": "Introduzca el nombre del rol",
			"viVi": "Vui lòng nhập tên vai trò",
			"ptPt": "Por favor, insira o nome da função"
		},
		{
			"textKey": "inputTenantBelongTo",
			"classify": "tips",
			"zhCn": "请输入所属租户",
			"zhTw": "請輸入所屬租戶",
			"enUs": "Please enter the tenant",
			"thTh": "กรุณาป้อนผู้เช่า",
			"idId": "Silakan masukkan penyewa",
			"esMx": "Ingrese el inquilino",
			"viVi": "Vui lòng nhập người thuê nhà",
			"ptPt": "Por favor, insira o inquilino"
		},
		{
			"textKey": "inputRoleAriaName",
			"classify": "tips",
			"zhCn": "请输入角色别名",
			"zhTw": "請輸入角色別名",
			"enUs": "Please enter a role alias",
			"thTh": "โปรดป้อนนามแฝงของตัวละคร",
			"idId": "Silakan masukkan karakter alias",
			"esMx": "Ingrese el alias del rol",
			"viVi": "Vui lòng nhập bí danh nhân vật",
			"ptPt": "Por favor, insira um alias de função"
		},
		{
			"textKey": "inputGatewayId",
			"classify": "tips",
			"zhCn": "请输入网关ID",
			"zhTw": "請輸入網關ID",
			"enUs": "Please enter Gateway ID",
			"thTh": "โปรดป้อนรหัสเกตเวย์",
			"idId": "Masukkan ID gateway",
			"esMx": "Ingrese el ID de la puerta de enlace",
			"viVi": "Vui lòng nhập ID cổng",
			"ptPt": "Por favor, insira o ID do gateway"
		},
		{
			"textKey": "inputLoginAccount",
			"classify": "tips",
			"zhCn": "请输入登录账号",
			"zhTw": "請輸入登錄賬號",
			"enUs": "Please enter your login account",
			"thTh": "กรุณากรอกบัญชีเข้าสู่ระบบ",
			"idId": "Silakan masukkan akun login",
			"esMx": "Ingrese la cuenta de inicio de sesión",
			"viVi": "Vui lòng nhập tài khoản đăng nhập của bạn",
			"ptPt": "Insira a conta de login"
		},
		{
			"textKey": "inputProjectName",
			"classify": "tips",
			"zhCn": "请输入项目名称",
			"zhTw": "請輸入項目名稱",
			"enUs": "Please enter a project name",
			"thTh": "กรุณากรอกชื่อรายการ",
			"idId": "Masukkan nama proyek",
			"esMx": "Por favor ingrese el nombre del proyecto",
			"viVi": "Vui lòng nhập tên dự án",
			"ptPt": "Por favor, insira o nome do projeto"
		},
		{
			"textKey": "inputAreaNum",
			"classify": "tips",
			"zhCn": "请输入区划编号",
			"zhTw": "請輸入區劃編號",
			"enUs": "Please enter zone number",
			"thTh": "โปรดป้อนหมายเลขการแบ่งเขต",
			"idId": "Masukkan nomor zonasi",
			"esMx": "Ingrese el número de división",
			"viVi": "Vui lòng nhập số phân vùng",
			"ptPt": "Por favor, insira o número da divisão"
		},
		{
			"textKey": "areaSubCode",
			"classify": "label",
			"zhCn": "区划子编号",
			"zhTw": "區劃子編號",
			"enUs": "Division sub-number",
			"thTh": "หมายเลขย่อยการแบ่งเขต",
			"idId": "Nomor divisi",
			"esMx": "Subnúmero de división",
			"viVi": "Số phân vùng",
			"ptPt": "Subnúmero de divisão"
		},
		{
			"textKey": "inputAreaName",
			"classify": "tips",
			"zhCn": "请输入区划名称",
			"zhTw": "請輸入區劃名稱",
			"enUs": "Please enter zone name",
			"thTh": "โปรดป้อนชื่อการแบ่งเขต",
			"idId": "Silakan masukkan nama zonasi",
			"esMx": "Ingrese el nombre de la división",
			"viVi": "Vui lòng nhập tên phân vùng",
			"ptPt": "Por favor, insira o nome da divisão"
		},
		{
			"textKey": "selectAreaLevel",
			"classify": "tips",
			"zhCn": "请选择区划等级",
			"zhTw": "請選擇區劃等級",
			"enUs": "Please select zoning level",
			"thTh": "โปรดเลือกระดับการแบ่งเขต",
			"idId": "Silakan pilih tingkat zonasi",
			"esMx": "Seleccione el nivel de zonificación",
			"viVi": "Vui lòng chọn cấp phân vùng",
			"ptPt": "Por favor, escolha o nível de divisão"
		},
		{
			"textKey": "inputAreaSort",
			"classify": "tips",
			"zhCn": "请输入区划排序",
			"zhTw": "請輸入區劃排序",
			"enUs": "Please enter a zone sort",
			"thTh": "โปรดป้อนการเรียงลำดับการแบ่งเขต",
			"idId": "Silakan masukkan zonasi",
			"esMx": "Ingrese la clasificación de la división",
			"viVi": "Vui lòng nhập sắp xếp phân vùng",
			"ptPt": "Por favor, insira a classificação da divisão"
		},
		{
			"textKey": "inputAreaSubNum",
			"classify": "tips",
			"zhCn": "请输入区划子编号",
			"zhTw": "請輸入區劃子編號",
			"enUs": "Please enter zone sub-number",
			"thTh": "โปรดป้อนหมายเลขย่อยของการแบ่งเขต",
			"idId": "Masukkan nomor divisi",
			"esMx": "Ingrese el subnúmero de división",
			"viVi": "Vui lòng nhập số phụ phân vùng",
			"ptPt": "Por favor, insira o subnúmero da divisão"
		},
		{
			"textKey": "areaDataImport",
			"classify": "tips",
			"zhCn": "行政区划数据导入",
			"zhTw": "行政區劃數據導入",
			"enUs": "Import of Administrative Division Data",
			"thTh": "การนำเข้าข้อมูลการแบ่งเขตการปกครอง",
			"idId": "Impor data divisi administrasi",
			"esMx": "Importación de datos de división administrativa",
			"viVi": "Nhập dữ liệu phân chia hành chính",
			"ptPt": "Importação de dados de divisões administrativas"
		},
		{
			"textKey": "areaDataDebuger",
			"classify": "tips",
			"zhCn": "行政区划数据调试",
			"zhTw": "行政區劃數據調試",
			"enUs": "Administrative Division Data Debugging",
			"thTh": "การดีบักข้อมูลการแบ่งเขตการปกครอง",
			"idId": "Debugging data divisi administrasi",
			"esMx": "Depuración de datos de división administrativa",
			"viVi": "Gỡ lỗi dữ liệu phân chia hành chính",
			"ptPt": "Depuração de dados da divisão administrativa"
		},
		{
			"textKey": "plzSelectArea",
			"classify": "tips",
			"zhCn": "请先选择一项区划",
			"zhTw": "請先選擇一項區劃",
			"enUs": "Please select a zone first",
			"thTh": "โปรดเลือกการแบ่งเขตก่อน",
			"idId": "Silakan pilih zonasi terlebih dahulu",
			"esMx": "Primero seleccione una división",
			"viVi": "Vui lòng chọn một khu vực trước",
			"ptPt": "Escolha uma divisão primeiro"
		},
		{
			"textKey": "dataDelete",
			"classify": "tips",
			"zhCn": "数据删除",
			"zhTw": "數據刪除",
			"enUs": "Data deletion",
			"thTh": "การลบข้อมูล",
			"idId": "Penghapusan data",
			"esMx": "Eliminación de datos",
			"viVi": "Xóa dữ liệu",
			"ptPt": "Delete de dados"
		},
		{
			"textKey": "confirmTo",
			"classify": "tips",
			"zhCn": "确定将",
			"zhTw": "確定將",
			"enUs": "Determined to be",
			"thTh": "ตกลงที่จะ",
			"idId": "Penentuan akan",
			"esMx": "Determinar",
			"viVi": "Xác định",
			"ptPt": "A determinação será"
		},
		{
			"textKey": "tips",
			"classify": "label",
			"zhCn": "提示",
			"zhTw": "提示",
			"enUs": "Prompt",
			"thTh": "เคล็ดลับ",
			"idId": "Tips",
			"esMx": "Consejos",
			"viVi": "Mẹo",
			"ptPt": "Dicas"
		},
		{
			"textKey": "confirmExportAreaData",
			"classify": "tips",
			"zhCn": "是否导出行政区划数据?",
			"zhTw": "是否導出行政區劃數據?",
			"enUs": "Export administrative division data?",
			"thTh": "คุณส่งออกข้อมูลการแบ่งเขตการปกครองหรือไม่?",
			"idId": "Apakah Anda mengekspor data pembagian administrasi?",
			"esMx": "¿Se exportan los datos de la división administrativa?",
			"viVi": "Có xuất dữ liệu phân chia hành chính không?",
			"ptPt": "Os dados da divisão administrativa são exportados?"
		},
		{
			"textKey": "areaData",
			"classify": "tips",
			"zhCn": "行政区划数据",
			"zhTw": "行政區劃數據",
			"enUs": "Administrative Division Data",
			"thTh": "ข้อมูลการแบ่งเขตการปกครอง",
			"idId": "Data pembagian administrasi",
			"esMx": "Datos de división administrativa",
			"viVi": "Dữ liệu phân chia hành chính",
			"ptPt": "Dados da divisão administrativa"
		},
		{
			"textKey": "areaTemplate",
			"classify": "tips",
			"zhCn": "行政区划模板",
			"zhTw": "行政區劃模板",
			"enUs": "Administrative Division Template",
			"thTh": "แม่แบบการแบ่งเขตการปกครอง",
			"idId": "Template pembagian administrasi",
			"esMx": "Plantilla de división administrativa",
			"viVi": "Mẫu phân chia hành chính",
			"ptPt": "Modelo de divisão administrativa"
		},
		{
			"textKey": "title",
			"classify": "tips",
			"zhCn": "标题",
			"zhTw": "標題",
			"enUs": "Title",
			"thTh": "ชื่อเรื่อง",
			"idId": "Judul",
			"esMx": "Título",
			"viVi": "Tiêu đề",
			"ptPt": "Título"
		},
		{
			"textKey": "inputSuperiorAreaNum",
			"classify": "tips",
			"zhCn": "请输入父区划编号",
			"zhTw": "請輸入父區劃編號",
			"enUs": "Please enter parent zone number",
			"thTh": "โปรดป้อนหมายเลขพาเรนต์",
			"idId": "Masukkan nomor divisi induk",
			"esMx": "Ingrese el número de división principal",
			"viVi": "Vui lòng nhập số phân vùng cha",
			"ptPt": "Por favor, insira o número da divisão pai"
		},
		{
			"textKey": "templateUpload",
			"classify": "label",
			"zhCn": "模板上传",
			"zhTw": "模板上傳",
			"enUs": "Template Upload",
			"thTh": "อัปโหลดเทมเพลต",
			"idId": "Unggah template",
			"esMx": "Carga de plantilla",
			"viVi": "Tải lên mẫu",
			"ptPt": "Upload de modelo"
		},
		{
			"textKey": "templateUploading",
			"classify": "tips",
			"zhCn": "模板上传中，请稍等",
			"zhTw": "模板上傳中,請稍等",
			"enUs": "Please wait while the template is being uploaded.",
			"thTh": "กำลังอัปโหลดเทมเพลตโปรดรอสักครู่",
			"idId": "Silakan tunggu dalam template upload",
			"esMx": "Cargue la plantilla, espere",
			"viVi": "Mẫu đang được tải lên, vui lòng đợi",
			"ptPt": "Faça o upload do modelo, espere um pouco"
		},
		{
			"textKey": "plzUpload",
			"classify": "tips",
			"zhCn": "请上传",
			"zhTw": "請上傳",
			"enUs": "Please upload",
			"thTh": "กรุณาอัปโหลด",
			"idId": "Silahkan upload",
			"esMx": "Por favor sube",
			"viVi": "Vui lòng tải lên",
			"ptPt": "Faça o upload"
		},
		{
			"textKey": "standarFile",
			"classify": "tips",
			"zhCn": "标准格式文件",
			"zhTw": "標準格式文件",
			"enUs": "standard format file",
			"thTh": "ไฟล์รูปแบบมาตรฐาน",
			"idId": "File format standar",
			"esMx": "Archivo de formato estándar",
			"viVi": "Tập tin định dạng chuẩn",
			"ptPt": "Arquivos de formato padrão"
		},
		{
			"textKey": "dataCover",
			"classify": "tips",
			"zhCn": "数据覆盖",
			"zhTw": "數據覆蓋",
			"enUs": "Data Overwrite",
			"thTh": "ความครอบคลุมของข้อมูล",
			"idId": "Cakupan data",
			"esMx": "Cobertura de datos",
			"viVi": "Bảo hiểm dữ liệu",
			"ptPt": "Sobreposições de dados"
		},
		{
			"textKey": "plzSelectIfCover",
			"classify": "tips",
			"zhCn": "请选择是否覆盖",
			"zhTw": "請選擇是否覆蓋",
			"enUs": "Please choose whether to overwrite",
			"thTh": "โปรดเลือกว่าจะเขียนทับหรือไม่",
			"idId": "Silakan pilih apakah akan mencakup",
			"esMx": "Seleccione si desea cubrir",
			"viVi": "Vui lòng chọn có ghi đè hay không",
			"ptPt": "Por favor, escolha se quer cobrir"
		},
		{
			"textKey": "templateDownload",
			"classify": "tips",
			"zhCn": "模板下载",
			"zhTw": "模板下載",
			"enUs": "Template Download",
			"thTh": "ดาวน์โหลดแม่แบบ",
			"idId": "Download Template",
			"esMx": "Descarga de la plantilla",
			"viVi": "Tải xuống mẫu",
			"ptPt": "Download do modelo"
		},
		{
			"textKey": "province",
			"classify": "label",
			"zhCn": "省份",
			"zhTw": "省份",
			"enUs": "Provinces",
			"thTh": "จังหวัด",
			"idId": "Provinsi",
			"esMx": "Provincia",
			"viVi": "Tỉnh",
			"ptPt": "Províncias"
		},
		{
			"textKey": "city",
			"classify": "label",
			"zhCn": "地市",
			"zhTw": "地市",
			"enUs": "City",
			"thTh": "เมือง",
			"idId": "Kota",
			"esMx": "Ciudad",
			"viVi": "Thành phố",
			"ptPt": "Prefeitura e cidade"
		},
		{
			"textKey": "district",
			"classify": "label",
			"zhCn": "区县",
			"zhTw": "區縣",
			"enUs": "Districts and counties",
			"thTh": "อำเภอและมณฑล",
			"idId": "Kabupaten/kota",
			"esMx": "Distrito y condado",
			"viVi": "Quận/huyện",
			"ptPt": "Distritos e condados"
		},
		{
			"textKey": "plzInput",
			"classify": "tips",
			"zhCn": "请输入",
			"zhTw": "請輸入",
			"enUs": "Please enter",
			"thTh": "กรุณาใส่",
			"idId": "Silakan masukkan",
			"esMx": "Por favor ingrese",
			"viVi": "Vui lòng nhập",
			"ptPt": "Por favor, insira"
		},
		{
			"textKey": "itemName",
			"classify": "table",
			"zhCn": "数据项名称",
			"zhTw": "數據項名稱",
			"enUs": "Data Item Name",
			"thTh": "ชื่อรายการข้อมูล",
			"idId": "Nama Item Data",
			"esMx": "Nombre del elemento de datos",
			"viVi": "Tên mục dữ liệu",
			"ptPt": "Nome do item de dados"
		},
		{
			"textKey": "projectTree",
			"classify": "label",
			"zhCn": "项目树",
			"zhTw": "項目樹",
			"enUs": "Project Tree",
			"thTh": "โครงการต้นไม้",
			"idId": "Pohon Proyek",
			"esMx": "Árbol de proyectos",
			"viVi": "Cây dự án",
			"ptPt": "Árvore do projeto"
		},
		{
			"textKey": "parentProject",
			"classify": "label",
			"zhCn": "父级项目",
			"zhTw": "父級項目",
			"enUs": "Parent Project",
			"thTh": "โครงการระดับพ่อ",
			"idId": "Proyek Induk",
			"esMx": "Proyecto principal",
			"viVi": "Dự án cha",
			"ptPt": "Projeto pai"
		},
		{
			"textKey": "inputParentProjectName",
			"classify": "tips",
			"zhCn": "请输入父项目名称",
			"zhTw": "請輸入父項目名稱",
			"enUs": "Please enter a parent project name",
			"thTh": "โปรดป้อนชื่อโครงการหลัก",
			"idId": "Masukkan nama proyek induk",
			"esMx": "Ingrese el nombre del proyecto principal",
			"viVi": "Vui lòng nhập tên dự án cha",
			"ptPt": "Insira o nome do projeto pai"
		},
		{
			"textKey": "close",
			"classify": "btn",
			"zhCn": "关闭",
			"zhTw": "關閉",
			"enUs": "Close",
			"thTh": "ปิด",
			"idId": "Tutup",
			"esMx": "Cerrar",
			"viVi": "Đóng cửa",
			"ptPt": "Fechar"
		},
		{
			"textKey": "hour",
			"classify": "option",
			"zhCn": "小时",
			"zhTw": "小時",
			"enUs": "Hours",
			"thTh": "ชั่วโมง",
			"idId": "Jam",
			"esMx": "Horas",
			"viVi": "Giờ",
			"ptPt": "Horas"
		},
		{
			"textKey": "category",
			"classify": "label",
			"zhCn": "分类名称",
			"zhTw": "分類名稱",
			"enUs": "Category Name",
			"thTh": "ชื่อหมวดหมู่",
			"idId": "Nama Kategori",
			"esMx": "Nombre de la categoría",
			"viVi": "Tên phân loại",
			"ptPt": "Nome da classificação"
		},
		{
			"textKey": "inputCategory",
			"classify": "tips",
			"zhCn": "请输入分类名称",
			"zhTw": "請輸入分類名稱",
			"enUs": "Please enter a classification name",
			"thTh": "โปรดป้อนชื่อหมวดหมู่",
			"idId": "Silakan masukkan nama kategori",
			"esMx": "Introduzca el nombre de la categoría",
			"viVi": "Vui lòng nhập tên danh mục",
			"ptPt": "Por favor, insira o nome da classificação"
		},
		{
			"textKey": "plzSelectOrg",
			"classify": "tips",
			"zhCn": "请选择所属机构",
			"zhTw": "請選擇所屬機構",
			"enUs": "Please select your organization",
			"thTh": "โปรดเลือกองค์กรของคุณ",
			"idId": "Silakan pilih institusi",
			"esMx": "Seleccione su organización",
			"viVi": "Vui lòng chọn tổ chức",
			"ptPt": "Escolha a sua instituição"
		},
		{
			"textKey": "viewData",
			"classify": "tips",
			"zhCn": "查看数据",
			"zhTw": "查看數據",
			"enUs": "View data",
			"thTh": "ดูข้อมูล",
			"idId": "Melihat data",
			"esMx": "Ver datos",
			"viVi": "Xem dữ liệu",
			"ptPt": "Visualização de dados"
		},
		{
			"textKey": "saveImage",
			"classify": "tips",
			"zhCn": "保存图片",
			"zhTw": "保存圖片",
			"enUs": "Save Picture",
			"thTh": "บันทึกภาพ",
			"idId": "Menyimpan gambar",
			"esMx": "Guardar una imagen",
			"viVi": "Lưu hình ảnh",
			"ptPt": "Salvar a imagem"
		},
		{
			"textKey": "plzInputRemark",
			"classify": "tips",
			"zhCn": "请输入备注",
			"zhTw": "請輸入備註",
			"enUs": "Please enter comments",
			"thTh": "กรุณากรอกหมายเหตุ",
			"idId": "Silakan masukkan catatan",
			"esMx": "Por favor ingrese las notas",
			"viVi": "Vui lòng nhập ghi chú",
			"ptPt": "Por favor, insira comentários"
		},
		{
			"textKey": "plzSelectSuppperiorRole",
			"classify": "tips",
			"zhCn": "请选择上级角色",
			"zhTw": "請選擇上級角色",
			"enUs": "Please select a superior role",
			"thTh": "โปรดเลือกบทบาทที่เหนือกว่า",
			"idId": "Silakan pilih karakter superior",
			"esMx": "Seleccione el rol superior",
			"viVi": "Vui lòng chọn vai trò cấp trên",
			"ptPt": "Por favor, escolha a função superior"
		},
		{
			"textKey": "plzInputServiceArea",
			"classify": "tips",
			"zhCn": "请输入服务区域",
			"zhTw": "請輸入服務區域",
			"enUs": "Please enter a service area",
			"thTh": "กรุณากรอกพื้นที่ให้บริการ",
			"idId": "Silakan masukkan area layanan",
			"esMx": "Introduzca el área de servicio",
			"viVi": "Vui lòng nhập khu vực dịch vụ",
			"ptPt": "Por favor, insira a área de serviço"
		},
		{
			"textKey": "plzInputInstallAddr",
			"classify": "tips",
			"zhCn": "请输入安装地址",
			"zhTw": "請輸入安裝地址",
			"enUs": "Please enter the installation address",
			"thTh": "โปรดป้อนที่อยู่การติดตั้ง",
			"idId": "Silakan masukkan alamat instalasi",
			"esMx": "Ingrese la dirección de instalación",
			"viVi": "Vui lòng nhập địa chỉ cài đặt",
			"ptPt": "Por favor, insira o endereço de instalação"
		},
		{
			"textKey": "plzInputArea",
			"classify": "tips",
			"zhCn": "请输入面积",
			"zhTw": "請輸入面積",
			"enUs": "Please enter area",
			"thTh": "กรุณาใส่พื้นที่",
			"idId": "Silakan masukkan area",
			"esMx": "Por favor ingrese el área",
			"viVi": "Vui lòng nhập khu vực",
			"ptPt": "Por favor, insira a área"
		},
		{
			"textKey": "plzInputDeviceName",
			"classify": "tips",
			"zhCn": "请输入设备名称",
			"zhTw": "請輸入設備名稱",
			"enUs": "Please enter a device name",
			"thTh": "กรุณาใส่ชื่ออุปกรณ์",
			"idId": "Masukkan nama perangkat",
			"esMx": "Introduzca el nombre del dispositivo",
			"viVi": "Vui lòng nhập tên thiết bị",
			"ptPt": "Por favor, insira o nome do dispositivo"
		},
		{
			"textKey": "plzInputAssetType",
			"classify": "tips",
			"zhCn": "选择资产类别",
			"zhTw": "選擇資產類別",
			"enUs": "Select Asset Category",
			"thTh": "เลือกประเภทสินทรัพย์",
			"idId": "Pilih kategori aset",
			"esMx": "Seleccionar una clase de activos",
			"viVi": "Chọn loại tài sản",
			"ptPt": "Selecionar uma classe de ativos"
		},
		{
			"textKey": "ifConfirmDelete",
			"classify": "tips",
			"zhCn": "确定将选择数据删除?",
			"zhTw": "確定將選擇數據刪除?",
			"enUs": "Are you sure you will select Data Delete?",
			"thTh": "แน่ใจว่าข้อมูลจะถูกลบเลือก?",
			"idId": "Menentukan bahwa data yang dipilih akan dihapus?",
			"esMx": "¿Estás seguro de que se eliminarán los datos seleccionados?",
			"viVi": "Chắc chắn sẽ chọn xóa dữ liệu?",
			"ptPt": "Determina que os dados selecionados serão excluídos?"
		},
		{
			"textKey": "onlyCanSelectOne",
			"classify": "tips",
			"zhCn": "只能选择一条数据",
			"zhTw": "只能選擇一條數據",
			"enUs": "Only one piece of data can be selected",
			"thTh": "เลือกได้เพียงข้อมูลเดียว",
			"idId": "Hanya satu data yang dapat dipilih",
			"esMx": "Solo se puede seleccionar un dato",
			"viVi": "Chỉ có thể chọn một dữ liệu",
			"ptPt": "Apenas um dado pode ser selecionado"
		},
		{
			"textKey": "plzSelectOne",
			"classify": "tips",
			"zhCn": "请选择至少一条数据",
			"zhTw": "請選擇至少一條數據",
			"enUs": "Please select at least one piece of data",
			"thTh": "โปรดเลือกอย่างน้อยหนึ่งข้อมูล",
			"idId": "Silakan pilih setidaknya satu data",
			"esMx": "Seleccione al menos un dato",
			"viVi": "Vui lòng chọn ít nhất một dữ liệu",
			"ptPt": "Escolha pelo menos um dado"
		},
		{
			"textKey": "refresh",
			"classify": "btn",
			"zhCn": "刷新",
			"zhTw": "刷新",
			"enUs": "Refresh",
			"thTh": "รีเฟรช",
			"idId": "Menyegarkan",
			"esMx": "Actualizar",
			"viVi": "Làm mới",
			"ptPt": "Atualizar"
		},
		{
			"textKey": "cantSelectSuperiorDept",
			"classify": "tips",
			"zhCn": "不能选择上级机构",
			"zhTw": "不能選擇上級機構",
			"enUs": "Cannot select parent body",
			"thTh": "ไม่สามารถเลือกสถาบันที่เหนือกว่าได้",
			"idId": "Tidak bisa memilih lembaga induk",
			"esMx": "No se puede elegir una institución superior",
			"viVi": "Không thể chọn cơ quan cấp trên",
			"ptPt": "Não é possível escolher uma instituição superior"
		},
		{
			"textKey": "personalInfo",
			"classify": "label",
			"zhCn": "个人信息",
			"zhTw": "個人信息",
			"enUs": "Personal Information",
			"thTh": "ข้อมูลส่วนบุคคล",
			"idId": "Informasi pribadi",
			"esMx": "Información personal",
			"viVi": "Thông tin cá nhân",
			"ptPt": "Informações pessoais"
		},
		{
			"textKey": "avatar",
			"classify": "label",
			"zhCn": "头像",
			"zhTw": "頭像",
			"enUs": "Avatar",
			"thTh": "อวตาร",
			"idId": "Avatar",
			"esMx": "Avatar",
			"viVi": "Hình đại diện",
			"ptPt": "Avatar"
		},
		{
			"textKey": "fullName",
			"classify": "label",
			"zhCn": "姓名",
			"zhTw": "姓名",
			"enUs": "Name",
			"thTh": "ชื่อ",
			"idId": "Nama",
			"esMx": "Nombre",
			"viVi": "Tên",
			"ptPt": "Nome"
		},
		{
			"textKey": "changePassword",
			"classify": "label",
			"zhCn": "修改密码",
			"zhTw": "修改密碼",
			"enUs": "Change Password",
			"thTh": "เปลี่ยนรหัสผ่าน",
			"idId": "Ubah kata sandi",
			"esMx": "Modificar la contraseña",
			"viVi": "Sửa đổi mật khẩu",
			"ptPt": "Modificar a senha"
		},
		{
			"textKey": "originPassword",
			"classify": "label",
			"zhCn": "原密码",
			"zhTw": "原密碼",
			"enUs": "Original password",
			"thTh": "รหัสผ่านเดิม",
			"idId": "Kata sandi asli",
			"esMx": "Contraseña original",
			"viVi": "Mật khẩu gốc",
			"ptPt": "A senha original"
		},
		{
			"textKey": "newPassword",
			"classify": "label",
			"zhCn": "新密码",
			"zhTw": "新密碼",
			"enUs": "New Password",
			"thTh": "รหัสผ่านใหม่",
			"idId": "Kata sandi baru",
			"esMx": "Nueva contraseña",
			"viVi": "Mật khẩu mới",
			"ptPt": "Nova senha"
		},
		{
			"textKey": "onlyAllowImageType",
			"classify": "tips",
			"zhCn": "只能上传jpg/png用户头像，且不超过500kb",
			"zhTw": "只能上傳jpg/png用戶頭像,且不超過500kb",
			"enUs": "Only jpg/png user avatars can be uploaded, and the avatars are no more than 500kb",
			"thTh": "อัปโหลดได้เฉพาะอวตารของผู้ใช้ JP/png และไม่เกิน500kb",
			"idId": "Hanya dapat meng-upload avatar pengguna jpg/png, dan tidak lebih dari 500kb",
			"esMx": "Solo puede cargar avatares de usuario jpg/png y no más de 500kb",
			"viVi": "Chỉ có thể tải lên hình đại diện người dùng jpg/png và không quá 500kb",
			"ptPt": "Somente o avatar do usuário jpg/png pode ser carregado e não deve exceder 500kb"
		},
		{
			"textKey": "menuConfig",
			"classify": "btn",
			"zhCn": "菜单配置",
			"zhTw": "菜單配置",
			"enUs": "Menu Configuration",
			"thTh": "การกำหนดค่าเมนู",
			"idId": "Konfigurasi menu",
			"esMx": "Configuración del menú",
			"viVi": "Cấu hình menu",
			"ptPt": "Configuração do menu"
		},
		{
			"textKey": "plzInputName",
			"classify": "tips",
			"zhCn": "请输入姓名",
			"zhTw": "請輸入姓名",
			"enUs": "Please enter a name",
			"thTh": "กรุณาใส่ชื่อ",
			"idId": "Silakan masukkan nama",
			"esMx": "Por favor ingrese el nombre",
			"viVi": "Vui lòng nhập tên",
			"ptPt": "Por favor, insira um nome"
		},
		{
			"textKey": "onlyCanUploadPngJpg",
			"classify": "tips",
			"zhCn": "只能上传jpg/png用户头像",
			"zhTw": "只能上傳jpg/png用戶頭像",
			"enUs": "Only jpg/png user avatars can be uploaded",
			"thTh": "อัปโหลดได้เฉพาะอวตารของผู้ใช้ JP/png",
			"idId": "Hanya dapat meng-upload avatar pengguna jpg/png",
			"esMx": "Solo puede cargar avatares de usuario jpg/png",
			"viVi": "Chỉ có thể tải lên hình đại diện người dùng jpg/png",
			"ptPt": "Somente o avatar do usuário jpg/png pode ser carregado"
		},
		{
			"textKey": "limitFiveHundredK",
			"classify": "tips",
			"zhCn": "不能超过500kb",
			"zhTw": "不能超過500kb",
			"enUs": "cannot exceed 500kb",
			"thTh": "ไม่เกิน500kb",
			"idId": "Tidak lebih dari 500kb",
			"esMx": "No más de 500kb",
			"viVi": "Không thể vượt quá 500kb",
			"ptPt": "Não pode exceder 500kb"
		},
		{
			"textKey": "plzInputCurrentPassword",
			"classify": "tips",
			"zhCn": "请输入当前密码",
			"zhTw": "請輸入當前密碼",
			"enUs": "Please enter the current password",
			"thTh": "โปรดป้อนรหัสผ่านปัจจุบัน",
			"idId": "Masukkan kata sandi saat ini",
			"esMx": "Ingrese la contraseña actual",
			"viVi": "Vui lòng nhập mật khẩu hiện tại",
			"ptPt": "Por favor, insira a senha atual"
		},
		{
			"textKey": "plzInputNewPassword",
			"classify": "tips",
			"zhCn": "请输入新密码",
			"zhTw": "請輸入新密碼",
			"enUs": "Please enter a new password",
			"thTh": "โปรดป้อนรหัสผ่านใหม่",
			"idId": "Masukkan kata sandi baru",
			"esMx": "Introduzca una nueva contraseña",
			"viVi": "Vui lòng nhập mật khẩu mới",
			"ptPt": "Por favor, digite uma nova senha"
		},
		{
			"textKey": "limit6to20character",
			"classify": "tips",
			"zhCn": "长度在 6 到 20 个字符",
			"zhTw": "長度在 6 到 20 個字符",
			"enUs": "6 to 20 characters in length",
			"thTh": "ความยาวตั้งแต่6ถึง20ตัวอักษร",
			"idId": "Panjang dalam 6 sampai 20 karakter",
			"esMx": "Longitud de 6 a 20 caracteres",
			"viVi": "Chiều dài từ 6 đến 20 ký tự",
			"ptPt": "Comprimento de 6 a 20 caracteres"
		},
		{
			"textKey": "plzInputNewPasswordAgain",
			"classify": "tips",
			"zhCn": "请再次输入新密码",
			"zhTw": "請再次輸入新密碼",
			"enUs": "Please enter the new password again",
			"thTh": "โปรดป้อนรหัสผ่านใหม่อีกครั้ง",
			"idId": "Silakan masukkan kata sandi baru lagi",
			"esMx": "Introduzca la nueva contraseña de nuevo",
			"viVi": "Vui lòng nhập lại mật khẩu mới",
			"ptPt": "Por favor, digite a nova senha novamente"
		},
		{
			"textKey": "plzSelectRegion",
			"classify": "tips",
			"zhCn": "请选择区域",
			"zhTw": "請選擇區域",
			"enUs": "Please select a region",
			"thTh": "โปรดเลือกพื้นที่",
			"idId": "Silakan pilih area",
			"esMx": "Por favor seleccione el área",
			"viVi": "Vui lòng chọn khu vực",
			"ptPt": "Por favor, escolha uma área"
		},
		{
			"textKey": "plzInputFilterText",
			"classify": "tips",
			"zhCn": "请输入关键字进行过滤",
			"zhTw": "請輸入關鍵字進行過濾",
			"enUs": "Please enter keywords to filter",
			"thTh": "โปรดป้อนคำสำคัญเพื่อกรอง",
			"idId": "Silahkan masukkan kata kunci untuk memfilter",
			"esMx": "Ingrese palabras clave para filtrar",
			"viVi": "Vui lòng nhập từ khóa để lọc",
			"ptPt": "Por favor, insira palavras-chave para filtrar"
		},
		{
			"textKey": "alarmManage",
			"classify": "tips",
			"zhCn": "告警管理",
			"zhTw": "告警管理",
			"enUs": "alarm management",
			"thTh": "การจัดการการเตือน",
			"idId": "Manajemen alarm",
			"esMx": "Gestión de alarmas",
			"viVi": "Quản lý cảnh báo",
			"ptPt": "Gestão de Alerta"
		},
		{
			"textKey": "createUser",
			"classify": "label",
			"zhCn": "创建人",
			"zhTw": "創建人",
			"enUs": "Creator",
			"thTh": "ผู้สร้าง",
			"idId": "Pencipta orang",
			"esMx": "Creador",
			"viVi": "Người sáng tạo",
			"ptPt": "O criador"
		},
		{
			"textKey": "createDept",
			"classify": "label",
			"zhCn": "创建部门",
			"zhTw": "創建部門",
			"enUs": "Create Department",
			"thTh": "สร้างแผนก",
			"idId": "Buat departemen",
			"esMx": "Creación de departamentos",
			"viVi": "Tạo bộ phận",
			"ptPt": "Criar um departamento"
		},
		{
			"textKey": "createTime",
			"classify": "label",
			"zhCn": "创建时间",
			"zhTw": "創建時間",
			"enUs": "Creation time",
			"thTh": "สร้างเวลา",
			"idId": "Waktu pembuatan",
			"esMx": "Hora de creación",
			"viVi": "Tạo thời gian",
			"ptPt": "Tempo de criação"
		},
		{
			"textKey": "updateUser",
			"classify": "label",
			"zhCn": "修改人",
			"zhTw": "修改人",
			"enUs": "Modified",
			"thTh": "คนแก้ไข",
			"idId": "Orang yang dimodifikasi",
			"esMx": "Modificar personas",
			"viVi": "Người sửa đổi",
			"ptPt": "Modificar a pessoa"
		},
		{
			"textKey": "updateTime",
			"classify": "label",
			"zhCn": "更新时间",
			"zhTw": "更新時間",
			"enUs": "Update time",
			"thTh": "แก้ไขเวลา",
			"idId": "Perbarui waktu",
			"esMx": "Tiempo de actualización",
			"viVi": "Thời gian sửa đổi",
			"ptPt": "Tempo de modificação"
		},
		{
			"textKey": "tenant",
			"classify": "label",
			"zhCn": "租户",
			"zhTw": "租戶",
			"enUs": "Tenant",
			"thTh": "ผู้เช่า",
			"idId": "Penyewa",
			"esMx": "Inquilino",
			"viVi": "Người thuê nhà",
			"ptPt": "Inquilino"
		},
		{
			"textKey": "ifDeleted",
			"classify": "label",
			"zhCn": "是否已删除",
			"zhTw": "是否已刪除",
			"enUs": "Deleted",
			"thTh": "ถูกลบหรือไม่",
			"idId": "Apakah sudah dihapus",
			"esMx": "Si se ha eliminado",
			"viVi": "Đã xóa chưa",
			"ptPt": "Se foi removido"
		},
		{
			"textKey": "alarming",
			"classify": "label",
			"zhCn": "状态告警中",
			"zhTw": "狀態告警中",
			"enUs": "Status alarm",
			"thTh": "สัญญาณเตือนสถานะ",
			"idId": "Peringatan negara",
			"esMx": "Alerta de estado",
			"viVi": "Cảnh báo trạng thái",
			"ptPt": "Alerta de estado"
		},
		{
			"textKey": "menuNum",
			"classify": "label",
			"zhCn": "菜单编号",
			"zhTw": "菜單編號",
			"enUs": "Menu Number",
			"thTh": "หมายเลขเมนู",
			"idId": "Nomor menu",
			"esMx": "Número de menú",
			"viVi": "Số menu",
			"ptPt": "Número do menu"
		},
		{
			"textKey": "menuName",
			"classify": "label",
			"zhCn": "菜单名称",
			"zhTw": "菜單名稱",
			"enUs": "Menu Name",
			"thTh": "ชื่อเมนู",
			"idId": "Nama menu",
			"esMx": "Nombre del menú",
			"viVi": "Tên thực đơn",
			"ptPt": "Nome do menu"
		},
		{
			"textKey": "plzInputMenuName",
			"classify": "tips",
			"zhCn": "请输入菜单名称",
			"zhTw": "請輸入菜單名稱",
			"enUs": "Please enter a menu name",
			"thTh": "กรุณาใส่ชื่อเมนู",
			"idId": "Silakan masukkan nama menu",
			"esMx": "Introduzca el nombre del menú",
			"viVi": "Vui lòng nhập tên menu",
			"ptPt": "Por favor, insira o nome do menu"
		},
		{
			"textKey": "interfaceConfig",
			"classify": "label",
			"zhCn": "接口权限配置",
			"zhTw": "接口權限配置",
			"enUs": "interface permission configuration",
			"thTh": "การกำหนดค่าสิทธิ์อินเทอร์เฟซ",
			"idId": "Konfigurasi izin antarmuka",
			"esMx": "Configuración de permisos de interfaz",
			"viVi": "Cấu hình quyền giao diện",
			"ptPt": "Configuração de permissões de interface"
		},
		{
			"textKey": "routeAddress",
			"classify": "label",
			"zhCn": "路由地址",
			"zhTw": "路由地址",
			"enUs": "Routing Address",
			"thTh": "ที่อยู่เส้นทาง",
			"idId": "Alamat rute",
			"esMx": "Dirección de enrutamiento",
			"viVi": "Địa chỉ định tuyến",
			"ptPt": "Endereço de roteamento"
		},
		{
			"textKey": "plzInputRouteAddress",
			"classify": "tips",
			"zhCn": "请输入路由地址",
			"zhTw": "請輸入路由地址",
			"enUs": "Please enter a routing address",
			"thTh": "โปรดป้อนที่อยู่เส้นทาง",
			"idId": "Silakan masukkan alamat rute",
			"esMx": "Ingrese la dirección de enrutamiento",
			"viVi": "Vui lòng nhập địa chỉ định tuyến",
			"ptPt": "Por favor, insira o endereço de roteamento"
		},
		{
			"textKey": "plzSelectSuperiorMenu",
			"classify": "tips",
			"zhCn": "请选择上级菜单",
			"zhTw": "請選擇上級菜單",
			"enUs": "Please select the superior menu",
			"thTh": "โปรดเลือกเมนูที่เหนือกว่า",
			"idId": "Silakan pilih menu superior",
			"esMx": "Seleccione el menú superior",
			"viVi": "Vui lòng chọn menu cao cấp",
			"ptPt": "Por favor, escolha o menu superior"
		},
		{
			"textKey": "menuIcon",
			"classify": "label",
			"zhCn": "菜单图标",
			"zhTw": "菜單圖標",
			"enUs": "Menu icon",
			"thTh": "ไอคอนเมนู",
			"idId": "Ikon menu",
			"esMx": "Icono de menú",
			"viVi": "Biểu tượng menu",
			"ptPt": "Ícone do menu"
		},
		{
			"textKey": "plzInputMenuIcon",
			"classify": "tips",
			"zhCn": "请输菜单图标",
			"zhTw": "請輸菜單圖標",
			"enUs": "Please enter the menu icon",
			"thTh": "กรุณาใส่ไอคอนเมนู",
			"idId": "Silakan masukkan ikon menu",
			"esMx": "Por favor, deje el icono del menú",
			"viVi": "Vui lòng nhập biểu tượng menu",
			"ptPt": "Por favor, perca o ícone do menu"
		},
		{
			"textKey": "plzInputMenuNum",
			"classify": "tips",
			"zhCn": "请输入菜单编号",
			"zhTw": "請輸入菜單編號",
			"enUs": "Please enter the menu number",
			"thTh": "โปรดป้อนหมายเลขเมนู",
			"idId": "Silakan masukkan nomor menu",
			"esMx": "Introduzca el número de menú",
			"viVi": "Vui lòng nhập số menu",
			"ptPt": "Por favor, insira o número do menu"
		},
		{
			"textKey": "plzSelectMenuType",
			"classify": "tips",
			"zhCn": "请选择菜单类型",
			"zhTw": "請選擇菜單類型",
			"enUs": "Please select a menu type",
			"thTh": "โปรดเลือกประเภทเมนู",
			"idId": "Silakan pilih jenis menu",
			"esMx": "Seleccione el tipo de menú",
			"viVi": "Vui lòng chọn loại menu",
			"ptPt": "Por favor, escolha o tipo de menu"
		},
		{
			"textKey": "menuAliaName",
			"classify": "label",
			"zhCn": "菜单别名",
			"zhTw": "菜單別名",
			"enUs": "Menu alias",
			"thTh": "นามแฝงเมนู",
			"idId": "Menu alias",
			"esMx": "Alias de menú",
			"viVi": "Bí danh menu",
			"ptPt": "Alias de menu"
		},
		{
			"textKey": "plzInputMenuAliaName",
			"classify": "tips",
			"zhCn": "请输入菜单别名",
			"zhTw": "請輸入菜單別名",
			"enUs": "Please enter a menu alias",
			"thTh": "โปรดป้อนนามแฝงของเมนู",
			"idId": "Silakan masukkan menu alias",
			"esMx": "Ingrese el alias del menú",
			"viVi": "Vui lòng nhập bí danh menu",
			"ptPt": "Por favor, insira um alias de menu"
		},
		{
			"textKey": "btnFunction",
			"classify": "label",
			"zhCn": "按钮功能",
			"zhTw": "按鈕功能",
			"enUs": "Button function",
			"thTh": "ฟังก์ชั่นปุ่ม",
			"idId": "Fungsi tombol",
			"esMx": "Función de botón",
			"viVi": "Chức năng nút",
			"ptPt": "Função de botão"
		},
		{
			"textKey": "toolBar",
			"classify": "label",
			"zhCn": "工具栏",
			"zhTw": "工具欄",
			"enUs": "Toolbar",
			"thTh": "แถบเครื่องมือ",
			"idId": "Bilah alat",
			"esMx": "Barra de herramientas",
			"viVi": "Thanh công cụ",
			"ptPt": "Barra de ferramentas"
		},
		{
			"textKey": "operationBar",
			"classify": "label",
			"zhCn": "操作栏",
			"zhTw": "操作欄",
			"enUs": "Action Bar",
			"thTh": "แถบการทำงาน",
			"idId": "Bilah operasi",
			"esMx": "Barra de operaciones",
			"viVi": "Thanh hoạt động",
			"ptPt": "Barra de operações"
		},
		{
			"textKey": "toolOperationBar",
			"classify": "label",
			"zhCn": "工具操作栏",
			"zhTw": "工具操作欄",
			"enUs": "Tool Operation Bar",
			"thTh": "แถบการทำงานของเครื่องมือ",
			"idId": "Bilah operasi alat",
			"esMx": "Barra de operación de herramientas",
			"viVi": "Thanh hoạt động công cụ",
			"ptPt": "Barra de operação da ferramenta"
		},
		{
			"textKey": "plzSelectBtnFunction",
			"classify": "tips",
			"zhCn": "请选择按钮功能",
			"zhTw": "請選擇按鈕功能",
			"enUs": "Please select button function",
			"thTh": "กรุณาเลือกฟังก์ชั่นปุ่ม",
			"idId": "Silakan pilih fungsi tombol",
			"esMx": "Seleccione la función de botón",
			"viVi": "Vui lòng chọn chức năng nút",
			"ptPt": "Por favor, selecione a função do botão"
		},
		{
			"textKey": "menuSort",
			"classify": "label",
			"zhCn": "菜单排序",
			"zhTw": "菜單排序",
			"enUs": "Menu Sort",
			"thTh": "การเรียงลำดับเมนู",
			"idId": "Penyortiran menu",
			"esMx": "Ordenar menú",
			"viVi": "Sắp xếp menu",
			"ptPt": "Classificação de menu"
		},
		{
			"textKey": "plzInputMenuSort",
			"classify": "tips",
			"zhCn": "请输入菜单排序",
			"zhTw": "請輸入菜單排序",
			"enUs": "Please enter menu sort",
			"thTh": "โปรดป้อนการเรียงลำดับเมนู",
			"idId": "Silakan masukkan pengurutan menu",
			"esMx": "Por favor ingrese el menú de clasificación",
			"viVi": "Vui lòng nhập trình đơn sắp xếp",
			"ptPt": "Por favor, insira o menu de classificação"
		},
		{
			"textKey": "newWindow",
			"classify": "label",
			"zhCn": "新窗口",
			"zhTw": "新窗口",
			"enUs": "New Window",
			"thTh": "หน้าต่างใหม่",
			"idId": "Jendela baru",
			"esMx": "Nueva ventana",
			"viVi": "Cửa sổ mới",
			"ptPt": "Nova janela"
		},
		{
			"textKey": "authName",
			"classify": "label",
			"zhCn": "权限名称",
			"zhTw": "權限名稱",
			"enUs": "Permission Name",
			"thTh": "ชื่อสิทธิ์",
			"idId": "Nama izin",
			"esMx": "Nombre de permiso",
			"viVi": "Tên quyền",
			"ptPt": "Nome da permissão"
		},
		{
			"textKey": "plzInputAuthName",
			"classify": "tips",
			"zhCn": "请输入权限名称",
			"zhTw": "請輸入權限名稱",
			"enUs": "Please enter permission name",
			"thTh": "โปรดป้อนชื่อสิทธิ์",
			"idId": "Masukkan nama izin",
			"esMx": "Por favor ingrese el nombre del permiso",
			"viVi": "Vui lòng nhập tên quyền",
			"ptPt": "Por favor, insira um nome de permissão"
		},
		{
			"textKey": "authNum",
			"classify": "label",
			"zhCn": "权限编号",
			"zhTw": "權限編號",
			"enUs": "Permission Number",
			"thTh": "หมายเลขสิทธิ์",
			"idId": "Nomor izin",
			"esMx": "Número de permiso",
			"viVi": "Số quyền",
			"ptPt": "Número de permissões"
		},
		{
			"textKey": "plzInputAuthNum",
			"classify": "tips",
			"zhCn": "请输入权限编号",
			"zhTw": "請輸入權限編號",
			"enUs": "Please enter permission number",
			"thTh": "โปรดป้อนหมายเลขสิทธิ์",
			"idId": "Masukkan nomor izin",
			"esMx": "Introduzca el número de permiso",
			"viVi": "Vui lòng nhập số quyền",
			"ptPt": "Por favor, insira o número de permissão"
		},
		{
			"textKey": "authPath",
			"classify": "label",
			"zhCn": "权限路径",
			"zhTw": "權限路徑",
			"enUs": "Permission Path",
			"thTh": "เส้นทางสิทธิ์",
			"idId": "Jalur Izin",
			"esMx": "Ruta de acceso",
			"viVi": "Đường dẫn quyền",
			"ptPt": "Caminho de permissões"
		},
		{
			"textKey": "plzInputAuthPath",
			"classify": "tips",
			"zhCn": "请输入权限路径",
			"zhTw": "請輸入權限路徑",
			"enUs": "Please enter permission path",
			"thTh": "โปรดป้อนเส้นทางการอนุญาต",
			"idId": "Silakan masukkan jalur izin",
			"esMx": "Ingrese la ruta de acceso",
			"viVi": "Vui lòng nhập đường dẫn quyền",
			"ptPt": "Por favor, insira o caminho de permissão"
		},
		{
			"textKey": "interfaceType",
			"classify": "label",
			"zhCn": "接口类型",
			"zhTw": "接口類型",
			"enUs": "Interface Type",
			"thTh": "ประเภทอินเทอร์เฟซ",
			"idId": "Tipe Antarmuka",
			"esMx": "Tipo de interfaz",
			"viVi": "Loại giao diện",
			"ptPt": "Tipo de interface"
		},
		{
			"textKey": "plzInputNoticeType",
			"classify": "tips",
			"zhCn": "请输入通知类型",
			"zhTw": "請輸入通知類型",
			"enUs": "Please enter a notification type",
			"thTh": "โปรดป้อนประเภทการแจ้งเตือน",
			"idId": "Masukkan jenis pemberitahuan",
			"esMx": "Introduzca el tipo de notificación",
			"viVi": "Vui lòng nhập loại thông báo",
			"ptPt": "Por favor, insira o tipo de notificação"
		},
		{
			"textKey": "userDataTabel",
			"classify": "tips",
			"zhCn": "用户数据表",
			"zhTw": "用戶數據表",
			"enUs": "User Data Table",
			"thTh": "เอกสารข้อมูลผู้ใช้",
			"idId": "Lembar Data Pengguna",
			"esMx": "Hoja de datos del usuario",
			"viVi": "Bảng dữ liệu người dùng",
			"ptPt": "Folha de dados do usuário"
		},
		{
			"textKey": "password",
			"classify": "label",
			"zhCn": "密码",
			"zhTw": "密碼",
			"enUs": "Password",
			"thTh": "รหัสผ่าน",
			"idId": "Kata sandi",
			"esMx": "Contraseña",
			"viVi": "Mật khẩu",
			"ptPt": "Senha"
		},
		{
			"textKey": "plzInputLinkAddress",
			"classify": "tips",
			"zhCn": "请输入连接地址",
			"zhTw": "請輸入連接地址",
			"enUs": "Please enter the connection address",
			"thTh": "โปรดป้อนที่อยู่การเชื่อมต่อ",
			"idId": "Masukkan alamat koneksi",
			"esMx": "Ingrese la dirección de conexión",
			"viVi": "Vui lòng nhập địa chỉ kết nối",
			"ptPt": "Por favor, insira o endereço de conexão"
		},
		{
			"textKey": "linkAddress",
			"classify": "label",
			"zhCn": "连接地址",
			"zhTw": "連接地址",
			"enUs": "Connection Address",
			"thTh": "ที่อยู่การเชื่อมต่อ",
			"idId": "Alamat koneksi",
			"esMx": "Dirección de conexión",
			"viVi": "Địa chỉ kết nối",
			"ptPt": "Endereço de conexão"
		},
		{
			"textKey": "dataType",
			"classify": "label",
			"zhCn": "数据类型",
			"zhTw": "數據類型",
			"enUs": "Data Type",
			"thTh": "ชนิดข้อมูล",
			"idId": "Tipe Data",
			"esMx": "Tipos de datos",
			"viVi": "Kiểu dữ liệu",
			"ptPt": "Tipo de dados"
		},
		{
			"textKey": "plzInputDataSourceName",
			"classify": "tips",
			"zhCn": "请输入数据源名称",
			"zhTw": "請輸入數據源名稱",
			"enUs": "Please enter a data source name",
			"thTh": "โปรดป้อนชื่อแหล่งข้อมูล",
			"idId": "Masukkan nama sumber data",
			"esMx": "Ingrese el nombre de la fuente de datos",
			"viVi": "Vui lòng nhập tên nguồn dữ liệu",
			"ptPt": "Insira o nome da fonte de dados"
		},
		{
			"textKey": "plzSelectType",
			"classify": "tips",
			"zhCn": "请选择类型",
			"zhTw": "請選擇類型",
			"enUs": "Please select type",
			"thTh": "โปรดเลือกหมวดหมู่",
			"idId": "Silakan pilih kategori",
			"esMx": "Por favor seleccione la categoría",
			"viVi": "Vui lòng chọn phân loại",
			"ptPt": "Por favor, escolha uma categoria"
		},
		{
			"textKey": "plzInputYaml",
			"classify": "tips",
			"zhCn": "请输入YAML配置",
			"zhTw": "請輸入YAML配置",
			"enUs": "Please enter YAML configuration",
			"thTh": "โปรดป้อนการกำหนดค่า YAML",
			"idId": "Masukkan konfigurasi YAML",
			"esMx": "Introduzca la configuración de YAML",
			"viVi": "Vui lòng nhập cấu hình YAML",
			"ptPt": "Por favor, insira a configuração YAML"
		},
		{
			"textKey": "driverType",
			"classify": "label",
			"zhCn": "驱动类",
			"zhTw": "驅動類",
			"enUs": "Driver Class",
			"thTh": "ไดรฟ์",
			"idId": "Kategori driver",
			"esMx": "Clase de unidad",
			"viVi": "Loại lái xe",
			"ptPt": "Classe de condução"
		},
		{
			"textKey": "plzInputDriverType",
			"classify": "tips",
			"zhCn": "请输入驱动类",
			"zhTw": "請輸入驅動類",
			"enUs": "Please enter driver class",
			"thTh": "โปรดป้อนคลาสไดรเวอร์",
			"idId": "Masukkan kategori driver",
			"esMx": "Ingrese la clase de controlador",
			"viVi": "Vui lòng nhập lớp trình điều khiển",
			"ptPt": "Por favor, insira a classe de driver"
		},
		{
			"textKey": "port",
			"classify": "label",
			"zhCn": "端口",
			"zhTw": "端口",
			"enUs": "Port",
			"thTh": "พอร์ต",
			"idId": "Pelabuhan",
			"esMx": "Puertos",
			"viVi": "Cổng",
			"ptPt": "Porta"
		},
		{
			"textKey": "account",
			"classify": "label",
			"zhCn": "账号",
			"zhTw": "賬號",
			"enUs": "Account Number",
			"thTh": "บัญชี",
			"idId": "Akun",
			"esMx": "Cuenta",
			"viVi": "Tài khoản",
			"ptPt": "Conta"
		},
		{
			"textKey": "belongToProject",
			"classify": "label",
			"zhCn": "所属项目",
			"zhTw": "所屬項目",
			"enUs": "Project",
			"thTh": "โครงการที่เป็นเจ้าของ",
			"idId": "Proyek",
			"esMx": "Proyecto de propiedad",
			"viVi": "Thuộc dự án",
			"ptPt": "Projetos afiliados"
		},
		{
			"textKey": "connectTimeout",
			"classify": "label",
			"zhCn": "通信超时(分)",
			"zhTw": "通信超時(分)",
			"enUs": "Communication timeout (min)",
			"thTh": "หมดเวลาการสื่อสาร (นาที)",
			"idId": "Waktu komunikasi (menit)",
			"esMx": "Tiempo de espera de comunicación (puntos)",
			"viVi": "Thời gian chờ giao tiếp (phút)",
			"ptPt": "Tempo limite de comunicação (pontos)"
		},
		{
			"textKey": "portAddress",
			"classify": "label",
			"zhCn": "串口地址",
			"zhTw": "串口地址",
			"enUs": "Serial port address",
			"thTh": "ที่อยู่พอร์ตอนุกรม",
			"idId": "Alamat port serial",
			"esMx": "Dirección del puerto serie",
			"viVi": "Địa chỉ cổng nối tiếp",
			"ptPt": "Endereço da porta serial"
		},
		{
			"textKey": "deviceInfo",
			"classify": "label",
			"zhCn": "设备信息",
			"zhTw": "設備信息",
			"enUs": "Device Information",
			"thTh": "ข้อมูลอุปกรณ์",
			"idId": "Informasi perangkat",
			"esMx": "Información del dispositivo",
			"viVi": "Thông tin thiết bị",
			"ptPt": "Informações do dispositivo"
		},
		{
			"textKey": "measurePoint",
			"classify": "label",
			"zhCn": "测量点",
			"zhTw": "測量點",
			"enUs": "Measuring point",
			"thTh": "จุดวัด",
			"idId": "Titik pengukuran",
			"esMx": "Puntos de medición",
			"viVi": "Điểm đo",
			"ptPt": "Ponto de medição"
		},
		{
			"textKey": "realTimeValue",
			"classify": "label",
			"zhCn": "实时值",
			"zhTw": "實時值",
			"enUs": "Real-time value",
			"thTh": "ค่าเรียลไทม์",
			"idId": "Nilai waktu nyata",
			"esMx": "Valor en tiempo real",
			"viVi": "Giá trị thời gian thực",
			"ptPt": "Valores em tempo real"
		},
		{
			"textKey": "config",
			"classify": "label",
			"zhCn": "配置",
			"zhTw": "配置",
			"enUs": "Configuration",
			"thTh": "การกำหนดค่า",
			"idId": "Konfigurasi",
			"esMx": "Configuración",
			"viVi": "Cấu hình",
			"ptPt": "Configuração"
		},
		{
			"textKey": "userPlatform",
			"classify": "label",
			"zhCn": "用户平台",
			"zhTw": "用戶平台",
			"enUs": "User Platform",
			"thTh": "แพลตฟอร์มผู้ใช้",
			"idId": "Platform pengguna",
			"esMx": "Plataforma de usuario",
			"viVi": "Nền tảng người dùng",
			"ptPt": "Plataforma do usuário"
		},
		{
			"textKey": "configSucceed",
			"classify": "tips",
			"zhCn": "配置成功!",
			"zhTw": "配置成功!",
			"enUs": "Configuration succeeded!",
			"thTh": "การกำหนดค่าสำเร็จ!",
			"idId": "Konfigurasi berhasil!",
			"esMx": "¡La configuración es exitosa!",
			"viVi": "Cấu hình thành công!",
			"ptPt": "A configuração foi bem sucedida!"
		},
		{
			"textKey": "operation",
			"classify": "label",
			"zhCn": "操作",
			"zhTw": "操作",
			"enUs": "Operation",
			"thTh": "การดำเนินงาน",
			"idId": "Operasi",
			"esMx": "Operación",
			"viVi": "Hoạt động",
			"ptPt": "Operação"
		},
		{
			"textKey": "systemBackground",
			"classify": "label",
			"zhCn": "系统背景",
			"zhTw": "系統背景",
			"enUs": "System Background",
			"thTh": "พื้นหลังของระบบ",
			"idId": "Latar belakang sistem",
			"esMx": "Antecedentes del sistema",
			"viVi": "Nền hệ thống",
			"ptPt": "Fundo do sistema"
		},
		{
			"textKey": "expireTime",
			"classify": "label",
			"zhCn": "过期时间",
			"zhTw": "過期時間",
			"enUs": "Expiration Time",
			"thTh": "เวลาหมดอายุ",
			"idId": "Waktu kedaluwarsa",
			"esMx": "Tiempo de caducidad",
			"viVi": "Thời gian hết hạn",
			"ptPt": "Tempo de expiração"
		},
		{
			"textKey": "accountAmount",
			"classify": "label",
			"zhCn": "账号额度",
			"zhTw": "賬號額度",
			"enUs": "Account Quota",
			"thTh": "วงเงินบัญชี",
			"idId": "Jumlah akun",
			"esMx": "Cuota de cuenta",
			"viVi": "Hạn mức tài khoản",
			"ptPt": "Limite de conta"
		},
		{
			"textKey": "menuPreview",
			"classify": "label",
			"zhCn": "菜单预览",
			"zhTw": "菜單預覽",
			"enUs": "Menu Preview",
			"thTh": "ตัวอย่างเมนู",
			"idId": "Pratinjau menu",
			"esMx": "Vista previa del menú",
			"viVi": "Xem trước menu",
			"ptPt": "Pré-visualização do menu"
		},
		{
			"textKey": "ifConfirmDeleteTenant",
			"classify": "tips",
			"zhCn": "确定将所选租户永久删除?",
			"zhTw": "確定將所選租戶永久刪除?",
			"enUs": "The selected tenant will enter the Recycle Bin after deletion. Continue?",
			"thTh": "แน่ใจว่าจะลบผู้เช่าที่เลือกอย่างถาวร?",
			"idId": "Setelah dihapus, penyewa yang dipilih akan memasuki tempat sampah. Apakah akan melanjutkan?",
			"esMx": "¿Estás seguro de que el inquilino seleccionado se eliminará permanentemente?",
			"viVi": "Sau khi xóa, người thuê được chọn sẽ vào thùng rác. Nó có tiếp tục không?",
			"ptPt": "Determinada a exclusão permanente do inquilino selecionado?"
		},
		{
			"textKey": "unLimit",
			"classify": "tips",
			"zhCn": "不限制",
			"zhTw": "不限制",
			"enUs": "No restrictions",
			"thTh": "ไม่จำกัด",
			"idId": "Tidak ada batasan",
			"esMx": "Sin restricciones",
			"viVi": "Không giới hạn",
			"ptPt": "Sem restrições"
		},
		{
			"textKey": "ifConfirmRecoverTenant",
			"classify": "tips",
			"zhCn": "确定将所选租户进行恢复?",
			"zhTw": "確定將所選租戶進行恢復?",
			"enUs": "Are you sure you want to restore the selected tenant?",
			"thTh": "แน่ใจว่าผู้เช่าที่เลือกจะได้รับการกู้คืน?",
			"idId": "Menentukan bahwa penyewa yang dipilih akan dipulihkan?",
			"esMx": "¿Estás seguro de que el inquilino seleccionado será restaurado?",
			"viVi": "Xác định người thuê nhà được chọn sẽ phục hồi?",
			"ptPt": "Identificar o inquilino selecionado para a recuperação?"
		},
		{
			"textKey": "plzInputEnCharater",
			"classify": "tips",
			"zhCn": "请输入英文字母",
			"zhTw": "請輸入英文字母",
			"enUs": "Please enter English letters",
			"thTh": "โปรดป้อนตัวอักษรภาษาอังกฤษ",
			"idId": "Silakan masukkan huruf bahasa Inggris",
			"esMx": "Por favor ingrese las letras en inglés",
			"viVi": "Vui lòng nhập các chữ cái tiếng Anh",
			"ptPt": "Por favor, insira o alfabeto Inglês"
		},
		{
			"textKey": "plzInputParamName",
			"classify": "tips",
			"zhCn": "请输入参数名称",
			"zhTw": "請輸入參數名稱",
			"enUs": "Please enter a parameter name",
			"thTh": "โปรดป้อนชื่อพารามิเตอร์",
			"idId": "Silakan masukkan nama parameter",
			"esMx": "Introduzca el nombre del parámetro",
			"viVi": "Vui lòng nhập tên tham số",
			"ptPt": "Por favor, insira o nome do parâmetro"
		},
		{
			"textKey": "plzInputContactMan",
			"classify": "tips",
			"zhCn": "请输入联系人",
			"zhTw": "請輸入聯繫人",
			"enUs": "Please enter a contact",
			"thTh": "กรุณาใส่ที่ติดต่อ",
			"idId": "Masukkan kontak",
			"esMx": "Por favor ingrese el contacto",
			"viVi": "Vui lòng nhập liên hệ",
			"ptPt": "Por favor, insira um contato"
		},
		{
			"textKey": "recycleStation",
			"classify": "btn",
			"zhCn": "回收站",
			"zhTw": "回收站",
			"enUs": "Recycle Bin",
			"thTh": "ถังรีไซเคิล",
			"idId": "Tempat sampah daur ulang",
			"esMx": "Papelera de reciclaje",
			"viVi": "Trạm tái chế",
			"ptPt": "Estação de reciclagem"
		},
		{
			"textKey": "recover",
			"classify": "btn",
			"zhCn": "恢复",
			"zhTw": "恢復",
			"enUs": "Recovery",
			"thTh": "การกู้คืน",
			"idId": "Pemulihan",
			"esMx": "Recuperación",
			"viVi": "Phục hồi",
			"ptPt": "Recuperação"
		},
		{
			"textKey": "turnback",
			"classify": "btn",
			"zhCn": "返 回",
			"zhTw": "返 回",
			"enUs": "Return",
			"thTh": "กลับ",
			"idId": "Kembali",
			"esMx": "Volver",
			"viVi": "Trở về",
			"ptPt": "Voltar"
		},
		{
			"textKey": "configTenantContent",
			"classify": "tips",
			"zhCn": "给租户配置账号额度、过期时间等授权信息",
			"zhTw": "給租戶配置賬號額度、過期時間等授權信息",
			"enUs": "Configure authorization information such as account quota and expiration time for tenants",
			"thTh": "กำหนดค่าข้อมูลการอนุญาตเช่นโควต้าบัญชีและเวลาหมดอายุสำหรับผู้เช่า",
			"idId": "Konfigurasikan informasi otorisasi seperti kuota akun dan waktu kedaluwarsa kepada penyewa",
			"esMx": "Configure la información de autorización, como el límite de la cuenta y el tiempo de vencimiento para los inquilinos.",
			"viVi": "Định cấu hình thông tin ủy quyền như hạn mức tài khoản và thời gian hết hạn cho người thuê",
			"ptPt": "Configure informações de autorização para o inquilino, como limite de conta e tempo de expiração"
		},
		{
			"textKey": "authConfig",
			"classify": "btn",
			"zhCn": "授权配置",
			"zhTw": "授權配置",
			"enUs": "Authorization Configuration",
			"thTh": "การกำหนดค่าการอนุญาต",
			"idId": "Konfigurasi otorisasi",
			"esMx": "Configuración de autorización",
			"viVi": "Cấu hình ủy quyền",
			"ptPt": "Configuração de autorização"
		},
		{
			"textKey": "tenantAuthConfig",
			"classify": "tips",
			"zhCn": "租户授权配置",
			"zhTw": "租戶授權配置",
			"enUs": "Tenant authorization configuration",
			"thTh": "การกำหนดค่าการอนุญาตผู้เช่า",
			"idId": "Konfigurasi otorisasi penyewa",
			"esMx": "Configuración de autorización de inquilino",
			"viVi": "Cấu hình ủy quyền của người thuê",
			"ptPt": "Configuração de autorização de inquilino"
		},
		{
			"textKey": "tenantDataSourceConfig",
			"classify": "tips",
			"zhCn": "租户数据源配置",
			"zhTw": "租戶數據源配置",
			"enUs": "tenant data source configuration",
			"thTh": "การกำหนดค่าแหล่งข้อมูลผู้เช่า",
			"idId": "Konfigurasi sumber data penyewa",
			"esMx": "Configuración de fuentes de datos de inquilinos",
			"viVi": "Cấu hình nguồn dữ liệu người thuê",
			"ptPt": "Configuração da fonte de dados do locatário"
		},
		{
			"textKey": "tenantProductPackConfig",
			"classify": "tips",
			"zhCn": "租户产品包配置",
			"zhTw": "租戶產品包配置",
			"enUs": "Tenant product package configuration",
			"thTh": "การกำหนดค่าแพคเกจผลิตภัณฑ์ผู้เช่า",
			"idId": "Konfigurasi paket produk penyewa",
			"esMx": "Configuración del paquete de productos del inquilino",
			"viVi": "Cấu hình gói sản phẩm cho người thuê",
			"ptPt": "Configuração do pacote de produtos do inquilino"
		},
		{
			"textKey": "tenantProductPackManage",
			"classify": "tips",
			"zhCn": "租户产品包管理",
			"zhTw": "租戶產品包管理",
			"enUs": "Tenant Product Package Management",
			"thTh": "การจัดการแพ็คเกจผลิตภัณฑ์ผู้เช่า",
			"idId": "Manajemen Paket Produk Penyewa",
			"esMx": "Gestión de paquetes de productos para inquilinos",
			"viVi": "Quản lý gói sản phẩm cho người thuê",
			"ptPt": "Gerenciamento de pacote de produtos de inquilino"
		},
		{
			"textKey": "alarmConfig",
			"classify": "tips",
			"zhCn": "报警配置",
			"zhTw": "報警配置",
			"enUs": "Alarm Configuration",
			"thTh": "การกำหนดค่าการเตือนภัย",
			"idId": "Konfigurasi alarm",
			"esMx": "Configuración de alarma",
			"viVi": "Cấu hình báo động",
			"ptPt": "Configuração de alarme"
		},
		{
			"textKey": "dataImport",
			"classify": "title",
			"zhCn": "用户数据导入",
			"zhTw": "用戶數據導入",
			"enUs": "User Data Import",
			"thTh": "การนำเข้าข้อมูลผู้ใช้",
			"idId": "Impor data pengguna",
			"esMx": "Importación de datos de usuario",
			"viVi": "Nhập dữ liệu người dùng",
			"ptPt": "Importação de dados do usuário"
		},
		{
			"textKey": "clickDownload",
			"classify": "btn",
			"zhCn": "点击下载",
			"zhTw": "點擊下載",
			"enUs": "Click to download",
			"thTh": "คลิกเพื่อดาวน์โหลด",
			"idId": "Klik untuk mengunduh",
			"esMx": "Haga clic para descargar",
			"viVi": "Bấm để tải xuống",
			"ptPt": "Clique em Download"
		},
		{
			"textKey": "userRoleConfig",
			"classify": "title",
			"zhCn": "用户角色配置",
			"zhTw": "用戶角色配置",
			"enUs": "User Role Configuration",
			"thTh": "การกำหนดค่าบทบาทผู้ใช้",
			"idId": "Konfigurasi peran pengguna",
			"esMx": "Configuración de roles de usuario",
			"viVi": "Cấu hình vai trò người dùng",
			"ptPt": "Configuração da função de usuário"
		},
		{
			"textKey": "userPlatformConfig",
			"classify": "title",
			"zhCn": "用户平台配置",
			"zhTw": "用戶平台配置",
			"enUs": "User Platform Configuration",
			"thTh": "การกำหนดค่าแพลตฟอร์มผู้ใช้",
			"idId": "Konfigurasi platform pengguna",
			"esMx": "Configuración de la plataforma de usuario",
			"viVi": "Cấu hình nền tảng người dùng",
			"ptPt": "Configuração da plataforma do usuário"
		},
		{
			"textKey": "plzInputNickName",
			"classify": "tips",
			"zhCn": "请输入用户昵称",
			"zhTw": "請輸入用戶暱稱",
			"enUs": "Please enter user nickname",
			"thTh": "โปรดป้อนชื่อเล่นของผู้ใช้",
			"idId": "Masukkan nama panggilan pengguna",
			"esMx": "Ingrese el apodo del usuario",
			"viVi": "Vui lòng nhập biệt hiệu người dùng",
			"ptPt": "Por favor, insira o apelido do usuário"
		},
		{
			"textKey": "limitFiveCharater",
			"classify": "tips",
			"zhCn": "姓名长度在2到5个字符",
			"zhTw": "姓名長度在2到5個字符",
			"enUs": "Name length between 2 and 5 characters",
			"thTh": "ความยาวของชื่อตั้งแต่2ถึง5ตัวอักษร",
			"idId": "Panjang nama dalam 2 sampai 5 karakter",
			"esMx": "La longitud del nombre es de 2 a 5 caracteres",
			"viVi": "Tên dài từ 2 đến 5 ký tự",
			"ptPt": "Comprimento do nome em 2 a 5 caracteres"
		},
		{
			"textKey": "accountStatus",
			"classify": "label",
			"zhCn": "账号状态",
			"zhTw": "賬號狀態",
			"enUs": "Account Status",
			"thTh": "สถานะบัญชี",
			"idId": "Status akun",
			"esMx": "Estado de la cuenta",
			"viVi": "Trạng thái tài khoản",
			"ptPt": "Status da conta"
		},
		{
			"textKey": "plzSelectRole",
			"classify": "tips",
			"zhCn": "请选择所属角色",
			"zhTw": "請選擇所屬角色",
			"enUs": "Please select a role",
			"thTh": "โปรดเลือกบทบาท",
			"idId": "Silakan pilih peran",
			"esMx": "Seleccione el rol",
			"viVi": "Vui lòng chọn vai trò của bạn",
			"ptPt": "Por favor, escolha o papel a que pertence"
		},
		{
			"textKey": "plzSelectDept",
			"classify": "tips",
			"zhCn": "请选择所属部门",
			"zhTw": "請選擇所屬部門",
			"enUs": "Please select the department",
			"thTh": "โปรดเลือกแผนก",
			"idId": "Silakan pilih departemen",
			"esMx": "Seleccione su departamento",
			"viVi": "Vui lòng chọn bộ phận",
			"ptPt": "Por favor, escolha o departamento"
		},
		{
			"textKey": "userExtend",
			"classify": "label",
			"zhCn": "用户拓展",
			"zhTw": "用戶拓展",
			"enUs": "User Expansion",
			"thTh": "การขยายผู้ใช้",
			"idId": "Pengembangan pengguna",
			"esMx": "Expansión de usuarios",
			"viVi": "Phát triển người dùng",
			"ptPt": "Expansão do usuário"
		},
		{
			"textKey": "templateUpload",
			"classify": "tips",
			"zhCn": "模板上传",
			"zhTw": "模板上傳",
			"enUs": "Template Upload",
			"thTh": "อัปโหลดเทมเพลต",
			"idId": "Unggah template",
			"esMx": "Carga de plantilla",
			"viVi": "Tải lên mẫu",
			"ptPt": "Upload de modelo"
		},
		{
			"textKey": "templateUploadingPlzWait",
			"classify": "tips",
			"zhCn": "模板上传中,请稍等",
			"zhTw": "模板上傳中,請稍等",
			"enUs": "Please wait while the template is being uploaded.",
			"thTh": "กำลังอัปโหลดเทมเพลตโปรดรอสักครู่",
			"idId": "Silakan tunggu dalam template upload",
			"esMx": "Cargue la plantilla, espere",
			"viVi": "Mẫu đang được tải lên, vui lòng đợi",
			"ptPt": "Faça o upload do modelo, espere um pouco"
		},
		{
			"textKey": "plzUploadStandarFile",
			"classify": "tips",
			"zhCn": "请上传 .xls,.xlsx 标准格式文件",
			"zhTw": "請上傳 . Xls,.xlsx 標準格式文件",
			"enUs": "Please upload. xls.xlsx standard format file",
			"thTh": "กรุณาอัปโหลด. Xls.xlsx ไฟล์รูปแบบมาตรฐาน",
			"idId": "Silahkan upload. File format standar xls.xlsx",
			"esMx": "Sube, por favor. Archivos de formato estándar xls.xlsx",
			"viVi": "Vui lòng tải lên. Xls.xlsx tập tin định dạng chuẩn",
			"ptPt": "Por favor, faça o upload. Arquivo de formato padrão xls.xlsx"
		},
		{
			"textKey": "ifConfirmResetPassword",
			"classify": "tips",
			"zhCn": "确定将选择账号密码重置为123456?",
			"zhTw": "確定將選擇賬號密碼重置為123456?",
			"enUs": "Are you sure to reset the selected account password to 123456?",
			"thTh": "ตกลงที่จะรีเซ็ตรหัสผ่านบัญชีที่เลือกเป็น123456?",
			"idId": "Apakah Anda yakin untuk mengatur ulang kata sandi akun yang dipilih ke 123456?",
			"esMx": "¿Confirme para restablecer la contraseña de la cuenta seleccionada a 123456?",
			"viVi": "Đảm bảo đặt lại mật khẩu tài khoản đã chọn thành 123456?",
			"ptPt": "Terá certeza de que a senha da conta selecionada será redefinida para 123456?"
		},
		{
			"textKey": "ifConfirmUnlockAccount",
			"classify": "tips",
			"zhCn": "确定将选择账号解封？",
			"zhTw": "確定將選擇賬號解封?",
			"enUs": "Are you sure you will unseal the selected account?",
			"thTh": "แน่ใจว่าคุณจะเลือกปลดบล็อกบัญชี?",
			"idId": "Apakah Anda memilih untuk membuka segel akun?",
			"esMx": "¿Estás seguro de que la cuenta seleccionada se desbloqueará?",
			"viVi": "Bạn có chắc rằng tài khoản sẽ được mở khóa không?",
			"ptPt": "Tenho certeza de que a conta será desbloqueada?"
		},
		{
			"textKey": "userDataTemplate",
			"classify": "tips",
			"zhCn": "用户数据模板",
			"zhTw": "用戶數據模板",
			"enUs": "User Data Template",
			"thTh": "เทมเพลตข้อมูลผู้ใช้",
			"idId": "Templat Data Pengguna",
			"esMx": "Plantilla de datos de usuario",
			"viVi": "Mẫu dữ liệu người dùng",
			"ptPt": "Modelos de dados do usuário"
		},
		{
			"textKey": "plzUploadStandarXMLfile",
			"classify": "tips",
			"zhCn": "请上传 .xml 标准格式文件",
			"zhTw": "請上傳 . Xml 標準格式文件",
			"enUs": "Please upload the. xml standard format file",
			"thTh": "กรุณาอัปโหลด. ไฟล์รูปแบบมาตรฐาน xml",
			"idId": "Silahkan upload. File format standar xml",
			"esMx": "Sube, por favor. Archivo de formato estándar xml",
			"viVi": "Vui lòng tải lên. Tệp định dạng chuẩn xml",
			"ptPt": "Por favor, faça o upload. Arquivo de formato padrão xml"
		},
		{
			"textKey": "ifConfirmPassAudit",
			"classify": "tips",
			"zhCn": "确定将选择数据通过审核?",
			"zhTw": "確定將選擇數據通過審核?",
			"enUs": "Are you sure you will select data to pass the review?",
			"thTh": "แน่ใจว่าจะเลือกข้อมูลที่จะผ่านการตรวจสอบ?",
			"idId": "Menentukan akan memilih data untuk lulus audit?",
			"esMx": "¿Seguro de que los datos seleccionados serán revisados?",
			"viVi": "Xác định dữ liệu sẽ được chọn để vượt qua kiểm toán?",
			"ptPt": "Determina que os dados selecionados serão aprovados na auditoria?"
		},
		{
			"textKey": "ifConfirmRefuseAudit",
			"classify": "tips",
			"zhCn": "确定将选择数据拒绝审核?",
			"zhTw": "確定將選擇數據拒絕審核?",
			"enUs": "Are you sure you will select Data Reject Audit?",
			"thTh": "แน่ใจว่าข้อมูลจะถูกเลือกปฏิเสธการตรวจสอบ?",
			"idId": "Menentukan bahwa data akan dipilih untuk menolak audit?",
			"esMx": "¿Seguro de que los datos seleccionados rechazarán la auditoría?",
			"viVi": "Chắc chắn sẽ chọn dữ liệu từ chối xem xét?",
			"ptPt": "Determina que os dados serão selecionados para rejeitar a auditoria?"
		},
		{
			"textKey": "add",
			"classify": "btn",
			"zhCn": "添加",
			"zhTw": "添加",
			"enUs": "Add",
			"thTh": "เพิ่ม",
			"idId": "Tambahkan",
			"esMx": "Añadir",
			"viVi": "Thêm",
			"ptPt": "Adicionar"
		},
		{
			"textKey": "empty",
			"classify": "btn",
			"zhCn": "清空",
			"zhTw": "清空",
			"enUs": "Empty",
			"thTh": "ว่างเปล่า",
			"idId": "Kosongkan",
			"esMx": "Vacío",
			"viVi": "Trống rỗng",
			"ptPt": "Esvaziar"
		},
		{
			"textKey": "plzSelectUserPlatform",
			"classify": "tips",
			"zhCn": "请选择用户平台",
			"zhTw": "請選擇用戶平台",
			"enUs": "Please select a user platform",
			"thTh": "โปรดเลือกแพลตฟอร์มผู้ใช้",
			"idId": "Silakan pilih platform pengguna",
			"esMx": "Seleccione la plataforma de usuario",
			"viVi": "Vui lòng chọn nền tảng người dùng",
			"ptPt": "Por favor, escolha a plataforma do usuário"
		},
		{
			"textKey": "model",
			"classify": "label",
			"zhCn": "模型",
			"zhTw": "模型",
			"enUs": "Model",
			"thTh": "โมเดล",
			"idId": "Model",
			"esMx": "Modelo",
			"viVi": "Mô hình",
			"ptPt": "Modelos"
		},
		{
			"textKey": "plzSelectModel",
			"classify": "tips",
			"zhCn": "请选择模型",
			"zhTw": "請選擇模型",
			"enUs": "Please select a model",
			"thTh": "กรุณาเลือกรุ่น",
			"idId": "Silakan pilih model",
			"esMx": "Seleccione el modelo",
			"viVi": "Vui lòng chọn mô hình",
			"ptPt": "Por favor, escolha o modelo"
		},
		{
			"textKey": "dataModelTemplate",
			"classify": "tips",
			"zhCn": "数据模型模板",
			"zhTw": "數據模型模板",
			"enUs": "Data Model Template",
			"thTh": "แม่แบบโมเดลข้อมูล",
			"idId": "Templat Model Data",
			"esMx": "Plantilla de modelo de datos",
			"viVi": "Mẫu mô hình dữ liệu",
			"ptPt": "Modelos de modelo de dados"
		},
		{
			"textKey": "plzInputPasswordAgain",
			"classify": "tips",
			"zhCn": "请再次输入密码",
			"zhTw": "請再次輸入密碼",
			"enUs": "Please enter the password again",
			"thTh": "กรุณาใส่รหัสผ่านอีกครั้ง",
			"idId": "Silakan masukkan kata sandi lagi",
			"esMx": "Por favor ingrese la contraseña de nuevo",
			"viVi": "Vui lòng nhập lại mật khẩu",
			"ptPt": "Por favor, digite a senha novamente"
		},
		{
			"textKey": "twoPasswordWasDiffrent",
			"classify": "tips",
			"zhCn": "两次输入密码不一致!",
			"zhTw": "兩次輸入密碼不一致!",
			"enUs": "Two input password is inconsistent!",
			"thTh": "รหัสผ่านไม่สอดคล้องกันสองครั้ง!",
			"idId": "Masukkan kata sandi dua kali tidak konsisten!",
			"esMx": "¡La contraseña de entrada dos veces es inconsistente!",
			"viVi": "Mật khẩu nhập hai lần không nhất quán!",
			"ptPt": "Inconsistente na senha duas vezes!"
		},
		{
			"textKey": "dataInfo",
			"classify": "label",
			"zhCn": "数据信息",
			"zhTw": "數據信息",
			"enUs": "Data Information",
			"thTh": "ข้อมูลข้อมูล",
			"idId": "Informasi Data",
			"esMx": "Información de datos",
			"viVi": "Thông tin dữ liệu",
			"ptPt": "Informações de dados"
		},
		{
			"textKey": "plzInputMenuEnName",
			"classify": "tips",
			"zhCn": "请输入菜单英文名称",
			"zhTw": "請輸入菜單英文名稱",
			"enUs": "Please enter the English name of the menu",
			"thTh": "โปรดป้อนชื่อภาษาอังกฤษของเมนู",
			"idId": "Silakan masukkan nama menu dalam bahasa Inggris",
			"esMx": "Introduzca el nombre en inglés del menú",
			"viVi": "Vui lòng nhập tên tiếng Anh của menu",
			"ptPt": "Por favor, insira o nome do menu em inglês"
		},
		{
			"textKey": "plzInputMenuLocalName",
			"classify": "tips",
			"zhCn": "请输入菜单本地名称",
			"zhTw": "請輸入菜單本地名稱",
			"enUs": "Please enter a menu local name",
			"thTh": "โปรดป้อนชื่อท้องถิ่นของเมนู",
			"idId": "Silahkan masukkan nama lokal menu",
			"esMx": "Introduzca el nombre local del menú",
			"viVi": "Vui lòng nhập tên địa phương của menu",
			"ptPt": "Por favor, insira o nome local do menu"
		},
		{
			"textKey": "plzUseOpenInNewWindow",
			"classify": "tips",
			"zhCn": "请选择新窗口打开",
			"zhTw": "請選擇新窗口打開",
			"enUs": "Please select a new window to open",
			"thTh": "โปรดเลือกหน้าต่างใหม่เพื่อเปิด",
			"idId": "Silakan pilih jendela baru untuk membuka",
			"esMx": "Seleccione una nueva ventana para abrir",
			"viVi": "Vui lòng chọn cửa sổ mới để mở",
			"ptPt": "Por favor, escolha uma nova janela para abrir"
		},
		{
			"textKey": "plzInputUnit",
			"classify": "tips",
			"zhCn": "请输入单位",
			"zhTw": "請輸入單位",
			"enUs": "Please enter unit",
			"thTh": "กรุณาใส่หน่วย",
			"idId": "Silakan masukkan unit",
			"esMx": "Por favor ingrese la unidad",
			"viVi": "Vui lòng nhập đơn vị",
			"ptPt": "Por favor, insira a unidade"
		},
		{
			"textKey": "plzInputForRemoteType",
			"classify": "tips",
			"zhCn": "请输入四遥类型",
			"zhTw": "請輸入四遙類型",
			"enUs": "Please enter four remote type",
			"thTh": "โปรดป้อนประเภทระยะไกลสี่ประเภท",
			"idId": "Silakan masukkan empat jenis jarak jauh",
			"esMx": "Ingrese el tipo de cuatro remotos",
			"viVi": "Vui lòng nhập bốn loại từ xa",
			"ptPt": "Por favor, insira quatro tipos remotos"
		},
		{
			"textKey": "plzSelect",
			"classify": "tips",
			"zhCn": "请选择",
			"zhTw": "請選擇",
			"enUs": "Please select",
			"thTh": "โปรดเลือก",
			"idId": "Silakan pilih",
			"esMx": "Por favor elija",
			"viVi": "Vui lòng chọn",
			"ptPt": "Por favor, escolha"
		},
		{
			"textKey": "roleAuthConfig",
			"classify": "title",
			"zhCn": "角色权限配置",
			"zhTw": "角色權限配置",
			"enUs": "Role permission configuration",
			"thTh": "การกำหนดค่าสิทธิ์บทบาท",
			"idId": "Konfigurasi izin peran",
			"esMx": "Configuración de permisos de rol",
			"viVi": "Cấu hình quyền vai trò",
			"ptPt": "Configuração de permissões de função"
		},
		{
			"textKey": "menuAuth",
			"classify": "label",
			"zhCn": "菜单权限",
			"zhTw": "菜單權限",
			"enUs": "Menu Permissions",
			"thTh": "สิทธิ์เมนู",
			"idId": "Izin menu",
			"esMx": "Permisos de menú",
			"viVi": "Quyền menu",
			"ptPt": "Permissões de menu"
		},
		{
			"textKey": "dataAuth",
			"classify": "label",
			"zhCn": "数据权限",
			"zhTw": "數據權限",
			"enUs": "Data Permissions",
			"thTh": "สิทธิ์ข้อมูล",
			"idId": "Izin Data",
			"esMx": "Permisos de datos",
			"viVi": "Quyền dữ liệu",
			"ptPt": "Permissões de dados"
		},
		{
			"textKey": "interfaceAuth",
			"classify": "label",
			"zhCn": "接口权限",
			"zhTw": "接口權限",
			"enUs": "Interface Permissions",
			"thTh": "สิทธิ์การเชื่อมต่อ",
			"idId": "Izin antarmuka",
			"esMx": "Permisos de interfaz",
			"viVi": "Quyền giao diện",
			"ptPt": "Permissões de interface"
		},
		{
			"textKey": "plzInputRoleSort",
			"classify": "tips",
			"zhCn": "请输入角色排序",
			"zhTw": "請輸入角色排序",
			"enUs": "Please enter a role sort",
			"thTh": "โปรดป้อนการเรียงลำดับบทบาท",
			"idId": "Silakan masukkan pengurutan peran",
			"esMx": "Ingrese la clasificación de roles",
			"viVi": "Vui lòng nhập sắp xếp vai trò",
			"ptPt": "Por favor, insira a classificação de papéis"
		},
		{
			"textKey": "dataAuthConfig",
			"classify": "label",
			"zhCn": "数据权限配置",
			"zhTw": "數據權限配置",
			"enUs": "Data permission configuration",
			"thTh": "การกำหนดค่าสิทธิ์ข้อมูล",
			"idId": "Konfigurasi izin data",
			"esMx": "Configuración de permisos de datos",
			"viVi": "Cấu hình quyền dữ liệu",
			"ptPt": "Configuração de permissões de dados"
		},
		{
			"textKey": "plzInputDataAuthName",
			"classify": "tips",
			"zhCn": "请输入数据权限名称",
			"zhTw": "請輸入數據權限名稱",
			"enUs": "Please enter data permission name",
			"thTh": "โปรดป้อนชื่อสิทธิ์ข้อมูล",
			"idId": "Masukkan nama izin data",
			"esMx": "Ingrese el nombre del permiso de datos",
			"viVi": "Vui lòng nhập tên quyền dữ liệu",
			"ptPt": "Insira um nome de permissão de dados"
		},
		{
			"textKey": "plzInputDataAuthNum",
			"classify": "tips",
			"zhCn": "请输入数据权限编号",
			"zhTw": "請輸入數據權限編號",
			"enUs": "Please enter data permission number",
			"thTh": "โปรดป้อนหมายเลขสิทธิ์ข้อมูล",
			"idId": "Masukkan nomor izin data",
			"esMx": "Ingrese el número de permiso de datos",
			"viVi": "Vui lòng nhập số quyền dữ liệu",
			"ptPt": "Por favor, insira o número de permissão de dados"
		},
		{
			"textKey": "authWordName",
			"classify": "tips",
			"zhCn": "权限字段",
			"zhTw": "權限字段",
			"enUs": "Permission field",
			"thTh": "ฟิลด์สิทธิ์",
			"idId": "Bidang Izin",
			"esMx": "Campos de permisos",
			"viVi": "Trường quyền",
			"ptPt": "Campos de permissão"
		},
		{
			"textKey": "rulesType",
			"classify": "label",
			"zhCn": "规则类型",
			"zhTw": "規則類型",
			"enUs": "Rule Type",
			"thTh": "ประเภทกฎ",
			"idId": "Jenis Aturan",
			"esMx": "Tipos de reglas",
			"viVi": "Loại quy tắc",
			"ptPt": "Tipo de regra"
		},
		{
			"textKey": "visiableField",
			"classify": "label",
			"zhCn": "可见字段",
			"zhTw": "可見字段",
			"enUs": "Visible Fields",
			"thTh": "ฟิลด์ที่มองเห็นได้",
			"idId": "Bidang yang terlihat",
			"esMx": "Campos visibles",
			"viVi": "Trường hiển thị",
			"ptPt": "Campos visíveis"
		},
		{
			"textKey": "plzInputDataAuthVisiableField",
			"classify": "tips",
			"zhCn": "请输入数据权限可见的字段",
			"zhTw": "請輸入數據權限可見的字段",
			"enUs": "Please enter a field where data permissions are visible",
			"thTh": "กรุณาใส่สิทธิ์ข้อมูลในฟิลด์ที่มองเห็นได้",
			"idId": "Masukkan bidang yang terlihat dengan izin data",
			"esMx": "Introduzca el campo donde los permisos de datos son visibles",
			"viVi": "Vui lòng nhập trường mà quyền dữ liệu hiển thị",
			"ptPt": "Insira os campos onde as permissões de dados são visíveis"
		},
		{
			"textKey": "authClassName",
			"classify": "label",
			"zhCn": "权限类名",
			"zhTw": "權限類名",
			"enUs": "Permission Class Name",
			"thTh": "ชื่อคลาสสิทธิ์",
			"idId": "Nama kelas izin",
			"esMx": "Nombre de la clase de permiso",
			"viVi": "Tên lớp quyền",
			"ptPt": "O nome da classe de permissões"
		},
		{
			"textKey": "plzInputMybatisMapperFunClassPath",
			"classify": "tips",
			"zhCn": "请输入MybatisMapper对应方法的完整类名路径",
			"zhTw": "請輸入MybatisMapper對應方法的完整類名路徑",
			"enUs": "Please enter the full class name path of MybatisMapper corresponding method",
			"thTh": "โปรดป้อนเส้นทางชื่อคลาสที่สมบูรณ์ของวิธีการที่เกี่ยวข้อง MybatisMapper",
			"idId": "Masukkan path nama kelas lengkap untuk metode yang sesuai dengan MybatisMapper",
			"esMx": "Ingrese la ruta completa del nombre de clase del método correspondiente a MybatisMapper",
			"viVi": "Vui lòng nhập đường dẫn tên lớp hoàn chỉnh của phương thức tương ứng MybatisMapper",
			"ptPt": "Insira o caminho completo do nome da classe para o método de correspondência MybatisMapper"
		},
		{
			"textKey": "rulesValue",
			"classify": "label",
			"zhCn": "规则值",
			"zhTw": "規則值",
			"enUs": "Rule Value",
			"thTh": "ค่ากฎ",
			"idId": "Nilai aturan",
			"esMx": "Valores de la regla",
			"viVi": "Giá trị quy tắc",
			"ptPt": "Valores da regra"
		},
		{
			"textKey": "emptyJustNow",
			"classify": "tips",
			"zhCn": "暂无",
			"zhTw": "暫無",
			"enUs": "No",
			"thTh": "ไม่",
			"idId": "Tidak ada",
			"esMx": "No",
			"viVi": "Không",
			"ptPt": "Não."
		},
		{
			"textKey": "allCanSee",
			"classify": "tips",
			"zhCn": "全部可见",
			"zhTw": "全部可見",
			"enUs": "All Visible",
			"thTh": "มองเห็นได้ทั้งหมด",
			"idId": "Semua terlihat",
			"esMx": "Todo visible",
			"viVi": "Tất cả có thể nhìn thấy",
			"ptPt": "Tudo visível"
		},
		{
			"textKey": "onlyYouCanSeeIt",
			"classify": "tips",
			"zhCn": "本人可见",
			"zhTw": "本人可見",
			"enUs": "I can see",
			"thTh": "ฉันสามารถมองเห็นได้",
			"idId": "Saya bisa melihatnya",
			"esMx": "Puedo ver",
			"viVi": "Tôi có thể nhìn thấy",
			"ptPt": "Eu posso ver"
		},
		{
			"textKey": "allDeptCanSee",
			"classify": "tips",
			"zhCn": "所在机构可见",
			"zhTw": "所在機構可見",
			"enUs": "Visible in institution",
			"thTh": "สถาบันสามารถมองเห็นได้",
			"idId": "Terlihat di institusi",
			"esMx": "Visible en la institución",
			"viVi": "Tổ chức hiển thị",
			"ptPt": "Visível na instituição"
		},
		{
			"textKey": "allDeptAndSubDeptCanSee",
			"classify": "tips",
			"zhCn": "所在机构可见及子级可见",
			"zhTw": "所在機構可見及子級可見",
			"enUs": "Visible for organization and child",
			"thTh": "สถาบันที่มองเห็นได้และมองเห็นได้ในระดับย่อย",
			"idId": "Lembaga dapat dilihat dan dapat dilihat pada tingkat anak",
			"esMx": "La organización es visible y el subnivel es visible",
			"viVi": "Tổ chức hiển thị và hiển thị cấp phụ",
			"ptPt": "A organização é visível e o subnível é visível"
		},
		{
			"textKey": "doItYourSelf",
			"classify": "tips",
			"zhCn": "自定义",
			"zhTw": "自定義",
			"enUs": "Custom",
			"thTh": "ที่กำหนดเอง",
			"idId": "Kustom",
			"esMx": "Personalización",
			"viVi": "Tùy chỉnh",
			"ptPt": "Personalização"
		},
		{
			"textKey": "dataItem",
			"classify": "label",
			"zhCn": "数据项",
			"zhTw": "數據項",
			"enUs": "Data Item",
			"thTh": "รายการข้อมูล",
			"idId": "Item Data",
			"esMx": "El elemento de datos",
			"viVi": "Mục dữ liệu",
			"ptPt": "Item de dados"
		},
		{
			"textKey": "dataModel",
			"classify": "tips",
			"zhCn": "数据模型",
			"zhTw": "數據模型",
			"enUs": "Data Model",
			"thTh": "โมเดลข้อมูล",
			"idId": "Model Data",
			"esMx": "Modelos de datos",
			"viVi": "Mô hình dữ liệu",
			"ptPt": "Modelos de dados"
		},
		{
			"textKey": "modelData",
			"classify": "tips",
			"zhCn": "模型数据",
			"zhTw": "模型數據",
			"enUs": "Model data",
			"thTh": "ข้อมูลแบบจำลอง",
			"idId": "Data Model",
			"esMx": "Datos del modelo",
			"viVi": "Dữ liệu mô hình",
			"ptPt": "Dados do modelo"
		},
		{
			"textKey": "noticeTitle",
			"classify": "tips",
			"zhCn": "通知标题",
			"zhTw": "通知標題",
			"enUs": "Notification Title",
			"thTh": "ชื่อการแจ้งเตือน",
			"idId": "Judul Pemberitahuan",
			"esMx": "Título de la notificación",
			"viVi": "Tiêu đề thông báo",
			"ptPt": "Título da notificação"
		},
		{
			"textKey": "plzInputNoticeTitle",
			"classify": "tips",
			"zhCn": "请输入通知标题",
			"zhTw": "請輸入通知標題",
			"enUs": "Please enter a notification title",
			"thTh": "โปรดป้อนชื่อการแจ้งเตือน",
			"idId": "Silakan masukkan judul pemberitahuan",
			"esMx": "Introduzca el título de la notificación",
			"viVi": "Vui lòng nhập tiêu đề thông báo",
			"ptPt": "Por favor, insira o título da notificação"
		},
		{
			"textKey": "noticeType",
			"classify": "label",
			"zhCn": "通知类型",
			"zhTw": "通知類型",
			"enUs": "Notification Type",
			"thTh": "ประเภทการแจ้งเตือน",
			"idId": "Jenis Pemberitahuan",
			"esMx": "Tipo de notificación",
			"viVi": "Loại thông báo",
			"ptPt": "Tipo de notificação"
		},
		{
			"textKey": "noticeTime",
			"classify": "label",
			"zhCn": "通知时间",
			"zhTw": "通知時間",
			"enUs": "Notification time",
			"thTh": "เวลาแจ้งเตือน",
			"idId": "Waktu pemberitahuan",
			"esMx": "Tiempo de notificación",
			"viVi": "Thời gian thông báo",
			"ptPt": "Tempo de notificação"
		},
		{
			"textKey": "plzInputNoticeTime",
			"classify": "tips",
			"zhCn": "请输入通知时间",
			"zhTw": "請輸入通知時間",
			"enUs": "Please enter the notification time",
			"thTh": "กรุณากรอกเวลาแจ้งเตือน",
			"idId": "Silakan masukkan waktu pemberitahuan",
			"esMx": "Ingrese el tiempo de notificación",
			"viVi": "Vui lòng nhập thời gian thông báo",
			"ptPt": "Por favor, insira o tempo de notificação"
		},
		{
			"textKey": "noticeDate",
			"classify": "label",
			"zhCn": "通知日期",
			"zhTw": "通知日期",
			"enUs": "Notification Date",
			"thTh": "วันที่แจ้งเตือน",
			"idId": "Tanggal pemberitahuan",
			"esMx": "Fecha de notificación",
			"viVi": "Ngày thông báo",
			"ptPt": "Data de notificação"
		},
		{
			"textKey": "plzInputNoticeDate",
			"classify": "tips",
			"zhCn": "请输入通知日期",
			"zhTw": "請輸入通知日期",
			"enUs": "Please enter the notification date",
			"thTh": "โปรดป้อนวันที่แจ้งเตือน",
			"idId": "Masukkan tanggal pemberitahuan",
			"esMx": "Introduzca la fecha de notificación",
			"viVi": "Vui lòng nhập ngày thông báo",
			"ptPt": "Por favor, insira a data de notificação"
		},
		{
			"textKey": "noticeContent",
			"classify": "label",
			"zhCn": "通知内容",
			"zhTw": "通知內容",
			"enUs": "Notification content",
			"thTh": "เนื้อหาการแจ้งเตือน",
			"idId": "Konten pemberitahuan",
			"esMx": "Contenido de la notificación",
			"viVi": "Nội dung thông báo",
			"ptPt": "Conteúdo da notificação"
		},
		{
			"textKey": "analysisData",
			"classify": "label",
			"zhCn": "分析数据",
			"zhTw": "分析數據",
			"enUs": "Analyze data",
			"thTh": "วิเคราะห์ข้อมูล",
			"idId": "Menganalisis data",
			"esMx": "Análisis de datos",
			"viVi": "Phân tích dữ liệu",
			"ptPt": "Análise de dados"
		},
		{
			"textKey": "save",
			"classify": "btn",
			"zhCn": "保存",
			"zhTw": "保存",
			"enUs": "Save",
			"thTh": "บันทึก",
			"idId": "Simpan",
			"esMx": "Guardar",
			"viVi": "Lưu",
			"ptPt": "Salvar"
		},
		{
			"textKey": "addData",
			"classify": "label",
			"zhCn": "添加数据",
			"zhTw": "添加數據",
			"enUs": "Add data",
			"thTh": "เพิ่มข้อมูล",
			"idId": "Menambahkan data",
			"esMx": "Añadir datos",
			"viVi": "Thêm dữ liệu",
			"ptPt": "Adicionar dados"
		},
		{
			"textKey": "indexDispaly",
			"classify": "label",
			"zhCn": "首页大屏",
			"zhTw": "首頁大屏",
			"enUs": "Home big screen",
			"thTh": "หน้าจอขนาดใหญ่หน้าแรก",
			"idId": "Home layar besar",
			"esMx": "Pantalla grande de la página de inicio",
			"viVi": "Trang chủ màn hình lớn",
			"ptPt": "Página inicial tela grande"
		},
		{
			"textKey": "published",
			"classify": "label",
			"zhCn": "已发布",
			"zhTw": "已發布",
			"enUs": "Published",
			"thTh": "โพสต์แล้ว",
			"idId": "Dirilis",
			"esMx": "Publicado",
			"viVi": "Đã phát hành",
			"ptPt": "Publicado"
		},
		{
			"textKey": "pagePath",
			"classify": "label",
			"zhCn": "页面地址",
			"zhTw": "頁面地址",
			"enUs": "Page Address",
			"thTh": "ที่อยู่หน้า",
			"idId": "Alamat halaman",
			"esMx": "Dirección de la página",
			"viVi": "Địa chỉ trang",
			"ptPt": "Endereço da página"
		},
		{
			"textKey": "viewPath",
			"classify": "label",
			"zhCn": "查看页面",
			"zhTw": "查看頁面",
			"enUs": "View Page",
			"thTh": "ดูหน้า",
			"idId": "Lihat halaman",
			"esMx": "Ver la página",
			"viVi": "Xem trang",
			"ptPt": "Ver a página"
		},
		{
			"textKey": "editPage",
			"classify": "label",
			"zhCn": "编辑页面",
			"zhTw": "編輯頁面",
			"enUs": "Edit Page",
			"thTh": "แก้ไขหน้า",
			"idId": "Mengedit halaman",
			"esMx": "Editar página",
			"viVi": "Chỉnh sửa trang",
			"ptPt": "Editar uma página"
		},
		{
			"textKey": "transformerTemperatureControl",
			"classify": "table",
			"zhCn": "变压器温控",
			"zhTw": "變壓器溫控",
			"enUs": "transformer temperature control",
			"thTh": "การควบคุมอุณหภูมิหม้อแปลง",
			"idId": "Kontrol suhu transformator",
			"esMx": "Control de temperatura del transformador",
			"viVi": "Điều khiển nhiệt độ máy biến áp",
			"ptPt": "Controle de temperatura do transformador"
		},
		{
			"textKey": "ABoxVolt",
			"classify": "table",
			"zhCn": "A相电压",
			"zhTw": "A相電壓",
			"enUs": "Phase A voltage",
			"thTh": "แรงดันไฟฟ้าเฟส",
			"idId": "Tegangan Fase A",
			"esMx": "Voltaje de fase A",
			"viVi": "A pha điện áp",
			"ptPt": "Tensão da fase A"
		},
		{
			"textKey": "BBoxVolt",
			"classify": "table",
			"zhCn": "B相电压",
			"zhTw": "B相電壓",
			"enUs": "Phase B voltage",
			"thTh": "แรงดันไฟฟ้าเฟส B",
			"idId": "Tegangan fase B",
			"esMx": "Voltaje de fase B",
			"viVi": "B pha điện áp",
			"ptPt": "Tensão da fase B"
		},
		{
			"textKey": "plzSelectPositionBelongTo",
			"classify": "tips",
			"zhCn": "请选择所属岗位",
			"zhTw": "請選擇所屬崗位",
			"enUs": "Please select the position",
			"thTh": "กรุณาเลือกตำแหน่ง",
			"idId": "Silakan pilih posisi",
			"esMx": "Seleccione su puesto",
			"viVi": "Vui lòng chọn vị trí của bạn",
			"ptPt": "Escolha a sua posição"
		},
		{
			"textKey": "plzInputGatewayName",
			"classify": "tips",
			"zhCn": "请输入网关名称",
			"zhTw": "請輸入網關名稱",
			"enUs": "Please enter gateway name",
			"thTh": "โปรดป้อนชื่อเกตเวย์",
			"idId": "Masukkan nama gateway",
			"esMx": "Ingrese el nombre de la puerta de enlace",
			"viVi": "Vui lòng nhập tên cổng",
			"ptPt": "Por favor, insira o nome do gateway"
		},
		{
			"textKey": "plzSelectProtocol",
			"classify": "tips",
			"zhCn": "请选择协议",
			"zhTw": "請選擇協議",
			"enUs": "Please select a protocol",
			"thTh": "โปรดเลือกข้อตกลง",
			"idId": "Silakan pilih protokol",
			"esMx": "Por favor seleccione el acuerdo",
			"viVi": "Vui lòng chọn thỏa thuận",
			"ptPt": "Por favor, escolha o acordo"
		},
		{
			"textKey": "plzSelectProjectBelongTo",
			"classify": "tips",
			"zhCn": "请选择所属项目",
			"zhTw": "請選擇所屬項目",
			"enUs": "Please select the project",
			"thTh": "โปรดเลือกรายการ",
			"idId": "Silakan pilih proyek",
			"esMx": "Seleccione el elemento al que pertenece",
			"viVi": "Vui lòng chọn mục thuộc về",
			"ptPt": "Por favor, escolha o projeto a que pertence"
		},
		{
			"textKey": "projectManage",
			"classify": "label",
			"zhCn": "项目管理",
			"zhTw": "項目管理",
			"enUs": "Project Management",
			"thTh": "การจัดการโครงการ",
			"idId": "Manajemen Proyek",
			"esMx": "Gestión de proyectos",
			"viVi": "Quản lý dự án",
			"ptPt": "Gerenciamento de projetos"
		},
		{
			"textKey": "projectEnergyTable",
			"classify": "tips",
			"zhCn": "项目能源表",
			"zhTw": "項目能源表",
			"enUs": "Project Energy Table",
			"thTh": "ตารางพลังงานโครงการ",
			"idId": "Tabel energi proyek",
			"esMx": "Medidor de energía del proyecto",
			"viVi": "Bảng năng lượng dự án",
			"ptPt": "Tabela de energia do projeto"
		},
		{
			"textKey": "design",
			"classify": "btn",
			"zhCn": "设计",
			"zhTw": "設計",
			"enUs": "Design",
			"thTh": "การออกแบบ",
			"idId": "Desain",
			"esMx": "Diseño",
			"viVi": "Thiết kế",
			"ptPt": "Design"
		},
		{
			"textKey": "preview",
			"classify": "btn",
			"zhCn": "预览",
			"zhTw": "預覽",
			"enUs": "Preview",
			"thTh": "ดูตัวอย่าง",
			"idId": "Pratinjau",
			"esMx": "Vista previa",
			"viVi": "Xem trước",
			"ptPt": "Pré-visualização"
		},
		{
			"textKey": "fileName",
			"classify": "label",
			"zhCn": "文件名",
			"zhTw": "文件名",
			"enUs": "File Name",
			"thTh": "ชื่อไฟล์",
			"idId": "Nama file",
			"esMx": "Nombre de archivo",
			"viVi": "Tên tập tin",
			"ptPt": "Nome do arquivo"
		},
		{
			"textKey": "upload",
			"classify": "btn",
			"zhCn": "上传",
			"zhTw": "上傳",
			"enUs": "Upload",
			"thTh": "อัปโหลด",
			"idId": "Unggah",
			"esMx": "Subir",
			"viVi": "Tải lên",
			"ptPt": "Upload"
		},
		{
			"textKey": "attachmentManage",
			"classify": "btn",
			"zhCn": "附件管理",
			"zhTw": "附件管理",
			"enUs": "Attachment Management",
			"thTh": "การจัดการสิ่งที่แนบมา",
			"idId": "Manajemen Lampiran",
			"esMx": "Gestión de archivos adjuntos",
			"viVi": "Quản lý tệp đính kèm",
			"ptPt": "Gerenciamento de anexos"
		},
		{
			"textKey": "attachmentAddress",
			"classify": "label",
			"zhCn": "附件地址",
			"zhTw": "附件地址",
			"enUs": "Attachment Address",
			"thTh": "ที่อยู่ไฟล์แนบ",
			"idId": "Alamat lampiran",
			"esMx": "Dirección adjunta",
			"viVi": "Địa chỉ đính kèm",
			"ptPt": "Endereço do anexo"
		},
		{
			"textKey": "plzInputAttachmentAddress",
			"classify": "label",
			"zhCn": "请输入附件地址",
			"zhTw": "請輸入附件地址",
			"enUs": "Please enter attachment address",
			"thTh": "กรุณากรอกที่อยู่ไฟล์แนบ",
			"idId": "Silakan masukkan alamat lampiran",
			"esMx": "Ingrese la dirección del archivo adjunto",
			"viVi": "Vui lòng nhập địa chỉ tệp đính kèm",
			"ptPt": "Por favor, insira o endereço do anexo"
		},
		{
			"textKey": "attachmentDomain",
			"classify": "label",
			"zhCn": "附件域名",
			"zhTw": "附件域名",
			"enUs": "Attachment Domain Name",
			"thTh": "ชื่อโดเมนที่แนบมา",
			"idId": "Nama Domain Lampiran",
			"esMx": "Nombre de dominio adjunto",
			"viVi": "Tên miền đính kèm",
			"ptPt": "Nome de domínio anexo"
		},
		{
			"textKey": "plzInputAttachmentDomain",
			"classify": "tips",
			"zhCn": "请输入附件域名",
			"zhTw": "請輸入附件域名",
			"enUs": "Please enter attachment domain name",
			"thTh": "โปรดป้อนชื่อโดเมนที่แนบมา",
			"idId": "Masukkan domain lampiran",
			"esMx": "Ingrese el nombre de dominio adjunto",
			"viVi": "Vui lòng nhập tên miền đính kèm",
			"ptPt": "Por favor, insira o nome de domínio anexo"
		},
		{
			"textKey": "attachmentName",
			"classify": "label",
			"zhCn": "附件名称",
			"zhTw": "附件名稱",
			"enUs": "Attachment Name",
			"thTh": "ชื่อสิ่งที่แนบมา",
			"idId": "Nama lampiran",
			"esMx": "Nombre del archivo adjunto",
			"viVi": "Tên phụ kiện",
			"ptPt": "Nome do anexo"
		},
		{
			"textKey": "plzInputAttachmentName",
			"classify": "tips",
			"zhCn": "请输入附件名称",
			"zhTw": "請輸入附件名稱",
			"enUs": "Please enter attachment name",
			"thTh": "กรุณากรอกชื่อไฟล์แนบ",
			"idId": "Masukkan nama lampiran",
			"esMx": "Por favor ingrese el nombre del archivo adjunto",
			"viVi": "Vui lòng nhập tên tệp đính kèm",
			"ptPt": "Por favor, insira o nome do anexo"
		},
		{
			"textKey": "attachmentOriginName",
			"classify": "label",
			"zhCn": "附件原名",
			"zhTw": "附件原名",
			"enUs": "Original name of Annex",
			"thTh": "ชื่อเดิมของภาคผนวก",
			"idId": "Nama asli lampiran",
			"esMx": "Nombre original del anexo",
			"viVi": "Tên ban đầu của tệp đính kèm",
			"ptPt": "O nome original do anexo"
		},
		{
			"textKey": "plzInputAttachmentOriginName",
			"classify": "tips",
			"zhCn": "请输入附件原名",
			"zhTw": "請輸入附件原名",
			"enUs": "Please enter the original name of the attachment",
			"thTh": "กรุณากรอกชื่อเดิมของไฟล์แนบ",
			"idId": "Silakan masukkan nama asli lampiran",
			"esMx": "Ingrese el nombre original del archivo adjunto",
			"viVi": "Vui lòng nhập tên gốc của tệp đính kèm",
			"ptPt": "Por favor, insira o nome original do anexo"
		},
		{
			"textKey": "attachmentExtName",
			"classify": "label",
			"zhCn": "附件拓展名",
			"zhTw": "附件拓展名",
			"enUs": "Attachment Extension Name",
			"thTh": "ชื่อส่วนขยายไฟล์แนบ",
			"idId": "Nama ekstensi lampiran",
			"esMx": "Nombre de extensión adjunto",
			"viVi": "Tên mở rộng tệp đính kèm",
			"ptPt": "O nome de expansão do anexo"
		},
		{
			"textKey": "plzInputAttachmentExtName",
			"classify": "tips",
			"zhCn": "请输入附件拓展名",
			"zhTw": "請輸入附件拓展名",
			"enUs": "Please enter an attachment extension name",
			"thTh": "กรุณากรอกชื่อส่วนขยายไฟล์แนบ",
			"idId": "Silakan masukkan ekstensi lampiran",
			"esMx": "Ingrese el nombre de extensión del archivo adjunto",
			"viVi": "Vui lòng nhập tên mở rộng tệp đính kèm",
			"ptPt": "Insira o nome de expansão do anexo"
		},
		{
			"textKey": "attachmentSize",
			"classify": "label",
			"zhCn": "附件大小",
			"zhTw": "附件大小",
			"enUs": "Attachment Size",
			"thTh": "ขนาดของอุปกรณ์เสริม",
			"idId": "Ukuran lampiran",
			"esMx": "Tamaño del archivo adjunto",
			"viVi": "Kích thước phụ kiện",
			"ptPt": "Tamanho do anexo"
		},
		{
			"textKey": "plzInputAttachmentSize",
			"classify": "tips",
			"zhCn": "请输入附件大小",
			"zhTw": "請輸入附件大小",
			"enUs": "Please enter attachment size",
			"thTh": "กรุณากรอกขนาดไฟล์แนบ",
			"idId": "Silakan masukkan ukuran lampiran",
			"esMx": "Ingrese el tamaño del archivo adjunto",
			"viVi": "Vui lòng nhập kích thước tệp đính kèm",
			"ptPt": "Por favor, insira o tamanho do anexo"
		},
		{
			"textKey": "attachmentUpload",
			"classify": "label",
			"zhCn": "附件上传",
			"zhTw": "附件上傳",
			"enUs": "Attachment Upload",
			"thTh": "อัปโหลดไฟล์แนบ",
			"idId": "Unggah lampiran",
			"esMx": "Carga de archivos adjuntos",
			"viVi": "Tải lên tệp đính kèm",
			"ptPt": "Upload de anexos"
		},
		{
			"textKey": "appid",
			"classify": "label",
			"zhCn": "应用id",
			"zhTw": "應用id",
			"enUs": "application id",
			"thTh": "การประยุกต์ใช้ id",
			"idId": "Aplikasi id",
			"esMx": "ID de aplicación",
			"viVi": "Ứng dụng id",
			"ptPt": "ID de aplicação"
		},
		{
			"textKey": "plzInputAppid",
			"classify": "tips",
			"zhCn": "请输入客户端id",
			"zhTw": "請輸入客戶端id",
			"enUs": "Please enter the client ID",
			"thTh": "กรุณาป้อนรหัสลูกค้า",
			"idId": "Silakan masukkan id klien",
			"esMx": "Ingrese el id del cliente",
			"viVi": "Vui lòng nhập id khách hàng",
			"ptPt": "Por favor, insira o cliente id"
		},
		{
			"textKey": "appSecret",
			"classify": "label",
			"zhCn": "应用密钥",
			"zhTw": "應用密鑰",
			"enUs": "Application Key",
			"thTh": "คีย์การประยุกต์ใช้",
			"idId": "Kunci aplikasi",
			"esMx": "Clave de aplicación",
			"viVi": "Khóa ứng dụng",
			"ptPt": "Chave de aplicação"
		},
		{
			"textKey": "plzInputAppSecret",
			"classify": "tips",
			"zhCn": "请输入客户端密钥",
			"zhTw": "請輸入客戶端密鑰",
			"enUs": "Please enter the client key",
			"thTh": "โปรดป้อนคีย์ไคลเอ็นต์",
			"idId": "Masukkan kunci klien",
			"esMx": "Introduzca la clave de cliente",
			"viVi": "Vui lòng nhập khóa khách hàng",
			"ptPt": "Insira a chave do cliente"
		},
		{
			"textKey": "authType",
			"classify": "label",
			"zhCn": "授权类型",
			"zhTw": "授權類型",
			"enUs": "Authorization Type",
			"thTh": "ประเภทการอนุญาต",
			"idId": "Jenis otorisasi",
			"esMx": "Tipo de autorización",
			"viVi": "Loại ủy quyền",
			"ptPt": "Tipo de autorização"
		},
		{
			"textKey": "plzInputAuthType",
			"classify": "tips",
			"zhCn": "请输入授权类型",
			"zhTw": "請輸入授權類型",
			"enUs": "Please enter an authorization type",
			"thTh": "โปรดป้อนประเภทการอนุญาต",
			"idId": "Masukkan jenis otorisasi",
			"esMx": "Introduzca el tipo de autorización",
			"viVi": "Vui lòng nhập loại ủy quyền",
			"ptPt": "Insira o tipo de autorização"
		},
		{
			"textKey": "authScope",
			"classify": "label",
			"zhCn": "授权范围",
			"zhTw": "授權範圍",
			"enUs": "Scope of authorization",
			"thTh": "ขอบเขตการอนุญาต",
			"idId": "Lingkup otorisasi",
			"esMx": "Alcance de la autorización",
			"viVi": "Phạm vi ủy quyền",
			"ptPt": "Escopo da autorização"
		},
		{
			"textKey": "plzInputAuthScope",
			"classify": "tips",
			"zhCn": "请输入授权范围",
			"zhTw": "請輸入授權範圍",
			"enUs": "Please enter authorization scope",
			"thTh": "โปรดป้อนขอบเขตการอนุญาต",
			"idId": "Masukkan ruang lingkup otorisasi",
			"esMx": "Ingrese el alcance de la autorización",
			"viVi": "Vui lòng nhập phạm vi ủy quyền",
			"ptPt": "Por favor, insira o escopo da autorização"
		},
		{
			"textKey": "accessTokenSeconds",
			"classify": "label",
			"zhCn": "令牌秒数",
			"zhTw": "令牌秒數",
			"enUs": "Token Seconds",
			"thTh": "โทเค็นจำนวนวินาที",
			"idId": "Token detik",
			"esMx": "Segundos de fichas",
			"viVi": "Số giây mã thông báo",
			"ptPt": "Número de segundos de token"
		},
		{
			"textKey": "plzInputAccessTokenTimeoutSec",
			"classify": "tips",
			"zhCn": "请输入令牌过期秒数",
			"zhTw": "請輸入令牌過期秒數",
			"enUs": "Please enter the number of seconds the token expires",
			"thTh": "โปรดป้อนจำนวนวินาทีที่หมดอายุของโทเค็น",
			"idId": "Masukkan jumlah detik kedaluwarsa token",
			"esMx": "Ingrese el número de segundos de vencimiento del token",
			"viVi": "Vui lòng nhập số giây hết hạn của mã thông báo",
			"ptPt": "Por favor, insira o número de segundos de expiração do token"
		},
		{
			"textKey": "refreshSecconds",
			"classify": "label",
			"zhCn": "刷新秒数",
			"zhTw": "刷新秒數",
			"enUs": "Refresh Seconds",
			"thTh": "รีเฟรชจำนวนวินาที",
			"idId": "Segarkan detik",
			"esMx": "Actualizar segundos",
			"viVi": "Làm mới số giây",
			"ptPt": "Atualizar o número de segundos"
		},
		{
			"textKey": "plzInputRefreshTokenTimeoutSec",
			"classify": "tips",
			"zhCn": "请输入刷新令牌过期秒数",
			"zhTw": "請輸入刷新令牌過期秒數",
			"enUs": "Please enter the number of seconds in which the refresh token expires",
			"thTh": "โปรดป้อนวินาทีที่หมดอายุในการรีเฟรชโทเค็น",
			"idId": "Masukkan jumlah detik kedaluwarsa token penyegaran",
			"esMx": "Ingrese el número de segundos de vencimiento del token de actualización",
			"viVi": "Vui lòng nhập số giây hết hạn của mã thông báo làm mới",
			"ptPt": "Por favor, insira o número de segundos expirados do token de atualização"
		},
		{
			"textKey": "callbackAddress",
			"classify": "label",
			"zhCn": "回调地址",
			"zhTw": "回調地址",
			"enUs": "Callback Address",
			"thTh": "ที่อยู่โทรกลับ",
			"idId": "Alamat panggilan balik",
			"esMx": "Dirección de devolución de llamada",
			"viVi": "Địa chỉ gọi lại",
			"ptPt": "Endereço de retorno de chamada"
		},
		{
			"textKey": "plzInputCallbackAddress",
			"classify": "tips",
			"zhCn": "请输入回调地址",
			"zhTw": "請輸入回調地址",
			"enUs": "Please enter the callback address",
			"thTh": "กรุณาป้อนที่อยู่โทรกลับ",
			"idId": "Silakan masukkan alamat panggilan balik",
			"esMx": "Ingrese la dirección de devolución de llamada",
			"viVi": "Vui lòng nhập địa chỉ gọi lại",
			"ptPt": "Por favor, insira o endereço de retorno de chamada"
		},
		{
			"textKey": "autoApprove",
			"classify": "label",
			"zhCn": "自动授权",
			"zhTw": "自動授權",
			"enUs": "Automatic authorization",
			"thTh": "การอนุญาตอัตโนมัติ",
			"idId": "Otorisasi otomatis",
			"esMx": "Autorización automática",
			"viVi": "Ủy quyền tự động",
			"ptPt": "Autorização automática"
		},
		{
			"textKey": "plzInputAutoApprove",
			"classify": "tips",
			"zhCn": "请输入自动授权",
			"zhTw": "請輸入自動授權",
			"enUs": "Please enter automatic authorization",
			"thTh": "โปรดป้อนการอนุญาตอัตโนมัติ",
			"idId": "Silakan masukkan otorisasi otomatis",
			"esMx": "Ingrese la autorización automática",
			"viVi": "Vui lòng nhập ủy quyền tự động",
			"ptPt": "Por favor, insira a autorização automática"
		},
		{
			"textKey": "assetsCollect",
			"classify": "label",
			"zhCn": "资源集合",
			"zhTw": "資源集合",
			"enUs": "Resource Collection",
			"thTh": "การรวบรวมทรัพยากร",
			"idId": "Koleksi sumber daya",
			"esMx": "Colección de recursos",
			"viVi": "Bộ sưu tập tài nguyên",
			"ptPt": "Coleção de recursos"
		},
		{
			"textKey": "plzInputAssetsCollect",
			"classify": "tips",
			"zhCn": "请输入资源集合",
			"zhTw": "請輸入資源集合",
			"enUs": "Please enter a resource collection",
			"thTh": "โปรดป้อนการรวบรวมทรัพยากร",
			"idId": "Silakan masukkan koleksi sumber daya",
			"esMx": "Ingrese la colección de recursos",
			"viVi": "Vui lòng nhập bộ sưu tập tài nguyên",
			"ptPt": "Insira a coleção de recursos"
		},
		{
			"textKey": "authorization",
			"classify": "label",
			"zhCn": "权限",
			"zhTw": "權限",
			"enUs": "Permissions",
			"thTh": "สิทธิ์",
			"idId": "Izin",
			"esMx": "Permisos",
			"viVi": "Quyền",
			"ptPt": "Permissões"
		},
		{
			"textKey": "plzInputAuth",
			"classify": "tips",
			"zhCn": "请输入权限",
			"zhTw": "請輸入權限",
			"enUs": "Please enter permissions",
			"thTh": "กรุณากรอกสิทธิ์",
			"idId": "Silakan masukkan izin",
			"esMx": "Por favor ingrese permisos",
			"viVi": "Vui lòng nhập quyền",
			"ptPt": "Por favor, insira as permissões"
		},
		{
			"textKey": "additionInformation",
			"classify": "label",
			"zhCn": "附加说明",
			"zhTw": "附加說明",
			"enUs": "Additional Notes",
			"thTh": "คำอธิบายเพิ่มเติม",
			"idId": "Catatan tambahan",
			"esMx": "Instrucciones adicionales",
			"viVi": "Hướng dẫn bổ sung",
			"ptPt": "Instruções adicionais"
		},
		{
			"textKey": "plzInputAdditionInformation",
			"classify": "tips",
			"zhCn": "请输入附加说明",
			"zhTw": "請輸入附加說明",
			"enUs": "Please enter additional instructions",
			"thTh": "โปรดป้อนคำอธิบายเพิ่มเติม",
			"idId": "Masukkan petunjuk tambahan",
			"esMx": "Introduzca las instrucciones adicionales",
			"viVi": "Vui lòng nhập hướng dẫn bổ sung",
			"ptPt": "Por favor, insira instruções adicionais"
		},
		{
			"textKey": "plzInputDeptName",
			"classify": "tips",
			"zhCn": "请输入机构名称",
			"zhTw": "請輸入機構名稱",
			"enUs": "Please enter institution name",
			"thTh": "โปรดป้อนชื่อองค์กร",
			"idId": "Silakan masukkan nama institusi",
			"esMx": "Por favor ingrese el nombre de la institución",
			"viVi": "Vui lòng nhập tên tổ chức",
			"ptPt": "Por favor, insira o nome da instituição"
		},
		{
			"textKey": "plzInputDeptFullName",
			"classify": "tips",
			"zhCn": "请输入机构全称",
			"zhTw": "請輸入機構全稱",
			"enUs": "Please enter the full name of the institution",
			"thTh": "โปรดป้อนชื่อเต็มขององค์กร",
			"idId": "Silakan masukkan nama lengkap organisasi",
			"esMx": "Ingrese el nombre completo de la organización",
			"viVi": "Vui lòng nhập tên đầy đủ của tổ chức",
			"ptPt": "Por favor, insira o nome completo da instituição"
		},
		{
			"textKey": "plzSelectSuperiorDept",
			"classify": "tips",
			"zhCn": "请选择上级机构",
			"zhTw": "請選擇上級機構",
			"enUs": "Please select a parent organization",
			"thTh": "โปรดเลือกองค์กรที่เหนือกว่า",
			"idId": "Silakan pilih lembaga induk",
			"esMx": "Elija una institución de nivel superior",
			"viVi": "Vui lòng chọn cơ quan cấp trên",
			"ptPt": "Por favor, escolha uma instituição superior"
		},
		{
			"textKey": "plzInputDeptType",
			"classify": "tips",
			"zhCn": "请输入机构类型",
			"zhTw": "請輸入機構類型",
			"enUs": "Please enter a mechanism type",
			"thTh": "โปรดป้อนประเภทสถาบัน",
			"idId": "Silakan masukkan jenis institusi",
			"esMx": "Introduzca el tipo de institución",
			"viVi": "Vui lòng nhập loại tổ chức",
			"ptPt": "Por favor, insira o tipo de instituição"
		},
		{
			"textKey": "plzInputDictNum",
			"classify": "tips",
			"zhCn": "请输入字典编号",
			"zhTw": "請輸入字典編號",
			"enUs": "Please enter a dictionary number",
			"thTh": "โปรดป้อนหมายเลขพจนานุกรม",
			"idId": "Silakan masukkan nomor kamus",
			"esMx": "Por favor ingrese el número de diccionario",
			"viVi": "Vui lòng nhập số từ điển",
			"ptPt": "Por favor, insira o número do dicionário"
		},
		{
			"textKey": "plzInputDictName",
			"classify": "tips",
			"zhCn": "请输入字典名称",
			"zhTw": "請輸入字典名稱",
			"enUs": "Please enter a dictionary name",
			"thTh": "กรุณาใส่ชื่อพจนานุกรม",
			"idId": "Silakan masukkan nama kamus",
			"esMx": "Por favor ingrese el nombre del diccionario",
			"viVi": "Vui lòng nhập tên từ điển",
			"ptPt": "Por favor, insira o nome do dicionário"
		},
		{
			"textKey": "plzSelectIfSealedUp",
			"classify": "tips",
			"zhCn": "请选择封存",
			"zhTw": "請選擇封存",
			"enUs": "Please select seal",
			"thTh": "โปรดเลือกการจัดเก็บ",
			"idId": "Silakan pilih penyimpanan",
			"esMx": "Elija sellar",
			"viVi": "Vui lòng chọn lưu trữ",
			"ptPt": "Por favor, escolha o selo"
		},
		{
			"textKey": "plzSelectSupperiorDict",
			"classify": "tips",
			"zhCn": "请选择上级字典",
			"zhTw": "請選擇上級字典",
			"enUs": "Please select a superior dictionary",
			"thTh": "โปรดเลือกพจนานุกรมที่เหนือกว่า",
			"idId": "Silakan pilih kamus tingkat tinggi",
			"esMx": "Seleccione el diccionario superior",
			"viVi": "Vui lòng chọn từ điển cấp trên",
			"ptPt": "Por favor, selecione o dicionário superior"
		},
		{
			"textKey": "plzInputDictKey",
			"classify": "tips",
			"zhCn": "请输入字典键值",
			"zhTw": "請輸入字典鍵值",
			"enUs": "Please enter a dictionary key value",
			"thTh": "กรุณาป้อนค่าคีย์พจนานุกรม",
			"idId": "Masukkan nilai kunci kamus",
			"esMx": "Ingrese el valor de la clave del diccionario",
			"viVi": "Vui lòng nhập giá trị khóa từ điển",
			"ptPt": "Por favor, insira um valor de chave de dicionário"
		},
		{
			"textKey": "search",
			"classify": "btn",
			"zhCn": "搜索",
			"zhTw": "搜索",
			"enUs": "Search",
			"thTh": "ค้นหา",
			"idId": "Pencarian",
			"esMx": "Búsqueda",
			"viVi": "Tìm kiếm",
			"ptPt": "Pesquisa"
		},
		{
			"textKey": "paramName",
			"classify": "label",
			"zhCn": "参数名",
			"zhTw": "參數名",
			"enUs": "Parameter Name",
			"thTh": "ชื่อพารามิเตอร์",
			"idId": "Nama parameter",
			"esMx": "Nombre del parámetro",
			"viVi": "Tên tham số",
			"ptPt": "Nome do parâmetro"
		},
		{
			"textKey": "paramKey",
			"classify": "label",
			"zhCn": "参数键",
			"zhTw": "參數鍵",
			"enUs": "Parameter Key",
			"thTh": "คีย์พารามิเตอร์",
			"idId": "Tombol Parameter",
			"esMx": "Teclas de parámetros",
			"viVi": "Phím tham số",
			"ptPt": "Chave de parâmetro"
		},
		{
			"textKey": "plzInputParamKey",
			"classify": "tips",
			"zhCn": "请输入参数键",
			"zhTw": "請輸入參數鍵",
			"enUs": "Please enter parameter key",
			"thTh": "โปรดป้อนปุ่มพารามิเตอร์",
			"idId": "Silakan masukkan parameter kunci",
			"esMx": "Por favor ingrese la clave de parámetro",
			"viVi": "Vui lòng nhập phím tham số",
			"ptPt": "Por favor, insira a chave de parâmetro"
		},
		{
			"textKey": "paramValue",
			"classify": "label",
			"zhCn": "参数值",
			"zhTw": "參數值",
			"enUs": "Parameter Value",
			"thTh": "ค่าพารามิเตอร์",
			"idId": "Nilai parameter",
			"esMx": "Valor de parámetro",
			"viVi": "Giá trị tham số",
			"ptPt": "Valores de parâmetro"
		},
		{
			"textKey": "plzInputParamValue",
			"classify": "tips",
			"zhCn": "请输入参数值",
			"zhTw": "請輸入參數值",
			"enUs": "Please enter a parameter value",
			"thTh": "กรุณาป้อนค่าพารามิเตอร์",
			"idId": "Masukkan nilai parameter",
			"esMx": "Ingrese el valor del parámetro",
			"viVi": "Vui lòng nhập giá trị tham số",
			"ptPt": "Por favor, insira o valor do parâmetro"
		},
		{
			"textKey": "plzSelectPositionType",
			"classify": "tips",
			"zhCn": "请选择岗位类型",
			"zhTw": "請選擇崗位類型",
			"enUs": "Please select a position type",
			"thTh": "โปรดเลือกประเภทงาน",
			"idId": "Silakan pilih jenis posting",
			"esMx": "Seleccione el tipo de trabajo",
			"viVi": "Vui lòng chọn loại công việc",
			"ptPt": "Por favor, escolha o tipo de trabalho"
		},
		{
			"textKey": "plzInputPositionNum",
			"classify": "tips",
			"zhCn": "请输入岗位编号",
			"zhTw": "請輸入崗位編號",
			"enUs": "Please enter position number",
			"thTh": "กรุณากรอกหมายเลขโพสต์",
			"idId": "Silakan masukkan nomor pos",
			"esMx": "Ingrese el número de publicación",
			"viVi": "Vui lòng nhập số bài",
			"ptPt": "Por favor, insira o número do posto"
		},
		{
			"textKey": "plzInputPositionName",
			"classify": "tips",
			"zhCn": "请输入岗位名称",
			"zhTw": "請輸入崗位名稱",
			"enUs": "Please enter the position name",
			"thTh": "กรุณากรอกชื่องาน",
			"idId": "Silakan masukkan nama posting",
			"esMx": "Por favor ingrese el nombre del trabajo",
			"viVi": "Vui lòng nhập tên công việc",
			"ptPt": "Por favor, insira o nome do trabalho"
		},
		{
			"textKey": "plzInputPositionSort",
			"classify": "tips",
			"zhCn": "请输入岗位排序",
			"zhTw": "請輸入崗位排序",
			"enUs": "Please enter a position sort",
			"thTh": "กรุณากรอกการเรียงลำดับงาน",
			"idId": "Silakan masukkan urutkan posisi",
			"esMx": "Ingrese la clasificación de puestos",
			"viVi": "Vui lòng nhập sắp xếp công việc",
			"ptPt": "Por favor, insira a classificação de posições"
		},
		{
			"textKey": "productPackName",
			"classify": "label",
			"zhCn": "产品包名",
			"zhTw": "產品包名",
			"enUs": "Product Package Name",
			"thTh": "ชื่อแพคเกจผลิตภัณฑ์",
			"idId": "Nama paket produk",
			"esMx": "Nombre del paquete del producto",
			"viVi": "Tên gói sản phẩm",
			"ptPt": "O nome do pacote do produto"
		},
		{
			"textKey": "plzInputProductName",
			"classify": "tips",
			"zhCn": "请输入产品包名称",
			"zhTw": "請輸入產品包名稱",
			"enUs": "Please enter a product package name",
			"thTh": "กรุณากรอกชื่อแพคเกจผลิตภัณฑ์",
			"idId": "Silakan masukkan nama paket produk",
			"esMx": "Introduzca el nombre del paquete del producto",
			"viVi": "Vui lòng nhập tên gói sản phẩm",
			"ptPt": "Por favor, insira o nome do pacote do produto"
		},
		{
			"textKey": "menuList",
			"classify": "label",
			"zhCn": "菜单列表",
			"zhTw": "菜單列表",
			"enUs": "Menu List",
			"thTh": "รายการเมนู",
			"idId": "Daftar menu",
			"esMx": "Lista de menús",
			"viVi": "Danh sách menu",
			"ptPt": "Lista de menus"
		},
		{
			"textKey": "plzSelectMenu",
			"classify": "tips",
			"zhCn": "请选择菜单",
			"zhTw": "請選擇菜單",
			"enUs": "Please select menu",
			"thTh": "โปรดเลือกเมนู",
			"idId": "Silakan pilih menu",
			"esMx": "Por favor seleccione el menú",
			"viVi": "Vui lòng chọn menu",
			"ptPt": "Por favor, escolha o menu"
		},
		{
			"textKey": "codeGenerate",
			"classify": "btn",
			"zhCn": "代码生成",
			"zhTw": "代碼生成",
			"enUs": "Code generation",
			"thTh": "การสร้างรหัส",
			"idId": "Pembuatan kode",
			"esMx": "Generación de código",
			"viVi": "Tạo mã",
			"ptPt": "Geração de código"
		},
		{
			"textKey": "copy",
			"classify": "btn",
			"zhCn": "复制",
			"zhTw": "複製",
			"enUs": "Copy",
			"thTh": "คัดลอก",
			"idId": "Menyalin",
			"esMx": "Copiar",
			"viVi": "Sao chép",
			"ptPt": "Reprodução"
		},
		{
			"textKey": "type",
			"classify": "label",
			"zhCn": "类型",
			"zhTw": "類型",
			"enUs": "Type",
			"thTh": "หมวดหมู่",
			"idId": "Kategori",
			"esMx": "Tipo",
			"viVi": "Thể loại",
			"ptPt": "Tipo"
		},
		{
			"textKey": "chinese",
			"classify": "label",
			"zhCn": "中文",
			"zhTw": "中文",
			"enUs": "Chinese",
			"thTh": "ภาษาจีน",
			"idId": "Bahasa Cina",
			"esMx": "Chino",
			"viVi": "Tiếng Trung",
			"ptPt": "Chinês"
		},
		{
			"textKey": "key",
			"classify": "label",
			"zhCn": "键",
			"zhTw": "鍵",
			"enUs": "Key",
			"thTh": "คีย์",
			"idId": "Tombol",
			"esMx": "Claves",
			"viVi": "Phím",
			"ptPt": "Chave"
		},
		{
			"textKey": "classify",
			"classify": "label",
			"zhCn": "分组分类",
			"zhTw": "分組分類",
			"enUs": "Group classification",
			"thTh": "การจัดกลุ่ม",
			"idId": "Klasifikasi grup",
			"esMx": "Clasificación de grupos",
			"viVi": "Phân loại nhóm",
			"ptPt": "Classificação de agrupamento"
		},
		{
			"textKey": "english",
			"classify": "label",
			"zhCn": "英文",
			"zhTw": "英文",
			"enUs": "English",
			"thTh": "ภาษาอังกฤษ",
			"idId": "Bahasa Inggris",
			"esMx": "Inglés",
			"viVi": "Tiếng Anh",
			"ptPt": "Inglês"
		},
		{
			"textKey": "thai",
			"classify": "label",
			"zhCn": "泰文",
			"zhTw": "泰文",
			"enUs": "Thai",
			"thTh": "ภาษาไทย",
			"idId": "Bahasa Thailand",
			"esMx": "Tailandés",
			"viVi": "Tiếng Thái",
			"ptPt": "Tailandês"
		},
		{
			"textKey": "indonesia",
			"classify": "label",
			"zhCn": "印尼",
			"zhTw": "印尼",
			"enUs": "Indonesia",
			"thTh": "อินโดนีเซีย",
			"idId": "Indonesia",
			"esMx": "Indonesia",
			"viVi": "Indonesia",
			"ptPt": "Indonésia"
		},
		{
			"textKey": "spain",
			"classify": "label",
			"zhCn": "西班牙",
			"zhTw": "西班牙",
			"enUs": "Spain",
			"thTh": "สเปน",
			"idId": "Spanyol",
			"esMx": "España",
			"viVi": "Tây Ban Nha",
			"ptPt": "Espanha"
		},
		{
			"textKey": "chinaTw",
			"classify": "label",
			"zhCn": "中文繁体",
			"zhTw": "中文繁體",
			"enUs": "Traditional Chinese",
			"thTh": "ภาษาจีนดั้งเดิม",
			"idId": "Cina Tradisional",
			"esMx": "Chino tradicional",
			"viVi": "Truyền thống Trung Quốc",
			"ptPt": "Chinês tradicional"
		},
		{
			"textKey": "translateInfo",
			"classify": "label",
			"zhCn": "翻译信息",
			"zhTw": "翻譯信息",
			"enUs": "Translate information",
			"thTh": "แปลข้อมูล",
			"idId": "Informasi terjemahan",
			"esMx": "Información de traducción",
			"viVi": "Dịch thông tin",
			"ptPt": "Traduzir informações"
		},
		{
			"textKey": "plzInputChinese",
			"classify": "tips",
			"zhCn": "请输入中文",
			"zhTw": "請輸入中文",
			"enUs": "Please enter Chinese",
			"thTh": "กรุณากรอกภาษาจีน",
			"idId": "Silakan masukkan bahasa Mandarin",
			"esMx": "Por favor ingrese chino",
			"viVi": "Vui lòng nhập tiếng Trung",
			"ptPt": "Por favor, digite chinês"
		},
		{
			"textKey": "plzInputKey",
			"classify": "tips",
			"zhCn": "请输入键",
			"zhTw": "請輸入鍵",
			"enUs": "Please enter the key",
			"thTh": "กรุณาใส่คีย์",
			"idId": "Silakan masukkan kunci",
			"esMx": "Por favor ingrese la tecla",
			"viVi": "Vui lòng nhập phím",
			"ptPt": "Por favor, digite a chave"
		},
		{
			"textKey": "plzInputClassify",
			"classify": "tips",
			"zhCn": "请输入分类",
			"zhTw": "請輸入分類",
			"enUs": "Please enter a classification",
			"thTh": "กรุณาใส่หมวดหมู่",
			"idId": "Silakan masukkan klasifikasi",
			"esMx": "Por favor ingrese la categoría",
			"viVi": "Vui lòng nhập danh mục",
			"ptPt": "Por favor, insira a classificação"
		},
		{
			"textKey": "pageName",
			"classify": "option",
			"zhCn": "页面名称",
			"zhTw": "頁面名稱",
			"enUs": "Page Name",
			"thTh": "ชื่อหน้า",
			"idId": "Nama Halaman",
			"esMx": "Nombre de la página",
			"viVi": "Tên trang",
			"ptPt": "Nome da página"
		},
		{
			"textKey": "electricQuantity",
			"classify": "label",
			"zhCn": "电量",
			"zhTw": "電量",
			"enUs": "Electricity",
			"thTh": "แบตเตอรี่",
			"idId": "Daya listrik",
			"esMx": "Electricidad",
			"viVi": "Điện",
			"ptPt": "Energia elétrica"
		},
		{
			"textKey": "price",
			"classify": "label",
			"zhCn": "价格",
			"zhTw": "價格",
			"enUs": "Price",
			"thTh": "ราคา",
			"idId": "Harga",
			"esMx": "Precio",
			"viVi": "Giá",
			"ptPt": "Preço"
		},
		{
			"textKey": "amount",
			"classify": "label",
			"zhCn": "金额",
			"zhTw": "金額",
			"enUs": "Amount",
			"thTh": "จำนวนเงิน",
			"idId": "Jumlah",
			"esMx": "Cantidad",
			"viVi": "Số tiền",
			"ptPt": "Quantidade"
		},
		{
			"textKey": "measurePointId",
			"classify": "label",
			"zhCn": "测量ID",
			"zhTw": "測量ID",
			"enUs": "Measurement ID",
			"thTh": "วัด ID",
			"idId": "ID pengukuran",
			"esMx": "ID de medición",
			"viVi": "ID đo lường",
			"ptPt": "ID de medição"
		},
		{
			"textKey": "planName",
			"classify": "label",
			"zhCn": "计划名称",
			"zhTw": "計劃名稱",
			"enUs": "Scheme Name",
			"thTh": "ชื่อโปรแกรม",
			"idId": "Nama rencana",
			"esMx": "Nombre del programa",
			"viVi": "Tên kế hoạch",
			"ptPt": "Nome do plano"
		},
		{
			"textKey": "timePeriodSetting",
			"classify": "title",
			"zhCn": "时间段设置",
			"zhTw": "時間段設置",
			"enUs": "Time period setting",
			"thTh": "การตั้งค่าช่วงเวลา",
			"idId": "Pengaturan periode waktu",
			"esMx": "Configuración del período de tiempo",
			"viVi": "Cài đặt khoảng thời gian",
			"ptPt": "Configurações de período de tempo"
		},
		{
			"textKey": "plzInputPlanName",
			"classify": "tips",
			"zhCn": "请输入计划名称",
			"zhTw": "請輸入計劃名稱",
			"enUs": "Please enter a schedule name",
			"thTh": "โปรดป้อนชื่อโปรแกรม",
			"idId": "Masukkan nama skema",
			"esMx": "Por favor ingrese el nombre del programa",
			"viVi": "Vui lòng nhập tên kế hoạch",
			"ptPt": "Por favor, insira o nome do plano"
		},
		{
			"textKey": "plzSelectEndTime",
			"classify": "tips",
			"zhCn": "请选择结束时间",
			"zhTw": "請選擇結束時間",
			"enUs": "Please select an end time",
			"thTh": "โปรดเลือกเวลาสิ้นสุด",
			"idId": "Silakan pilih waktu akhir",
			"esMx": "Seleccione la hora de finalización",
			"viVi": "Vui lòng chọn thời gian kết thúc",
			"ptPt": "Por favor, escolha o horário de término"
		},
		{
			"textKey": "YUAN",
			"classify": "label",
			"zhCn": "元",
			"zhTw": "元",
			"enUs": "USD",
			"thTh": "THB",
			"idId": "IDR",
			"esMx": "Yuan",
			"viVi": "Nhân dân tệ",
			"ptPt": "Yuan"
		},
		{
			"textKey": "plzSelectStatus",
			"classify": "tips",
			"zhCn": "请选择状态",
			"zhTw": "請選擇狀態",
			"enUs": "Please select a status",
			"thTh": "โปรดเลือกสถานะ",
			"idId": "Silakan pilih status",
			"esMx": "Seleccione el estado",
			"viVi": "Vui lòng chọn trạng thái",
			"ptPt": "Por favor, escolha o estado"
		},
		{
			"textKey": "plzInputPrice",
			"classify": "tips",
			"zhCn": "请输入价格",
			"zhTw": "請輸入價格",
			"enUs": "Please enter price",
			"thTh": "กรุณากรอกราคา",
			"idId": "Silakan masukkan harga",
			"esMx": "Por favor ingrese el precio",
			"viVi": "Vui lòng nhập giá",
			"ptPt": "Por favor, insira o preço"
		},
		{
			"textKey": "timePeriod",
			"classify": "label",
			"zhCn": "时间段",
			"zhTw": "時間段",
			"enUs": "Time period",
			"thTh": "ช่วงเวลา",
			"idId": "Periode waktu",
			"esMx": "Período de tiempo",
			"viVi": "Khoảng thời gian",
			"ptPt": "Período de tempo"
		},
		{
			"textKey": "limitPriceInput",
			"classify": "tips",
			"zhCn": "只能输入数字，最多三位小数",
			"zhTw": "只能輸入數字,最多三位小數",
			"enUs": "Can only enter numbers, up to three decimal places",
			"thTh": "สามารถป้อนตัวเลขได้สูงสุดทศนิยมสามตำแหน่ง",
			"idId": "Hanya bisa memasukkan angka, hingga tiga desimal",
			"esMx": "Solo puede ingresar números, hasta tres decimales",
			"viVi": "Chỉ có thể nhập số, tối đa ba chữ số thập phân",
			"ptPt": "Apenas números podem ser inseridos, até três decimais"
		},
		{
			"textKey": "tenantId",
			"classify": "label",
			"zhCn": "租户ID",
			"zhTw": "租戶ID",
			"enUs": "Tenant ID",
			"thTh": "ID ผู้เช่า",
			"idId": "Penyewa ID",
			"esMx": "ID de inquilino",
			"viVi": "ID người thuê nhà",
			"ptPt": "ID do inquilino"
		},
		{
			"textKey": "billPlan",
			"classify": "label",
			"zhCn": "计费方案",
			"zhTw": "計費方案",
			"enUs": "Billing scheme",
			"thTh": "แผนการเรียกเก็บเงิน",
			"idId": "Skema penagihan",
			"esMx": "Plan de facturación",
			"viVi": "Kế hoạch thanh toán",
			"ptPt": "Plano de faturamento"
		},
		{
			"textKey": "backToDashboard",
			"classify": "label",
			"zhCn": "返回大屏",
			"zhTw": "返回大屏",
			"enUs": "Return to Big Screen",
			"thTh": "กลับไปที่หน้าจอขนาดใหญ่",
			"idId": "Kembali ke layar besar",
			"esMx": "Volver a la pantalla grande",
			"viVi": "Quay lại màn hình lớn",
			"ptPt": "Voltar para a tela grande"
		},
		{
			"textKey": "plzInputSort",
			"classify": "tipsa",
			"zhCn": "请输入排序",
			"zhTw": "請輸入排序",
			"enUs": "Please enter a sort",
			"thTh": "กรุณาป้อนการเรียงลำดับ",
			"idId": "Silakan masukkan pengurutan",
			"esMx": "Por favor ingrese la clasificación",
			"viVi": "Vui lòng nhập sắp xếp",
			"ptPt": "Por favor, insira a classificação"
		},
		{
			"textKey": "content",
			"classify": "label",
			"zhCn": "内容",
			"zhTw": "內容",
			"enUs": "Content",
			"thTh": "เนื้อหา",
			"idId": "Konten",
			"esMx": "Contenido",
			"viVi": "Nội dung",
			"ptPt": "Conteúdo"
		},
		{
			"textKey": "operator",
			"classify": "label",
			"zhCn": "操作人",
			"zhTw": "操作人",
			"enUs": "Operator",
			"thTh": "ผู้ดำเนินการ",
			"idId": "Operator",
			"esMx": "Operadores",
			"viVi": "Người điều hành",
			"ptPt": "Homem de operação"
		},
		{
			"textKey": "pageDoesNotExit",
			"classify": "tips",
			"zhCn": "页面不存在",
			"zhTw": "頁面不存在",
			"enUs": "Page does not exist",
			"thTh": "ไม่มีหน้า",
			"idId": "Halaman tidak ada",
			"esMx": "La página no existe",
			"viVi": "Trang không tồn tại",
			"ptPt": "A página não existe"
		},
		{
			"textKey": "pageClassify",
			"classify": "label",
			"zhCn": "页面分类",
			"zhTw": "頁面分類",
			"enUs": "Page Classification",
			"thTh": "หมวดหมู่หน้า",
			"idId": "Kategori Halaman",
			"esMx": "Categoría de página",
			"viVi": "Phân loại trang",
			"ptPt": "Categorias de páginas"
		},
		{
			"textKey": "addClassify",
			"classify": "label",
			"zhCn": "新增分类",
			"zhTw": "新增分類",
			"enUs": "Add Category",
			"thTh": "เพิ่มหมวดหมู่",
			"idId": "Kategori baru",
			"esMx": "Nueva categoría",
			"viVi": "Danh mục mới",
			"ptPt": "Nova classificação"
		},
		{
			"textKey": "addAssemblePage",
			"classify": "label",
			"zhCn": "新增组态页面",
			"zhTw": "新增組態頁面",
			"enUs": "New Configuration Page",
			"thTh": "เพิ่มหน้าการกำหนดค่า",
			"idId": "Ditambahkan halaman konfigurasi",
			"esMx": "Agregar página de configuración",
			"viVi": "Trang cấu hình mới",
			"ptPt": "Nova página de configuração"
		},
		{
			"textKey": "fileUpload",
			"classify": "label",
			"zhCn": "文件上传",
			"zhTw": "文件上傳",
			"enUs": "File Upload",
			"thTh": "อัปโหลดไฟล์",
			"idId": "Unggah file",
			"esMx": "Carga de archivos",
			"viVi": "Tải lên tệp",
			"ptPt": "Upload de arquivo"
		},
		{
			"textKey": "selectFile",
			"classify": "label",
			"zhCn": "选择文件",
			"zhTw": "選擇文件",
			"enUs": "Select File",
			"thTh": "เลือกไฟล์",
			"idId": "Memilih file",
			"esMx": "Seleccionar archivos",
			"viVi": "Chọn tập tin",
			"ptPt": "Escolher o arquivo"
		},
		{
			"textKey": "inspectGroup",
			"classify": "label",
			"zhCn": "巡检分组",
			"zhTw": "巡檢分組",
			"enUs": "Inspection Group",
			"thTh": "กลุ่มตรวจสอบ",
			"idId": "Kelompok inspeksi",
			"esMx": "Grupo de inspección",
			"viVi": "Nhóm kiểm tra",
			"ptPt": "Grupo de inspeção"
		},
		{
			"textKey": "addGroup",
			"classify": "label",
			"zhCn": "添加分组",
			"zhTw": "添加分組",
			"enUs": "Add Grouping",
			"thTh": "เพิ่มการจัดกลุ่ม",
			"idId": "Menambahkan pengelompokan",
			"esMx": "Añadir grupos",
			"viVi": "Thêm nhóm",
			"ptPt": "Adicionar um agrupamento"
		},
		{
			"textKey": "groupName",
			"classify": "label",
			"zhCn": "分组名称",
			"zhTw": "分組名稱",
			"enUs": "Group Name",
			"thTh": "ชื่อกลุ่ม",
			"idId": "Nama grup",
			"esMx": "Nombre del grupo",
			"viVi": "Tên nhóm",
			"ptPt": "Nome do agrupamento"
		},
		{
			"textKey": "plzInputGroupName",
			"classify": "tips",
			"zhCn": "请输入分组名称",
			"zhTw": "請輸入分組名稱",
			"enUs": "Please enter a group name",
			"thTh": "โปรดป้อนชื่อกลุ่ม",
			"idId": "Masukkan nama grup",
			"esMx": "Ingrese el nombre del grupo",
			"viVi": "Vui lòng nhập tên nhóm",
			"ptPt": "Por favor, insira o nome do grupo"
		},
		{
			"textKey": "inspectMethod",
			"classify": "label",
			"zhCn": "巡检方法",
			"zhTw": "巡檢方法",
			"enUs": "inspection method",
			"thTh": "วิธีการตรวจสอบ",
			"idId": "Metode inspeksi",
			"esMx": "Método de inspección",
			"viVi": "Phương pháp kiểm tra",
			"ptPt": "Método de inspeção"
		},
		{
			"textKey": "ifTakePhoto",
			"classify": "label",
			"zhCn": "是否拍照",
			"zhTw": "是否拍照",
			"enUs": "Whether to take pictures",
			"thTh": "ถ่ายภาพหรือไม่",
			"idId": "Apakah akan mengambil foto",
			"esMx": "Si tomar una foto",
			"viVi": "Có chụp ảnh không",
			"ptPt": "Se tirar uma foto"
		},
		{
			"textKey": "standardRange",
			"classify": "label",
			"zhCn": "标准范围",
			"zhTw": "標準範圍",
			"enUs": "Standard Range",
			"thTh": "ช่วงมาตรฐาน",
			"idId": "Rentang standar",
			"esMx": "Rango estándar",
			"viVi": "Phạm vi tiêu chuẩn",
			"ptPt": "Escopo padrão"
		},
		{
			"textKey": "inspectProjectName",
			"classify": "label",
			"zhCn": "巡检项目",
			"zhTw": "巡檢項目",
			"enUs": "Inspection items",
			"thTh": "รายการตรวจสอบ",
			"idId": "Proyek inspeksi",
			"esMx": "Elementos de inspección",
			"viVi": "Dự án kiểm tra",
			"ptPt": "Itens de inspeção"
		},
		{
			"textKey": "plzInputProjectName",
			"classify": "tips",
			"zhCn": "请输入项目名称",
			"zhTw": "請輸入項目名稱",
			"enUs": "Please enter a project name",
			"thTh": "กรุณากรอกชื่อรายการ",
			"idId": "Masukkan nama proyek",
			"esMx": "Por favor ingrese el nombre del proyecto",
			"viVi": "Vui lòng nhập tên dự án",
			"ptPt": "Por favor, insira o nome do projeto"
		},
		{
			"textKey": "plzSelectInspectMethod",
			"classify": "tips",
			"zhCn": "请选择巡检方法",
			"zhTw": "請選擇巡檢方法",
			"enUs": "Please select inspection method",
			"thTh": "โปรดเลือกวิธีการตรวจสอบ",
			"idId": "Silakan pilih metode inspeksi",
			"esMx": "Seleccione el método de inspección",
			"viVi": "Vui lòng chọn phương pháp kiểm tra",
			"ptPt": "Por favor, escolha o método de inspeção"
		},
		{
			"textKey": "plzSelectIfTakePhoto",
			"classify": "tips",
			"zhCn": "请选择是否拍照",
			"zhTw": "請選擇是否拍照",
			"enUs": "Please choose whether to take pictures",
			"thTh": "โปรดเลือกว่าจะถ่ายภาพหรือไม่",
			"idId": "Silakan pilih apakah akan mengambil foto",
			"esMx": "Elija si desea tomar una foto",
			"viVi": "Vui lòng chọn có chụp ảnh không",
			"ptPt": "Por favor, escolha se quer tirar uma foto"
		},
		{
			"textKey": "plzInputStandarRange",
			"classify": "tips",
			"zhCn": "请输入标准范围",
			"zhTw": "請輸入標準範圍",
			"enUs": "Please enter a standard range",
			"thTh": "โปรดป้อนช่วงมาตรฐาน",
			"idId": "Silakan masukkan rentang standar",
			"esMx": "Ingrese el rango estándar",
			"viVi": "Vui lòng nhập phạm vi tiêu chuẩn",
			"ptPt": "Por favor, insira o intervalo padrão"
		},
		{
			"textKey": "groupInfo",
			"classify": "label",
			"zhCn": "分组信息",
			"zhTw": "分組信息",
			"enUs": "Grouping Information",
			"thTh": "ข้อมูลการจัดกลุ่ม",
			"idId": "Informasi grup",
			"esMx": "Información de agrupación",
			"viVi": "Thông tin nhóm",
			"ptPt": "Informação de agrupamento"
		},
		{
			"textKey": "importGroup",
			"classify": "btn",
			"zhCn": "导入分组",
			"zhTw": "導入分組",
			"enUs": "Import Grouping",
			"thTh": "กลุ่มนำเข้า",
			"idId": "Mengimpor pengelompokan",
			"esMx": "Agrupación de importación",
			"viVi": "Nhập nhóm",
			"ptPt": "Importar um agrupamento"
		},
		{
			"textKey": "importStandar",
			"classify": "btn",
			"zhCn": "导入标准",
			"zhTw": "導入標準",
			"enUs": "Import Standards",
			"thTh": "มาตรฐานการนำเข้า",
			"idId": "Standar Impor",
			"esMx": "Estándar de importación",
			"viVi": "Nhập tiêu chuẩn",
			"ptPt": "Importar critérios"
		},
		{
			"textKey": "exportGroup",
			"classify": "btn",
			"zhCn": "导出分组",
			"zhTw": "導出分組",
			"enUs": "Export Grouping",
			"thTh": "ส่งออกการจัดกลุ่ม",
			"idId": "Pengelompokan ekspor",
			"esMx": "Exportar grupos",
			"viVi": "Xuất nhóm",
			"ptPt": "Exportar agrupamento"
		},
		{
			"textKey": "exportStandar",
			"classify": "btn",
			"zhCn": "导出标准",
			"zhTw": "導出標準",
			"enUs": "Export Criteria",
			"thTh": "ส่งออกมาตรฐาน",
			"idId": "Standar ekspor",
			"esMx": "Estándar de exportación",
			"viVi": "Tiêu chuẩn xuất khẩu",
			"ptPt": "Padrão de exportação"
		},
		{
			"textKey": "addStandar",
			"classify": "btn",
			"zhCn": "新增标准",
			"zhTw": "新增標準",
			"enUs": "New standard",
			"thTh": "มาตรฐานใหม่",
			"idId": "Standar baru",
			"esMx": "Nuevos estándares",
			"viVi": "Tiêu chuẩn mới",
			"ptPt": "Novos padrões"
		},
		{
			"textKey": "editGroup",
			"classify": "label",
			"zhCn": "编辑分组",
			"zhTw": "編輯分組",
			"enUs": "Edit Grouping",
			"thTh": "แก้ไขการจัดกลุ่ม",
			"idId": "Mengedit pengelompokan",
			"esMx": "Edición de grupos",
			"viVi": "Nhóm chỉnh sửa",
			"ptPt": "Editar um agrupamento"
		},
		{
			"textKey": "deleteGroup",
			"classify": "label",
			"zhCn": "删除分组",
			"zhTw": "刪除分組",
			"enUs": "Delete Grouping",
			"thTh": "ลบการจัดกลุ่ม",
			"idId": "Menghapus grup",
			"esMx": "Eliminar grupos",
			"viVi": "Xóa nhóm",
			"ptPt": "Excluir um agrupamento"
		},
		{
			"textKey": "plzSelectGroupId",
			"classify": "tips",
			"zhCn": "请选择巡检分组",
			"zhTw": "請選擇巡檢分組",
			"enUs": "Please select inspection group",
			"thTh": "โปรดเลือกกลุ่มการตรวจสอบ",
			"idId": "Silakan pilih grup inspeksi",
			"esMx": "Seleccione el grupo de inspección",
			"viVi": "Vui lòng chọn nhóm kiểm tra",
			"ptPt": "Por favor, escolha o grupo de inspeção"
		},
		{
			"textKey": "inspectionStandar",
			"classify": "label",
			"zhCn": "巡检标准",
			"zhTw": "巡檢標準",
			"enUs": "Inspection standard",
			"thTh": "มาตรฐานการตรวจสอบ",
			"idId": "Standar inspeksi",
			"esMx": "Estándar de inspección",
			"viVi": "Tiêu chuẩn kiểm tra",
			"ptPt": "Padrões de inspeção"
		},
		{
			"textKey": "responsiblePerson",
			"classify": "label",
			"zhCn": "责任人",
			"zhTw": "責任人",
			"enUs": "Responsible Person",
			"thTh": "ผู้รับผิดชอบ",
			"idId": "Orang yang bertanggung jawab",
			"esMx": "Persona responsable",
			"viVi": "Người chịu trách nhiệm",
			"ptPt": "Responsável"
		},
		{
			"textKey": "peroidStartTime",
			"classify": "label",
			"zhCn": "周期开始时间",
			"zhTw": "週期開始時間",
			"enUs": "Cycle Start Time",
			"thTh": "เวลาเริ่มต้นของวงจร",
			"idId": "Waktu mulai siklus",
			"esMx": "Hora de inicio del ciclo",
			"viVi": "Thời gian bắt đầu chu kỳ",
			"ptPt": "Hora de início do ciclo"
		},
		{
			"textKey": "peroidEndTime",
			"classify": "label",
			"zhCn": "周期结束时间",
			"zhTw": "周期結束時間",
			"enUs": "Period End Time",
			"thTh": "เวลาสิ้นสุดของวงจร",
			"idId": "Waktu akhir siklus",
			"esMx": "Tiempo de finalización del ciclo",
			"viVi": "Thời gian kết thúc chu kỳ",
			"ptPt": "Tempo de término do ciclo"
		},
		{
			"textKey": "taskStartTime",
			"classify": "label",
			"zhCn": "任务生成时间",
			"zhTw": "任務開始時間",
			"enUs": "Task start time",
			"thTh": "เวลาในการสร้างงาน",
			"idId": "Waktu mulai tugas",
			"esMx": "Tiempo de generación de tareas",
			"viVi": "Thời gian tạo nhiệm vụ",
			"ptPt": "Tempo de geração de tarefas"
		},
		{
			"textKey": "taskEndTime",
			"classify": "label",
			"zhCn": "任务结束时间",
			"zhTw": "任務結束時間",
			"enUs": "Task End Time",
			"thTh": "เวลาสิ้นสุดภารกิจ",
			"idId": "Waktu akhir tugas",
			"esMx": "Tiempo de finalización de la misión",
			"viVi": "Thời gian kết thúc nhiệm vụ",
			"ptPt": "Tempo de conclusão da missão"
		},
		{
			"textKey": "inspectPeriod",
			"classify": "label",
			"zhCn": "巡检周期(天)",
			"zhTw": "巡檢周期(天)",
			"enUs": "Inspection period (days)",
			"thTh": "รอบการตรวจสอบ (วัน)",
			"idId": "Siklus inspeksi (hari)",
			"esMx": "Ciclo de inspección (días)",
			"viVi": "Chu kỳ kiểm tra (ngày)",
			"ptPt": "Ciclo de inspeção (dias)"
		},
		{
			"textKey": "inspectTimes",
			"classify": "label",
			"zhCn": "巡检次数",
			"zhTw": "巡檢次數",
			"enUs": "Inspection times",
			"thTh": "จำนวนการตรวจสอบ",
			"idId": "Jumlah inspeksi",
			"esMx": "Número de inspecciones",
			"viVi": "Số lần kiểm tra",
			"ptPt": "Número de inspeções"
		},
		{
			"textKey": "ifEnable",
			"classify": "label",
			"zhCn": "是否停用",
			"zhTw": "是否停用",
			"enUs": "Deactivate",
			"thTh": "ปิดใช้งานหรือไม่",
			"idId": "Apakah akan dinonaktifkan",
			"esMx": "Ya sea para desactivar",
			"viVi": "Có hủy kích hoạt không",
			"ptPt": "Desativar ou não"
		},
		{
			"textKey": "advanceDistribution",
			"classify": "label",
			"zhCn": "提前派发(分钟)",
			"zhTw": "提前派發(分鐘)",
			"enUs": "Early Dispatch (min)",
			"thTh": "แจกจ่ายล่วงหน้า (นาที)",
			"idId": "Distribusi awal (menit)",
			"esMx": "Distribución anticipada (minutos)",
			"viVi": "Phân phối trước (phút)",
			"ptPt": "Demissão antecipada (minutos)"
		},
		{
			"textKey": "resourceType",
			"classify": "label",
			"zhCn": "资源类型",
			"zhTw": "資源類型",
			"enUs": "Resource Type",
			"thTh": "ประเภททรัพยากร",
			"idId": "Jenis sumber daya",
			"esMx": "Tipo de recurso",
			"viVi": "Loại tài nguyên",
			"ptPt": "Tipos de recursos"
		},
		{
			"textKey": "plzSelectResponseiblePerson",
			"classify": "tips",
			"zhCn": "请选择责任人",
			"zhTw": "請選擇責任人",
			"enUs": "Please select the responsible person",
			"thTh": "โปรดเลือกผู้รับผิดชอบ",
			"idId": "Silakan pilih orang yang bertanggung jawab",
			"esMx": "Por favor seleccione la persona responsable",
			"viVi": "Vui lòng chọn người chịu trách nhiệm",
			"ptPt": "Por favor, escolha o responsável"
		},
		{
			"textKey": "plzInspectPeriod",
			"classify": "tips",
			"zhCn": "请输入巡检周期",
			"zhTw": "請輸入巡檢周期",
			"enUs": "Please enter the inspection cycle",
			"thTh": "โปรดป้อนรอบการตรวจสอบ",
			"idId": "Silakan masukkan siklus inspeksi",
			"esMx": "Ingrese el ciclo de inspección",
			"viVi": "Vui lòng nhập chu kỳ kiểm tra",
			"ptPt": "Por favor, insira o ciclo de inspeção"
		},
		{
			"textKey": "plzInputInspectTimes",
			"classify": "tips",
			"zhCn": "请输入巡检次数",
			"zhTw": "請輸入巡檢次數",
			"enUs": "Please enter the number of inspections",
			"thTh": "กรุณากรอกจำนวนการตรวจสอบ",
			"idId": "Silakan masukkan jumlah inspeksi",
			"esMx": "Ingrese el número de inspecciones",
			"viVi": "Vui lòng nhập số lần kiểm tra",
			"ptPt": "Por favor, insira o número de inspeções"
		},
		{
			"textKey": "plzSelectIfEnable",
			"classify": "tips",
			"zhCn": "请选择是否启用",
			"zhTw": "請選擇是否啟用",
			"enUs": "Please select whether to enable",
			"thTh": "โปรดเลือกว่าจะเปิดใช้งานหรือไม่",
			"idId": "Silakan pilih apakah akan mengaktifkan",
			"esMx": "Seleccione si desea habilitar",
			"viVi": "Vui lòng chọn có bật hay không",
			"ptPt": "Por favor, escolha se deseja ativar"
		},
		{
			"textKey": "plzInputAdvanceDistribution",
			"classify": "tips",
			"zhCn": "请输入提前派发",
			"zhTw": "請輸入提前派發",
			"enUs": "Please enter advance dispatch",
			"thTh": "กรุณากรอกการจัดส่งล่วงหน้า",
			"idId": "Silakan masukkan distribusi terlebih dahulu",
			"esMx": "Ingrese la distribución anticipada",
			"viVi": "Vui lòng nhập phân phối trước",
			"ptPt": "Por favor, insira e distribuiu com antecedência"
		},
		{
			"textKey": "plzSelectResourceType",
			"classify": "tips",
			"zhCn": "请选择资源类型",
			"zhTw": "請選擇資源類型",
			"enUs": "Please select a resource type",
			"thTh": "โปรดเลือกประเภททรัพยากร",
			"idId": "Silakan pilih jenis sumber daya",
			"esMx": "Seleccione el tipo de recurso",
			"viVi": "Vui lòng chọn loại tài nguyên",
			"ptPt": "Selecione o tipo de recurso"
		},
		{
			"textKey": "maintainGroup",
			"classify": "label",
			"zhCn": "保养分组",
			"zhTw": "保養分組",
			"enUs": "Maintenance Group",
			"thTh": "การจัดกลุ่มการบำรุงรักษา",
			"idId": "Pengelompokan perawatan",
			"esMx": "Grupo de mantenimiento",
			"viVi": "Nhóm bảo trì",
			"ptPt": "Agrupamento de manutenção"
		},
		{
			"textKey": "maintainProjectName",
			"classify": "label",
			"zhCn": "保养项目",
			"zhTw": "保養項目",
			"enUs": "Maintenance Items",
			"thTh": "รายการบำรุงรักษา",
			"idId": "Item perawatan",
			"esMx": "Elementos de mantenimiento",
			"viVi": "Hạng mục bảo trì",
			"ptPt": "Itens de manutenção"
		},
		{
			"textKey": "plzInputMaintainProjectName",
			"classify": "tips",
			"zhCn": "请输入保养项目名称",
			"zhTw": "請輸入保養項目名稱",
			"enUs": "Please enter the maintenance item name",
			"thTh": "กรุณากรอกชื่อรายการบำรุงรักษา",
			"idId": "Silakan masukkan nama item perawatan",
			"esMx": "Ingrese el nombre del elemento de mantenimiento",
			"viVi": "Vui lòng nhập tên mục bảo trì",
			"ptPt": "Por favor, insira o nome do item de manutenção"
		},
		{
			"textKey": "part",
			"classify": "label",
			"zhCn": "部位",
			"zhTw": "部位",
			"enUs": "Location",
			"thTh": "ส่วน",
			"idId": "Bagian",
			"esMx": "Ubicación",
			"viVi": "Bộ phận",
			"ptPt": "Partes"
		},
		{
			"textKey": "plzInputPart",
			"classify": "tips",
			"zhCn": "请输入部位",
			"zhTw": "請輸入部位",
			"enUs": "Please enter part",
			"thTh": "กรุณาใส่ตำแหน่ง",
			"idId": "Silakan masukkan bagian",
			"esMx": "Ingrese la ubicación",
			"viVi": "Vui lòng nhập phần",
			"ptPt": "Por favor, insira a parte"
		},
		{
			"textKey": "noticeItem",
			"classify": "label",
			"zhCn": "注意事项",
			"zhTw": "注意事項",
			"enUs": "Precautions",
			"thTh": "ข้อควรระวัง",
			"idId": "Catatan",
			"esMx": "Notas",
			"viVi": "Những vấn đề cần chú ý",
			"ptPt": "Precauções"
		},
		{
			"textKey": "plzInputNoticeItem",
			"classify": "tips",
			"zhCn": "请输入注意事项",
			"zhTw": "請輸入注意事項",
			"enUs": "Please enter notes",
			"thTh": "กรุณาใส่หมายเหตุ",
			"idId": "Silakan masukkan catatan",
			"esMx": "Por favor ingrese las notas",
			"viVi": "Vui lòng nhập ghi chú",
			"ptPt": "Por favor, insira as notas"
		},
		{
			"textKey": "utilsAndTech",
			"classify": "label",
			"zhCn": "工具与技术",
			"zhTw": "工具與技術",
			"enUs": "Tools and Techniques",
			"thTh": "เครื่องมือและเทคโนโลยี",
			"idId": "Alat dan Teknologi",
			"esMx": "Herramientas y tecnología",
			"viVi": "Công cụ và công nghệ",
			"ptPt": "Ferramentas e Tecnologia"
		},
		{
			"textKey": "plzInputUtilsAndTech",
			"classify": "tips",
			"zhCn": "请输入工具与技术",
			"zhTw": "請輸入工具與技術",
			"enUs": "Please enter tools and techniques",
			"thTh": "โปรดป้อนเครื่องมือและเทคโนโลยี",
			"idId": "Masukkan alat dan teknologi",
			"esMx": "Introduzca herramientas y técnicas",
			"viVi": "Vui lòng nhập các công cụ và công nghệ",
			"ptPt": "Por favor, insira ferramentas e técnicas"
		},
		{
			"textKey": "plzSelectMaintainGroupId",
			"classify": "tips",
			"zhCn": "请选择保养分组",
			"zhTw": "請選擇保養分組",
			"enUs": "Please select a service grouping",
			"thTh": "โปรดเลือกกลุ่มการบำรุงรักษา",
			"idId": "Silakan pilih paket perawatan",
			"esMx": "Seleccione el grupo de mantenimiento",
			"viVi": "Vui lòng chọn nhóm bảo trì",
			"ptPt": "Por favor, escolha o grupo de manutenção"
		},
		{
			"textKey": "judgeStandar",
			"classify": "label",
			"zhCn": "判定基准",
			"zhTw": "判定基準",
			"enUs": "Judgment reference",
			"thTh": "เกณฑ์การตัดสิน",
			"idId": "Tolok ukur penilaian",
			"esMx": "Base de juicio",
			"viVi": "Điểm chuẩn đánh giá",
			"ptPt": "Referência de julgamento"
		},
		{
			"textKey": "plzInputJudgeStandar",
			"classify": "tips",
			"zhCn": "请输入判定基准",
			"zhTw": "請輸入判定基準",
			"enUs": "Please enter a judgment reference",
			"thTh": "โปรดป้อนเกณฑ์การตัดสิน",
			"idId": "Silakan masukkan tolok ukur",
			"esMx": "Ingrese la base de juicio",
			"viVi": "Vui lòng nhập điểm chuẩn",
			"ptPt": "Por favor, insira o benchmark de julgamento"
		},
		{
			"textKey": "maintainStandar",
			"classify": "label",
			"zhCn": "保养标准",
			"zhTw": "保養標準",
			"enUs": "Maintenance standard",
			"thTh": "มาตรฐานการบำรุงรักษา",
			"idId": "Standar perawatan",
			"esMx": "Estándar de mantenimiento",
			"viVi": "Tiêu chuẩn bảo trì",
			"ptPt": "Padrão de manutenção"
		},
		{
			"textKey": "maintainDevice",
			"classify": "label",
			"zhCn": "保养设备",
			"zhTw": "保養設備",
			"enUs": "Maintenance of equipment",
			"thTh": "อุปกรณ์บำรุงรักษา",
			"idId": "Peralatan perawatan",
			"esMx": "Equipo de mantenimiento",
			"viVi": "Thiết bị bảo trì",
			"ptPt": "Manutenção de equipamentos"
		},
		{
			"textKey": "taskName",
			"classify": "label",
			"zhCn": "任务名称",
			"zhTw": "任務名稱",
			"enUs": "Task Name",
			"thTh": "ชื่องาน",
			"idId": "Nama tugas",
			"esMx": "Nombre de la tarea",
			"viVi": "Tên nhiệm vụ",
			"ptPt": "Nome da tarefa"
		},
		{
			"textKey": "realStartTime",
			"classify": "label",
			"zhCn": "实际开始时间",
			"zhTw": "實際開始時間",
			"enUs": "Actual Start Time",
			"thTh": "เวลาเริ่มต้นจริง",
			"idId": "Waktu mulai yang sebenarnya",
			"esMx": "Hora de inicio real",
			"viVi": "Thời gian bắt đầu thực tế",
			"ptPt": "Hora de início real"
		},
		{
			"textKey": "realFinishTime",
			"classify": "label",
			"zhCn": "实际完成时间",
			"zhTw": "實際完成時間",
			"enUs": "Actual completion time",
			"thTh": "เวลาเสร็จสิ้นจริง",
			"idId": "Waktu penyelesaian aktual",
			"esMx": "Tiempo real de finalización",
			"viVi": "Thời gian hoàn thành thực tế",
			"ptPt": "Tempo de conclusão real"
		},
		{
			"textKey": "taskNoumber",
			"classify": "label",
			"zhCn": "任务编号",
			"zhTw": "任務編號",
			"enUs": "Task Number",
			"thTh": "หมายเลขงาน",
			"idId": "Nomor Tugas",
			"esMx": "Número de tarea",
			"viVi": "Số nhiệm vụ",
			"ptPt": "Número da tarefa"
		},
		{
			"textKey": "taskStatus",
			"classify": "label",
			"zhCn": "任务状态",
			"zhTw": "任務狀態",
			"enUs": "Task Status",
			"thTh": "สถานะงาน",
			"idId": "Status tugas",
			"esMx": "Estado de la tarea",
			"viVi": "Tình trạng nhiệm vụ",
			"ptPt": "Status da tarefa"
		},
		{
			"textKey": "actualWorkHour",
			"classify": "label",
			"zhCn": "实际总工时",
			"zhTw": "實際總工時",
			"enUs": "Actual total work",
			"thTh": "ชั่วโมงการทำงานจริงทั้งหมด",
			"idId": "Total jam kerja aktual",
			"esMx": "Total de horas de trabajo reales",
			"viVi": "Tổng số giờ làm việc thực tế",
			"ptPt": "Total de horas de trabalho real"
		},
		{
			"textKey": "workHour",
			"classify": "label",
			"zhCn": "工时",
			"zhTw": "工時",
			"enUs": "Hours",
			"thTh": "ชั่วโมงการทำงาน",
			"idId": "Jam kerja",
			"esMx": "Horas de trabajo",
			"viVi": "Giờ làm việc",
			"ptPt": "Horas de trabalho"
		},
		{
			"textKey": "problemDes",
			"classify": "label",
			"zhCn": "问题描述",
			"zhTw": "問題描述",
			"enUs": "Problem Description",
			"thTh": "คำอธิบายปัญหา",
			"idId": "Deskripsi masalah",
			"esMx": "Descripción del problema",
			"viVi": "Mô tả vấn đề",
			"ptPt": "Descrição do problema"
		},
		{
			"textKey": "plzInputWorkHour",
			"classify": "tips",
			"zhCn": "请输入工时",
			"zhTw": "請輸入工時",
			"enUs": "Please enter work",
			"thTh": "กรุณากรอกชั่วโมงการทำงาน",
			"idId": "Silakan masukkan jam kerja",
			"esMx": "Ingrese las horas de trabajo",
			"viVi": "Vui lòng nhập giờ làm việc",
			"ptPt": "Por favor, insira horas de trabalho"
		},
		{
			"textKey": "plzInputProblemDes",
			"classify": "tips",
			"zhCn": "请输入问题描述",
			"zhTw": "請輸入問題描述",
			"enUs": "Please enter a description of the problem",
			"thTh": "โปรดป้อนคำอธิบายปัญหา",
			"idId": "Silakan masukkan deskripsi masalah",
			"esMx": "Introduzca la descripción del problema",
			"viVi": "Vui lòng nhập mô tả vấn đề",
			"ptPt": "Por favor, insira a descrição do problema"
		},
		{
			"textKey": "plzSelectTaskStatus",
			"classify": "tips",
			"zhCn": "请选择任务状态",
			"zhTw": "請選擇任務狀態",
			"enUs": "Please select a task status",
			"thTh": "โปรดเลือกสถานะงาน",
			"idId": "Silakan pilih status tugas",
			"esMx": "Seleccione el estado de la tarea",
			"viVi": "Vui lòng chọn trạng thái nhiệm vụ",
			"ptPt": "Por favor, escolha o status da tarefa"
		},
		{
			"textKey": "hasBeenCopiedToClipboard",
			"classify": "tips",
			"zhCn": "已复制到剪切板",
			"zhTw": "已複製到剪切板",
			"enUs": "Copied to clipboard",
			"thTh": "คัดลอกไปยังคลิปบอร์ด",
			"idId": "Disalin ke papan potong",
			"esMx": "Copiado en el portapapeles",
			"viVi": "Đã sao chép vào khay nhớ tạm",
			"ptPt": "Copiado para a placa de corte"
		},
		{
			"textKey": "productSeries",
			"classify": "label",
			"zhCn": "产品系列",
			"zhTw": "產品系列",
			"enUs": "Product Series",
			"thTh": "ชุดผลิตภัณฑ์",
			"idId": "Seri produk",
			"esMx": "Serie de productos",
			"viVi": "Dòng sản phẩm",
			"ptPt": "Série de produtos"
		},
		{
			"textKey": "plzSelectProductSeries",
			"classify": "tips",
			"zhCn": "请选择产品系列",
			"zhTw": "請選擇產品系列",
			"enUs": "Please select product series",
			"thTh": "โปรดเลือกชุดผลิตภัณฑ์",
			"idId": "Silakan pilih seri produk",
			"esMx": "Seleccione la serie de productos",
			"viVi": "Vui lòng chọn dòng sản phẩm",
			"ptPt": "Por favor, escolha uma série de produtos"
		},
		{
			"textKey": "plzInputIntNumber",
			"classify": "tips",
			"zhCn": "请输入正整数",
			"zhTw": "請輸入正整數",
			"enUs": "Please enter a positive integer",
			"thTh": "กรุณาใส่จำนวนเต็มบวก",
			"idId": "Masukkan bilangan bulat positif",
			"esMx": "Ingrese un número entero positivo",
			"viVi": "Vui lòng nhập số nguyên dương",
			"ptPt": "Por favor, insira um número inteiro positivo"
		},
		{
			"textKey": "plzInputChartOrNumber",
			"classify": "tips",
			"zhCn": "请输入英文字母或数字",
			"zhTw": "請輸入英文字母或數字",
			"enUs": "Please enter English letters or numbers",
			"thTh": "โปรดป้อนตัวอักษรหรือตัวเลขภาษาอังกฤษ",
			"idId": "Masukkan huruf atau angka dalam bahasa Inggris",
			"esMx": "Introduzca letras o números en inglés",
			"viVi": "Vui lòng nhập các chữ cái hoặc số tiếng Anh",
			"ptPt": "Por favor, insira letras ou números em inglês"
		},
		{
			"textKey": "deviceIdLengthLimit20",
			"classify": "tips",
			"zhCn": "设备ID长度不能超过20个字符",
			"zhTw": "設備ID長度不能超過20個字符",
			"enUs": "Device ID cannot be longer than 20 characters",
			"thTh": "ความยาวของอุปกรณ์ ID ต้องไม่เกิน20ตัวอักษร",
			"idId": "Perangkat ID panjang tidak dapat melebihi 20 karakter",
			"esMx": "La longitud del ID del dispositivo no puede exceder los 20 caracteres",
			"viVi": "Độ dài ID thiết bị không được vượt quá 20 ký tự",
			"ptPt": "O comprimento do ID do dispositivo não pode exceder 20 caracteres"
		},
		{
			"textKey": "moduleName",
			"classify": "label",
			"zhCn": "模块名",
			"zhTw": "模塊名",
			"enUs": "Module Name",
			"thTh": "ชื่อโมดูล",
			"idId": "Nama modul",
			"esMx": "Nombre del módulo",
			"viVi": "Tên mô-đun",
			"ptPt": "Nome do módulo"
		},
		{
			"textKey": "templateType",
			"classify": "label",
			"zhCn": "模版类型",
			"zhTw": "模版類型",
			"enUs": "Template Type",
			"thTh": "ประเภทแม่แบบ",
			"idId": "Tipe Template",
			"esMx": "Tipo de plantilla",
			"viVi": "Loại mẫu",
			"ptPt": "Tipo de estêncil"
		},
		{
			"textKey": "serviceName",
			"classify": "label",
			"zhCn": "服务名",
			"zhTw": "服務名",
			"enUs": "Service Name",
			"thTh": "ชื่อบริการ",
			"idId": "Nama layanan",
			"esMx": "Nombre del servicio",
			"viVi": "Tên dịch vụ",
			"ptPt": "Nome de serviço"
		},
		{
			"textKey": "packageName",
			"classify": "label",
			"zhCn": "包名",
			"zhTw": "包名",
			"enUs": "Package Name",
			"thTh": "ชื่อกระเป๋า",
			"idId": "Nama paket",
			"esMx": "Nombre del paquete",
			"viVi": "Tên túi",
			"ptPt": "O nome do pacote"
		},
		{
			"textKey": "modelConfig",
			"classify": "label",
			"zhCn": "模型配置",
			"zhTw": "模型配置",
			"enUs": "Model Configuration",
			"thTh": "การกำหนดค่าโมเดล",
			"idId": "Konfigurasi model",
			"esMx": "Configuración del modelo",
			"viVi": "Cấu hình mô hình",
			"ptPt": "Configuração do modelo"
		},
		{
			"textKey": "plzSelectDataModel",
			"classify": "tips",
			"zhCn": "请选择数据模型",
			"zhTw": "請選擇數據模型",
			"enUs": "Please select a data model",
			"thTh": "โปรดเลือกรูปแบบข้อมูล",
			"idId": "Silakan pilih Model Data",
			"esMx": "Seleccione el modelo de datos",
			"viVi": "Vui lòng chọn mô hình dữ liệu",
			"ptPt": "Escolha o modelo de dados"
		},
		{
			"textKey": "plzInputModuleName",
			"classify": "tips",
			"zhCn": "请输入模块名",
			"zhTw": "請輸入模塊名",
			"enUs": "Please enter a module name",
			"thTh": "โปรดป้อนชื่อโมดูล",
			"idId": "Masukkan nama modul",
			"esMx": "Ingrese el nombre del módulo",
			"viVi": "Vui lòng nhập tên mô-đun",
			"ptPt": "Por favor, insira o nome do módulo"
		},
		{
			"textKey": "plzInputServiceName",
			"classify": "tips",
			"zhCn": "请输入服务名",
			"zhTw": "請輸入服務名",
			"enUs": "Please enter a service name",
			"thTh": "กรุณากรอกชื่อบริการ",
			"idId": "Silakan masukkan nama layanan",
			"esMx": "Ingrese el nombre del servicio",
			"viVi": "Vui lòng nhập tên dịch vụ",
			"ptPt": "Por favor, insira um nome de serviço"
		},
		{
			"textKey": "reportName",
			"classify": "label",
			"zhCn": "报表名称",
			"zhTw": "報表名稱",
			"enUs": "Report Name",
			"thTh": "ชื่อรายงาน",
			"idId": "Nama laporan",
			"esMx": "Nombre del informe",
			"viVi": "Tên báo cáo",
			"ptPt": "Nome do relatório"
		},
		{
			"textKey": "tableName",
			"classify": "label",
			"zhCn": "表名",
			"zhTw": "錶名",
			"enUs": "Table Name",
			"thTh": "ชื่อตาราง",
			"idId": "Nama jam",
			"esMx": "Nombre de la tabla",
			"viVi": "Tên bảng",
			"ptPt": "O nome da tabela"
		},
		{
			"textKey": "plzInputTabelName",
			"classify": "tips",
			"zhCn": "请输入表名",
			"zhTw": "請輸入錶名",
			"enUs": "Please enter a table name",
			"thTh": "กรุณากรอกชื่อตาราง",
			"idId": "Silakan masukkan nama tabel",
			"esMx": "Ingrese el nombre de la tabla",
			"viVi": "Vui lòng nhập tên bảng",
			"ptPt": "Por favor, insira o nome da tabela"
		},
		{
			"textKey": "tablePrefix",
			"classify": "label",
			"zhCn": "表前缀",
			"zhTw": "錶前綴",
			"enUs": "Table Prefix",
			"thTh": "คำนำหน้าตาราง",
			"idId": "Awalan tabel",
			"esMx": "Prefijo de tabla",
			"viVi": "Tiền tố bảng",
			"ptPt": "Prefixo da tabela"
		},
		{
			"textKey": "plzInputTablePrefix",
			"classify": "tips",
			"zhCn": "请输入表前缀",
			"zhTw": "請輸入錶前綴",
			"enUs": "Please enter a table prefix",
			"thTh": "โปรดป้อนคำนำหน้าตาราง",
			"idId": "Silakan masukkan awalan tabel",
			"esMx": "Ingrese el prefijo de la tabla",
			"viVi": "Vui lòng nhập tiền tố bảng",
			"ptPt": "Insira o prefixo da tabela"
		},
		{
			"textKey": "primaryKeyName",
			"classify": "label",
			"zhCn": "主键名",
			"zhTw": "主鍵名",
			"enUs": "Primary Key Name",
			"thTh": "ชื่อคีย์หลัก",
			"idId": "Nama kunci utama",
			"esMx": "Nombre de la clave principal",
			"viVi": "Tên khóa chính",
			"ptPt": "O nome da chave primária"
		},
		{
			"textKey": "plzInputPrimaryKeyName",
			"classify": "tips",
			"zhCn": "请输入主键名",
			"zhTw": "請輸入主鍵名",
			"enUs": "Please enter a primary key name",
			"thTh": "โปรดป้อนชื่อคีย์หลัก",
			"idId": "Masukkan nama kunci utama",
			"esMx": "Ingrese el nombre de la clave principal",
			"viVi": "Vui lòng nhập tên khóa chính",
			"ptPt": "Por favor, insira o nome da chave primária"
		},
		{
			"textKey": "plzInputPackageName",
			"classify": "tips",
			"zhCn": "请输入包名",
			"zhTw": "請輸入包名",
			"enUs": "Please enter a package name",
			"thTh": "กรุณากรอกชื่อแพคเกจ",
			"idId": "Silakan masukkan nama paket",
			"esMx": "Ingrese el nombre del paquete",
			"viVi": "Vui lòng nhập tên gói",
			"ptPt": "Por favor, insira o nome do pacote"
		},
		{
			"textKey": "templateConfig",
			"classify": "label",
			"zhCn": "模版配置",
			"zhTw": "模版配置",
			"enUs": "Template Configuration",
			"thTh": "การกำหนดค่าเทมเพลต",
			"idId": "Konfigurasi templat",
			"esMx": "Configuración de la plantilla",
			"viVi": "Cấu hình mẫu",
			"ptPt": "Configuração de estêncil"
		},
		{
			"textKey": "plzSelectTemplateType",
			"classify": "tips",
			"zhCn": "请选择模版类型",
			"zhTw": "請選擇模版類型",
			"enUs": "Please select a template type",
			"thTh": "โปรดเลือกประเภทเทมเพลต",
			"idId": "Silakan pilih tipe template",
			"esMx": "Seleccione el tipo de plantilla",
			"viVi": "Vui lòng chọn loại mẫu",
			"ptPt": "Por favor, escolha o tipo de estêncil"
		},
		{
			"textKey": "authorInfo",
			"classify": "label",
			"zhCn": "作者信息",
			"zhTw": "作者信息",
			"enUs": "Author Information",
			"thTh": "ข้อมูลผู้เขียน",
			"idId": "Informasi Penulis",
			"esMx": "Información del autor",
			"viVi": "Thông tin tác giả",
			"ptPt": "Informações do autor"
		},
		{
			"textKey": "plzInputAuthor",
			"classify": "tips",
			"zhCn": "请输入作者",
			"zhTw": "請輸入作者",
			"enUs": "Please enter author",
			"thTh": "โปรดป้อนผู้เขียน",
			"idId": "Masukkan penulis",
			"esMx": "Por favor ingrese el autor",
			"viVi": "Vui lòng nhập tác giả",
			"ptPt": "Por favor, insira o autor"
		},
		{
			"textKey": "subTabelModel",
			"classify": "label",
			"zhCn": "子表模型",
			"zhTw": "子錶模型",
			"enUs": "child table model",
			"thTh": "แบบจำลองตารางย่อย",
			"idId": "Model jam tangan",
			"esMx": "Modelo de submesa",
			"viVi": "Mô hình bảng con",
			"ptPt": "Modelos de subtabela"
		},
		{
			"textKey": "subTableOutKey",
			"classify": "label",
			"zhCn": "子表外键",
			"zhTw": "子錶外鍵",
			"enUs": "child table foreign key",
			"thTh": "ปุ่มภายนอกตารางย่อย",
			"idId": "Tombol di luar sub-tabel",
			"esMx": "Clave externa de subtabla",
			"viVi": "Khóa ngoại bảng phụ",
			"ptPt": "Chave externa sub-tabela"
		},
		{
			"textKey": "treePrimaryKey",
			"classify": "label",
			"zhCn": "树主键字段",
			"zhTw": "樹主鍵字段",
			"enUs": "Tree Primary Key Field",
			"thTh": "ฟิลด์คีย์หลักของต้นไม้",
			"idId": "Bidang kunci utama pohon",
			"esMx": "Campo de clave principal del árbol",
			"viVi": "Trường khóa chính cây",
			"ptPt": "Campo de chave primária da árvore"
		},
		{
			"textKey": "treeParentPrimaryKey",
			"classify": "label",
			"zhCn": "树父主键字段",
			"zhTw": "樹父主鍵字段",
			"enUs": "Tree Parent Primary Key Field",
			"thTh": "ฟิลด์คีย์หลักของต้นไม้",
			"idId": "Pohon induk kunci bidang",
			"esMx": "Campo de clave principal principal del árbol",
			"viVi": "Trường khóa chính của cây cha",
			"ptPt": "Campo de chave primária pai da árvore"
		},
		{
			"textKey": "treeNameField",
			"classify": "label",
			"zhCn": "树名称字段",
			"zhTw": "樹名稱字段",
			"enUs": "Tree Name Field",
			"thTh": "ฟิลด์ชื่อต้นไม้",
			"idId": "Bidang Nama Pohon",
			"esMx": "Campo Nombre del árbol",
			"viVi": "Trường tên cây",
			"ptPt": "Campo Nome da árvore"
		},
		{
			"textKey": "generateConfig",
			"classify": "label",
			"zhCn": "生成配置",
			"zhTw": "生成配置",
			"enUs": "Build Configuration",
			"thTh": "สร้างการกำหนดค่า",
			"idId": "Menghasilkan konfigurasi",
			"esMx": "Generar configuración",
			"viVi": "Tạo cấu hình",
			"ptPt": "Configuração de geração"
		},
		{
			"textKey": "baseBusiness",
			"classify": "label",
			"zhCn": "基础业务",
			"zhTw": "基礎業務",
			"enUs": "Basic Business",
			"thTh": "ธุรกิจพื้นฐาน",
			"idId": "Bisnis Dasar",
			"esMx": "Negocio básico",
			"viVi": "Kinh doanh cơ bản",
			"ptPt": "Negócio básico"
		},
		{
			"textKey": "codeGenerateConfirm",
			"classify": "label",
			"zhCn": "代码生成确认",
			"zhTw": "代碼生成確認",
			"enUs": "Code generation confirmation",
			"thTh": "การยืนยันการสร้างรหัส",
			"idId": "Konfirmasi pembuatan kode",
			"esMx": "Confirmación de generación de código",
			"viVi": "Xác nhận tạo mã",
			"ptPt": "Confirmação de geração de código"
		},
		{
			"textKey": "ifGenerateSelectedModuleCode",
			"classify": "tips",
			"zhCn": "是否生成选中模块的代码?",
			"zhTw": "是否生成選中模塊的代碼?",
			"enUs": "Generate code for the selected module?",
			"thTh": "คุณสร้างรหัสสำหรับโมดูลที่เลือกหรือไม่",
			"idId": "Apakah Anda menghasilkan kode untuk modul yang dipilih?",
			"esMx": "¿Se genera el código para el módulo seleccionado?",
			"viVi": "Bạn có tạo mã cho mô-đun đã chọn không?",
			"ptPt": "O código para o módulo selecionado é gerado?"
		},
		{
			"textKey": "plzInputFrontEndGenerationPath",
			"classify": "tips",
			"zhCn": "请输入前端生成路径",
			"zhTw": "請輸入前端生成路徑",
			"enUs": "Please enter the frontend generation path",
			"thTh": "โปรดป้อนเส้นทางการสร้างส่วนหน้า",
			"idId": "Masukkan jalur generasi front-end",
			"esMx": "Ingrese la ruta de generación de front-end",
			"viVi": "Vui lòng nhập đường dẫn tạo giao diện người dùng",
			"ptPt": "Insira o caminho de geração do front-end"
		},
		{
			"textKey": "frontEndGenerationPath",
			"classify": "label",
			"zhCn": "前端生成路径",
			"zhTw": "前端生成路徑",
			"enUs": "Front End Generation Path",
			"thTh": "เส้นทางการสร้างส่วนหน้า",
			"idId": "Jalur generasi ujung depan",
			"esMx": "Ruta de generación de front-end",
			"viVi": "Đường dẫn tạo giao diện người dùng",
			"ptPt": "Caminho de geração de front-end"
		},
		{
			"textKey": "plzInputBackEndGenerationPath",
			"classify": "tips",
			"zhCn": "请输入后端生成路径",
			"zhTw": "請輸入後端生成路徑",
			"enUs": "Please enter backend generation path",
			"thTh": "โปรดป้อนเส้นทางการสร้างส่วนหลัง",
			"idId": "Masukkan jalur generasi back-end",
			"esMx": "Ingrese la ruta de generación de back-end",
			"viVi": "Vui lòng nhập đường dẫn tạo back-end",
			"ptPt": "Insira o caminho de geração de back-end"
		},
		{
			"textKey": "backEndGenerationPath",
			"classify": "label",
			"zhCn": "后端生成路径",
			"zhTw": "後端生成路徑",
			"enUs": "Back-end generation path",
			"thTh": "เส้นทางการสร้างส่วนหลัง",
			"idId": "Jalur generasi back-end",
			"esMx": "Ruta de generación de back-end",
			"viVi": "Đường dẫn tạo back-end",
			"ptPt": "Caminho de geração de back-end"
		},
		{
			"textKey": "plzChoiceCodeStyle",
			"classify": "tips",
			"zhCn": "请选择代码风格",
			"zhTw": "請選擇代碼風格",
			"enUs": "Please select a code style",
			"thTh": "โปรดเลือกรูปแบบรหัส",
			"idId": "Silakan pilih gaya kode",
			"esMx": "Seleccione el estilo de código",
			"viVi": "Vui lòng chọn kiểu mã",
			"ptPt": "Por favor, escolha o estilo de código"
		},
		{
			"textKey": "selectDiffFundationImplementCodeTemplate",
			"classify": "tips",
			"zhCn": "选择不同底层实现的代码模版",
			"zhTw": "選擇不同底層實現的代碼模版",
			"enUs": "Select code templates for different underlying implementations",
			"thTh": "เลือกเทมเพลตโค้ดสำหรับการใช้งานพื้นฐานที่แตกต่างกัน",
			"idId": "Pilih templat kode untuk implementasi tingkat bawah yang berbeda",
			"esMx": "Elija plantillas de código para diferentes implementaciones subyacentes",
			"viVi": "Chọn mẫu mã cho các triển khai cơ bản khác nhau",
			"ptPt": "Escolha um modelo de código para diferentes implementações subjacentes"
		},
		{
			"textKey": "codeStyle",
			"classify": "label",
			"zhCn": "代码风格",
			"zhTw": "代碼風格",
			"enUs": "Code Style",
			"thTh": "สไตล์รหัส",
			"idId": "Kode Gaya",
			"esMx": "Estilo de código",
			"viVi": "Kiểu mã",
			"ptPt": "Estilo de código"
		},
		{
			"textKey": "plzSelectBaseBusiness",
			"classify": "tips",
			"zhCn": "请选择基础业务",
			"zhTw": "請選擇基礎業務",
			"enUs": "Please select basic business",
			"thTh": "โปรดเลือกธุรกิจพื้นฐาน",
			"idId": "Silakan pilih bisnis dasar",
			"esMx": "Seleccione el negocio básico",
			"viVi": "Vui lòng chọn kinh doanh cơ bản",
			"ptPt": "Por favor, escolha o negócio básico"
		},
		{
			"textKey": "ifConfigUseFeignRemoteCall",
			"classify": "tips",
			"zhCn": "配置是否使用Feign远程调用",
			"zhTw": "配置是否使用Feign遠程調用",
			"enUs": "Configure whether to use Feign remote invocation",
			"thTh": "กำหนดค่าการโทรระยะไกลโดยใช้ Feign",
			"idId": "Konfigurasi apakah akan menggunakan Feign untuk panggilan jarak jauh",
			"esMx": "Configurar si usar la llamada remota de Feign",
			"viVi": "Cấu hình có sử dụng cuộc gọi từ xa Feign hay không",
			"ptPt": "Configurar se a chamada remota do Feign é usada"
		},
		{
			"textKey": "remoteInvocation",
			"classify": "label",
			"zhCn": "远程调用",
			"zhTw": "遠程調用",
			"enUs": "Remote call",
			"thTh": "โทรระยะไกล",
			"idId": "Panggilan jarak jauh",
			"esMx": "Llamada remota",
			"viVi": "Cuộc gọi từ xa",
			"ptPt": "Chamada remota"
		},
		{
			"textKey": "plzSelectPackageDecorator",
			"classify": "tips",
			"zhCn": "请选择包装器",
			"zhTw": "請選擇包裝器",
			"enUs": "Please select a wrapper",
			"thTh": "โปรดเลือกบรรจุภัณฑ์",
			"idId": "Silakan pilih pembungkus",
			"esMx": "Por favor seleccione el envasador",
			"viVi": "Vui lòng chọn máy đóng gói",
			"ptPt": "Por favor, escolha o empacotador"
		},
		{
			"textKey": "wraper",
			"classify": "label",
			"zhCn": "包装器",
			"zhTw": "包裝器",
			"enUs": "Wrapper",
			"thTh": "เครื่องบรรจุ",
			"idId": "Pengemas",
			"esMx": "Empaquetador",
			"viVi": "Máy đóng gói",
			"ptPt": "Embalador"
		},
		{
			"textKey": "configIfUseWrapperToExtendControllerFields",
			"classify": "tips",
			"zhCn": "配置是否使用Wrapper包装器来拓展Controller返回列表的字段",
			"zhTw": "配置是否使用Wrapper包裝器來拓展Controller返回列表的字段",
			"enUs": "Configure whether to use Wrapper wrappers to expand the fields that Controller the return list",
			"thTh": "กำหนดค่าว่าจะใช้ Wrapper Packer เพื่อขยาย Controller กลับไปที่ฟิลด์ของรายการ",
			"idId": "Konfigurasikan apakah akan menggunakan Wrapper pembungkus untuk memperluas kolom daftar pengembalian Controller",
			"esMx": "Configurar si usar el empaquetador Wrapper para ampliar los campos de la lista de retorno del Controller",
			"viVi": "Định cấu hình có sử dụng trình đóng gói Wrapper để mở rộng trường mà Trình điều khiển trả về danh sách hay không",
			"ptPt": "Configurar os campos para usar o Wrapper para expandir a lista de retorno do Controller"
		},
		{
			"textKey": "configIfUseBaseServiceToUnLockMoreFunction",
			"classify": "tips",
			"zhCn": "配置是否使用BladeX封装的BaseService解锁更多功能",
			"zhTw": "配置是否使用BladeX封裝的BaseService解鎖更多功能",
			"enUs": "Configure whether to use BladeX-encapsulated BaseService to unlock more features",
			"thTh": "กำหนดค่าว่าจะใช้ BaseService ในแพ็คเกจ BladeX เพื่อปลดล็อกคุณสมบัติเพิ่มเติมหรือไม่",
			"idId": "Konfigurasi apakah akan membuka lebih banyak fitur dengan BaseService yang dikemas dengan BladeX",
			"esMx": "Configure si usar BaseService encapsulado por BladeX para desbloquear más funciones",
			"viVi": "Định cấu hình có mở khóa nhiều tính năng hơn bằng BaseService được đóng gói trong BladeX hay không",
			"ptPt": "Configurar o uso do pacote BladeX BaseService para desbloquear mais recursos"
		},
		{
			"textKey": "databaseModelConfig",
			"classify": "label",
			"zhCn": "数据库模型配置",
			"zhTw": "數據庫模型配置",
			"enUs": "Database model configuration",
			"thTh": "การกำหนดค่าโมเดลฐานข้อมูล",
			"idId": "Konfigurasi Model Database",
			"esMx": "Configuración del modelo de base de datos",
			"viVi": "Cấu hình mô hình cơ sở dữ liệu",
			"ptPt": "Configuração do modelo de banco de dados"
		},
		{
			"textKey": "physicalTabelReading",
			"classify": "tips",
			"zhCn": "物理表读取中",
			"zhTw": "物理表讀取中",
			"enUs": "Physical table reading",
			"thTh": "กำลังอ่านตารางทางกายภาพ",
			"idId": "Tabel fisik dalam membaca",
			"esMx": "Lectura de tabla física",
			"viVi": "Đọc bảng vật lý",
			"ptPt": "Leitura de tabela física"
		},
		{
			"textKey": "ifConfigModel",
			"classify": "tips",
			"zhCn": "是否进行模型配置?",
			"zhTw": "是否進行模型配置?",
			"enUs": "Do you want to configure the model?",
			"thTh": "มีการกำหนดค่าโมเดลหรือไม่?",
			"idId": "Apakah model dikonfigurasi?",
			"esMx": "¿Se realiza la configuración del modelo?",
			"viVi": "Cấu hình mô hình có được thực hiện không?",
			"ptPt": "A configuração do modelo está em andamento?"
		},
		{
			"textKey": "ifConfirmModelConfig",
			"classify": "tips",
			"zhCn": "确定提交模型配置?",
			"zhTw": "確定提交模型配置?",
			"enUs": "Confirm to submit model configuration?",
			"thTh": "ยืนยันที่จะส่งการกำหนดค่าโมเดล?",
			"idId": "Konfigurasi model pengiriman ditentukan?",
			"esMx": "¿Determinar la configuración del modelo de envío?",
			"viVi": "Xác định cấu hình mô hình đệ trình?",
			"ptPt": "Identificar a configuração do modelo de envio?"
		},
		{
			"textKey": "viewLineChart",
			"classify": "tips",
			"zhCn": "查看折线图",
			"zhTw": "查看折線圖",
			"enUs": "View Line Chart",
			"thTh": "ดูแผนภูมิเส้น",
			"idId": "Lihat grafik garis",
			"esMx": "Ver el gráfico de líneas",
			"viVi": "Xem biểu đồ đường",
			"ptPt": "Ver o gráfico de linhas"
		},
		{
			"textKey": "viewBarChart",
			"classify": "tips",
			"zhCn": "查看柱状图",
			"zhTw": "查看柱狀圖",
			"enUs": "View Bar Chart",
			"thTh": "ดูฮิสโตแกรม",
			"idId": "Melihat histogram",
			"esMx": "Ver el histograma",
			"viVi": "Xem biểu đồ",
			"ptPt": "Veja o histograma"
		},
		{
			"textKey": "toDispostionGateway",
			"classify": "label",
			"zhCn": "待配置网关",
			"zhTw": "待配置網關",
			"enUs": "Gateway to be configured",
			"thTh": "เกตเวย์ที่จะกำหนดค่า",
			"idId": "Gateway untuk dikonfigurasi",
			"esMx": "Puerta de enlace a configurar",
			"viVi": "Cổng được cấu hình",
			"ptPt": "Gateway a ser configurado"
		},
		{
			"textKey": "more",
			"classify": "btn",
			"zhCn": "更多",
			"zhTw": "更多",
			"enUs": "More",
			"thTh": "มากกว่า",
			"idId": "Lebih banyak",
			"esMx": "Más",
			"viVi": "Thêm",
			"ptPt": "Mais"
		},
		{
			"textKey": "batchDelete",
			"classify": "btn",
			"zhCn": "批量删除",
			"zhTw": "批量刪除",
			"enUs": "Batch Delete",
			"thTh": "การลบแบทช์",
			"idId": "Penghapusan massal",
			"esMx": "Eliminación por lotes",
			"viVi": "Xóa hàng loạt",
			"ptPt": "Excluir em massa"
		},
		{
			"textKey": "batchOperation",
			"classify": "btn",
			"zhCn": "批量操作",
			"zhTw": "批量操作",
			"enUs": "Batch operation",
			"thTh": "การดำเนินการแบทช์",
			"idId": "Operasi massal",
			"esMx": "Operación por lotes",
			"viVi": "Hoạt động hàng loạt",
			"ptPt": "Operação em lote"
		},
		{
			"textKey": "addChildren",
			"classify": "btn",
			"zhCn": "添加下级",
			"zhTw": "添加下級",
			"enUs": "Add Subordinate",
			"thTh": "เพิ่มผู้ใต้บังคับบัญชา",
			"idId": "Menambahkan bawahan",
			"esMx": "Agregar un subordinado",
			"viVi": "Thêm cấp dưới",
			"ptPt": "Adicionar um subordinado"
		},
		{
			"textKey": "acrossTimePeriod",
			"classify": "label",
			"zhCn": "跨时间段",
			"zhTw": "跨時間段",
			"enUs": "Across Time Periods",
			"thTh": "ข้ามช่วงเวลา",
			"idId": "Lintas periode waktu",
			"esMx": "Período de tiempo cruzado",
			"viVi": "Khoảng thời gian",
			"ptPt": "Interperíodo de tempo"
		},
		{
			"textKey": "minuteAcrossLimitOneDay",
			"classify": "tips",
			"zhCn": "分钟的时间跨度不可以超过1天",
			"zhTw": "分鐘的時間跨度不可以超過1天",
			"enUs": "The time span of minutes cannot exceed 1 day.",
			"thTh": "ช่วงเวลานาทีต้องไม่เกิน1วัน",
			"idId": "Rentang waktu menit tidak dapat melebihi 1 hari",
			"esMx": "El lapso de tiempo de minutos no puede exceder 1 día",
			"viVi": "Khoảng thời gian của phút không được vượt quá 1 ngày",
			"ptPt": "O intervalo de tempo em minutos não pode exceder 1 dia"
		},
		{
			"textKey": "hourAcrossLimitThirtyDay",
			"classify": "tips",
			"zhCn": "小时的时间跨度不可以超过31天",
			"zhTw": "小時的時間跨度不可以超過31天",
			"enUs": "The time span of the hour cannot exceed 31 days.",
			"thTh": "ช่วงเวลาของชั่วโมงต้องไม่เกิน31วัน",
			"idId": "Rentang waktu jam tidak lebih dari 31 hari",
			"esMx": "El lapso de tiempo de la hora no puede exceder los 31 días",
			"viVi": "Khoảng thời gian của giờ không được vượt quá 31 ngày",
			"ptPt": "O intervalo de tempo de uma hora não pode exceder 31 dias"
		},
		{
			"textKey": "dayAcrossLimit365day",
			"classify": "tips",
			"zhCn": "天的时间跨度不可以超过365天",
			"zhTw": "天的時間跨度不可以超過365天",
			"enUs": "The time span of days cannot exceed 365 days.",
			"thTh": "ช่วงเวลาของวันต้องไม่เกิน365วัน",
			"idId": "Rentang waktu hari tidak dapat melebihi 365 hari",
			"esMx": "El lapso de tiempo de los días no puede exceder los 365 días",
			"viVi": "Khoảng thời gian của ngày không được vượt quá 365 ngày",
			"ptPt": "O intervalo de tempo de um dia não pode exceder 365 dias"
		},
		{
			"textKey": "energyUsageInsight",
			"classify": "tips",
			"zhCn": "能源使用洞察",
			"zhTw": "能源使用洞察",
			"enUs": "Energy use insights",
			"thTh": "ข้อมูลเชิงลึกเกี่ยวกับการใช้พลังงาน",
			"idId": "Wawasan Penggunaan Energi",
			"esMx": "Información sobre el uso de la energía",
			"viVi": "Thông tin chi tiết về sử dụng năng lượng",
			"ptPt": "Insights sobre o uso de energia"
		},
		{
			"textKey": "quantity",
			"classify": "label",
			"zhCn": "数量",
			"zhTw": "數量",
			"enUs": "Quantity",
			"thTh": "จำนวน",
			"idId": "Jumlah",
			"esMx": "Cantidad",
			"viVi": "Số lượng",
			"ptPt": "Quantidade"
		},
		{
			"textKey": "nodeName",
			"classify": "table",
			"zhCn": "节点名称",
			"zhTw": "節點名稱",
			"enUs": "Node Name",
			"thTh": "ชื่อโหนด",
			"idId": "Nama simpul",
			"esMx": "Nombre del nodo",
			"viVi": "Tên nút",
			"ptPt": "Nome do nó"
		},
		{
			"textKey": "tokenExpired",
			"classify": "tips",
			"zhCn": "用户令牌过期，请重新登录",
			"zhTw": "用戶令牌過期,請重新登錄",
			"enUs": "User token expired, please login again",
			"thTh": "โทเค็นผู้ใช้หมดอายุโปรดเข้าสู่ระบบอีกครั้ง",
			"idId": "Token pengguna kedaluwarsa, silakan masuk kembali",
			"esMx": "El token de usuario caducó, inicie sesión de nuevo",
			"viVi": "Mã thông báo người dùng đã hết hạn, vui lòng đăng nhập lại",
			"ptPt": "O token do usuário expira, faça login novamente"
		},
		{
			"textKey": "plzInputDataItemId",
			"classify": "tips",
			"zhCn": "请输入数据项ID",
			"zhTw": "請輸入數據項ID",
			"enUs": "Please enter data item ID",
			"thTh": "กรุณาใส่ ID รายการข้อมูล",
			"idId": "Masukkan ID item data",
			"esMx": "Ingrese el ID del elemento de datos",
			"viVi": "Vui lòng nhập ID mục dữ liệu",
			"ptPt": "Insira o ID do item de dados"
		},
		{
			"textKey": "plzInputDeviceId",
			"classify": "tips",
			"zhCn": "请输入设备ID",
			"zhTw": "請輸入設備ID",
			"enUs": "Please enter device ID",
			"thTh": "โปรดป้อน ID อุปกรณ์ของคุณ",
			"idId": "Masukkan ID perangkat",
			"esMx": "Introduzca el ID del dispositivo",
			"viVi": "Vui lòng nhập ID thiết bị",
			"ptPt": "Por favor, insira o ID do dispositivo"
		},
		{
			"textKey": "plzInputDataItemName",
			"classify": "tips",
			"zhCn": "请输入数据项名称",
			"zhTw": "請輸入數據項名稱",
			"enUs": "Please enter data item name",
			"thTh": "กรุณากรอกชื่อรายการข้อมูล",
			"idId": "Masukkan nama item data",
			"esMx": "Ingrese el nombre del elemento de datos",
			"viVi": "Vui lòng nhập tên mục dữ liệu",
			"ptPt": "Por favor, insira o nome do item de dados"
		},
		{
			"textKey": "downloadError",
			"classify": "tips",
			"zhCn": "下载出错",
			"zhTw": "下載出錯",
			"enUs": "Download error",
			"thTh": "ข้อผิดพลาดในการดาวน์โหลด",
			"idId": "Kesalahan unduhan",
			"esMx": "Error de descarga",
			"viVi": "Lỗi tải xuống",
			"ptPt": "Erro de download"
		},
		{
			"textKey": "co2Description",
			"classify": "tips",
			"zhCn": "二氧化碳 (CO₂) 浓度以百万分率 (ppm) 为单位，表示大气中存在的 CO₂ 量。它是评估人类活动对环境影响的重要指标，例如化石燃料燃烧和森林砍伐，这些活动导致二氧化碳水平升高。",
			"zhTw": "二氧化碳 (CO₂) 濃度以百萬分率 (ppm) 為單位，表示大氣中存在的 CO₂ 量。它是評估人類活動對環境影響的重要指標，例如化石燃料燃燒和森林砍伐，這些活動導致二氧化碳水平升高",
			"enUs": "Carbon dioxide (CO₂) concentration, measured in parts per million (ppm), indicates the amount of CO₂ present in the atmosphere. It serves as a critical metric for assessing the impact of human activities on the environment, such as fossil fuel combustion and deforestation, which contribute to increased CO₂ levels",
			"thTh": "ค่าความเข้มข้นของคาร์บอนไดออกไซด์ (CO₂) เป็นค่าที่วัดเป็นหน่วยส่วนต่อล้านส่วน (ppm) ใช้บ่งชี้ปริมาณของ CO₂ ที่มีอยู่ในชั้นบรรยากาศ ซึ่งทำหน้าที่เป็นตัวชี้วัดที่สำคัญในการประเมินผลกระทบจากกิจกรรมของมนุษย์ต่อสิ่งแวดล้อม เช่น การเผาไหม้เชื้อเพลิงฟอสซิลและการตัดไม้ทำลายป่า ซึ่งส่งผลให้ระดับ CO₂ เพิ่มขึ้น",
			"idId": "Konsentrasi karbon dioksida (CO₂), diukur dalam bagian per juta (ppm), menunjukkan jumlah CO₂ yang ada di atmosfer. Ini berfungsi sebagai metrik penting untuk menilai dampak aktivitas manusia terhadap lingkungan, seperti pembakaran bahan bakar fosil dan penggundulan hutan, yang berkontribusi terhadap peningkatan emisi. Ini berfungsi sebagai metrik penting untuk menilai dampak aktivitas manusia terhadap lingkungan, seperti pembakaran bahan bakar fosil dan penggundulan hutan, yang berkontribusi terhadap peningkatan Tingkat CO₂",
			"esMx": "La concentración de dióxido de carbono (CO₂) se mide en partes por millón (ppm) y representa la cantidad de CO₂ presente en la atmósfera. Es un indicador importante para evaluar el impacto de las actividades humanas en el medio ambiente, como la quema de combustibles fósiles y la deforestación, actividades que han llevado a un aumento en los niveles de dióxido de carbono.",
			"viVi": "Carbon dioxide mô tả",
			"ptPt": "Descrições de dióxido de carbono"
		},
		{
			"textKey": "pm2_5Description",
			"classify": "tips",
			"zhCn": "PM2.5是指直径小于2.5微米的颗粒物 (PM)。这些细小颗粒可以深入肺部甚至进入血液，对呼吸和心血管问题等健康造成重大风险，是空气质量和公共卫生的主要关注点。",
			"zhTw": "PM2.5是指直徑小於2.5微米的顆粒物 (PM)。 這些細小顆粒可以深入肺部甚至進入血液,對呼吸和心血管問題等健康造成重大風險,是空氣質量和公共衛生的主要關注點。",
			"enUs": "PM2.5 refers to particulate matter (PM) that has a diameter of less than 2.5 micrometers. These fine particles can penetrate deep into the lungs and even enter the bloodstream, posing significant health risks, including respiratory and cardiovascular issues. They are a major concern for air quality and public health.",
			"thTh": "PM2.5 หมายถึงฝุ่นละอองขนาดเล็ก (PM) ที่มีเส้นผ่านศูนย์กลางน้อยกว่า 2.5 ไมโครเมตร อนุภาคขนาดเล็กเหล่านี้สามารถแทรกซึมลึกเข้าไปในปอดและอาจเข้าสู่กระแสเลือดได้ ก่อให้เกิดความเสี่ยงต่อสุขภาพมากมาย รวมถึงปัญหาเกี่ยวกับระบบทางเดินหายใจและหลอดเลือดหัวใจ ถือเป็นปัญหาสำคัญต่อคุณภาพอากาศและสุขภาพ",
			"idId": "PM2.5 mengacu pada materi partikulat (PM) yang memiliki diameter kurang dari 2,5 mikrometer. Partikel-partikel halus ini dapat menembus jauh ke dalam paru-paru dan bahkan masuk ke dalam aliran darah, sehingga menimbulkan risiko kesehatan yang signifikan, termasuk masalah pernapasan dan kardiovaskular. Partikel-partikel halus ini dapat menembus jauh ke dalam paru-paru dan bahkan masuk ke dalam aliran darah, sehingga menimbulkan risiko kesehatan yang signifikan, termasuk masalah pernapasan dan kardiovaskular. Partikel-partikel ini menjadi perhatian utama bagi kualitas udara dan kesehatan masyarakat.",
			"esMx": "PM2.5 se refiere al material particulado (PM) de menos de 2,5 micrómetros de diámetro. Estas partículas finas, que pueden penetrar profundamente en los pulmones e incluso en el torrente sanguíneo, representan un riesgo significativo para la salud, como los problemas respiratorios y cardiovasculares, y son una gran preocupación para la calidad del aire y la salud pública.",
			"viVi": "PM2.5 đề cập đến vật chất hạt (PM) có đường kính nhỏ hơn 2,5 micron. Những hạt mịn này có thể xâm nhập sâu vào phổi hoặc thậm chí vào máu, gây ra rủi ro đáng kể cho sức khỏe như các vấn đề về hô hấp và tim mạch, và là mối quan tâm chính về chất lượng không khí và sức khỏe cộng đồng.",
			"ptPt": "PM2.5 refere-se a partículas (PM) com um diâmetro inferior a 2,5 mícrons. Essas partículas finas podem penetrar profundamente nos pulmões e até mesmo na corrente sanguínea, causando riscos significativos à saúde, como problemas respiratórios e cardiovasculares, e são uma grande preocupação para a qualidade do ar e a saúde pública."
		},
		{
			"textKey": "pm10Description",
			"classify": "tips",
			"zhCn": "PM10是指直径为10微米或更小的颗粒物 (PM)。这些颗粒物可能被吸入并进入肺部，导致呼吸问题和其他健康问题，从而引起健康问题。PM10 是空气污染的关键指标，通过监测可评估空气质量。",
			"zhTw": "PM10是指直徑為10微米或更小的顆粒物 (PM)。 這些顆粒物可能被吸入並進入肺部,導致呼吸問題和其他健康問題,從而引起健康問題。 PM10 是空氣污染的關鍵指標,通過監測可評估空氣質量。",
			"enUs": "PM10 refers to particulate matter (PM) with a diameter of 10 micrometers or less. These particles can cause health problems because they can be inhaled and reach the lungs, leading to respiratory issues and other health concerns. PM10 is a key indicator of air pollution and is monitored to assess air quality.",
			"thTh": "PM10 หมายถึงฝุ่นละอองขนาดเล็ก (PM) ที่มีเส้นผ่านศูนย์กลาง 10 ไมโครเมตรหรือเล็กกว่า อนุภาคเหล่านี้อาจทำให้เกิดปัญหาสุขภาพได้ เนื่องจากสามารถสูดดมเข้าไปและเข้าสู่ปอด ส่งผลให้เกิดปัญหาทางระบบทางเดินหายใจและปัญหาสุขภาพอื่นๆ PM10 เป็นตัวบ่งชี้หลักของมลพิษทางอากาศ และได้รับการตรวจสอบเพื่อประเมินคุณภาพอากาศ",
			"idId": "PM10 mengacu pada materi partikulat (PM) dengan diameter 10 mikrometer atau kurang. Partikel-partikel ini dapat menyebabkan masalah kesehatan karena dapat terhirup dan mencapai paru-paru, yang menyebabkan masalah pernapasan dan masalah kesehatan lainnya. Partikel-partikel ini dapat menyebabkan masalah kesehatan karena dapat terhirup dan mencapai paru-paru, yang menyebabkan masalah pernapasan dan masalah kesehatan lainnya. PM10 adalah indikator utama polusi udara dan dipantau untuk menilai kualitas udara.",
			"esMx": "PM10 se refiere a partículas (PM) que tienen un diámetro de 10 micrómetros o menos. Estas partículas pueden inhalarse e ingresar a los pulmones, causando problemas respiratorios y otros problemas de salud que pueden causar problemas de salud. PM10 es un indicador clave de la contaminación del aire y la calidad del aire se puede evaluar mediante el monitoreo.",
			"viVi": "PM10 đề cập đến vật chất hạt (PM) có đường kính 10 micron hoặc nhỏ hơn. Những hạt này có thể được hít vào và xâm nhập vào phổi, gây ra các vấn đề về hô hấp và các vấn đề sức khỏe khác có thể gây ra các vấn đề sức khỏe. PM10 là một chỉ số chính của ô nhiễm không khí và chất lượng không khí có thể được đánh giá thông qua giám sát.",
			"ptPt": "PM10 significa material particulado (PM) com um diâmetro de 10 mícrons ou menos. Essas partículas podem ser inaladas e entrar nos pulmões, causando problemas respiratórios e outros problemas de saúde que podem causar problemas de saúde. O PM10 é um indicador chave da poluição do ar e a qualidade do ar pode ser avaliada através do monitoramento."
		},
		{
			"textKey": "co2Level1Desc",
			"classify": "tips",
			"zhCn": "低于正常浓度",
			"zhTw": "低於正常濃度",
			"enUs": "Lower than normal concentrations",
			"thTh": "ต่ำกว่าความเข้มข้นปกติ",
			"idId": "Lebih rendah dari konsentrasi normal",
			"esMx": "Concentración por debajo de lo normal",
			"viVi": "Dưới nồng độ bình thường",
			"ptPt": "Abaixo da concentração normal"
		},
		{
			"textKey": "co2Level2Desc",
			"classify": "tips",
			"zhCn": "正常",
			"zhTw": "正常",
			"enUs": "Normal",
			"thTh": "ปกติ",
			"idId": "Normal",
			"esMx": "Normal",
			"viVi": "Bình thường",
			"ptPt": "Normal"
		},
		{
			"textKey": "co2Level3Desc",
			"classify": "tips",
			"zhCn": "轻微症状",
			"zhTw": "輕微症狀",
			"enUs": "Mild symptoms",
			"thTh": "อาการไม่รุนแรง",
			"idId": "Gejala ringan",
			"esMx": "Síntomas leves",
			"viVi": "Triệu chứng nhẹ",
			"ptPt": "Sintomas leves"
		},
		{
			"textKey": "co2Level4Desc",
			"classify": "tips",
			"zhCn": "中度症状",
			"zhTw": "中度症狀",
			"enUs": "Moderate symptoms",
			"thTh": "อาการปานกลาง",
			"idId": "Gejala sedang",
			"esMx": "Síntomas moderados",
			"viVi": "Triệu chứng vừa phải",
			"ptPt": "Sintomas moderados"
		},
		{
			"textKey": "co2Level5Desc",
			"classify": "tips",
			"zhCn": "危及生命的症状",
			"zhTw": "危及生命的症狀",
			"enUs": "Life-threatening symptoms",
			"thTh": "อาการที่เป็นอันตรายถึงชีวิต",
			"idId": "Gejala yang mengancam jiwa",
			"esMx": "Síntomas potencialmente mortales",
			"viVi": "Các triệu chứng đe dọa tính mạng",
			"ptPt": "Sintomas com risco de vida"
		},
		{
			"textKey": "tovcLevel1Desc",
			"classify": "tips",
			"zhCn": "良好",
			"zhTw": "良好",
			"enUs": "Good",
			"thTh": "ดี",
			"idId": "Bagus.",
			"esMx": "Bueno",
			"viVi": "Tốt",
			"ptPt": "Bom"
		},
		{
			"textKey": "tovcLevel2Desc",
			"classify": "tips",
			"zhCn": "中等",
			"zhTw": "中等",
			"enUs": "Moderate",
			"thTh": "ปานกลาง",
			"idId": "Sedang",
			"esMx": "Medio",
			"viVi": "Trung bình",
			"ptPt": "Médio"
		},
		{
			"textKey": "tovcLevel3Desc",
			"classify": "tips",
			"zhCn": "中度污染",
			"zhTw": "中度污染",
			"enUs": "Moderately Polluted",
			"thTh": "มีมลพิษปานกลาง",
			"idId": "Cukup Tercemar",
			"esMx": "Contaminación moderada",
			"viVi": "Ô nhiễm vừa phải",
			"ptPt": "Poluição moderada"
		},
		{
			"textKey": "tovcLevel4Desc",
			"classify": "tips",
			"zhCn": "重度污染",
			"zhTw": "重度污染",
			"enUs": "Heavily Polluted",
			"thTh": "มีมลพิษสูง",
			"idId": "Sangat Tercemar",
			"esMx": "Contaminación intensa",
			"viVi": "Ô nhiễm nặng",
			"ptPt": "Poluição pesada"
		},
		{
			"textKey": "tovcLevel5Desc",
			"classify": "tips",
			"zhCn": "严重污染",
			"zhTw": "嚴重污染",
			"enUs": "Severely Polluted",
			"thTh": "มีมลพิษรุนแรง",
			"idId": "Sangat Tercemar",
			"esMx": "Contaminación grave",
			"viVi": "Ô nhiễm nghiêm trọng",
			"ptPt": "Poluição grave"
		},
		{
			"textKey": "pmLevel1Desc",
			"classify": "tips",
			"zhCn": "良好",
			"zhTw": "良好",
			"enUs": "Good",
			"thTh": "ดี",
			"idId": "Bagus.",
			"esMx": "Bueno",
			"viVi": "Tốt",
			"ptPt": "Bom"
		},
		{
			"textKey": "pmLevel2Desc",
			"classify": "tips",
			"zhCn": "中等",
			"zhTw": "中等",
			"enUs": "Moderate",
			"thTh": "ปานกลาง",
			"idId": "Sedang",
			"esMx": "Medio",
			"viVi": "Trung bình",
			"ptPt": "Médio"
		},
		{
			"textKey": "pmLevel3Desc",
			"classify": "tips",
			"zhCn": "对敏感人群不健康",
			"zhTw": "對敏感人群不健康",
			"enUs": "Unhealthy for Sensitive Groups",
			"thTh": "มีผลกระทบต่อสุขภาพสำหรับผู้อ่อนไหว",
			"idId": "Tidak Sehat untuk Kelompok Sensitif",
			"esMx": "No saludable para personas sensibles",
			"viVi": "Không lành mạnh cho những người nhạy cảm",
			"ptPt": "Não é saudável para pessoas sensíveis"
		},
		{
			"textKey": "pmLevel4Desc",
			"classify": "tips",
			"zhCn": "不健康",
			"zhTw": "不健康",
			"enUs": "Unhealthy",
			"thTh": "มีผลกระทบต่อสุขภาพ",
			"idId": "Tidak sehat",
			"esMx": "No saludable",
			"viVi": "Không lành mạnh",
			"ptPt": "Não é saudável"
		},
		{
			"textKey": "pmLevel5Desc",
			"classify": "tips",
			"zhCn": "非常不健康",
			"zhTw": "非常不健康",
			"enUs": "Very Unhealthy",
			"thTh": "มีผลกระทบต่อสุขภาพมาก",
			"idId": "Sangat Tidak Sehat",
			"esMx": "Muy poco saludable",
			"viVi": "Rất không lành mạnh",
			"ptPt": "Muito insalubre"
		},
		{
			"textKey": "pmLevel6Desc",
			"classify": "tips",
			"zhCn": "危险",
			"zhTw": "危險",
			"enUs": "Hazardous",
			"thTh": "อันตราย",
			"idId": "Berbahaya",
			"esMx": "Peligro",
			"viVi": "Nguy hiểm",
			"ptPt": "Perigo"
		},
		{
			"textKey": "caculateRule",
			"classify": "label",
			"zhCn": "计算规则",
			"zhTw": "計算規則",
			"enUs": "Calculation Rules",
			"thTh": "กฎการคำนวณ",
			"idId": "Aturan perhitungan",
			"esMx": "Reglas de cálculo",
			"viVi": "Quy tắc tính toán",
			"ptPt": "Regras de cálculo"
		},
		{
			"textKey": "plzSelectCaculateRule",
			"classify": "tips",
			"zhCn": "请选择计算规则",
			"zhTw": "請選擇計算規則",
			"enUs": "Please select a calculation rule",
			"thTh": "โปรดเลือกกฎการคำนวณ",
			"idId": "Silakan pilih aturan perhitungan",
			"esMx": "Seleccione la regla de cálculo",
			"viVi": "Vui lòng chọn quy tắc tính toán",
			"ptPt": "Por favor, escolha a regra de cálculo"
		},
		{
			"textKey": "copiedToClickboard",
			"classify": "tips",
			"zhCn": "已复制到剪切板",
			"zhTw": "已複製到剪切板",
			"enUs": "Copied to clipboard",
			"thTh": "คัดลอกไปยังคลิปบอร์ด",
			"idId": "Disalin ke papan potong",
			"esMx": "Copiado en el portapapeles",
			"viVi": "Đã sao chép vào khay nhớ tạm",
			"ptPt": "Copiado para a placa de corte"
		},
		{
			"textKey": "lightLevelDescription",
			"classify": "tips",
			"zhCn": "照度通常指光的强度或照明水平。",
			"zhTw": "照度通常指光的強度或照明水平。",
			"enUs": "Illumination usually refers to the intensity of light or the level of lighting.",
			"thTh": "ความส่องสว่างโดยทั่วไปหมายถึงความเข้มของแสงหรือระดับของแสง",
			"idId": "Iluminasi biasanya mengacu ke intensitas cahaya atau tingkat pencahayaan.",
			"esMx": "La iluminancia generalmente se refiere a la intensidad de la luz o al nivel de iluminación.",
			"viVi": "Độ rọi thường đề cập đến cường độ ánh sáng hoặc mức độ chiếu sáng.",
			"ptPt": "Iluminância geralmente se refere à intensidade da luz ou ao nível de iluminação."
		},
		{
			"textKey": "Temperature",
			"classify": "label",
			"zhCn": "温度",
			"zhTw": "溫度",
			"enUs": "Temperature",
			"thTh": "อุณหภูมิ",
			"idId": "Suhu",
			"esMx": "Temperatura",
			"viVi": "Nhiệt độ",
			"ptPt": "Temperatura"
		},
		{
			"textKey": "Humidity",
			"classify": "label",
			"zhCn": "湿度",
			"zhTw": "濕度",
			"enUs": "Humidity",
			"thTh": "ความชื้น",
			"idId": "Kelembaban",
			"esMx": "Humedad",
			"viVi": "Độ ẩm",
			"ptPt": "Umidade"
		},
		{
			"textKey": "CO2",
			"classify": "label",
			"zhCn": "二氧化碳",
			"zhTw": "二氧化碳",
			"enUs": "CO2",
			"thTh": "CO2",
			"idId": "CO2",
			"esMx": "CO2",
			"viVi": "CO2",
			"ptPt": "CO2"
		},
		{
			"textKey": "TVOC",
			"classify": "label",
			"zhCn": "TVOC",
			"zhTw": "TVOC",
			"enUs": "TVOC",
			"thTh": "TVOC",
			"idId": "TVOC",
			"esMx": "TVOC",
			"viVi": "TVOC",
			"ptPt": "TVOC"
		},
		{
			"textKey": "AirPressure",
			"classify": "label",
			"zhCn": "气压",
			"zhTw": "氣壓",
			"enUs": "Air pressure",
			"thTh": "ความดันอากาศ",
			"idId": "Tekanan udara",
			"esMx": "Presión de aire",
			"viVi": "Áp suất không khí",
			"ptPt": "Pressão do ar"
		},
		{
			"textKey": "PM2_5",
			"classify": "label",
			"zhCn": "PM2.5",
			"zhTw": "PM2.5",
			"enUs": "PM2.5",
			"thTh": "PM2.5",
			"idId": "PM2.5",
			"esMx": "PM2.5",
			"viVi": "PM2.5",
			"ptPt": "PM2.5"
		},
		{
			"textKey": "Illumination",
			"classify": "label",
			"zhCn": "照度",
			"zhTw": "照度",
			"enUs": "Illumination",
			"thTh": "ความสว่าง",
			"idId": "Pencahayaan",
			"esMx": "Iluminación",
			"viVi": "Độ chiếu sáng",
			"ptPt": "Illuminância"
		},
		{
			"textKey": "TemperatureAndHumidity",
			"classify": "label",
			"zhCn": "温度 &amp; 湿度",
			"zhTw": "溫度 &amp; 濕度",
			"enUs": "Temperature &amp; Humidity",
			"thTh": "อุณหภูมิ &amp; ความชื้น",
			"idId": "Suhu &amp; Kelembaban",
			"esMx": "Temperatura y humedad",
			"viVi": "Nhiệt độ &amp; độ ẩm",
			"ptPt": "Temperatura &amp; umidade"
		},
		{
			"textKey": "PM10",
			"classify": "label",
			"zhCn": "PM10",
			"zhTw": "PM10",
			"enUs": "PM10",
			"thTh": "PM10",
			"idId": "PM10",
			"esMx": "PM10",
			"viVi": "PM10",
			"ptPt": "PM10"
		},
		{
			"textKey": "energyinsightTrend",
			"classify": "label",
			"zhCn": "能耗趋势",
			"zhTw": "",
			"enUs": "Energy Trend",
			"thTh": "แนวโน้มการใช้พลังงาน",
			"idId": "Tren Energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtMinute",
			"classify": "label",
			"zhCn": "分钟",
			"zhTw": "",
			"enUs": "Minute",
			"thTh": "นาที",
			"idId": "Menit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtHour",
			"classify": "label",
			"zhCn": "小时",
			"zhTw": "",
			"enUs": "Hour",
			"thTh": "ชั่วโมง",
			"idId": "Jam",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtDay",
			"classify": "label",
			"zhCn": "天",
			"zhTw": "",
			"enUs": "Day",
			"thTh": "วัน",
			"idId": "Hari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtMonth",
			"classify": "label",
			"zhCn": "月",
			"zhTw": "",
			"enUs": "Month",
			"thTh": "เดือน",
			"idId": "Bulan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtYear",
			"classify": "label",
			"zhCn": "年",
			"zhTw": "",
			"enUs": "Year",
			"thTh": "ปี",
			"idId": "Tahun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxAcrosstime",
			"classify": "label",
			"zhCn": "跨时间段",
			"zhTw": "",
			"enUs": "Across Time Period",
			"thTh": "ข้ามช่วงเวลา",
			"idId": "Di Seluruh Periode Waktu",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxUnit",
			"classify": "label",
			"zhCn": "单位",
			"zhTw": "",
			"enUs": "Unit",
			"thTh": "หน่วย",
			"idId": "Unit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtExport",
			"classify": "label",
			"zhCn": "导出",
			"zhTw": "",
			"enUs": "Export",
			"thTh": "ส่งออก",
			"idId": "Ekspor",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtTimecolumn",
			"classify": "label",
			"zhCn": "时间按列排列",
			"zhTw": "",
			"enUs": "Time in Columns",
			"thTh": "แสดงเวลาในคอลัมน์",
			"idId": "Waktu dalam Kolom",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtTimerow",
			"classify": "label",
			"zhCn": "时间按行排列",
			"zhTw": "",
			"enUs": "Time in Rows",
			"thTh": "แสดงเวลาในแถว",
			"idId": "Waktu dalam Baris",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyinsightProportion",
			"classify": "label",
			"zhCn": "能耗占比",
			"zhTw": "",
			"enUs": "Energy Proportion",
			"thTh": "สัดส่วนการใช้พลังงาน",
			"idId": "Proporsi Energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyinsightRanking",
			"classify": "label",
			"zhCn": "能耗排名",
			"zhTw": "",
			"enUs": "Energy Ranking",
			"thTh": "อันดับการใช้พลังงาน",
			"idId": "Peringkat Energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxJanuary",
			"classify": "label",
			"zhCn": "一月",
			"zhTw": "",
			"enUs": "January",
			"thTh": "มกราคม",
			"idId": "Januari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxFebruary",
			"classify": "label",
			"zhCn": "二月",
			"zhTw": "",
			"enUs": "February",
			"thTh": "กุมภาพันธ์",
			"idId": "Februari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxMarch",
			"classify": "label",
			"zhCn": "三月",
			"zhTw": "",
			"enUs": "March",
			"thTh": "มีนาคม",
			"idId": "Maret",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxApril",
			"classify": "label",
			"zhCn": "四月",
			"zhTw": "",
			"enUs": "April",
			"thTh": "เมษายน",
			"idId": "April",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxMay",
			"classify": "label",
			"zhCn": "五月",
			"zhTw": "",
			"enUs": "May",
			"thTh": "พฤษภาคม",
			"idId": "Mei",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxJune",
			"classify": "label",
			"zhCn": "六月",
			"zhTw": "",
			"enUs": "June",
			"thTh": "มิถุนายน",
			"idId": "Juni",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxJuly",
			"classify": "label",
			"zhCn": "七月",
			"zhTw": "",
			"enUs": "July",
			"thTh": "กรกฎาคม",
			"idId": "Juli",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxAugust",
			"classify": "label",
			"zhCn": "八月",
			"zhTw": "",
			"enUs": "August",
			"thTh": "สิงหาคม",
			"idId": "Agustus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxSeptember",
			"classify": "label",
			"zhCn": "九月",
			"zhTw": "",
			"enUs": "September",
			"thTh": "กันยายน",
			"idId": "September",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxOctober",
			"classify": "label",
			"zhCn": "十月",
			"zhTw": "",
			"enUs": "October",
			"thTh": "ตุลาคม",
			"idId": "Oktober",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxNovember",
			"classify": "label",
			"zhCn": "十一月",
			"zhTw": "",
			"enUs": "November",
			"thTh": "พฤศจิกายน",
			"idId": "November",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxDecember",
			"classify": "label",
			"zhCn": "十二月",
			"zhTw": "",
			"enUs": "December",
			"thTh": "ธันวาคม",
			"idId": "Desember",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxMon",
			"classify": "label",
			"zhCn": "周一",
			"zhTw": "",
			"enUs": "Mon",
			"thTh": "จ",
			"idId": "Sen",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxTue",
			"classify": "label",
			"zhCn": "周二",
			"zhTw": "",
			"enUs": "Tue",
			"thTh": "อ",
			"idId": "Sel",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxWed",
			"classify": "label",
			"zhCn": "周三",
			"zhTw": "",
			"enUs": "Wed",
			"thTh": "พ",
			"idId": "Rab",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxFri",
			"classify": "label",
			"zhCn": "周五",
			"zhTw": "",
			"enUs": "Fri",
			"thTh": "ศ",
			"idId": "Jum",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxSat",
			"classify": "label",
			"zhCn": "周六",
			"zhTw": "",
			"enUs": "Sat",
			"thTh": "ส",
			"idId": "Sab",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtJan",
			"classify": "label",
			"zhCn": "一月",
			"zhTw": "",
			"enUs": "Jan",
			"thTh": "ม.ค.",
			"idId": "Jan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtFeb",
			"classify": "label",
			"zhCn": "二月",
			"zhTw": "",
			"enUs": "Feb",
			"thTh": "ก.พ.",
			"idId": "Feb",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtMar",
			"classify": "label",
			"zhCn": "三月",
			"zhTw": "",
			"enUs": "Mar",
			"thTh": "มี.ค.",
			"idId": "Mar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtApr",
			"classify": "label",
			"zhCn": "四月",
			"zhTw": "",
			"enUs": "Apr",
			"thTh": "เม.ย.",
			"idId": "Apr",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtMay",
			"classify": "label",
			"zhCn": "五月",
			"zhTw": "",
			"enUs": "May",
			"thTh": "พ.ค.",
			"idId": "Mei",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtJun",
			"classify": "label",
			"zhCn": "六月",
			"zhTw": "",
			"enUs": "Jun",
			"thTh": "มิ.ย.",
			"idId": "Jun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtJul",
			"classify": "label",
			"zhCn": "七月",
			"zhTw": "",
			"enUs": "Jul",
			"thTh": "ก.ค.",
			"idId": "Jul",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtAug",
			"classify": "label",
			"zhCn": "八月",
			"zhTw": "",
			"enUs": "Aug",
			"thTh": "ส.ค.",
			"idId": "Agt",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtSep",
			"classify": "label",
			"zhCn": "九月",
			"zhTw": "",
			"enUs": "Sep",
			"thTh": "ก.ย.",
			"idId": "Sep",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtOct",
			"classify": "label",
			"zhCn": "十月",
			"zhTw": "",
			"enUs": "Oct",
			"thTh": "ต.ค.",
			"idId": "Okt",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtNov",
			"classify": "label",
			"zhCn": "十一月",
			"zhTw": "",
			"enUs": "Nov",
			"thTh": "พ.ย.",
			"idId": "Nov",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtDec",
			"classify": "label",
			"zhCn": "十二月",
			"zhTw": "",
			"enUs": "Dec",
			"thTh": "ธ.ค.",
			"idId": "Des",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtOk",
			"classify": "label",
			"zhCn": "确定",
			"zhTw": "",
			"enUs": "OK",
			"thTh": "ตกลง",
			"idId": "BAIKLAH",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtCancel",
			"classify": "label",
			"zhCn": "取消",
			"zhTw": "",
			"enUs": "Cancel",
			"thTh": "ยกเลิก",
			"idId": "Batal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyinsightHead",
			"classify": "label",
			"zhCn": "能้耗洞察",
			"zhTw": "",
			"enUs": "Energy Usage Insight",
			"thTh": "ข้อมูลเชิงลึกเกี่ยวกับการใช้พลังงาน",
			"idId": "Wawasan Penggunaan Energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyinsightNo",
			"classify": "label",
			"zhCn": "序号",
			"zhTw": "",
			"enUs": "No.",
			"thTh": "ลำดับ",
			"idId": "Tidak.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyinsightTime",
			"classify": "label",
			"zhCn": "时间",
			"zhTw": "",
			"enUs": "Time",
			"thTh": "เวลา",
			"idId": "Waktu",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyinsightConsumption",
			"classify": "label",
			"zhCn": "能耗 (kWh)",
			"zhTw": "",
			"enUs": "Energy Consumption (kWh)",
			"thTh": "การใช้พลังงาน (kWh)",
			"idId": "Konsumsi Energi (kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyinsightNodename",
			"classify": "label",
			"zhCn": "节点名称",
			"zhTw": "",
			"enUs": "Node Name",
			"thTh": "ชื่อโหนด",
			"idId": "Nama Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbNoinverter",
			"classify": "label",
			"zhCn": "逆变器数量",
			"zhTw": "",
			"enUs": "Number of Inverters",
			"thTh": "จำนวนอินเวอร์เตอร์",
			"idId": "Jumlah Inverter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbInstalledcap",
			"classify": "label",
			"zhCn": "装机容量 (kWp)",
			"zhTw": "",
			"enUs": "Installed Capacity (kWp)",
			"thTh": "กำลังการผลิตที่ติดตั้ง (kWp)",
			"idId": "Kapasitas Terpasang (kWp)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbOperationdate",
			"classify": "label",
			"zhCn": "运行日期",
			"zhTw": "",
			"enUs": "Operation Date",
			"thTh": "วันที่ดำเนินการ",
			"idId": "Tanggal Operasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbMoreinfo",
			"classify": "label",
			"zhCn": "更多",
			"zhTw": "",
			"enUs": "More Info",
			"thTh": "เพิ่มเติม",
			"idId": "Info Lebih Lanjut",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbAddress",
			"classify": "label",
			"zhCn": "地址",
			"zhTw": "",
			"enUs": "Address",
			"thTh": "ที่อยู่",
			"idId": "Alamat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbGridcontype",
			"classify": "label",
			"zhCn": "并网类型",
			"zhTw": "",
			"enUs": "Grid-connected Type",
			"thTh": "ประเภทที่เชื่อมต่อกับโครงข่ายไฟฟ้า",
			"idId": "Tipe yang terhubung ke jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbOffgrid",
			"classify": "label",
			"zhCn": "离网",
			"zhTw": "",
			"enUs": "Off-Grid",
			"thTh": "ไม่เชื่อมต่อกับโครงข่ายไฟฟ้า",
			"idId": "Off-Grid",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbExsurplustogrid",
			"classify": "label",
			"zhCn": "自发自用余电上网",
			"zhTw": "",
			"enUs": "Export Surplus Electricity to Grid",
			"thTh": "ส่งออกไฟฟ้าส่วนเกินสู่โครงข่ายไฟฟ้า",
			"idId": "Ekspor Kelebihan Listrik ke Jaringan Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbExalltogrid",
			"classify": "label",
			"zhCn": "全额上网",
			"zhTw": "",
			"enUs": "Export All Electricity to Grid",
			"thTh": "ส่งออกไฟฟ้าทั้งหมดสู่โครงข่ายไฟฟ้า",
			"idId": "Ekspor Semua Listrik ke Jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbHigh",
			"classify": "label",
			"zhCn": "高",
			"zhTw": "",
			"enUs": "H",
			"thTh": "สูง",
			"idId": "H",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbLow",
			"classify": "label",
			"zhCn": "低",
			"zhTw": "",
			"enUs": "L",
			"thTh": "ต่ำ",
			"idId": "L",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbUv",
			"classify": "label",
			"zhCn": "紫外线",
			"zhTw": "",
			"enUs": "UV",
			"thTh": "UV",
			"idId": "UV",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbUpdated",
			"classify": "label",
			"zhCn": "更新时间",
			"zhTw": "",
			"enUs": "Updated at",
			"thTh": "อัปเดตเมื่อ",
			"idId": "Diperbarui pada",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbForecasr",
			"classify": "label",
			"zhCn": "预报",
			"zhTw": "",
			"enUs": "Forecast",
			"thTh": "พยากรณ์",
			"idId": "Perkiraan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbRtgeneff",
			"classify": "label",
			"zhCn": "实时发电效率（%）",
			"zhTw": "",
			"enUs": "Real-time Generation Efficiency (%)",
			"thTh": "ประสิทธิภาพการผลิตไฟฟ้าเรียลไทม์ (%)",
			"idId": "Efisiensi Pembangkitan Waktu Nyata (%)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbRtpower",
			"classify": "label",
			"zhCn": "实时发电功率",
			"zhTw": "",
			"enUs": "Real-time Power",
			"thTh": "กำลังการผลิตไฟฟ้าเรียลไทม์",
			"idId": "Daya Waktu Nyata",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbTodayequihr",
			"classify": "label",
			"zhCn": "今日等效小时数",
			"zhTw": "",
			"enUs": "Today’s Equivalent Hours",
			"thTh": "ชั่วโมงการผลิตเทียบเท่าของวันนี้",
			"idId": "Jam Setara Hari Ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbSttsum",
			"classify": "label",
			"zhCn": "站点汇总",
			"zhTw": "",
			"enUs": "Station Summary of",
			"thTh": "สรุปผลสถานี",
			"idId": "Ringkasan Stasiun dari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbElecgen",
			"classify": "label",
			"zhCn": "发电量（kWh）",
			"zhTw": "",
			"enUs": "Electricity Generation (kWh)",
			"thTh": "ปริมาณไฟฟ้าที่ผลิต (kWh)",
			"idId": "Pembangkitan Listrik (kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbSelfconsump",
			"classify": "label",
			"zhCn": "自用电量（kWh）",
			"zhTw": "",
			"enUs": "Self-consumption Electricity (kWh)",
			"thTh": "ปริมาณไฟฟ้าที่ใช้เอง (kWh)",
			"idId": "Listrik Konsumsi Sendiri (kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbGridfeed",
			"classify": "label",
			"zhCn": "电网供电电量（kWh）",
			"zhTw": "",
			"enUs": "Grid Feed-in Electricity (kWh)",
			"thTh": "ไฟฟ้าที่ส่งออกสู่โครงข่ายไฟฟ้า (kWh)",
			"idId": "Listrik Masuk ke Jaringan (kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbRevenue",
			"classify": "label",
			"zhCn": "收入（THB）",
			"zhTw": "",
			"enUs": "Revenue (THB)",
			"thTh": "รายได้ (THB)",
			"idId": "Pendapatan (THB)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtToday",
			"classify": "label",
			"zhCn": "今日",
			"zhTw": "",
			"enUs": "Today",
			"thTh": "วันนี้",
			"idId": "Hari ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtThismonth",
			"classify": "label",
			"zhCn": "本月",
			"zhTw": "",
			"enUs": "This Month",
			"thTh": "เดือนนี้",
			"idId": "Bulan ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtThisyear",
			"classify": "label",
			"zhCn": "今年",
			"zhTw": "",
			"enUs": "This Year",
			"thTh": "ปีนี้",
			"idId": "Tahun ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicbtTotal",
			"classify": "label",
			"zhCn": "总计",
			"zhTw": "",
			"enUs": "Total",
			"thTh": "รวม",
			"idId": "Total",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbGenandcomsuptrend",
			"classify": "label",
			"zhCn": "发电及用电趋势",
			"zhTw": "",
			"enUs": "Electricity Generation and Consumption Trend",
			"thTh": "แนวโน้มการผลิตและการบริโภคไฟฟ้า",
			"idId": "Tren Pembangkitan dan Konsumsi Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbGeneration",
			"classify": "label",
			"zhCn": "发电量",
			"zhTw": "",
			"enUs": "Electricity Generation",
			"thTh": "ปริมาณไฟฟ้าที่ผลิต",
			"idId": "Pembangkit Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbGridfeedin",
			"classify": "label",
			"zhCn": "上网电量(kWh)",
			"zhTw": "",
			"enUs": "Grid Feed-In Electricity(kWh)",
			"thTh": "ปริมาณไฟฟ้าส่งออกสู่โครงข่ายไฟฟ้า(kWh)",
			"idId": "Listrik Feed-In Grid(kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbSelfconsumpelec",
			"classify": "label",
			"zhCn": "自发自用电量",
			"zhTw": "",
			"enUs": "Self-Consumption Electricity",
			"thTh": "ปริมาณไฟฟ้าที่ใช้เอง",
			"idId": "Listrik Konsumsi Sendiri",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbPowernefftrend",
			"classify": "label",
			"zhCn": "发电功率及效率趋势",
			"zhTw": "",
			"enUs": "Electricity Generation Power and Efficiency Trend",
			"thTh": "แนวโน้มกำลังการผลิตและประสิทธิภาพการผลิตไฟฟ้า",
			"idId": "Tren Daya dan Efisiensi Pembangkit Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbGeneff",
			"classify": "label",
			"zhCn": "发电效率",
			"zhTw": "",
			"enUs": "Electricity Gerenation Efficiency",
			"thTh": "ประสิทธิภาพการผลิตไฟฟ้า",
			"idId": "Efisiensi Pembangkitan Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbGenpower",
			"classify": "label",
			"zhCn": "发电功率",
			"zhTw": "",
			"enUs": "Electricity Generation Power",
			"thTh": "กำลังการผลิตไฟฟ้า",
			"idId": "Daya Pembangkit Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbInverters",
			"classify": "label",
			"zhCn": "逆变器",
			"zhTw": "",
			"enUs": "Inverters",
			"thTh": "อินเวอร์เตอร์",
			"idId": "Inverter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbNo",
			"classify": "label",
			"zhCn": "编号",
			"zhTw": "",
			"enUs": "No.",
			"thTh": "ลำดับ",
			"idId": "Tidak.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbIvtname",
			"classify": "label",
			"zhCn": "逆变器名称",
			"zhTw": "",
			"enUs": "Inverter Name",
			"thTh": "ชื่ออินเวอร์เตอร์",
			"idId": "Nama Inverter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbDevicesn",
			"classify": "label",
			"zhCn": "设备序列号",
			"zhTw": "",
			"enUs": "Device SN",
			"thTh": "หมายเลข SN",
			"idId": "Perangkat SN",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbStatus",
			"classify": "label",
			"zhCn": "状态",
			"zhTw": "",
			"enUs": "Status",
			"thTh": "สถานะ",
			"idId": "Status",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbTodaygen",
			"classify": "label",
			"zhCn": "今日发电量（kWh）",
			"zhTw": "",
			"enUs": "Today Generation (kWh)",
			"thTh": "ไฟฟ้าที่ผลิตได้วันนี้ (kWh)",
			"idId": "Pembangkitan Hari Ini (kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbTodayquivhour",
			"classify": "label",
			"zhCn": "今日等效小时数",
			"zhTw": "",
			"enUs": "Today’s Equivalent Hours",
			"thTh": "จำนวนชั่วโมงการผลิตเทียบเท่าของวันนี้",
			"idId": "Jam Setara Hari Ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "ivtstatusNormal",
			"classify": "label",
			"zhCn": "正常运行",
			"zhTw": "",
			"enUs": "Normal",
			"thTh": "ปกติ",
			"idId": "Normal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "ivtstatusFault",
			"classify": "label",
			"zhCn": "故障",
			"zhTw": "",
			"enUs": "Fault",
			"thTh": "เกิดข้อผิดพลาด",
			"idId": "Kesalahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "ivtstatusStandby",
			"classify": "label",
			"zhCn": "待机",
			"zhTw": "",
			"enUs": "Standby",
			"thTh": "สแตนด์บาย",
			"idId": "Siaga",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "ivtstatusStop",
			"classify": "label",
			"zhCn": "停机",
			"zhTw": "",
			"enUs": "Stop",
			"thTh": "หยุดทำงาน",
			"idId": "Berhenti.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "ivtstatusPowerlimit",
			"classify": "label",
			"zhCn": "限功率运行",
			"zhTw": "",
			"enUs": "Power-limited operation",
			"thTh": "ทำงานแบบจำกัดกำลัง",
			"idId": "Pengoperasian dengan daya terbatas",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbManufacturer",
			"classify": "label",
			"zhCn": "厂商",
			"zhTw": "",
			"enUs": "Manufacturer",
			"thTh": "ผู้ผลิต",
			"idId": "Produsen",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbInstalledcap",
			"classify": "label",
			"zhCn": "装机容量",
			"zhTw": "",
			"enUs": "Installed Capacity",
			"thTh": "กำลังการผลิตที่ติดตั้ง",
			"idId": "Kapasitas Terpasang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbRatedpower",
			"classify": "label",
			"zhCn": "额定输出功率",
			"zhTw": "",
			"enUs": "Rated Output Power",
			"thTh": "พิกัดกำลังไฟฟ้าเอาต์พุต",
			"idId": "Daya Keluaran Terukur",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbMoreinfo",
			"classify": "label",
			"zhCn": "更多",
			"zhTw": "",
			"enUs": "More Info",
			"thTh": "เพิ่มเติม",
			"idId": "Info Lebih Lanjut",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbDevicesn",
			"classify": "label",
			"zhCn": "设备序列号",
			"zhTw": "",
			"enUs": "Device SN",
			"thTh": "หมายเลข SN",
			"idId": "Perangkat SN",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbModel",
			"classify": "label",
			"zhCn": "型号",
			"zhTw": "",
			"enUs": "Model",
			"thTh": "รุ่น",
			"idId": "Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbElecgensum",
			"classify": "label",
			"zhCn": "发电量汇总",
			"zhTw": "",
			"enUs": "Electricity Generation Summary",
			"thTh": "สรุปผลการผลิตไฟฟ้า",
			"idId": "Ringkasan Pembangkit Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbToday",
			"classify": "label",
			"zhCn": "今日",
			"zhTw": "",
			"enUs": "Today",
			"thTh": "วันนี้",
			"idId": "Hari ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbThismonth",
			"classify": "label",
			"zhCn": "本月",
			"zhTw": "",
			"enUs": "This Month",
			"thTh": "เดือนนี้",
			"idId": "Bulan ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxJan",
			"classify": "label",
			"zhCn": "一月",
			"zhTw": "",
			"enUs": "Jan",
			"thTh": "ม.ค.",
			"idId": "Jan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxFeb",
			"classify": "label",
			"zhCn": "二月",
			"zhTw": "",
			"enUs": "Feb",
			"thTh": "ก.พ.",
			"idId": "Feb",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxMar",
			"classify": "label",
			"zhCn": "三月",
			"zhTw": "",
			"enUs": "Mar",
			"thTh": "มี.ค.",
			"idId": "Mar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxApr",
			"classify": "label",
			"zhCn": "四月",
			"zhTw": "",
			"enUs": "Apr",
			"thTh": "เม.ย.",
			"idId": "Apr",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxJun",
			"classify": "label",
			"zhCn": "六月",
			"zhTw": "",
			"enUs": "Jun",
			"thTh": "มิ.ย.",
			"idId": "Jun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxJul",
			"classify": "label",
			"zhCn": "七月",
			"zhTw": "",
			"enUs": "Jul",
			"thTh": "ก.ค.",
			"idId": "Jul",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxAug",
			"classify": "label",
			"zhCn": "八月",
			"zhTw": "",
			"enUs": "Aug",
			"thTh": "ส.ค.",
			"idId": "Agt",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxSep",
			"classify": "label",
			"zhCn": "九月",
			"zhTw": "",
			"enUs": "Sep",
			"thTh": "ก.ย.",
			"idId": "Sep",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxOct",
			"classify": "label",
			"zhCn": "十月",
			"zhTw": "",
			"enUs": "Oct",
			"thTh": "ต.ค.",
			"idId": "Okt",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxNov",
			"classify": "label",
			"zhCn": "十一月",
			"zhTw": "",
			"enUs": "Nov",
			"thTh": "พ.ย.",
			"idId": "Nov",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxDec",
			"classify": "label",
			"zhCn": "十二月",
			"zhTw": "",
			"enUs": "Dec",
			"thTh": "ธ.ค.",
			"idId": "Des",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbThisyear",
			"classify": "label",
			"zhCn": "今年",
			"zhTw": "",
			"enUs": "This Year",
			"thTh": "ปีนี้",
			"idId": "Tahun ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbTotal",
			"classify": "label",
			"zhCn": "总计",
			"zhTw": "",
			"enUs": "Total",
			"thTh": "รวม",
			"idId": "Total",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbRtgeneff",
			"classify": "label",
			"zhCn": "实时发电效率",
			"zhTw": "",
			"enUs": "Real-time Generation Efficiency",
			"thTh": "ประสิทธิภาพการผลิตไฟฟ้าเรียลไทม์",
			"idId": "Efisiensi Pembangkitan Waktu Nyata",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbRtpower",
			"classify": "label",
			"zhCn": "实时发电功率",
			"zhTw": "",
			"enUs": "Real-time Power",
			"thTh": "กำลังการผลิตไฟฟ้าเรียลไทม์",
			"idId": "Daya Waktu Nyata",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbTodayequivhr",
			"classify": "label",
			"zhCn": "今日等效小时数",
			"zhTw": "",
			"enUs": "Today’s Equivalent Hours",
			"thTh": "ชั่วโมงการผลิตเทียบเท่าของวันนี้",
			"idId": "Jam Setara Hari Ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbGennconsumptrend",
			"classify": "label",
			"zhCn": "发电及用电趋势",
			"zhTw": "",
			"enUs": "Electricity Generation and Consumption Trend",
			"thTh": "แนวโน้มการผลิตและการบริโภคไฟฟ้า",
			"idId": "Tren Pembangkitan dan Konsumsi Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbElecgen",
			"classify": "label",
			"zhCn": "发电量",
			"zhTw": "",
			"enUs": "Electricity Generation",
			"thTh": "ปริมาณไฟฟ้าที่ผลิต",
			"idId": "Pembangkit Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbGenpowerneff",
			"classify": "label",
			"zhCn": "发电功率及效率趋势",
			"zhTw": "",
			"enUs": "Electricity Generation Power and Efficiency Trend",
			"thTh": "แนวโน้มกำลังการผลิตและประสิทธิภาพการผลิตไฟฟ้า",
			"idId": "Tren Daya dan Efisiensi Pembangkit Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbGeneff",
			"classify": "label",
			"zhCn": "发电效率",
			"zhTw": "",
			"enUs": "Electricity Gerenation Efficiency",
			"thTh": "ประสิทธิภาพการผลิตไฟฟ้า",
			"idId": "Efisiensi Pembangkitan Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbGenpower",
			"classify": "label",
			"zhCn": "发电功率",
			"zhTw": "",
			"enUs": "Electricity Generation Power",
			"thTh": "กำลังการผลิตไฟฟ้า",
			"idId": "Daya Pembangkit Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbConversion",
			"classify": "label",
			"zhCn": "转换",
			"zhTw": "",
			"enUs": "Conversion",
			"thTh": "การแปลงไฟฟ้า",
			"idId": "Konversi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbDcside",
			"classify": "label",
			"zhCn": "直流侧",
			"zhTw": "",
			"enUs": "DC Side",
			"thTh": "ด้าน DC",
			"idId": "Sisi DC",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbString",
			"classify": "label",
			"zhCn": "组串",
			"zhTw": "",
			"enUs": "String",
			"thTh": "สตริง",
			"idId": "String",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbInputv",
			"classify": "label",
			"zhCn": "输入电压 (V)",
			"zhTw": "",
			"enUs": "Input Voltage (V)",
			"thTh": "แรงดันไฟฟ้าอินพุต (V)",
			"idId": "Tegangan Input (V)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbInputa",
			"classify": "label",
			"zhCn": "输入电流 (A)",
			"zhTw": "",
			"enUs": "Input Current (A)",
			"thTh": "กระแสไฟฟ้าอินพุต (A)",
			"idId": "Arus Masukan (A)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbAcside",
			"classify": "label",
			"zhCn": "交流侧",
			"zhTw": "",
			"enUs": "AC Side",
			"thTh": "ด้าน AC",
			"idId": "Sisi AC",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbPhase",
			"classify": "label",
			"zhCn": "相",
			"zhTw": "",
			"enUs": "Phase",
			"thTh": "เฟส",
			"idId": "Fase",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbPhasea",
			"classify": "label",
			"zhCn": "A相",
			"zhTw": "",
			"enUs": "Phase A",
			"thTh": "เฟส A",
			"idId": "Fase A",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbPhaseb",
			"classify": "label",
			"zhCn": "B相",
			"zhTw": "",
			"enUs": "Phase B",
			"thTh": "เฟส B",
			"idId": "Fase B",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbPhasec",
			"classify": "label",
			"zhCn": "C相",
			"zhTw": "",
			"enUs": "Phase C",
			"thTh": "เฟส C",
			"idId": "Fase C",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbOutputv",
			"classify": "label",
			"zhCn": "输出电压 (V)",
			"zhTw": "",
			"enUs": "Output Voltage (V)",
			"thTh": "แรงดันไฟฟ้าเอาต์พุต (V)",
			"idId": "Tegangan Output (V)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbOutputa",
			"classify": "label",
			"zhCn": "输出电流 (A)",
			"zhTw": "",
			"enUs": "Output Current (A)",
			"thTh": "กระแสไฟเอาต์พุต (A)",
			"idId": "Arus Keluaran (A)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbRtconverioneff",
			"classify": "label",
			"zhCn": "实时转换效率",
			"zhTw": "",
			"enUs": "Real-time Conversion Efficiency",
			"thTh": "ประสิทธิภาพการแปลงไฟฟ้าแบบเรียลไทม์",
			"idId": "Efisiensi Konversi Waktu Nyata",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbDcinpower",
			"classify": "label",
			"zhCn": "总直流输入功率",
			"zhTw": "",
			"enUs": "Total DC Input Power",
			"thTh": "กำลังไฟฟ้าอินพุต DC รวม",
			"idId": "Total Daya Input DC",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbAcoutpower",
			"classify": "label",
			"zhCn": "总交流输出功率",
			"zhTw": "",
			"enUs": "Total AC Output Power",
			"thTh": "กำลังไฟฟ้าเอาต์พุต AC รวม",
			"idId": "Total Daya Keluaran AC",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "onlineType",
			"classify": "tips",
			"zhCn": "上网类型",
			"zhTw": "上網類型",
			"enUs": "Internet type",
			"thTh": "ประเภทอินเทอร์เน็ต",
			"idId": "Jenis Internet",
			"esMx": "Tipo de acceso a Internet",
			"viVi": "Loại Internet",
			"ptPt": "Tipo de Internet"
		},
		{
			"textKey": "systemTitle",
			"classify": "label",
			"zhCn": "能源管理平台",
			"zhTw": "能源管理平台",
			"enUs": "Energy Management Platform",
			"thTh": "แพลตฟอร์มการจัดการพลังงาน",
			"idId": "Platform manajemen energi",
			"esMx": "Plataforma de gestión energética",
			"viVi": "Nền tảng quản lý năng lượng",
			"ptPt": "Plataforma de gestão de energia"
		},
		{
			"textKey": "empIcon",
			"classify": "label",
			"zhCn": "EMP图标",
			"zhTw": "EMP圖標",
			"enUs": "EMP icon",
			"thTh": "ไอคอน EMP",
			"idId": "Ikon EMP",
			"esMx": "Icono de EMP",
			"viVi": "Biểu tượng EMP",
			"ptPt": "Ícones EMP"
		},
		{
			"textKey": "commonIcon",
			"classify": "label",
			"zhCn": "通用图标",
			"zhTw": "通用圖標",
			"enUs": "General icon",
			"thTh": "ไอคอนสากล",
			"idId": "Ikon universal",
			"esMx": "Iconos universales",
			"viVi": "Biểu tượng phổ quát",
			"ptPt": "Ícone universal"
		},
		{
			"textKey": "systemIcon",
			"classify": "label",
			"zhCn": "系统图标",
			"zhTw": "系統圖標",
			"enUs": "System icon",
			"thTh": "ไอคอนระบบ",
			"idId": "Ikon sistem",
			"esMx": "Icono del sistema",
			"viVi": "Biểu tượng hệ thống",
			"ptPt": "Ícones do sistema"
		},
		{
			"textKey": "subMenuConfig",
			"classify": "label",
			"zhCn": "下级菜单配置",
			"zhTw": "下級菜單配置",
			"enUs": "Lower-level menu configuration",
			"thTh": "การกำหนดค่าเมนูระดับล่าง",
			"idId": "Konfigurasi menu bawahan",
			"esMx": "Configuración del menú de nivel inferior",
			"viVi": "Cấu hình menu cấp thấp hơn",
			"ptPt": "Configuração do menu inferior"
		},
		{
			"textKey": "ifExportData",
			"classify": "tips",
			"zhCn": "是否确认导出数据？",
			"zhTw": "是否導出數據?",
			"enUs": "Confirm to export data?",
			"thTh": "ยืนยันการส่งออกข้อมูลหรือไม่",
			"idId": "Konfirmasi untuk mengekspor data?",
			"esMx": "¿Se exportan los datos?",
			"viVi": "Có xuất dữ liệu không?",
			"ptPt": "Os dados são exportados?"
		},
		{
			"textKey": "timeInRows",
			"classify": "label",
			"zhCn": "时间在行中",
			"zhTw": "時間在行中",
			"enUs": "Time in Rows",
			"thTh": "แสดงเวลาในแถว",
			"idId": "Waktu dalam Baris",
			"esMx": "Tiempo en la línea",
			"viVi": "Thời gian trong dòng",
			"ptPt": "O tempo está na linha"
		},
		{
			"textKey": "timeInColumns",
			"classify": "label",
			"zhCn": "时间在列中",
			"zhTw": "時間在列中",
			"enUs": "Time in Columns",
			"thTh": "แสดงเวลาในคอลัมน์",
			"idId": "Waktu dalam Kolom",
			"esMx": "Tiempo en la columna",
			"viVi": "Thời gian trong cột",
			"ptPt": "O tempo está na coluna"
		},
		{
			"textKey": "loginPageTitle",
			"classify": "label",
			"zhCn": "登录页",
			"zhTw": "登錄頁",
			"enUs": "Login Page",
			"thTh": "หน้าเข้าสู่ระบบ",
			"idId": "Halaman login",
			"esMx": "Página de inicio de sesión",
			"viVi": "Trang đăng nhập",
			"ptPt": "Página de login"
		},
		{
			"textKey": "energyAnalysisPageTitle",
			"classify": "label",
			"zhCn": "能耗洞察",
			"zhTw": "能耗洞察",
			"enUs": "Energy Usage Insight",
			"thTh": "ข้อมูลเชิงลึกเกี่ยวกับการใช้พลังงาน",
			"idId": "Wawasan konsumsi energi",
			"esMx": "Información sobre el consumo de energía",
			"viVi": "Thông tin chi tiết về tiêu thụ năng lượng",
			"ptPt": "Insights de consumo de energia"
		},
		{
			"textKey": "inputAccountName",
			"classify": "tips",
			"zhCn": "请输入账号名称",
			"zhTw": "請輸入賬號名稱",
			"enUs": "Please enter your Account Name",
			"thTh": "กรุณากรอกชื่อบัญชี",
			"idId": "Silakan masukkan Nama Akun Anda",
			"esMx": "Ingrese el nombre de la cuenta",
			"viVi": "Vui lòng nhập tên tài khoản",
			"ptPt": "Por favor, insira o nome da conta"
		},
		{
			"textKey": "inputPassword",
			"classify": "tips",
			"zhCn": "请输入密码",
			"zhTw": "請輸入密碼",
			"enUs": "Please enter your password",
			"thTh": "กรุณากรอกรหัสผ่าน",
			"idId": "Masukkan kata sandi Anda",
			"esMx": "Por favor ingrese la contraseña",
			"viVi": "Vui lòng nhập mật khẩu",
			"ptPt": "Por favor, digite a senha"
		},
		{
			"textKey": "plzInputCode",
			"classify": "tips",
			"zhCn": "请输入验证码",
			"zhTw": "請輸入驗證碼",
			"enUs": "Please enter the verification code",
			"thTh": "กรุณากรอกรหัสยืนยัน",
			"idId": "Masukkan kode verifikasi",
			"esMx": "Ingrese el código de verificación",
			"viVi": "Vui lòng nhập mã xác minh",
			"ptPt": "Por favor, insira o código de verificação"
		},
		{
			"textKey": "loggingInPlzWait",
			"classify": "tips",
			"zhCn": "登录中，请稍后",
			"zhTw": "登錄中,請稍後",
			"enUs": "Login, please wait",
			"thTh": "เข้าสู่ระบบโปรดรอสักครู่",
			"idId": "Masuk, silakan nanti",
			"esMx": "Inicie sesión, espere",
			"viVi": "Đăng nhập, vui lòng đợi",
			"ptPt": "Login, por favor mais tarde"
		},
		{
			"textKey": "basicdtConfirm",
			"classify": "label",
			"zhCn": "确认",
			"zhTw": "",
			"enUs": "Confirm",
			"thTh": "ยืนยัน",
			"idId": "Mengonfirmasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "meLang",
			"classify": "label",
			"zhCn": "语言",
			"zhTw": "",
			"enUs": "Language",
			"thTh": "ภาษา",
			"idId": "Bahasa",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "meUserinfo",
			"classify": "label",
			"zhCn": "个人信息",
			"zhTw": "",
			"enUs": "User Info",
			"thTh": "ข้อมูลผู้ใช้",
			"idId": "Info Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "meLogout",
			"classify": "label",
			"zhCn": "退出登录",
			"zhTw": "",
			"enUs": "Logout",
			"thTh": "ออกจากระบบ",
			"idId": "Keluar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoPic",
			"classify": "label",
			"zhCn": "头像",
			"zhTw": "",
			"enUs": "Profile Picture",
			"thTh": "รูปโปรไฟล์",
			"idId": "Gambar Profil",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoPictext",
			"classify": "label",
			"zhCn": "只能上传jpg/png用户头像,且不超过500kb",
			"zhTw": "",
			"enUs": "Only jpg/png picture can be uploaded, and the picture are no more than 500kb",
			"thTh": "สามารถอัพโหลดได้เฉพาะรูป jpg/png เท่านั้น และขนาดรูปต้องไม่เกิน 500kb",
			"idId": "Hanya gambar jpg/png yang dapat diunggah, dan ukuran gambar tidak lebih dari 500kb",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoAccname",
			"classify": "label",
			"zhCn": "账号名称",
			"zhTw": "",
			"enUs": "Account Name",
			"thTh": "ชื่อบัญชี",
			"idId": "Nama Akun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputaccname",
			"classify": "label",
			"zhCn": "请输入账号名称",
			"zhTw": "",
			"enUs": "Please enter Account Name",
			"thTh": "กรุณากรอกชื่อบัญชี",
			"idId": "Silakan masukkan Nama Akun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputacctext",
			"classify": "label",
			"zhCn": "请输入账号名称",
			"zhTw": "",
			"enUs": "Please enter Account Name",
			"thTh": "กรุณากรอกชื่อบัญชี",
			"idId": "Silakan masukkan Nama Akun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoUsername",
			"classify": "label",
			"zhCn": "用户姓名",
			"zhTw": "",
			"enUs": "User Name",
			"thTh": "ชื่อผู้ใช้",
			"idId": "Nama Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputusername",
			"classify": "label",
			"zhCn": "请输入用户姓名",
			"zhTw": "",
			"enUs": "Please enter User Name",
			"thTh": "กรุณากรอกชื่อผู้ใช้",
			"idId": "Silakan masukkan Nama Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputusertext",
			"classify": "label",
			"zhCn": "请输入用户姓名",
			"zhTw": "",
			"enUs": "Please enter User Name",
			"thTh": "กรุณากรอกชื่อผู้ใช้",
			"idId": "Silakan masukkan Nama Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoPhone",
			"classify": "label",
			"zhCn": "手机号码",
			"zhTw": "",
			"enUs": "Phone",
			"thTh": "หมายเลขโทรศัพท์",
			"idId": "Telepon",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputphone",
			"classify": "label",
			"zhCn": "请输入手机号码",
			"zhTw": "",
			"enUs": "Please enter Phone number",
			"thTh": "กรุณากรอกหมายเลขโทรศัพท์",
			"idId": "Silakan masukkan nomor telepon",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoEmail",
			"classify": "label",
			"zhCn": "电子邮箱",
			"zhTw": "",
			"enUs": "Email",
			"thTh": "อีเมล",
			"idId": "Email",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputmail",
			"classify": "label",
			"zhCn": "请输入电子邮箱",
			"zhTw": "",
			"enUs": "Please enter Email",
			"thTh": "กรุณากรอกอีเมล",
			"idId": "Silakan masukkan Email",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoOldpass",
			"classify": "label",
			"zhCn": "原密码",
			"zhTw": "",
			"enUs": "Original Password",
			"thTh": "รหัสผ่านเดิม",
			"idId": "Kata Sandi Asli",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputoldpass",
			"classify": "label",
			"zhCn": "请输入原密码",
			"zhTw": "",
			"enUs": "Please enter Original Password",
			"thTh": "กรุณากรอกรหัสผ่านเดิม",
			"idId": "Silakan masukkan Kata Sandi Asli",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputoldpasstx",
			"classify": "label",
			"zhCn": "请输入当前密码",
			"zhTw": "",
			"enUs": "Please enter the current password",
			"thTh": "กรุณากรอกรหัสผ่านปัจจุบัน",
			"idId": "Masukkan kata sandi saat ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoNewpass",
			"classify": "label",
			"zhCn": "新密码",
			"zhTw": "",
			"enUs": "New Password",
			"thTh": "รหัสผ่านใหม่",
			"idId": "Kata Sandi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputnewpass",
			"classify": "label",
			"zhCn": "请输入新密码",
			"zhTw": "",
			"enUs": "Please enter New Password",
			"thTh": "กรุณากรอกรหัสผ่านใหม่",
			"idId": "Silakan masukkan Kata Sandi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputnewpasstx",
			"classify": "label",
			"zhCn": "请输入新密码",
			"zhTw": "",
			"enUs": "Please enter a new password",
			"thTh": "กรุณากรอกรหัสผ่านใหม่",
			"idId": "Silakan masukkan kata sandi baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoCfpass",
			"classify": "label",
			"zhCn": "确认密码",
			"zhTw": "",
			"enUs": "Confirm Password",
			"thTh": "ยืนยันรหัสผ่าน",
			"idId": "Konfirmasi Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputcfpass",
			"classify": "label",
			"zhCn": "请输入确认密码",
			"zhTw": "",
			"enUs": "Please enter Confirm Password",
			"thTh": "กรุณายืนยันรหัสผ่าน",
			"idId": "Silakan masukkan Konfirmasi Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userinfoInputcfpasstx",
			"classify": "label",
			"zhCn": "请再次输入新密码",
			"zhTw": "",
			"enUs": "Please enter the new password again",
			"thTh": "กรุณากรอกรหัสผ่านใหม่อีกครั้ง",
			"idId": "Silakan masukkan kata sandi baru lagi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "logoutPromt",
			"classify": "label",
			"zhCn": "是否确认退出系统？",
			"zhTw": "",
			"enUs": "Are you sure you want to exit the system?",
			"thTh": "คุณแน่ใจว่าต้องการออกจากระบบหรือไม่?",
			"idId": "Apakah Anda yakin ingin keluar dari sistem?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginHeader",
			"classify": "label",
			"zhCn": "登录",
			"zhTw": "",
			"enUs": "Login",
			"thTh": "เข้าสู่ระบบ",
			"idId": "Masuk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginAcc",
			"classify": "label",
			"zhCn": "账号",
			"zhTw": "",
			"enUs": "Account",
			"thTh": "บัญชี",
			"idId": "Akun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginAcctx",
			"classify": "label",
			"zhCn": "请输入账号名称",
			"zhTw": "",
			"enUs": "Please enter your Account Name",
			"thTh": "กรุณากรอกชื่อบัญชี",
			"idId": "Silakan masukkan Nama Akun Anda",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginPasstx",
			"classify": "label",
			"zhCn": "请输入密码",
			"zhTw": "",
			"enUs": "Please enter your password",
			"thTh": "กรุณากรอกรหัสผ่าน",
			"idId": "Silakan masukkan kata sandi Anda",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginCodetx",
			"classify": "label",
			"zhCn": "请输入验证码",
			"zhTw": "",
			"enUs": "Please enter the verification code",
			"thTh": "กรุณากรอกรหัสยืนยัน",
			"idId": "Masukkan kode verifikasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginButton",
			"classify": "label",
			"zhCn": "登录",
			"zhTw": "",
			"enUs": "Login",
			"thTh": "เข้าสู่ระบบ",
			"idId": "Masuk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginWait",
			"classify": "label",
			"zhCn": "登录中，请稍后",
			"zhTw": "",
			"enUs": "Logging in, please wait",
			"thTh": "กำลังเข้าสู่ระบบ กรุณารอสักครู่",
			"idId": "Masuk, silakan tunggu",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxLoading",
			"classify": "label",
			"zhCn": "CSE EMP\n系统加载中",
			"zhTw": "",
			"enUs": "CSE EMP\nSystem loading",
			"thTh": "CSE EMP\nระบบกำลังโหลด",
			"idId": "CSE EMP\nPemuatan sistem",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "language",
			"classify": "label",
			"zhCn": "语言",
			"zhTw": "語言",
			"enUs": "Language",
			"thTh": "ภาษา",
			"idId": "Bahasa",
			"esMx": "Idioma",
			"viVi": "Ngôn ngữ",
			"ptPt": "Linguagem"
		},
		{
			"textKey": "serialNumber",
			"classify": "table",
			"zhCn": "序号",
			"zhTw": "序號",
			"enUs": "No.",
			"thTh": "ลำดับ",
			"idId": "Tidak.",
			"esMx": "Número de serie",
			"viVi": "Số thứ tự",
			"ptPt": "Número de série"
		},
		{
			"textKey": "confirmPassword",
			"classify": "label",
			"zhCn": "确认密码",
			"zhTw": "確認密碼",
			"enUs": "Confirm Password",
			"thTh": "ยืนยันรหัสผ่าน",
			"idId": "Konfirmasi Kata Sandi",
			"esMx": "Confirmar la contraseña",
			"viVi": "Xác nhận mật khẩu",
			"ptPt": "Confirmar a senha"
		},
		{
			"textKey": "confirm",
			"classify": "btn",
			"zhCn": "确认",
			"zhTw": "確認",
			"enUs": "Confirm",
			"thTh": "ยืนยัน",
			"idId": "Mengonfirmasi",
			"esMx": "Determinar",
			"viVi": "Xác nhận",
			"ptPt": "OK"
		},
		{
			"textKey": "ifExitSystemConfirm",
			"classify": "tips",
			"zhCn": "是否确认退出系统？",
			"zhTw": "是否退出系統,?",
			"enUs": "Are you sure you want to exit the system?",
			"thTh": "คุณแน่ใจว่าต้องการออกจากระบบหรือไม่?",
			"idId": "Apakah Anda yakin ingin keluar dari sistem?",
			"esMx": "¿Salir del sistema, continuar?",
			"viVi": "Bạn có thoát khỏi hệ thống không, bạn có tiếp tục không?",
			"ptPt": "Saia do sistema e continue?"
		},
		{
			"textKey": "plzInputGateway",
			"classify": "label",
			"zhCn": "请输入网关",
			"zhTw": "請輸入網關",
			"enUs": "Please enter a gateway",
			"thTh": "กรุณาป้อนเกตเวย์",
			"idId": "Silakan masukkan gateway",
			"esMx": "Ingrese la puerta de enlace",
			"viVi": "Vui lòng nhập cổng",
			"ptPt": "Por favor, insira o gateway"
		},
		{
			"textKey": "plzSelectStartTime",
			"classify": "tips",
			"zhCn": "请选择开始时间",
			"zhTw": "請選擇開始時間",
			"enUs": "Please select a start time",
			"thTh": "กรุณากรอกเวลาเริ่มต้น",
			"idId": "Harap pilih Waktu Mulai",
			"esMx": "Seleccione la hora de inicio",
			"viVi": "Vui lòng chọn thời gian bắt đầu",
			"ptPt": "Por favor, escolha o horário de início"
		},
		{
			"textKey": "PleaseselectAlarmlevel",
			"classify": "label",
			"zhCn": "请选择告警等级",
			"zhTw": "請選擇告警等級",
			"enUs": "Please select an alarm level",
			"thTh": "โปรดเลือกระดับการเตือน",
			"idId": "Silakan pilih tingkat alarm",
			"esMx": "Seleccione el nivel de alarma",
			"viVi": "Vui lòng chọn mức cảnh báo",
			"ptPt": "Por favor, escolha o nível de alerta"
		},
		{
			"textKey": "energyCostTrend",
			"classify": "graph",
			"zhCn": "能耗趋势",
			"zhTw": "能耗趨勢",
			"enUs": "Energy consumption trends",
			"thTh": "แนวโน้มการใช้พลังงาน",
			"idId": "Tren konsumsi energi",
			"esMx": "Tendencias de consumo de energía",
			"viVi": "Xu hướng tiêu thụ năng lượng",
			"ptPt": "Tendências de consumo de energia"
		},
		{
			"textKey": "energyConsumptionRatio",
			"classify": "graph",
			"zhCn": "能耗占比",
			"zhTw": "能耗占比",
			"enUs": "Energy consumption ratio",
			"thTh": "สัดส่วนการใช้พลังงาน",
			"idId": "Konsumsi energi",
			"esMx": "Consumo de energía como porcentaje",
			"viVi": "Tỷ lệ tiêu thụ năng lượng",
			"ptPt": "A proporção do consumo de energia"
		},
		{
			"textKey": "gatewayInterrupted",
			"classify": "option",
			"zhCn": "网关通讯中断",
			"zhTw": "網關通訊中斷",
			"enUs": "Gateway communication interruption",
			"thTh": "การสื่อสารเกตเวย์หยุดชะงัก",
			"idId": "Gangguan komunikasi gateway",
			"esMx": "Interrupción de la comunicación de la puerta de enlace",
			"viVi": "Giao tiếp cổng bị gián đoạn",
			"ptPt": "Interrupção da comunicação do gateway"
		},
		{
			"textKey": "fivePoints",
			"classify": "option",
			"zhCn": "5分",
			"zhTw": "5分",
			"enUs": "5 points",
			"thTh": "5จุด",
			"idId": "5 poin",
			"esMx": "5 puntos",
			"viVi": "5 điểm",
			"ptPt": "5 pontos"
		},
		{
			"textKey": "fifteenPoints",
			"classify": "option",
			"zhCn": "15分",
			"zhTw": "15分",
			"enUs": "15 points",
			"thTh": "15จุด",
			"idId": "15 poin",
			"esMx": "15 puntos",
			"viVi": "15 điểm",
			"ptPt": "15 pontos"
		},
		{
			"textKey": "thirtyMinutes",
			"classify": "option",
			"zhCn": "30分",
			"zhTw": "30分",
			"enUs": "30 points",
			"thTh": "30นาที",
			"idId": "30 poin",
			"esMx": "30 puntos",
			"viVi": "30 điểm",
			"ptPt": "30 pontos"
		},
		{
			"textKey": "daily",
			"classify": "option",
			"zhCn": "日报",
			"zhTw": "日報",
			"enUs": "Daily newspaper",
			"thTh": "หนังสือพิมพ์รายวัน",
			"idId": "Harian",
			"esMx": "Diario",
			"viVi": "Nhật báo",
			"ptPt": "Diário"
		},
		{
			"textKey": "monthly",
			"classify": "option",
			"zhCn": "月报",
			"zhTw": "月報",
			"enUs": "Monthly Report",
			"thTh": "รายเดือน",
			"idId": "Laporan bulanan",
			"esMx": "Informe mensual",
			"viVi": "Báo cáo hàng tháng",
			"ptPt": "Relatório mensal"
		},
		{
			"textKey": "YoY",
			"classify": "option",
			"zhCn": "同比",
			"zhTw": "同比",
			"enUs": "YoY",
			"thTh": "ปีต่อปี",
			"idId": "Tahun ke tahun",
			"esMx": "Año tras año",
			"viVi": "Theo năm",
			"ptPt": "Ano a ano"
		},
		{
			"textKey": "MoM",
			"classify": "option",
			"zhCn": "环比",
			"zhTw": "環比",
			"enUs": "Ring comparison",
			"thTh": "ห่วงโซ่",
			"idId": "Rantai",
			"esMx": "La cadena",
			"viVi": "Chuỗi",
			"ptPt": "A cadeia"
		},
		{
			"textKey": "YoYAndMoM",
			"classify": "option",
			"zhCn": "同环比",
			"zhTw": "同環比",
			"enUs": "Same Ring",
			"thTh": "ห่วงโซ่เดียวกัน",
			"idId": "Rantai yang sama",
			"esMx": "La misma cadena",
			"viVi": "Cùng chuỗi",
			"ptPt": "O mesmo mês"
		},
		{
			"textKey": "historicalAlarms",
			"classify": "label",
			"zhCn": "历史告警",
			"zhTw": "歷史告警",
			"enUs": "Historical alarm",
			"thTh": "คำเตือนทางประวัติศาสตร์",
			"idId": "Peringatan sejarah",
			"esMx": "Alerta histórica",
			"viVi": "Cảnh báo lịch sử",
			"ptPt": "Aviso histórico"
		},
		{
			"textKey": "warning",
			"classify": "label",
			"zhCn": "正在告警",
			"zhTw": "正在告警",
			"enUs": "Alarm in progress",
			"thTh": "กำลังแจ้งเตือน",
			"idId": "Polisi",
			"esMx": "Alerta",
			"viVi": "Đang báo động",
			"ptPt": "Está alertando"
		},
		{
			"textKey": "ignore",
			"classify": "btn",
			"zhCn": "忽略",
			"zhTw": "忽略",
			"enUs": "Ignore",
			"thTh": "ละเว้น",
			"idId": "Abaikan",
			"esMx": "Ignorar",
			"viVi": "Bỏ qua",
			"ptPt": "Ignorar"
		},
		{
			"textKey": "operationSuccess",
			"classify": "tips",
			"zhCn": "操作成功",
			"zhTw": "操作成功",
			"enUs": "Operation succeeded",
			"thTh": "การดำเนินงานที่ประสบความสำเร็จ",
			"idId": "Operasi yang sukses",
			"esMx": "Operación exitosa",
			"viVi": "Hoạt động thành công",
			"ptPt": "Operação bem sucedida"
		},
		{
			"textKey": "gatewayDevice",
			"classify": "btn",
			"zhCn": "网关设备",
			"zhTw": "網關設備",
			"enUs": "Gateway device",
			"thTh": "เกตเวย์อุปกรณ์",
			"idId": "Perangkat gateway",
			"esMx": "Equipo de puerta de enlace",
			"viVi": "Thiết bị cổng",
			"ptPt": "Dispositivos de gateway"
		},
		{
			"textKey": "pvsttdbHours",
			"classify": "label",
			"zhCn": "小时",
			"zhTw": "",
			"enUs": "hours",
			"thTh": "ชั่วโมง",
			"idId": "Jam",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "inverterdbGentrend",
			"classify": "label",
			"zhCn": "发电趋势",
			"zhTw": "發電趨勢",
			"enUs": "Electricity Generation Trend",
			"thTh": "แนวโน้มการผลิตไฟฟ้า",
			"idId": "Tren Pembangkitan Listrik",
			"esMx": "Tendencias de generación eléctrica",
			"viVi": "Xu hướng phát điện",
			"ptPt": "Tendências de geração de energia"
		},
		{
			"textKey": "inverterdbHours",
			"classify": "label",
			"zhCn": "小时",
			"zhTw": "",
			"enUs": "hours",
			"thTh": "ชั่วโมง",
			"idId": "Jam",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginPass",
			"classify": "label",
			"zhCn": "密码",
			"zhTw": "",
			"enUs": "Password",
			"thTh": "รหัสผ่าน",
			"idId": "Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "loginCode",
			"classify": "label",
			"zhCn": "验证码",
			"zhTw": "",
			"enUs": "Verification Code",
			"thTh": "รหัสยืนยัน",
			"idId": "Kode Verifikasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "assetsIdLengthLimit8To50",
			"classify": "tips",
			"zhCn": "8~50个字符",
			"zhTw": "8~ 50個字符",
			"enUs": "8~50 characters",
			"thTh": "8 ~ 50ตัวอักษร",
			"idId": "8 ~ 50 karakter",
			"esMx": "8 ~ 50 caracteres",
			"viVi": "8 ~ 50 ký tự",
			"ptPt": "8 ~ 50 caracteres"
		},
		{
			"textKey": "assetId",
			"classify": "table",
			"zhCn": "资产ID",
			"zhTw": "資產ID",
			"enUs": "Asset ID",
			"thTh": "ID สินทรัพย์",
			"idId": "ID aset",
			"esMx": "ID de activos",
			"viVi": "ID tài sản",
			"ptPt": "ID de ativos"
		},
		{
			"textKey": "openApiAuth",
			"classify": "label",
			"zhCn": "开放接口权限",
			"zhTw": "開放接口權限",
			"enUs": "Open interface permissions",
			"thTh": "สิทธิ์เปิดอินเทอร์เฟซ",
			"idId": "Izin antarmuka terbuka",
			"esMx": "Permisos de interfaz abierta",
			"viVi": "Quyền giao diện mở",
			"ptPt": "Permissões de interface aberta"
		},
		{
			"textKey": "tvocDescription",
			"classify": "tips",
			"zhCn": "TVOC代表\"总挥发性有机化合物\"，是指一类在室温下容易蒸发的有机化合物的统称。TVOC包括苯、甲苯、二甲苯等多种化合物，主要来源于建筑材料、装饰材料、家具、家用电器、清洁剂和人体自身的排放物。",
			"zhTw": "TVOC代表\"總揮發性有機化合物\",是指一類在室溫下容易蒸發的有機化合物的統稱。 TVOC包括苯、甲苯、二甲苯等多種化合物,主要來源於建築材料、裝飾材料、家具、家用電器、清潔劑和人體自身的排放物。",
			"enUs": "TVOC stands for \"Total Volatile Organic Compounds\". It refers to the collective term for a class of organic compounds that easily vaporize at room temperature. TVOC includes a variety of compounds such as benzene, toluene, xylene, etc., which mainly originate from building materials, decorative materials, furniture, household appliances, cleaning agents, and emissions from the human body itself.",
			"thTh": " TVOC ย่อมาจาก \" Total Volatile Organic Compounds \" หมายถึงสารประกอบอินทรีย์ที่ระเหยได้ง่ายที่อุณหภูมิห้อง TVOC ประกอบด้วยสารประกอบต่างๆ เช่น เบนซิน โทลูอีน ไซลีน เป็นต้น ซึ่งส่วนใหญ่มาจากวัสดุก่อสร้าง วัสดุตกแต่ง เฟอร์นิเจอร์ เครื่องใช้ในครัวเรือน น้ำยาทำความสะอาด และสารที่ปล่อยออกมาจากร่างกายมนุษย์",
			"idId": "  TVOC adalah singkatan dari \"Total Volatile Organic Compounds\". Istilah ini mengacu pada istilah kolektif untuk kelas senyawa organik yang mudah menguap pada suhu kamar. TVOC mencakup berbagai senyawa seperti benzena, toluena, xilena, dll., yang terutama berasal dari bahan bangunan, bahan dekoratif, furnitur, peralatan rumah tangga, bahan pembersih, dan emisi dari tubuh manusia. agen pembersih, dan emisi dari tubuh manusia itu sendiri.",
			"esMx": "TVOC significa \"compuestos orgánicos volátiles totales\" y se refiere a una clase de compuestos orgánicos que se evaporan fácilmente a temperatura ambiente. TVOC incluye una variedad de compuestos como benceno, tolueno, xileno, etc., que se derivan principalmente de materiales de construcción, materiales decorativos, muebles, electrodomésticos, detergentes y las propias emisiones del cuerpo humano.",
			"viVi": "TVOC là viết tắt của \"tổng hợp chất hữu cơ dễ bay hơi\" và dùng để chỉ một thuật ngữ chung cho một nhóm các hợp chất hữu cơ dễ bay hơi ở nhiệt độ phòng. TVOC bao gồm benzen, toluen, xylen và các hợp chất khác, chủ yếu có nguồn gốc từ vật liệu xây dựng, vật liệu trang trí, đồ nội thất, thiết bị gia dụng, chất tẩy rửa và khí thải của chính cơ thể con người.",
			"ptPt": "TVOC significa \"composto orgânico volátil total\" e se refere a um termo coletivo para uma classe de compostos orgânicos que são fáceis de evaporar à temperatura ambiente. O TVOC inclui uma variedade de compostos, como benzeno, tolueno e xileno, que são derivados principalmente de materiais de construção, materiais decorativos, móveis, eletrodomésticos, detergentes e emissões do próprio corpo humano."
		},
		{
			"textKey": "addSub",
			"classify": "btn",
			"zhCn": "新增子项",
			"zhTw": "新增子項",
			"enUs": "Add child",
			"thTh": "เพิ่มรายการย่อย",
			"idId": "Menambahkan sub item",
			"esMx": "Agregar subelementos",
			"viVi": "Thêm các mục con",
			"ptPt": "Novos subitens"
		},
		{
			"textKey": "resetPassword",
			"classify": "btn",
			"zhCn": "重置密码",
			"zhTw": "重置密碼",
			"enUs": "Reset Password",
			"thTh": "รีเซ็ตรหัสผ่าน",
			"idId": "Atur ulang kata sandi",
			"esMx": "Restablecer contraseña",
			"viVi": "Đặt lại mật khẩu",
			"ptPt": "Redefinir a senha"
		},
		{
			"textKey": "enable",
			"classify": "btn",
			"zhCn": "启用",
			"zhTw": "啟用",
			"enUs": "Enable",
			"thTh": "เปิดใช้งาน",
			"idId": "Aktifkan",
			"esMx": "Habilitar",
			"viVi": "Kích hoạt",
			"ptPt": "Habilitar"
		},
		{
			"textKey": "disable",
			"classify": "btn",
			"zhCn": "禁用",
			"zhTw": "禁用",
			"enUs": "Disable",
			"thTh": "ปิดการใช้งาน",
			"idId": "Menonaktifkan",
			"esMx": "Deshabilitar",
			"viVi": "Vô hiệu hóa",
			"ptPt": "Desativar"
		},
		{
			"textKey": "setting",
			"classify": "btn",
			"zhCn": "设置",
			"zhTw": "設置",
			"enUs": "Setup",
			"thTh": "การตั้งค่า",
			"idId": "Pengaturan",
			"esMx": "Configuración",
			"viVi": "Cài đặt",
			"ptPt": "Configurações"
		},
		{
			"textKey": "addOrganization",
			"classify": "btn",
			"zhCn": "添加级织",
			"zhTw": "添加級織",
			"enUs": "Add Graded Weaving",
			"thTh": "เพิ่มเกรดทอ",
			"idId": "Tambahkan tingkat tenun",
			"esMx": "Agregar tejido de grado",
			"viVi": "Thêm lớp dệt",
			"ptPt": "Adicionar um nível de tecelagem"
		},
		{
			"textKey": "energyConsumptionRank",
			"classify": "graph",
			"zhCn": "能耗排名",
			"zhTw": "能耗排名",
			"enUs": "Energy Consumption Ranking",
			"thTh": "การจัดอันดับการใช้พลังงาน",
			"idId": "Peringkat konsumsi energi",
			"esMx": "Clasificación de consumo de energía",
			"viVi": "Xếp hạng tiêu thụ năng lượng",
			"ptPt": "Classificação de consumo de energia"
		},
		{
			"textKey": "deleteCantBeRestored",
			"classify": "tips",
			"zhCn": "删除账号不可恢复，是否继续？",
			"zhTw": "刪除賬號不可恢復,是否繼續?",
			"enUs": "Deleted account cannot be restored. Continue?",
			"thTh": "บัญชีที่ถูกลบไม่สามารถกู้คืนได้จะดำเนินการต่อหรือไม่",
			"idId": "Menghapus akun tidak dapat dipulihkan, apakah akan melanjutkan?",
			"esMx": "La cuenta eliminada no se puede recuperar, ¿continúa?",
			"viVi": "Không thể khôi phục tài khoản đã xóa, nó có tiếp tục không?",
			"ptPt": "A exclusão da conta não é recuperável, continua?"
		},
		{
			"textKey": "modelName",
			"classify": "label",
			"zhCn": "模型名称",
			"zhTw": "模型名稱",
			"enUs": "Model Name",
			"thTh": "ชื่อรุ่น",
			"idId": "Nama Model",
			"esMx": "Nombre del modelo",
			"viVi": "Tên mô hình",
			"ptPt": "Nome do modelo"
		},
		{
			"textKey": "orgDetail",
			"classify": "Title",
			"zhCn": "组织详情",
			"zhTw": "組織詳情",
			"enUs": "Organization Details",
			"thTh": "รายละเอียดองค์กร",
			"idId": "Rincian Organisasi",
			"esMx": "Detalles de la organización",
			"viVi": "Chi tiết tổ chức",
			"ptPt": "Detalhes da organização"
		},
		{
			"textKey": "deviceId",
			"classify": "table",
			"zhCn": "设备ID",
			"zhTw": "設備ID",
			"enUs": "Device ID",
			"thTh": "ID อุปกรณ์",
			"idId": "ID perangkat",
			"esMx": "ID de dispositivo",
			"viVi": "ID thiết bị",
			"ptPt": "ID do dispositivo"
		},
		{
			"textKey": "plzInputTruePhoneNumber",
			"classify": "tips",
			"zhCn": "请输入正确电话号码",
			"zhTw": "請輸入正確電話號碼",
			"enUs": "Please enter the correct phone number",
			"thTh": "โปรดป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
			"idId": "Masukkan nomor telepon yang benar",
			"esMx": "Introduzca el número de teléfono correcto",
			"viVi": "Vui lòng nhập số điện thoại chính xác",
			"ptPt": "Por favor, insira o número de telefone correto"
		},
		{
			"textKey": "userinfoInputCurrentPass",
			"classify": "tips",
			"zhCn": "请输入当前密码",
			"zhTw": "請輸入當前密碼",
			"enUs": "Please enter the current password",
			"thTh": "โปรดป้อนรหัสผ่านปัจจุบัน",
			"idId": "Masukkan kata sandi saat ini",
			"esMx": "Ingrese la contraseña actual",
			"viVi": "Vui lòng nhập mật khẩu hiện tại",
			"ptPt": "Por favor, insira a senha atual"
		},
		{
			"textKey": "level",
			"classify": "Text",
			"zhCn": "级",
			"zhTw": "級",
			"enUs": "Level",
			"thTh": "ระดับ",
			"idId": "Tingkat",
			"esMx": "Nivel",
			"viVi": "Cấp",
			"ptPt": "Nível"
		},
		{
			"textKey": "plzInput6to13Number",
			"classify": "tips",
			"zhCn": "请输入6-13位数字",
			"zhTw": "請輸入6-13位數字",
			"enUs": "Please enter 6-13 digits",
			"thTh": "กรุณากรอกตัวเลข6-13หลัก",
			"idId": "Masukkan 6-13 digit",
			"esMx": "Ingrese 6-13 dígitos",
			"viVi": "Vui lòng nhập 6-13 chữ số",
			"ptPt": "Por favor, insira 6-13 dígitos"
		},
		{
			"textKey": "timeoutMustBiggerThen1",
			"classify": "tips",
			"zhCn": "时间不能小于1",
			"zhTw": "時間不能小於1",
			"enUs": "Time cannot be less than 1",
			"thTh": "เวลาต้องไม่น้อยกว่า1",
			"idId": "Waktu tidak boleh kurang dari 1",
			"esMx": "El tiempo no puede ser inferior a 1",
			"viVi": "Thời gian không được ít hơn 1",
			"ptPt": "O tempo não pode ser inferior a 1"
		},
		{
			"textKey": "limit0Int",
			"classify": "tips",
			"zhCn": "仅支持输入0及正整数",
			"zhTw": "僅支持輸入0及正整數",
			"enUs": "only supports input 0 and positive integer",
			"thTh": "รองรับอินพุต0และจำนวนเต็มบวกเท่านั้น",
			"idId": "Hanya mendukung input 0 dan bilangan bulat positif",
			"esMx": "Solo admite entrada 0 y enteros positivos",
			"viVi": "Chỉ hỗ trợ đầu vào 0 và số nguyên dương",
			"ptPt": "Suporta apenas entrada 0 e inteiros positivos"
		},
		{
			"textKey": "plzInputValidateEmail",
			"classify": "tips",
			"zhCn": "请输入正确邮箱地址",
			"zhTw": "請輸入正確郵箱地址",
			"enUs": "Please enter the correct email address",
			"thTh": "โปรดป้อนที่อยู่อีเมลที่ถูกต้อง",
			"idId": "Silakan masukkan alamat email yang benar",
			"esMx": "Ingrese la dirección de correo electrónico correcta",
			"viVi": "Vui lòng nhập địa chỉ email chính xác",
			"ptPt": "Insira o endereço de e-mail correto"
		},
		{
			"textKey": "validateUserCode",
			"classify": "tips",
			"zhCn": "请输入数字及字母组合",
			"zhTw": "請輸入數字及字母組合",
			"enUs": "Please enter a combination of numbers and letters",
			"thTh": "กรุณาใส่ตัวเลขและตัวอักษรผสมกัน",
			"idId": "Masukkan angka dan kombinasi huruf",
			"esMx": "Introduzca la combinación de números y letras",
			"viVi": "Vui lòng nhập số và kết hợp chữ cái",
			"ptPt": "Por favor, insira uma combinação de números e letras"
		},
		{
			"textKey": "itemText",
			"classify": "Text",
			"zhCn": "条",
			"zhTw": "條",
			"enUs": "Article",
			"thTh": "แถบ",
			"idId": "Strip",
			"esMx": "Artículo",
			"viVi": "Sọc",
			"ptPt": "Artigo"
		},
		{
			"textKey": "basicItemText",
			"classify": "Text",
			"zhCn": "条",
			"zhTw": "條",
			"enUs": "",
			"thTh": "",
			"idId": "",
			"esMx": "",
			"viVi": "Sọc",
			"ptPt": "Artigo"
		},
		{
			"textKey": "basicTxIncludeSub",
			"classify": "Text",
			"zhCn": "包含子节点",
			"zhTw": "",
			"enUs": "Include Subnodes",
			"thTh": "รวมโหนดย่อย",
			"idId": "Sertakan Subnode",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxTotal",
			"classify": "Text",
			"zhCn": "共",
			"zhTw": "",
			"enUs": "Total",
			"thTh": "ทั้งหมด",
			"idId": "Total",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxPage",
			"classify": "Text",
			"zhCn": "页",
			"zhTw": "",
			"enUs": "page",
			"thTh": "หน้า",
			"idId": "halaman",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxGoTo",
			"classify": "Text",
			"zhCn": "前往",
			"zhTw": "",
			"enUs": "Go to ",
			"thTh": "ไปที่",
			"idId": "Pergi ke ",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxEmp",
			"classify": "Text",
			"zhCn": "能源管理平台",
			"zhTw": "",
			"enUs": "Energy Management Platform",
			"thTh": "แพลตฟอร์มการจัดการพลังงาน",
			"idId": "Sistem Manajemen Energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxNoData",
			"classify": "Text",
			"zhCn": "无数据",
			"zhTw": "",
			"enUs": "No data available",
			"thTh": "ไม่มีข้อมูล",
			"idId": "Tidak ada data yang tersedia",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxPlsEn",
			"classify": "Text",
			"zhCn": "请输入{Title}",
			"zhTw": "",
			"enUs": "Please enter {Title}",
			"thTh": "กรุณากรอก {Title}",
			"idId": "Silakan masukkan {Title}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxPlsEnCorrect",
			"classify": "Text",
			"zhCn": "请输入正确的{Title}",
			"zhTw": "",
			"enUs": "Please enter the correct {Title}",
			"thTh": "กรุณากรอก {Title} ที่ถูกต้อง",
			"idId": "Silakan masukkan {Title} yang benar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxPlsSelect",
			"classify": "Text",
			"zhCn": "请选择{Title}",
			"zhTw": "",
			"enUs": "Please select {Title}",
			"thTh": "กรุณาเลือก {Title}",
			"idId": "Silakan pilih {Title}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTosLoading",
			"classify": "Toast",
			"zhCn": "正在加载…请稍候。",
			"zhTw": "",
			"enUs": "Loading… Please wait.",
			"thTh": "กำลังโหลด… กรุณารอสักครู่",
			"idId": "Memuat... Mohon tunggu.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTosErrorTry",
			"classify": "Toast",
			"zhCn": "发生错误。请重试。",
			"zhTw": "",
			"enUs": "An error occurred. Please try again.",
			"thTh": "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
			"idId": "Terjadi kesalahan. Silakan coba lagi.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTxPageNotExist",
			"classify": "Text",
			"zhCn": "抱歉，您查找的页面不存在。",
			"zhTw": "",
			"enUs": "Sorry, the page you are looking for does not exist.",
			"thTh": "ขออภัย ไม่พบหน้าที่คุณกำลังค้นหา",
			"idId": "Maaf, halaman yang Anda cari tidak ada.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicBtBackHome",
			"classify": "Button",
			"zhCn": "返回首页",
			"zhTw": "",
			"enUs": "Back to Home",
			"thTh": "กลับไปที่หน้าแรก",
			"idId": "Kembali ke Beranda",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicBtCancel",
			"classify": "Button",
			"zhCn": "取消",
			"zhTw": "",
			"enUs": "Cancel",
			"thTh": "ยกเลิก",
			"idId": "Batal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicBtExport",
			"classify": "Button",
			"zhCn": "导出",
			"zhTw": "",
			"enUs": "Export",
			"thTh": "ส่งออก",
			"idId": "Ekspor",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicBtSearch",
			"classify": "Button",
			"zhCn": "搜索",
			"zhTw": "",
			"enUs": "Search",
			"thTh": "ค้นหา",
			"idId": "Cari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicBtDelete",
			"classify": "Button",
			"zhCn": "删除",
			"zhTw": "",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicBtEdit",
			"classify": "Button",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Mengedit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionPv",
			"classify": "Text",
			"zhCn": "光伏",
			"zhTw": "",
			"enUs": "Photovoltaic",
			"thTh": "พลังงานแสงอาทิตย์",
			"idId": "Fotovoltaik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionPvStation",
			"classify": "Text",
			"zhCn": "PV电站",
			"zhTw": "",
			"enUs": "PV Power Station",
			"thTh": "สถานีไฟฟ้าพลังงานแสงอาทิตย์",
			"idId": "Pembangkit Listrik Tenaga PV",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionInverterNo",
			"classify": "Text",
			"zhCn": "逆变器数量",
			"zhTw": "",
			"enUs": "Inverter Number",
			"thTh": "จำนวนอินเวอร์เตอร์",
			"idId": "Nomor Inverter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionCommissDate",
			"classify": "Text",
			"zhCn": "投运日期",
			"zhTw": "",
			"enUs": "Commissioning Date",
			"thTh": "วันที่เริ่มดำเนินการ",
			"idId": "Tanggal Komisioning",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGridConType",
			"classify": "Text",
			"zhCn": "并网类型",
			"zhTw": "",
			"enUs": "Grid Connection Type",
			"thTh": "ประเภทที่เชื่อมต่อกับโครงข่ายไฟฟ้า",
			"idId": "Jenis Koneksi Jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionStationRegion",
			"classify": "Text",
			"zhCn": "站点区域",
			"zhTw": "",
			"enUs": "Site Region",
			"thTh": "เขตพื้นที่สถานี",
			"idId": "Wilayah Situs",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionStationAdd",
			"classify": "Text",
			"zhCn": "站点地址",
			"zhTw": "",
			"enUs": "Site Address",
			"thTh": "ที่อยู่สถานี",
			"idId": "Alamat Situs",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGridFeedin",
			"classify": "Text",
			"zhCn": "上网电量",
			"zhTw": "",
			"enUs": "Grid Feed-In Electricity",
			"thTh": "ปริมาณไฟฟ้าส่งออกสู่โครงข่ายไฟฟ้า",
			"idId": "Listrik Umpan Masuk Jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionPvToEss",
			"classify": "Text",
			"zhCn": "光伏往储能的电量",
			"zhTw": "",
			"enUs": "PV to BESS Electricity",
			"thTh": "ปริมาณไฟฟ้าส่งออกสู่ BESS",
			"idId": "PV ke Listrik BESS",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGenUnitPrice",
			"classify": "Text",
			"zhCn": "发电单价",
			"zhTw": "",
			"enUs": "Generation Unit Price",
			"thTh": "ราคาไฟฟ้าที่ผลิตต่อหน่วย",
			"idId": "Harga Satuan Pembangkitan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionInverter",
			"classify": "Text",
			"zhCn": "逆变器",
			"zhTw": "",
			"enUs": "Inverter",
			"thTh": "อินเวอร์เตอร์",
			"idId": "Inverter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionInstallCap",
			"classify": "Text",
			"zhCn": "装机容量",
			"zhTw": "",
			"enUs": "Installed capacity",
			"thTh": "กำลังการผลิตติดตั้ง",
			"idId": "Kapasitas terpasang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionRatedOpPower",
			"classify": "Text",
			"zhCn": "额定输出功率",
			"zhTw": "",
			"enUs": "Rated Output Power",
			"thTh": "พิกัดกำลังไฟฟ้าเอาต์พุต",
			"idId": "Daya Keluaran Terukur",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionBess",
			"classify": "Text",
			"zhCn": "储能",
			"zhTw": "",
			"enUs": "Battery Energy Storage System",
			"thTh": "ระบบกักเก็บพลังงาน",
			"idId": "Sistem Penyimpanan Energi Baterai",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionBessStation",
			"classify": "Text",
			"zhCn": "储能站点",
			"zhTw": "",
			"enUs": "BESS Station",
			"thTh": "สถานีระบบกักเก็บพลังงาน",
			"idId": "Stasiun BESS",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionBessCab",
			"classify": "Text",
			"zhCn": "储能柜",
			"zhTw": "",
			"enUs": "Energy storage cabinet",
			"thTh": "ตู้กักเก็บพลังงาน",
			"idId": "Kabinet penyimpanan energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionPcs",
			"classify": "Text",
			"zhCn": "PCS",
			"zhTw": "",
			"enUs": "PCS",
			"thTh": "PCS",
			"idId": "PCS",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionBatCluster",
			"classify": "Text",
			"zhCn": "电池簇",
			"zhTw": "",
			"enUs": "Battery cluster",
			"thTh": "คลัสเตอร์แบตเตอรี่",
			"idId": "Gugus baterai",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGrid",
			"classify": "Text",
			"zhCn": "市电",
			"zhTw": "",
			"enUs": "Grid",
			"thTh": "ไฟฟ้าโครงข่าย",
			"idId": "Jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionElectMeter",
			"classify": "Text",
			"zhCn": "电表",
			"zhTw": "",
			"enUs": "Electricity meter",
			"thTh": "มิเตอร์ไฟฟ้า",
			"idId": "Meteran listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionPowerDistrib",
			"classify": "Text",
			"zhCn": "配电",
			"zhTw": "",
			"enUs": "Power Distribution",
			"thTh": "การจ่ายไฟฟ้า",
			"idId": "Distribusi Daya",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionTransformer",
			"classify": "Text",
			"zhCn": "变压器",
			"zhTw": "",
			"enUs": "Transformer",
			"thTh": "หม้อแปลงไฟฟ้า",
			"idId": "Transformator",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionRatedCap",
			"classify": "Text",
			"zhCn": "额定容量",
			"zhTw": "",
			"enUs": "Rated Capacity",
			"thTh": "พิกัดความจุ",
			"idId": "Kapasitas Terukur",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionCapacitorCab",
			"classify": "Text",
			"zhCn": "电容补偿柜",
			"zhTw": "",
			"enUs": "Capacitor compensation cabinet",
			"thTh": "ตู้ชดเชยตัวเก็บประจุ",
			"idId": "Kabinet kompensasi kapasitor",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionIncomingCab",
			"classify": "Text",
			"zhCn": "进线柜",
			"zhTw": "",
			"enUs": "Incoming cabinet",
			"thTh": "ตู้ Incoming",
			"idId": "Kabinet yang masuk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionFeederCab",
			"classify": "Text",
			"zhCn": "馈线柜",
			"zhTw": "",
			"enUs": "Feeder cabinet",
			"thTh": "ตู้ Feeder",
			"idId": "Kabinet pengumpan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionAreaEnergyConsum",
			"classify": "Text",
			"zhCn": "区域能耗",
			"zhTw": "",
			"enUs": "Area Energy Consumption",
			"thTh": "การใช้พลังงานตามพื้นที่",
			"idId": "Konsumsi Energi Area",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionEnv",
			"classify": "Text",
			"zhCn": "环境",
			"zhTw": "",
			"enUs": "Environment",
			"thTh": "สิ่งแวดล้อม",
			"idId": "Lingkungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionEnvMainZone",
			"classify": "Text",
			"zhCn": "环境监控总区域",
			"zhTw": "",
			"enUs": "Environmental Monitoring Main Zone",
			"thTh": "พื้นที่เฝ้าตรวจสอบสิ่งแวดล้อมโดยรวม",
			"idId": "Zona Utama Pemantauan Lingkungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionZoneLayout",
			"classify": "Text",
			"zhCn": "区域平面图",
			"zhTw": "",
			"enUs": "Zone Layout",
			"thTh": "แผนผังพื้นที่",
			"idId": "Tata Letak Zona",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionEnvSubZone",
			"classify": "Text",
			"zhCn": "环境监控分区域",
			"zhTw": "",
			"enUs": "Environmental monitoring sub zone",
			"thTh": "พื้นที่เฝ้าตรวจสอบสิ่งแวดล้อมย่อย",
			"idId": "Sub zona pemantauan lingkungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionEnvGroup",
			"classify": "Text",
			"zhCn": "环境监控分组",
			"zhTw": "",
			"enUs": "Environmental monitoring group",
			"thTh": "กลุ่มตรวจสอบสิ่งแวดล้อม",
			"idId": "Kelompok pemantauan lingkungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionMainZoneCoor",
			"classify": "Text",
			"zhCn": "总区域坐标位置",
			"zhTw": "",
			"enUs": "Main Zone Coordinates",
			"thTh": "พิกัดพื้นที่หลัก",
			"idId": "Koordinat Zona Utama",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionSubZoneCoor",
			"classify": "Text",
			"zhCn": "分区域坐标位置",
			"zhTw": "",
			"enUs": "Sub Zone Coordinates",
			"thTh": "พิกัดพื้นที่ย่อย",
			"idId": "Koordinat Sub Zona",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionEnvMonitor",
			"classify": "Text",
			"zhCn": "环境监测仪表",
			"zhTw": "",
			"enUs": "Environmental monitoring instrument",
			"thTh": "เครื่องมือตรวจวัดสิ่งแวดล้อม",
			"idId": "Instrumen pemantauan lingkungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionBilling",
			"classify": "Text",
			"zhCn": "计费",
			"zhTw": "",
			"enUs": "Billing",
			"thTh": "ค่าใช้จ่าย",
			"idId": "Penagihan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionAccount",
			"classify": "Text",
			"zhCn": "账户",
			"zhTw": "",
			"enUs": "Account",
			"thTh": "บัญชี",
			"idId": "Akun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDimension",
			"classify": "Text",
			"zhCn": "维度",
			"zhTw": "",
			"enUs": "Dimension",
			"thTh": "มิติ",
			"idId": "Dimensi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionShowConsum",
			"classify": "Text",
			"zhCn": "是否在能耗板块显示",
			"zhTw": "",
			"enUs": "Available in Energy Consumption",
			"thTh": "แสดงในแดชบอร์ดการใช้พลังงานหรือไม่",
			"idId": "Tersedia dalam Konsumsi Energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionSearchNode",
			"classify": "Text",
			"zhCn": "使用节点名称搜索",
			"zhTw": "",
			"enUs": "Search by node name",
			"thTh": "ค้นหาด้วยชื่อโหนด",
			"idId": "Cari berdasarkan nama node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionAddNode",
			"classify": "Button",
			"zhCn": "添加节点",
			"zhTw": "",
			"enUs": "Add Node",
			"thTh": "เพิ่มโหนด",
			"idId": "Tambah Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionAddSubNode",
			"classify": "Button",
			"zhCn": "添加子节点",
			"zhTw": "",
			"enUs": "Add Sub-node",
			"thTh": "เพิ่มโหนดย่อย",
			"idId": "Tambah Sub-simpul",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionMoveNode",
			"classify": "Button",
			"zhCn": "移动到另一个节点",
			"zhTw": "",
			"enUs": "Move to Another Node",
			"thTh": "ย้ายไปที่โหนดอื่น",
			"idId": "Pindah ke Node Lain",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDelete",
			"classify": "Button",
			"zhCn": "删除",
			"zhTw": "",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionUpdatedBy",
			"classify": "Text",
			"zhCn": "由{用户名}于{时间}更新",
			"zhTw": "",
			"enUs": "Updated by {用户名} on {时间}",
			"thTh": "อัปเดตโดย {用户名} เมื่อ {时间}",
			"idId": "Diperbarui oleh {用户名} pada {时间}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionEdit",
			"classify": "Button",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionLinkedBy",
			"classify": "Text",
			"zhCn": "由{用户名}于{时间}关联",
			"zhTw": "",
			"enUs": "Linked by {用户名} on {时间}",
			"thTh": "เชื่อมโยงโดย {用户名} เมื่อ {时间}",
			"idId": "Ditautkan oleh {用户名} pada {时间}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionUnlinkDevice",
			"classify": "Button",
			"zhCn": "取消关联设备",
			"zhTw": "",
			"enUs": "Unlink Device",
			"thTh": "ยกเลิกการเชื่อมโยงอุปกรณ์",
			"idId": "Putuskan Tautan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDeviceType",
			"classify": "Button",
			"zhCn": "设备类型",
			"zhTw": "",
			"enUs": "Device Type",
			"thTh": "ประเภทอุปกรณ์",
			"idId": "Jenis Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionInstallLo",
			"classify": "Title",
			"zhCn": "安装位置",
			"zhTw": "",
			"enUs": "Installation Location",
			"thTh": "ตำแหน่งการติดตั้ง",
			"idId": "Lokasi Pemasangan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDesc",
			"classify": "Title",
			"zhCn": "描述",
			"zhTw": "",
			"enUs": "Description",
			"thTh": "คำอธิบาย",
			"idId": "Deskripsi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionNoDevice",
			"classify": "Title",
			"zhCn": "无关联设备",
			"zhTw": "",
			"enUs": "No Linked Device",
			"thTh": "ไม่มีอุปกรณ์ที่เชื่อมโยง",
			"idId": "Tidak Ada Perangkat yang Ditautkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionUnlinkBy",
			"classify": "Text",
			"zhCn": "由{用户名}于{时间}取消关联",
			"zhTw": "",
			"enUs": "Unlinked by {用户名} on {时间}",
			"thTh": "ยกเลิกการเชื่อมโยงโดย {用户名} เมื่อ {时间}",
			"idId": "Tidak ditautkan oleh {用户名} pada {时间}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionLinkDevice",
			"classify": "Button",
			"zhCn": "关联设备",
			"zhTw": "",
			"enUs": "Link Device",
			"thTh": "อุปกรณ์เชื่อมโยง",
			"idId": "Perangkat Tautan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionPvStation",
			"classify": "Title",
			"zhCn": "光伏电站",
			"zhTw": "",
			"enUs": "PV Station",
			"thTh": "สถานีไฟฟ้าแสงอาทิตย์",
			"idId": "Stasiun PV",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionInverter",
			"classify": "Title",
			"zhCn": "逆变器",
			"zhTw": "",
			"enUs": "Inverter",
			"thTh": "อินเวอร์เตอร์",
			"idId": "Inverter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionCapacityKwp",
			"classify": "Title",
			"zhCn": "容量（kWp）",
			"zhTw": "",
			"enUs": "Capacity (kWp)",
			"thTh": "ความจุ (kWp)",
			"idId": "Kapasitas (kWp)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionInverterNo",
			"classify": "Title",
			"zhCn": "逆变器数量",
			"zhTw": "",
			"enUs": "Inverter Count",
			"thTh": "จำนวนอินเวอร์เตอร์",
			"idId": "Jumlah Inverter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGridConType",
			"classify": "Title",
			"zhCn": "并网类型",
			"zhTw": "",
			"enUs": "Grid-connected Type",
			"thTh": "ประเภทที่เชื่อมต่อกับโครงข่ายไฟฟ้า",
			"idId": "Jenis yang terhubung ke jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionExAllToGrid",
			"classify": "Text",
			"zhCn": "全额上网",
			"zhTw": "",
			"enUs": "Export All Electricity to Grid",
			"thTh": "ส่งออกไฟฟ้าทั้งหมดสู่โครงข่ายไฟฟ้า",
			"idId": "Ekspor Semua Listrik ke Jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionExSurplusToGrid",
			"classify": "Text",
			"zhCn": "自发自用余电上网",
			"zhTw": "",
			"enUs": "Export Surplus Electricity to Grid",
			"thTh": "ส่งออกไฟฟ้าส่วนเกินสู่โครงข่ายไฟฟ้า",
			"idId": "Ekspor Surplus Listrik ke Jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionOffgrid",
			"classify": "Text",
			"zhCn": "离网",
			"zhTw": "",
			"enUs": "Off-Grid",
			"thTh": "ไม่เชื่อมต่อกับโครงข่ายไฟฟ้า",
			"idId": "Di luar jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionStationRegion",
			"classify": "Title",
			"zhCn": "站点区域",
			"zhTw": "",
			"enUs": "Site Region",
			"thTh": "เขตพื้นที่",
			"idId": "Wilayah Situs",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionStationAdd",
			"classify": "Title",
			"zhCn": "站点地址",
			"zhTw": "",
			"enUs": "Site Address",
			"thTh": "ที่อยู่สถานี",
			"idId": "Alamat Situs",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionOpDate",
			"classify": "Title",
			"zhCn": "运营日期",
			"zhTw": "",
			"enUs": "Operational Date",
			"thTh": "วันที่ดำเนินการ",
			"idId": "Tanggal Operasional",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGenUnitPrice",
			"classify": "Title",
			"zhCn": "发电单价（{货币}/kWh）",
			"zhTw": "",
			"enUs": "Generation Unit Price（{货币}/kWh）",
			"thTh": "ราคาไฟฟ้าที่ผลิตต่อหน่วย ({货币}/kWh)",
			"idId": "Harga Satuan Pembangkitan（{货币}/kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGridFeedin",
			"classify": "Title",
			"zhCn": "上网电量",
			"zhTw": "",
			"enUs": "Grid Feed-In Electricity",
			"thTh": "ปริมาณไฟฟ้าส่งออกสู่โครงข่ายไฟฟ้า",
			"idId": "Listrik Feed-In Grid",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionPvToEss",
			"classify": "Title",
			"zhCn": "光伏往储能的电量",
			"zhTw": "",
			"enUs": "PV to BESS Electricity",
			"thTh": "ปริมาณไฟฟ้าส่งออกสู่ BESS",
			"idId": "PV ke Listrik BESS",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionRatedOpPower",
			"classify": "Title",
			"zhCn": "额定输出功率",
			"zhTw": "",
			"enUs": "Rated Output Power",
			"thTh": "พิกัดกำลังไฟฟ้าเอาต์พุต",
			"idId": "Nilai Daya Keluaran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionUnlinkDevice",
			"classify": "Title",
			"zhCn": "取消关联设备",
			"zhTw": "",
			"enUs": "Unlink Device",
			"thTh": "ยกเลิกการเชื่อมโยงอุปกรณ์",
			"idId": "Putuskan Tautan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionUnlinkDeviceCon",
			"classify": "Text",
			"zhCn": "取消关联设备后，此节点将不再从其接收数据。您确定要继续吗？",
			"zhTw": "",
			"enUs": "After unlinking the device, this node will no longer receive data from it. Are you sure you want to proceed?",
			"thTh": "หลังจากยกเลิกการเชื่อมโยงอุปกรณ์แล้ว โหนดนี้จะไม่รับข้อมูลจากอุปกรณ์อีกต่อไป คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ",
			"idId": "Setelah memutuskan tautan perangkat, node ini tidak akan lagi menerima data darinya. Apakah Anda yakin ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionLinkDevice",
			"classify": "Title",
			"zhCn": "关联设备",
			"zhTw": "",
			"enUs": "Link Device",
			"thTh": "เชื่อมโยงอุปกรณ์",
			"idId": "Tautkan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionAllGw",
			"classify": "Text",
			"zhCn": "所有网关",
			"zhTw": "",
			"enUs": "All Gateways",
			"thTh": "เกตเวย์ทั้งหมด",
			"idId": "Semua Gerbang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionSearchDeviceName",
			"classify": "Text",
			"zhCn": "搜索设备名称或设备序列号",
			"zhTw": "",
			"enUs": "Search Device Name or Device SN",
			"thTh": "ค้นหาชื่ออุปกรณ์หรือหมายเลขอุปกรณ์",
			"idId": "Cari Nama Perangkat atau SN Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGwGroup",
			"classify": "Title",
			"zhCn": "网关组",
			"zhTw": "",
			"enUs": "Gateway Group",
			"thTh": "กลุ่มเกตเวย์",
			"idId": "Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionGw",
			"classify": "Title",
			"zhCn": "网关",
			"zhTw": "",
			"enUs": "Gateway",
			"thTh": "เกตเวย์",
			"idId": "Gerbang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDeviceName",
			"classify": "Title",
			"zhCn": "设备名称",
			"zhTw": "",
			"enUs": "Device Name",
			"thTh": "ชื่ออุปกรณ์",
			"idId": "Nama Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDeviceSn",
			"classify": "Title",
			"zhCn": "设备序列号",
			"zhTw": "",
			"enUs": "Device SN",
			"thTh": "หมายเลขอุปกรณ์",
			"idId": "SN Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionModel",
			"classify": "Title",
			"zhCn": "型号",
			"zhTw": "",
			"enUs": "Model",
			"thTh": "รุ่น",
			"idId": "Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionStatus",
			"classify": "Title",
			"zhCn": "状态",
			"zhTw": "",
			"enUs": "Status",
			"thTh": "สถานะ",
			"idId": "Status",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionAddNode",
			"classify": "Title",
			"zhCn": "添加节点",
			"zhTw": "",
			"enUs": "Add Node",
			"thTh": "เพิ่มโหนด",
			"idId": "Tambah Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionNodeName",
			"classify": "Title",
			"zhCn": "节点名称",
			"zhTw": "",
			"enUs": "Node Name",
			"thTh": "ชื่อโหนด",
			"idId": "Nama Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionNodeType",
			"classify": "Title",
			"zhCn": "节点类型",
			"zhTw": "",
			"enUs": "Node Type",
			"thTh": "ประเภทโหนด",
			"idId": "Jenis Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionSequence",
			"classify": "Title",
			"zhCn": "序列",
			"zhTw": "",
			"enUs": "Sequence",
			"thTh": "ลำดับ",
			"idId": "Urutan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionMoveNode",
			"classify": "Title",
			"zhCn": "移动到另一个节点",
			"zhTw": "",
			"enUs": "Move to Another Node",
			"thTh": "ย้ายไปยังโหนดอื่น",
			"idId": "Pindah ke Node Lain",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionNode",
			"classify": "Title",
			"zhCn": "节点",
			"zhTw": "",
			"enUs": "Node",
			"thTh": "โหนด",
			"idId": "Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionSourcePath",
			"classify": "Title",
			"zhCn": "源路径",
			"zhTw": "",
			"enUs": "Source Path",
			"thTh": "ตำแหน่งเดิม",
			"idId": "Jalur Sumber",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionTargetPath",
			"classify": "Title",
			"zhCn": "目标路径",
			"zhTw": "",
			"enUs": "Target Path",
			"thTh": "ตำแหน่งใหม่",
			"idId": "Jalur Target",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDelNode",
			"classify": "Title",
			"zhCn": "删除节点",
			"zhTw": "",
			"enUs": "Delete Node",
			"thTh": "ลบโหนด",
			"idId": "Hapus Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionNodeC",
			"classify": "Text",
			"zhCn": "节点：",
			"zhTw": "",
			"enUs": "Node:",
			"thTh": "โหนด:",
			"idId": "Node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionDelNodeCon",
			"classify": "Text",
			"zhCn": "节点将被删除，无法恢复。是否要继续？",
			"zhTw": "",
			"enUs": "The Node will be deleted and cannot be restored .Do you want to continue?",
			"thTh": "โหนดจะถูกลบและไม่สามารถกู้คืนได้ คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Node akan dihapus dan tidak dapat dipulihkan Apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionRatedCapKva",
			"classify": "Title",
			"zhCn": "额定容量 (kVA)",
			"zhTw": "",
			"enUs": "Rated Capacity (kVA)",
			"thTh": "พิกัดความจุ (kVA)",
			"idId": "Kapasitas Terukur (kVA)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionZoneLayput",
			"classify": "Title",
			"zhCn": "区域平面图",
			"zhTw": "",
			"enUs": "Zone Layout",
			"thTh": "แผนผังพื้นที่",
			"idId": "Tata Letak Zona",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionUpload",
			"classify": "Button",
			"zhCn": "上传",
			"zhTw": "",
			"enUs": "Upload",
			"thTh": "อัปโหลด",
			"idId": "Unggah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionImgOverSize",
			"classify": "Toast",
			"zhCn": "图像超过 5MB 大小限制。请上传较小的文件。",
			"zhTw": "",
			"enUs": "The image exceeds the 5MB size limit. Please upload a smaller file.",
			"thTh": "รูปภาพมีขนาดเกินขีดจำกัด 5MB โปรดอัปโหลดไฟล์ที่มีขนาดลง",
			"idId": "Gambar melebihi batas ukuran 5MB. Silakan unggah file yang lebih kecil.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionImgWrongFile",
			"classify": "Toast",
			"zhCn": "图像必须是 png 或 jpg。",
			"zhTw": "",
			"enUs": "The image must be png or jpg.",
			"thTh": "รูปภาพจะต้องเป็น png หรือ jpg",
			"idId": "Gambar harus dalam format png atau jpg.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionMainZoneCoor",
			"classify": "Title",
			"zhCn": "主区域坐标",
			"zhTw": "",
			"enUs": "Main Zone Coordinates",
			"thTh": "พิกัดโซนหลัก",
			"idId": "Koordinat Zona Utama",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionSubZoneCoor",
			"classify": "Title",
			"zhCn": "子区域坐标",
			"zhTw": "",
			"enUs": "Sub Zone Coordinates ",
			"thTh": "พิกัดโซนย่อย",
			"idId": "Koordinat Sub Zona ",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAddNode",
			"classify": "Text",
			"zhCn": "添加节点",
			"zhTw": "",
			"enUs": "Add node",
			"thTh": "เพิ่มโหนด",
			"idId": "Tambahkan node",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissMoveNode",
			"classify": "Text",
			"zhCn": "移动节点",
			"zhTw": "",
			"enUs": "Move node",
			"thTh": "ย้ายโหนด",
			"idId": "Pindahkan simpul",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDelNode",
			"classify": "Text",
			"zhCn": "删除节点",
			"zhTw": "",
			"enUs": "Delete node",
			"thTh": "ลบโหนด",
			"idId": "Hapus simpul",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEditNode",
			"classify": "Text",
			"zhCn": "编辑节点",
			"zhTw": "",
			"enUs": "Edit node",
			"thTh": "แก้ไขโหนด",
			"idId": "Edit simpul",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissLinkDevice",
			"classify": "Text",
			"zhCn": "关联设备",
			"zhTw": "",
			"enUs": "Link device",
			"thTh": "เชื่อมโนงอุปกรณ์",
			"idId": "Tautkan perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseSearch",
			"classify": "Button",
			"zhCn": "搜索",
			"zhTw": "",
			"enUs": "Search",
			"thTh": "ค้นหา",
			"idId": "Cari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseAddEtnp",
			"classify": "Button",
			"zhCn": "添加企业",
			"zhTw": "",
			"enUs": "Add Enterprise",
			"thTh": "เพิ่มองค์กร",
			"idId": "Tambahkan Perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseId",
			"classify": "Title",
			"zhCn": "编码",
			"zhTw": "",
			"enUs": "ID",
			"thTh": "รหัส",
			"idId": "ID",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseStatus",
			"classify": "Title",
			"zhCn": "状态",
			"zhTw": "",
			"enUs": "Status",
			"thTh": "สถานะ",
			"idId": "Status",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseActive",
			"classify": "Title",
			"zhCn": "有效",
			"zhTw": "",
			"enUs": "Active",
			"thTh": "ใช้งานได้",
			"idId": "Aktif",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseDisabled",
			"classify": "Title",
			"zhCn": "已禁用",
			"zhTw": "",
			"enUs": "Disabled",
			"thTh": "ปิดใช้งาน",
			"idId": "Dinonaktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseCreator",
			"classify": "Title",
			"zhCn": "创建者",
			"zhTw": "",
			"enUs": "Creator",
			"thTh": "ผู้สร้าง",
			"idId": "Pembuat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseCreateTime",
			"classify": "Title",
			"zhCn": "创建时间",
			"zhTw": "",
			"enUs": "Created Time",
			"thTh": "เวลาที่สร้าง",
			"idId": "Waktu Dibuat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseUpdateBy",
			"classify": "Title",
			"zhCn": "更新者",
			"zhTw": "",
			"enUs": "Updated By",
			"thTh": "อัปเดตโดย",
			"idId": "Diperbarui Oleh",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseUpdateTime",
			"classify": "Title",
			"zhCn": "更新时间",
			"zhTw": "",
			"enUs": "Updated Time",
			"thTh": "เวลาที่อัปเดต",
			"idId": "Waktu Diperbarui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseAction",
			"classify": "Title",
			"zhCn": "操作",
			"zhTw": "",
			"enUs": "Action",
			"thTh": "การดำเนินการ",
			"idId": "Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseEdit",
			"classify": "Button",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterprisePermiss",
			"classify": "Button",
			"zhCn": "权限",
			"zhTw": "",
			"enUs": "Permission",
			"thTh": "สิทธิ์",
			"idId": "Izin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseResetPass",
			"classify": "Button",
			"zhCn": "重置密码",
			"zhTw": "",
			"enUs": "Reset Password",
			"thTh": "รีเซ็ตรหัสผ่าน",
			"idId": "Atur Ulang Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseDisable",
			"classify": "Button",
			"zhCn": "禁用",
			"zhTw": "",
			"enUs": "Disable",
			"thTh": "ปิดใช้งาน",
			"idId": "Nonaktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseEnable",
			"classify": "Button",
			"zhCn": "启用",
			"zhTw": "",
			"enUs": "Enable",
			"thTh": "เปิดใช้งาน",
			"idId": "Aktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseAddEtnp",
			"classify": "Title",
			"zhCn": "添加企业",
			"zhTw": "",
			"enUs": "Add Enterprise",
			"thTh": "เพิ่มองค์กร",
			"idId": "Tambah Perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseEntpName",
			"classify": "Title",
			"zhCn": "企业名称",
			"zhTw": "",
			"enUs": "Enterprise Name",
			"thTh": "ชื่อองค์กร",
			"idId": "Nama Perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseExpriDate",
			"classify": "Title",
			"zhCn": "过期日期",
			"zhTw": "",
			"enUs": "Expiration Date",
			"thTh": "วันหมดอายุ",
			"idId": "Tanggal Kedaluwarsa",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseCustomDomin",
			"classify": "Title",
			"zhCn": "自定义域",
			"zhTw": "",
			"enUs": "Custom Domain",
			"thTh": "โดเมนกำหนดเอง",
			"idId": "Domain Khusus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseCurrenct",
			"classify": "Title",
			"zhCn": "货币代码",
			"zhTw": "",
			"enUs": "Currency Code",
			"thTh": "รหัสสกุลเงิน",
			"idId": "Kode Mata Uang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseAcc",
			"classify": "Title",
			"zhCn": "登录账号",
			"zhTw": "",
			"enUs": "Login  Account",
			"thTh": "บัญชีเข้าสู่ระบบ",
			"idId": "Akun Masuk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterprisePass",
			"classify": "Title",
			"zhCn": "登录密码",
			"zhTw": "",
			"enUs": "Login Password",
			"thTh": "รหัสผ่านเข้าสู่ระบบ",
			"idId": "Kata Sandi Masuk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseContact",
			"classify": "Title",
			"zhCn": "联系人",
			"zhTw": "",
			"enUs": "Contact Person",
			"thTh": "ผู้ติดต่อ",
			"idId": "Narahubung",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseContactNo",
			"classify": "Title",
			"zhCn": "联系电话",
			"zhTw": "",
			"enUs": "Contact Number",
			"thTh": "หมายเลขติดต่อ",
			"idId": "Nomor Kontak",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseEmail",
			"classify": "Title",
			"zhCn": "联系邮箱",
			"zhTw": "",
			"enUs": "Contact Email",
			"thTh": "อีเมลติดต่อ",
			"idId": "Email Kontak",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseEditEntp",
			"classify": "Title",
			"zhCn": "编辑企业",
			"zhTw": "",
			"enUs": "Edit Enterprise",
			"thTh": "แก้ไของค์กร",
			"idId": "Edit Perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseResetPass",
			"classify": "Title",
			"zhCn": "重置密码",
			"zhTw": "",
			"enUs": "Reset Password",
			"thTh": "รีเซ็ตรหัสผ่าน",
			"idId": "Atur Ulang Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseEntpc",
			"classify": "Text",
			"zhCn": "企业：",
			"zhTw": "",
			"enUs": "Enterprise:",
			"thTh": "องค์กร:",
			"idId": "Perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "enterpriseNewPass",
			"classify": "Title",
			"zhCn": "新密码",
			"zhTw": "",
			"enUs": "New Password",
			"thTh": "รหัสผ่านใหม่",
			"idId": "Kata Sandi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAddEntp",
			"classify": "Text",
			"zhCn": "添加企业",
			"zhTw": "",
			"enUs": "Add enterprise",
			"thTh": "เพิ่มองค์กร",
			"idId": "Tambah perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEditEntp",
			"classify": "Text",
			"zhCn": "编辑企业",
			"zhTw": "",
			"enUs": "Edit enterprise",
			"thTh": "แก้ไของค์กร",
			"idId": "Edit perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissResetAdminPass",
			"classify": "Text",
			"zhCn": "重置超管密码",
			"zhTw": "",
			"enUs": "Reset Super Administrator password",
			"thTh": "รีเซ็ตรหัสผ่านผู้ดูแลระบบขั้นสูง",
			"idId": "Mengatur ulang kata sandi Administrator Super",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDisEntp",
			"classify": "Text",
			"zhCn": "禁用企业",
			"zhTw": "",
			"enUs": "Disable enterprise",
			"thTh": "ปิดใช้งานองค์กร",
			"idId": "Menonaktifkan perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissPermissSet",
			"classify": "Text",
			"zhCn": "权限设置",
			"zhTw": "",
			"enUs": "Permission settings",
			"thTh": "การตั้งค่าสิทธิ์",
			"idId": "Pengaturan izin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceSearchSn",
			"classify": "Text",
			"zhCn": "搜索SN/名称/型号/资产ID",
			"zhTw": "",
			"enUs": "Search SN /Name/Model/Asset ID",
			"thTh": "ค้นหา SN /ชื่อ/รุ่น/ID สินทรัพย์",
			"idId": "Cari SN / Nama / Model / ID Aset",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAddGw",
			"classify": "Button",
			"zhCn": "添加网关",
			"zhTw": "",
			"enUs": "Add Gateway",
			"thTh": "เพิ่มเกตเวย์",
			"idId": "Tambahkan Gerbang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAddGwGroup",
			"classify": "Button",
			"zhCn": "添加网关组",
			"zhTw": "",
			"enUs": "Add Gateway Group",
			"thTh": "เพิ่มกลุ่มเกตเวย์",
			"idId": "Tambahkan Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAddDevice",
			"classify": "Button",
			"zhCn": "添加设备",
			"zhTw": "",
			"enUs": "Add Device",
			"thTh": "เพิ่มอุปกรณ์",
			"idId": "Tambah Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceMoveNode",
			"classify": "Button",
			"zhCn": "移动到另一个节点",
			"zhTw": "",
			"enUs": "Move to Another Node",
			"thTh": "ย้ายไปยังโหนดอื่น",
			"idId": "Pindah ke Node Lain",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDelete",
			"classify": "Button",
			"zhCn": "删除",
			"zhTw": "",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisable",
			"classify": "Button",
			"zhCn": "禁用",
			"zhTw": "",
			"enUs": "Disable",
			"thTh": "ปิดใช้งาน",
			"idId": "Nonaktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEdit",
			"classify": "Button",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceGwId",
			"classify": "Title",
			"zhCn": "网关ID",
			"zhTw": "",
			"enUs": "Gateway ID",
			"thTh": "ID เกตเวย์",
			"idId": "ID Gerbang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceOffline",
			"classify": "Text",
			"zhCn": "离线",
			"zhTw": "",
			"enUs": "Offline",
			"thTh": "ออฟไลน์",
			"idId": "Offline",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceUnknown",
			"classify": "Text",
			"zhCn": "未知",
			"zhTw": "",
			"enUs": "Unknown",
			"thTh": "ไม่ทราบ",
			"idId": "Tidak diketahui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisabled",
			"classify": "Text",
			"zhCn": "已禁用",
			"zhTw": "",
			"enUs": "Disabled",
			"thTh": "ปิดใช้งาน",
			"idId": "Dinonaktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceOnline",
			"classify": "Text",
			"zhCn": "在线",
			"zhTw": "",
			"enUs": "Online",
			"thTh": "ออนไลน์",
			"idId": "Online",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceManufac",
			"classify": "Title",
			"zhCn": "制造商",
			"zhTw": "",
			"enUs": "Manufacturer",
			"thTh": "ผู้ผลิต",
			"idId": "Pabrikan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "devicePassword",
			"classify": "Title",
			"zhCn": "密码",
			"zhTw": "",
			"enUs": "Password",
			"thTh": "รหัสผ่าน",
			"idId": "Kata sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceCommuTineout",
			"classify": "Title",
			"zhCn": "通信超时警报（分钟）",
			"zhTw": "",
			"enUs": "Communication Timeout Alarm (min)",
			"thTh": "แจ้งเตือนการหมดเวลาการสื่อสาร (นาที)",
			"idId": "Alarm Batas Waktu Komunikasi (menit)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceCommuProtocal",
			"classify": "Title",
			"zhCn": "通信协议",
			"zhTw": "",
			"enUs": "Communication Protocol",
			"thTh": "โปรโตคอลการสื่อสาร",
			"idId": "Protokol Komunikasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceLastCommuTime",
			"classify": "Title",
			"zhCn": "最后通信时间",
			"zhTw": "",
			"enUs": "Last Communication Time",
			"thTh": "เวลาการสื่อสารครั้งล่าสุด",
			"idId": "Waktu Komunikasi Terakhir",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAddGwGroup",
			"classify": "Title",
			"zhCn": "添加网关组",
			"zhTw": "",
			"enUs": "Add Gateway Group",
			"thTh": "เพิ่มกลุ่มเกตเวย์",
			"idId": "Tambahkan Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAddGw",
			"classify": "Title",
			"zhCn": "添加网关",
			"zhTw": "",
			"enUs": "Add Gateway",
			"thTh": "เพิ่มเกตเวย์",
			"idId": "Tambahkan Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceGwGroupName",
			"classify": "Title",
			"zhCn": "网关组名称",
			"zhTw": "",
			"enUs": "Gateway Group Name",
			"thTh": "ชื่อกลุ่มเกตเวย์",
			"idId": "Nama Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceGwName",
			"classify": "Title",
			"zhCn": "网关名称",
			"zhTw": "",
			"enUs": "Gateway Name",
			"thTh": "ชื่อเกตเวย์",
			"idId": "Nama Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceOrgCodeExist",
			"classify": "Title",
			"zhCn": "资产编码已存在。",
			"zhTw": "",
			"enUs": "Asset ID already exists.",
			"thTh": "ID สินทรพย์ซ้ำกับที่มีอยู่แล้ว",
			"idId": "ID Aset sudah ada.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceCommuSet",
			"classify": "Title",
			"zhCn": "通信设置",
			"zhTw": "",
			"enUs": "Communication Settings",
			"thTh": "การตั้งค่าการสื่อสาร",
			"idId": "Pengaturan Komunikasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceCommuAdd",
			"classify": "Title",
			"zhCn": "通信地址",
			"zhTw": "",
			"enUs": "Communication Address",
			"thTh": "ที่อยู่การสื่อสาร",
			"idId": "Alamat Komunikasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "devicePort",
			"classify": "Title",
			"zhCn": "端口",
			"zhTw": "",
			"enUs": "Port",
			"thTh": "พอร์ต",
			"idId": "Pelabuhan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAccount",
			"classify": "Title",
			"zhCn": "帐户",
			"zhTw": "",
			"enUs": "Account",
			"thTh": "บัญชี",
			"idId": "Akun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "devicePaaword",
			"classify": "Title",
			"zhCn": "密码",
			"zhTw": "",
			"enUs": "Password",
			"thTh": "รหัสผ่าน",
			"idId": "Kata sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceOtherParam",
			"classify": "Title",
			"zhCn": "其他参数",
			"zhTw": "",
			"enUs": "Other Parameter",
			"thTh": "พารามิเตอร์อื่น",
			"idId": "Parameter Lainnya",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceGwGroupExist",
			"classify": "Toast",
			"zhCn": "此网关组名称已存在，请输入新的名称。",
			"zhTw": "",
			"enUs": "This gateway group name already exists, please enter a new one.",
			"thTh": "ชื่อกลุ่มเกตเวย์นี้มีอยู่แล้ว โปรดกรอกชื่อใหม่",
			"idId": "Nama grup gateway ini sudah ada, silakan masukkan yang baru.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceGwExist",
			"classify": "Toast",
			"zhCn": "此网关名称已存在，请输入新的名称。",
			"zhTw": "",
			"enUs": "This gateway name already exists, please enter a new one.",
			"thTh": "ชื่อเกตเวย์นี้มีอยู่แล้ว โปรดกรอกชื่อใหม่",
			"idId": "Nama gateway ini sudah ada, silakan masukkan yang baru.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEditGw",
			"classify": "Title",
			"zhCn": "编辑网关",
			"zhTw": "",
			"enUs": "Edit Gateway",
			"thTh": "แก้ไขเกตเวย์",
			"idId": "Edit Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEditGwGroup",
			"classify": "Title",
			"zhCn": "编辑网关组",
			"zhTw": "",
			"enUs": "Edit Gateway Group",
			"thTh": "แก้ไขกลุ่มเกตเวย์",
			"idId": "Edit Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceSyncParent",
			"classify": "Text",
			"zhCn": "从父网关组同步",
			"zhTw": "",
			"enUs": "Sync from the parent gateway group",
			"thTh": "ซิงค์จากกลุ่มเกตเวย์หลัก",
			"idId": "Sinkronisasi dari grup gateway induk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceSearchPoint",
			"classify": "Text",
			"zhCn": "搜索测量点或ID",
			"zhTw": "",
			"enUs": "Search Measurement Point or ID",
			"thTh": "ค้นหาจุดตรวจวัดหรือ ID",
			"idId": "Cari Titik Pengukuran atau ID",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAllType",
			"classify": "Text",
			"zhCn": "全部测量类型",
			"zhTw": "",
			"enUs": "All Measurement Type",
			"thTh": "ประเภทการวัดทั้งหมด",
			"idId": "Semua Jenis Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceUpdateTime",
			"classify": "Text",
			"zhCn": "更新时间",
			"zhTw": "",
			"enUs": "Updated Time",
			"thTh": "เวลาที่อัปเดต",
			"idId": "Waktu yang Diperbarui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceId",
			"classify": "Title",
			"zhCn": "ID",
			"zhTw": "",
			"enUs": "ID",
			"thTh": "ID",
			"idId": "ID",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceFormat",
			"classify": "Title",
			"zhCn": "格式",
			"zhTw": "",
			"enUs": "Format",
			"thTh": "รูปแบบ",
			"idId": "Format",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceUnit",
			"classify": "Title",
			"zhCn": "单位",
			"zhTw": "",
			"enUs": "Unit",
			"thTh": "หน่วย",
			"idId": "Satuan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnumDef",
			"classify": "Title",
			"zhCn": "枚举定义",
			"zhTw": "",
			"enUs": "Enumeration Definition",
			"thTh": "นิยาม Enum",
			"idId": "Definisi Pencacahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceMeasValue",
			"classify": "Title",
			"zhCn": "测量值",
			"zhTw": "",
			"enUs": "Measured Value",
			"thTh": "ค่าที่วัดได้",
			"idId": "Nilai yang Diukur",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceMeasTime",
			"classify": "Title",
			"zhCn": "测量时间",
			"zhTw": "",
			"enUs": "Measurement Time",
			"thTh": "เวลาวัดค่า",
			"idId": "Waktu Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceStore",
			"classify": "Title",
			"zhCn": "存储",
			"zhTw": "",
			"enUs": "Storage",
			"thTh": "บันทึกข้อมูล",
			"idId": "Penyimpanan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAddDevice",
			"classify": "Title",
			"zhCn": "添加设备",
			"zhTw": "",
			"enUs": "Add Device",
			"thTh": "เพิ่มอุปกรณ์",
			"idId": "Tambah Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceBasicInfo",
			"classify": "Title",
			"zhCn": "基本信息",
			"zhTw": "",
			"enUs": "Basic Infomation",
			"thTh": "ข้อมูลพื้นฐาน",
			"idId": "Informasi Dasar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDeviceName",
			"classify": "Title",
			"zhCn": "设备名称",
			"zhTw": "",
			"enUs": "Device Name",
			"thTh": "ชื่ออุปกรณ์",
			"idId": "Nama Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceSn",
			"classify": "Title",
			"zhCn": "SN",
			"zhTw": "",
			"enUs": "SN",
			"thTh": "SN",
			"idId": "SN",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAssetId",
			"classify": "Title",
			"zhCn": "资产ID",
			"zhTw": "",
			"enUs": "Asset ID",
			"thTh": "ID สินทรัพย์",
			"idId": "ID Aset",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceType",
			"classify": "Title",
			"zhCn": "类型",
			"zhTw": "",
			"enUs": "Type",
			"thTh": "ประเภท",
			"idId": "Jenis",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceModel",
			"classify": "Title",
			"zhCn": "型号",
			"zhTw": "",
			"enUs": "Model",
			"thTh": "รุ่นอุปกรณ์",
			"idId": "Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceCommuTimeout",
			"classify": "Title",
			"zhCn": "通信超时警报（分钟）",
			"zhTw": "",
			"enUs": "Communication Timeout Alarm (min)",
			"thTh": "แจ้งเตือนการหมดเวลาการสื่อสาร (นาที)",
			"idId": "Alarm Batas Waktu Komunikasi (menit)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceOpDate",
			"classify": "Title",
			"zhCn": "运行日期",
			"zhTw": "",
			"enUs": "Operational Date",
			"thTh": "วันที่ดำเนินการ",
			"idId": "Tanggal Operasional",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceInstallLo",
			"classify": "Title",
			"zhCn": "安装位置",
			"zhTw": "",
			"enUs": "Installation Location",
			"thTh": "ตำแหน่งที่ติดตั้ง",
			"idId": "Lokasi Instalasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDesc",
			"classify": "Title",
			"zhCn": "描述",
			"zhTw": "",
			"enUs": "Description",
			"thTh": "คำอธิบาย",
			"idId": "Deskripsi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceOrg",
			"classify": "Title",
			"zhCn": "组织",
			"zhTw": "",
			"enUs": "Organization",
			"thTh": "องค์กร",
			"idId": "Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDeviceAlarm",
			"classify": "Title",
			"zhCn": "设备告警",
			"zhTw": "",
			"enUs": "Device Alarm",
			"thTh": "การเตือนอุปกรณ์",
			"idId": "Alarm Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "devicePointSet",
			"classify": "Title",
			"zhCn": "测量点设置",
			"zhTw": "",
			"enUs": "Measurement Point Settings",
			"thTh": "การตั้งค่าจุดตรวจวัด",
			"idId": "Pengaturan Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "devicePoint",
			"classify": "Title",
			"zhCn": "测量点",
			"zhTw": "",
			"enUs": "Measurement Point",
			"thTh": "จุดตรวจวัด",
			"idId": "Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDataSource",
			"classify": "Title",
			"zhCn": "数据源",
			"zhTw": "",
			"enUs": "Data Source",
			"thTh": "แหล่งข้อมูล",
			"idId": "Sumber Data",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDeviceCollect",
			"classify": "Title",
			"zhCn": "设备采集",
			"zhTw": "",
			"enUs": "Device Collection",
			"thTh": "จากอุปกรณ์ตรวจวัด",
			"idId": "Pengumpulan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceFormulaCollect",
			"classify": "Title",
			"zhCn": "公式采集",
			"zhTw": "",
			"enUs": "Formula Collection",
			"thTh": "จากสูตรคำนวณ",
			"idId": "Pengumpulan Formula",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnterFormula",
			"classify": "Text",
			"zhCn": "请输入计算公式",
			"zhTw": "",
			"enUs": "Please enter the calculation formula",
			"thTh": "กรุณากรอกสูตรคำนวณ",
			"idId": "Silakan masukkan rumus perhitungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceMoveNode",
			"classify": "Title",
			"zhCn": "移动到另一个节点",
			"zhTw": "",
			"enUs": "Move to Another Node",
			"thTh": "ย้ายไปที่โหนดอื่น",
			"idId": "Pindah ke Node Lain",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceGw",
			"classify": "Title",
			"zhCn": "网关",
			"zhTw": "",
			"enUs": "Gateway",
			"thTh": "เกตเวย์",
			"idId": "Gerbang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceSourceGwGroup",
			"classify": "Title",
			"zhCn": "源网关组",
			"zhTw": "",
			"enUs": "Source Gateway Group",
			"thTh": "กลุ่มเกตเวย์ต้นทาง",
			"idId": "Grup Gateway Sumber",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceTargetGwGroup",
			"classify": "Title",
			"zhCn": "目标网关组",
			"zhTw": "",
			"enUs": "Target Gateway Group",
			"thTh": "กลุ่มเกตเวย์เป้าหมาย",
			"idId": "Grup Gateway Target",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceAllDeviceMove",
			"classify": "Text",
			"zhCn": "与此网关关联的所有设备也将被移动。",
			"zhTw": "",
			"enUs": "All devices associated with this gateway will also be moved.",
			"thTh": "อุปกรณ์ทั้งหมดภายใต้เกตเวย์นี้จะถูกย้ายด้วย",
			"idId": "Semua perangkat yang terkait dengan gateway ini juga akan dipindahkan.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDevice",
			"classify": "Title",
			"zhCn": "设备",
			"zhTw": "",
			"enUs": "Device",
			"thTh": "อุปกรณ์",
			"idId": "Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceSourceGw",
			"classify": "Title",
			"zhCn": "源网关",
			"zhTw": "",
			"enUs": "Source Gateway",
			"thTh": "เกตเวย์ต้นทาง",
			"idId": "Gateway Sumber",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceTargetGw",
			"classify": "Title",
			"zhCn": "目标网关",
			"zhTw": "",
			"enUs": "Target Gateway",
			"thTh": "เกตเวย์เป้าหมาย",
			"idId": "Gateway Target",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDelGwGroup",
			"classify": "Title",
			"zhCn": "删除网关组",
			"zhTw": "",
			"enUs": "Delete Gateway Group",
			"thTh": "ลบกลุ่มเกตเวย์",
			"idId": "Hapus Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDelGwGroupCon",
			"classify": "Text",
			"zhCn": "网关组中的所有设备将被删除，无法恢复。是否要继续？",
			"zhTw": "",
			"enUs": "All devices in the gateway group will be deleted and cannot be restored .Do you want to continue?",
			"thTh": "อุปกรณ์ทั้งหมดในกลุ่มเกตเวย์จะถูกลบและไม่สามารถกู้คืนได้ คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Semua perangkat dalam grup gateway akan dihapus dan tidak dapat dipulihkan.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDelGw",
			"classify": "Title",
			"zhCn": "删除网关",
			"zhTw": "",
			"enUs": "Delete Gateway",
			"thTh": "ลบเกตเวย์",
			"idId": "Hapus Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDelGwCon",
			"classify": "Text",
			"zhCn": "网关中的所有设备将被删除，无法恢复。是否要继续？",
			"zhTw": "",
			"enUs": "All devices in the gateway will be deleted and cannot be restored .Do you want to continue?",
			"thTh": "อุปกรณ์ทั้งหมดในเกตเวย์จะถูกลบและไม่สามารถกู้คืนได้ คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Semua perangkat di gateway akan dihapus dan tidak dapat dipulihkan. Apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDelDevice",
			"classify": "Title",
			"zhCn": "删除设备",
			"zhTw": "",
			"enUs": "Delete Device",
			"thTh": "ลบอุปกรณ์",
			"idId": "Hapus Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDelDeviceCon",
			"classify": "Text",
			"zhCn": "设备将被删除，无法恢复。是否要继续？",
			"zhTw": "",
			"enUs": "The device will be deleted and cannot be restored .Do you want to continue?",
			"thTh": "อุปกรณ์จะถูกลบและไม่สามารถกู้คืนได้ คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Perangkat akan dihapus dan tidak dapat dipulihkan. Apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisGwGroup",
			"classify": "Title",
			"zhCn": "禁用网关组",
			"zhTw": "",
			"enUs": "Disable Gateway Group",
			"thTh": "ปิดใช้งานกลุ่มเกตเวย์",
			"idId": "Nonaktifkan Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisGwGroupCon",
			"classify": "Text",
			"zhCn": "网关组中的所有设备将停止报告数据，并且在重新启用之前不会触发任任何告警。是否要继续？",
			"zhTw": "",
			"enUs": "All devices in the gateway group will stop reporting data and will not trigger any alerts until re-enabled.Do you want to continue?",
			"thTh": "อุปกรณ์ทั้งหมดในกลุ่มเกตเวย์จะหยุดการรายงานข้อมูลและจะไม่ส่งการแจ้งเตือนใดๆ จนกว่าจะเปิดใช้งานอีกครั้ง คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Semua perangkat dalam grup gateway akan berhenti melaporkan data dan tidak akan memicu peringatan apa pun hingga diaktifkan kembali, apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisGw",
			"classify": "Title",
			"zhCn": "禁用网关",
			"zhTw": "",
			"enUs": "Disable Gateway",
			"thTh": "ปิดใช้งานเกตเวย์",
			"idId": "Nonaktifkan Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisGwCon",
			"classify": "Text",
			"zhCn": "网关中的所有设备将停止报告数据，并且在重新启用之前不会触发任何告警。是否要继续？",
			"zhTw": "",
			"enUs": "All devices in the gateway will stop reporting data and will not trigger any alerts until re-enabled .Do you want to continue?",
			"thTh": "อุปกรณ์ทั้งหมดในเกตเวย์จะหยุดการรายงานข้อมูลและจะไม่ส่งการแจ้งเตือนใดๆ จนกว่าจะเปิดใช้งานอีกครั้ง คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Semua perangkat di gateway akan berhenti melaporkan data dan tidak akan memicu peringatan apa pun hingga diaktifkan kembali, apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisDevice",
			"classify": "Title",
			"zhCn": "禁用设备",
			"zhTw": "",
			"enUs": "Disable Device",
			"thTh": "ปิดใช้งานอุปกรณ์",
			"idId": "Nonaktifkan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceDisDeviceCon",
			"classify": "Text",
			"zhCn": "设备将停止报告数据，并且在重新启用之前不会触发任何告警。是否要继续？",
			"zhTw": "",
			"enUs": "The device will  stop reporting data and will not trigger any alerts until re-enabled .Do you want to continue?",
			"thTh": "อุปกรณ์จะหยุดการรายงานข้อมูลและจะไม่ส่งการแจ้งเตือนใดๆ จนกว่าจะเปิดใช้งานอีกครั้ง คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Perangkat akan berhenti melaporkan data dan tidak akan memicu peringatan apa pun sampai diaktifkan kembali. Apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnGwGroup",
			"classify": "Title",
			"zhCn": "启用网关组",
			"zhTw": "",
			"enUs": "Enable Gateway Group",
			"thTh": "เปิดใช้งานกลุ่มเกตเวย์",
			"idId": "Aktifkan Grup Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnGwGroupCon",
			"classify": "Text",
			"zhCn": "启用网关组还将启用所有相关网关和设备。是否要继续？",
			"zhTw": "",
			"enUs": "Enabling the gateway group will also enable all associated gateways and devices. Do you want to proceed?",
			"thTh": "การเปิดใช้งานกลุ่มเกตเวย์จะเปิดใช้งานเกตเวย์และอุปกรณ์ที่เกี่ยวข้องทั้งหมดด้วย คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Mengaktifkan grup gateway juga akan mengaktifkan semua gateway dan perangkat yang terkait. Apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnGw",
			"classify": "Title",
			"zhCn": "启用网关",
			"zhTw": "",
			"enUs": "Enable Gateway",
			"thTh": "เปิดใช้งานเกตเวย์",
			"idId": "Aktifkan Gateway",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnGwCon",
			"classify": "Text",
			"zhCn": "启用网关还将启用所有相关设备。是否要继续？",
			"zhTw": "",
			"enUs": "Enabling the gateway will also enable all associated devices. Do you want to proceed?",
			"thTh": "การเปิดใช้งานเกตเวย์จะเปิดใช้งานอุปกรณ์ที่เกี่ยวข้องทั้งหมดด้วย คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Mengaktifkan gateway juga akan mengaktifkan semua perangkat yang terkait. Apakah Anda ingin melanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnDivice",
			"classify": "Title",
			"zhCn": "启用设备",
			"zhTw": "",
			"enUs": "Enable Device",
			"thTh": "เปิดใช้งานอุปกรณ์",
			"idId": "Aktifkan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceEnDiviceCon",
			"classify": "Text",
			"zhCn": "是否要启用设备？",
			"zhTw": "",
			"enUs": "Do you want to enable the device?",
			"thTh": "คุณต้องการเปิดใช้งานอุปกรณ์หรือไม่",
			"idId": "Apakah Anda ingin mengaktifkan perangkat?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEdit",
			"classify": "Text",
			"zhCn": "添加",
			"zhTw": "",
			"enUs": "Add",
			"thTh": "เพิ่ม",
			"idId": "Tambah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAdd",
			"classify": "Text",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEnDis",
			"classify": "Text",
			"zhCn": "启禁用",
			"zhTw": "",
			"enUs": "Enable/Disable",
			"thTh": "เปิด/ปิดใช้งาน",
			"idId": "Aktifkan/Nonaktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDel",
			"classify": "Text",
			"zhCn": "删除",
			"zhTw": "",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoLang",
			"classify": "Button",
			"zhCn": "语言",
			"zhTw": "",
			"enUs": "Language",
			"thTh": "ภาษา",
			"idId": "Bahasa",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoSetting",
			"classify": "Button",
			"zhCn": "我的账号",
			"zhTw": "",
			"enUs": "My Account",
			"thTh": "บัญชีของฉัน",
			"idId": "Akun Saya",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoLogout",
			"classify": "Button",
			"zhCn": "注销",
			"zhTw": "",
			"enUs": "Log Out",
			"thTh": "ออกจากระบบ",
			"idId": "Keluar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoUserInfo",
			"classify": "Title",
			"zhCn": "用户信息",
			"zhTw": "",
			"enUs": "User Info",
			"thTh": "ข้อมูลผู้ใช้",
			"idId": "Info Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoProfilePic",
			"classify": "Title",
			"zhCn": "个人资料图片",
			"zhTw": "",
			"enUs": "Profile Picture",
			"thTh": "รูปโปรไฟล์",
			"idId": "Gambar Profil",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoUploadSize",
			"classify": "Text",
			"zhCn": "仅上传JPG/PNG，最大尺寸 500KB。",
			"zhTw": "",
			"enUs": "Upload only JPG/PNG, max size 500KB.",
			"thTh": "อัปโหลดได้เฉพาะ JPG/PNG ขนาดสูงสุด 500KB",
			"idId": "Unggah hanya JPG/PNG, ukuran maksimal 500KB.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoChange",
			"classify": "Title",
			"zhCn": "更改",
			"zhTw": "",
			"enUs": "Change",
			"thTh": "เปลี่ยน",
			"idId": "Ubah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoName",
			"classify": "Title",
			"zhCn": "名称",
			"zhTw": "",
			"enUs": "Name",
			"thTh": "ชื่อ",
			"idId": "Nama",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoAccc",
			"classify": "Title",
			"zhCn": "账号：",
			"zhTw": "",
			"enUs": "Account: ",
			"thTh": "บัญชี:",
			"idId": "Akun ",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoOrgan",
			"classify": "Title",
			"zhCn": "组织",
			"zhTw": "",
			"enUs": "Organization",
			"thTh": "องค์กร",
			"idId": "Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoSex",
			"classify": "Title",
			"zhCn": "性别",
			"zhTw": "",
			"enUs": "Gender",
			"thTh": "เพศ",
			"idId": "Jenis Kelamin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoUnknown",
			"classify": "Title",
			"zhCn": "未知",
			"zhTw": "",
			"enUs": "Unkhown",
			"thTh": "ไม่ทราบ",
			"idId": "Tidak diketahui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoMale",
			"classify": "Title",
			"zhCn": "男",
			"zhTw": "",
			"enUs": "Male",
			"thTh": "ชาย",
			"idId": "Laki-laki",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoFemale",
			"classify": "Title",
			"zhCn": "女",
			"zhTw": "",
			"enUs": "Female",
			"thTh": "หญิง",
			"idId": "Perempuan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoPhoneNo",
			"classify": "Title",
			"zhCn": "电话号码",
			"zhTw": "",
			"enUs": "Phone Number",
			"thTh": "หมายเลขโทรศัพท์",
			"idId": "Nomor Telepon",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoEmail",
			"classify": "Title",
			"zhCn": "电子邮件",
			"zhTw": "",
			"enUs": "Email",
			"thTh": "อีเมล",
			"idId": "Email",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoDateFormat",
			"classify": "Title",
			"zhCn": "日期格式",
			"zhTw": "",
			"enUs": "Date Format",
			"thTh": "รูปแบบวันที่",
			"idId": "Format Tanggal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoPreview",
			"classify": "Text",
			"zhCn": "预览：",
			"zhTw": "",
			"enUs": "Preview: ",
			"thTh": "ตัวอย่าง:",
			"idId": "Pratinjau: ",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoDiscardChang",
			"classify": "Button",
			"zhCn": "放弃更改",
			"zhTw": "",
			"enUs": "Discard Changes",
			"thTh": "ยกเลิกการเปลี่ยนแปลง",
			"idId": "Buang Perubahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoSaveChang",
			"classify": "Button",
			"zhCn": "保存更改",
			"zhTw": "",
			"enUs": "Save Changes",
			"thTh": "บันทึกการเปลี่ยนแปลง",
			"idId": "Simpan Perubahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoChangPass",
			"classify": "Title",
			"zhCn": "更改密码",
			"zhTw": "",
			"enUs": "Change Password",
			"thTh": "เปลี่ยนรหัสผ่าน",
			"idId": "Ubah Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoCurrentPass",
			"classify": "Title",
			"zhCn": "当前密码",
			"zhTw": "",
			"enUs": "Current Password",
			"thTh": "รหัสผ่านปัจจุบัน",
			"idId": "Kata Sandi Saat Ini",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoNewPass",
			"classify": "Title",
			"zhCn": "新密码",
			"zhTw": "",
			"enUs": "New Password",
			"thTh": "รหัสผ่านใหม่",
			"idId": "Kata Sandi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoConfirmPass",
			"classify": "Title",
			"zhCn": "确认新密码",
			"zhTw": "",
			"enUs": "Confirm New Password",
			"thTh": "ยืนยันรหัสผ่านใหม่",
			"idId": "Konfirmasi Kata Sandi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoPlsConfirmPass",
			"classify": "Title",
			"zhCn": "请确认新密码",
			"zhTw": "",
			"enUs": "Please confirm New Password",
			"thTh": "กรุณายืนยันรหัสผ่านใหม่",
			"idId": "Harap konfirmasi Kata Sandi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoEmpty",
			"classify": "Button",
			"zhCn": "清空",
			"zhTw": "",
			"enUs": "Empty",
			"thTh": "ลบทั้งหมด",
			"idId": "Kosongkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoSaveChange",
			"classify": "Button",
			"zhCn": "保存更改",
			"zhTw": "",
			"enUs": "Save Changes",
			"thTh": "บันทึกการเปลี่ยนแปลง",
			"idId": "Simpan Perubahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoPassCannotEmpty",
			"classify": "Toast",
			"zhCn": "❌ 当前密码不能为空。",
			"zhTw": "",
			"enUs": "❌ Current password cannot be empty.",
			"thTh": "❌ รหัสผ่านปัจจุบันไม่สามารถเว้นว่างได้",
			"idId": "❌ Kata sandi saat ini tidak boleh kosong.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoNewCannotEmprty",
			"classify": "Toast",
			"zhCn": "❌ 新密码不能为空。",
			"zhTw": "",
			"enUs": "❌ New password cannot be empty.",
			"thTh": "❌ รหัสผ่านใหม่ไม่สามารถเว้นว่างได้",
			"idId": "❌ Kata sandi baru tidak boleh kosong.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoPassSix",
			"classify": "Toast",
			"zhCn": "⚠️ 密码长度至少为 6 个字符",
			"zhTw": "",
			"enUs": "⚠️ Password should be at least 6 characters long",
			"thTh": "⚠️ รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร",
			"idId": "⚠️ Kata sandi harus terdiri dari minimal 6 karakter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoPassCannotSame",
			"classify": "Toast",
			"zhCn": "❌ 新密码不能与当前密码相同。",
			"zhTw": "",
			"enUs": "❌ New password cannot be the same as the current password.",
			"thTh": "❌ รหัสผ่านใหม่ไม่สามารถเหมือนกับรหัสผ่านปัจจุบันได้",
			"idId": "Kata sandi baru tidak boleh sama dengan kata sandi saat ini.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoConfirmPassEmpty",
			"classify": "Toast",
			"zhCn": "❌ 确认密码不能为空。",
			"zhTw": "",
			"enUs": "❌ Confirm password cannot be empty.",
			"thTh": "❌ ยืนยันรหัสผ่านไม่สามารถเว้นว่างได้",
			"idId": "❌ Kata sandi konfirmasi tidak boleh kosong.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userInfoPassNotMatch",
			"classify": "Toast",
			"zhCn": "❌ 密码不匹配。",
			"zhTw": "",
			"enUs": "❌ Passwords do not match.",
			"thTh": "❌ รหัสผ่านไม่ตรงกัน",
			"idId": "❌ Kata sandi tidak cocok.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDefault",
			"classify": "Toast",
			"zhCn": "默认",
			"zhTw": "",
			"enUs": "Default",
			"thTh": "ค่าเริ่มต้น",
			"idId": "Default",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEdit",
			"classify": "Toast",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleSearchRole",
			"classify": "Text",
			"zhCn": "搜索角色",
			"zhTw": "",
			"enUs": "Search role",
			"thTh": "ค้นหาบทบาท",
			"idId": "Cari peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleAddRole",
			"classify": "Button",
			"zhCn": "添加角色",
			"zhTw": "",
			"enUs": "Add Role",
			"thTh": "เพิ่มบทบาท",
			"idId": "Menambahkan Peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleDel",
			"classify": "Button",
			"zhCn": "删除",
			"zhTw": "",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleFunction",
			"classify": "Title",
			"zhCn": "功能",
			"zhTw": "",
			"enUs": "Function",
			"thTh": "ฟังก์ชัน",
			"idId": "Fungsi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleApi",
			"classify": "Title",
			"zhCn": "API",
			"zhTw": "",
			"enUs": "API",
			"thTh": "API",
			"idId": "API",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleEdit",
			"classify": "Button",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleAllPermission",
			"classify": "Text",
			"zhCn": "全部权限",
			"zhTw": "",
			"enUs": "All Permission",
			"thTh": "สิทธิ์ทั้งหมด",
			"idId": "Semua Izin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleAddRole",
			"classify": "Title",
			"zhCn": "添加角色",
			"zhTw": "",
			"enUs": "Add Role",
			"thTh": "เพิ่มบทบาท",
			"idId": "Tambahkan Peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleRoleName",
			"classify": "Title",
			"zhCn": "角色名称",
			"zhTw": "",
			"enUs": "Role Name",
			"thTh": "ชื่อบทบาท",
			"idId": "Nama Peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleParentRole",
			"classify": "Title",
			"zhCn": "父角色",
			"zhTw": "",
			"enUs": "Parent Role",
			"thTh": "บทบาทหลัก",
			"idId": "Peran Induk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "roleEditRole",
			"classify": "Title",
			"zhCn": "编辑角色",
			"zhTw": "",
			"enUs": "Edit Role",
			"thTh": "แก้ไขบทบาท",
			"idId": "Edit Peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAddRole",
			"classify": "Text",
			"zhCn": "添加角色",
			"zhTw": "",
			"enUs": "Add role",
			"thTh": "เพิ่มบทบาท",
			"idId": "Menambahkan peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEditRole",
			"classify": "Text",
			"zhCn": "编辑角色",
			"zhTw": "",
			"enUs": "Edit role",
			"thTh": "แก้ไขบทบาท",
			"idId": "Edit peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDelRole",
			"classify": "Text",
			"zhCn": "删除角色",
			"zhTw": "",
			"enUs": "Delete role",
			"thTh": "ลบบทบาท",
			"idId": "Menghapus peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissPermisSet",
			"classify": "Text",
			"zhCn": "权限设置",
			"zhTw": "",
			"enUs": "Permission settings",
			"thTh": "การตั้งค่าสิทธิ์",
			"idId": "Pengaturan izin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataSearchNode",
			"classify": "Text",
			"zhCn": "使用节点名搜索",
			"zhTw": "",
			"enUs": "Search by node name",
			"thTh": "ค้นหาด้วยชื่อโหนด",
			"idId": "Cari berdasarkan nama simpul",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataNoti",
			"classify": "Title",
			"zhCn": "通知",
			"zhTw": "",
			"enUs": "Notification",
			"thTh": "แจ้งเตือน",
			"idId": "Pemberitahuan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataTwoUnits",
			"classify": "Text",
			"zhCn": "最多只能选择2个不同单位的测量点",
			"zhTw": "",
			"enUs": "Only up to measurement points with 2 different units can be selected.",
			"thTh": "สามารถเลือกจุดตรวจวัดที่มีหน่วยต่างกันได้สูงสุด 2 หน่วยเท่านั้น",
			"idId": "Hanya maksimal 2 titik pengukuran dengan satuan yang berbeda yang dapat dipilih.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicBtConfirm",
			"classify": "Button",
			"zhCn": "确认",
			"zhTw": "",
			"enUs": "Confirm",
			"thTh": "ยืนยัน",
			"idId": "Konfirmasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataHead",
			"classify": "Title",
			"zhCn": "历史数据",
			"zhTw": "",
			"enUs": "Historical Data",
			"thTh": "ประวัติข้อมูล",
			"idId": "Data Historis",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataStatSum",
			"classify": "Title",
			"zhCn": "统计信息摘要",
			"zhTw": "",
			"enUs": "Statistics Summary",
			"thTh": "สรุปข้อมูลสถิติ",
			"idId": "Ringkasan Statistik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataNo",
			"classify": "Title",
			"zhCn": "序号",
			"zhTw": "",
			"enUs": "No.",
			"thTh": "ลำดับ",
			"idId": "Tidak",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataStat",
			"classify": "Title",
			"zhCn": "统计信息",
			"zhTw": "",
			"enUs": "Statistics",
			"thTh": "ข้อมูลสถิติ",
			"idId": "Statistik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataMax",
			"classify": "Title",
			"zhCn": "最大值",
			"zhTw": "",
			"enUs": "Maximum",
			"thTh": "ค่าสูงสุด",
			"idId": "Maksimum",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataMin",
			"classify": "Title",
			"zhCn": "最小值",
			"zhTw": "",
			"enUs": "Minimum",
			"thTh": "ค่าต่ำสุด",
			"idId": "Minimum",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataAvr",
			"classify": "Title",
			"zhCn": "平均值",
			"zhTw": "",
			"enUs": "Average",
			"thTh": "ค่าเฉลี่ย",
			"idId": "Rata-rata",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataTime",
			"classify": "Title",
			"zhCn": "时间",
			"zhTw": "",
			"enUs": "Time",
			"thTh": "เวลา",
			"idId": "Waktu",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataNoDeive",
			"classify": "Text",
			"zhCn": "无关联设备数据",
			"zhTw": "",
			"enUs": "No associated device data",
			"thTh": "ไม่มีข้อมูลอุปกรณ์",
			"idId": "Tidak ada data perangkat terkait",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "hisDataNoPoint",
			"classify": "Text",
			"zhCn": "未选择测量点",
			"zhTw": "",
			"enUs": "No measurement point selected",
			"thTh": "ไม่ได้เลือกจุดตรวจวัด",
			"idId": "Tidak ada titik pengukuran yang dipilih",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointPointId",
			"classify": "Title",
			"zhCn": "测点ID",
			"zhTw": "",
			"enUs": "Point ID",
			"thTh": "ID จุดตรวจวัด",
			"idId": "ID Titik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointAll",
			"classify": "Text",
			"zhCn": "全部",
			"zhTw": "",
			"enUs": "All",
			"thTh": "ทั้งหมด",
			"idId": "Semua",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointSearch",
			"classify": "Button",
			"zhCn": "搜索",
			"zhTw": "",
			"enUs": "Search",
			"thTh": "ค้นหา",
			"idId": "Cari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointAddPoint",
			"classify": "Button",
			"zhCn": "添加测量点",
			"zhTw": "",
			"enUs": "Add Measurement Point",
			"thTh": "เพิ่มจุดตรวจวัด",
			"idId": "Tambahkan Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointId",
			"classify": "Title",
			"zhCn": "ID",
			"zhTw": "",
			"enUs": "ID",
			"thTh": "ID",
			"idId": "ID",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointValue",
			"classify": "Text",
			"zhCn": "数值",
			"zhTw": "",
			"enUs": "Value",
			"thTh": "ค่า",
			"idId": "Nilai",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointEnum",
			"classify": "Text",
			"zhCn": "枚举",
			"zhTw": "",
			"enUs": "Enumeration",
			"thTh": "Enum",
			"idId": "Pencacahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointString",
			"classify": "Text",
			"zhCn": "字符串",
			"zhTw": "",
			"enUs": "String",
			"thTh": "สตริง",
			"idId": "String",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointTime",
			"classify": "Text",
			"zhCn": "时间",
			"zhTw": "",
			"enUs": "Time",
			"thTh": "เวลา",
			"idId": "Waktu",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointImg",
			"classify": "Text",
			"zhCn": "图片",
			"zhTw": "",
			"enUs": "Image",
			"thTh": "รูปภาพ",
			"idId": "Gambar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointLastUpdateTime",
			"classify": "Title",
			"zhCn": "最后更新时间",
			"zhTw": "",
			"enUs": "Last updated time",
			"thTh": "เวลาที่อัปเดตล่าสุด",
			"idId": "Waktu terakhir diperbarui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointAddPoint",
			"classify": "Title",
			"zhCn": "添加测量点",
			"zhTw": "",
			"enUs": "Add Measurement Point",
			"thTh": "เพิ่มจุดตรวจวัด",
			"idId": "Menambahkan Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointType",
			"classify": "Title",
			"zhCn": "类型",
			"zhTw": "",
			"enUs": "Type",
			"thTh": "ประเภท",
			"idId": "Ketik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointFormat",
			"classify": "Title",
			"zhCn": "格式",
			"zhTw": "",
			"enUs": "Format",
			"thTh": "รูปแบบ",
			"idId": "Format",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointCantModify",
			"classify": "Text",
			"zhCn": "添加后不可修改。",
			"zhTw": "",
			"enUs": "Cannot be modified after adding.",
			"thTh": "ไม่สามารถแก้ไขได้หลังจากเพิ่มแล้ว",
			"idId": "Tidak dapat dimodifikasi setelah ditambahkan.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointLangVer",
			"classify": "Title",
			"zhCn": "语言版本",
			"zhTw": "",
			"enUs": "Language Version",
			"thTh": "เวอร์ชันภาษา",
			"idId": "Versi Bahasa",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointEn",
			"classify": "Text",
			"zhCn": "EN",
			"zhTw": "",
			"enUs": "EN",
			"thTh": "EN",
			"idId": "EN",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointTh",
			"classify": "Text",
			"zhCn": "TH",
			"zhTw": "",
			"enUs": "TH",
			"thTh": "TH",
			"idId": "TH",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointCn",
			"classify": "Text",
			"zhCn": "CN",
			"zhTw": "",
			"enUs": "CN",
			"thTh": "CN",
			"idId": "CN",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointPoint",
			"classify": "Title",
			"zhCn": "测量点",
			"zhTw": "",
			"enUs": "Measurement Point",
			"thTh": "จุดตรวจวัด",
			"idId": "Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointUnit",
			"classify": "Title",
			"zhCn": "单位",
			"zhTw": "",
			"enUs": "Unit",
			"thTh": "หน่วย",
			"idId": "Satuan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointNoUnit",
			"classify": "Text",
			"zhCn": "无单位",
			"zhTw": "",
			"enUs": "No Unit",
			"thTh": "ไม่มีหน่วย",
			"idId": "Tidak ada Satuan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointCustomeUnit",
			"classify": "Text",
			"zhCn": "自定义单位",
			"zhTw": "",
			"enUs": "Custom Unit",
			"thTh": "หน่วยที่กำหนดเอง",
			"idId": "Satuan Khusus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointNote",
			"classify": "Title",
			"zhCn": "备注",
			"zhTw": "",
			"enUs": "Note",
			"thTh": "หมายเหตุ",
			"idId": "Catatan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointEnumDef",
			"classify": "Title",
			"zhCn": "枚举定义",
			"zhTw": "",
			"enUs": "Enumeration Definition",
			"thTh": "นิยาม Enum",
			"idId": "Definisi Pencacahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointParam",
			"classify": "Title",
			"zhCn": "参数",
			"zhTw": "",
			"enUs": "Parameter",
			"thTh": "พารามิเตอร์",
			"idId": "Parameter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointAdd",
			"classify": "Title",
			"zhCn": "添加",
			"zhTw": "",
			"enUs": "Add",
			"thTh": "เพิ่ม",
			"idId": "Menambahkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointAction",
			"classify": "Title",
			"zhCn": "操作",
			"zhTw": "",
			"enUs": "Action",
			"thTh": "ดำเนินการ",
			"idId": "Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointEditPoint",
			"classify": "Title",
			"zhCn": "编辑测量点",
			"zhTw": "",
			"enUs": "Edit Measurement Point",
			"thTh": "แก้ไขจุดตรวจวัด",
			"idId": "Edit Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointDelPoint",
			"classify": "Title",
			"zhCn": "删除测量点",
			"zhTw": "",
			"enUs": "Delete Measurement Point",
			"thTh": "ลบจุดตรวจวัด",
			"idId": "Hapus Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointPointc",
			"classify": "Text",
			"zhCn": "测量点:",
			"zhTw": "",
			"enUs": "Measurement point:",
			"thTh": "จุดตรวจวัด:",
			"idId": "Titik pengukuran:",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "standardPointDelPointCon",
			"classify": "Text",
			"zhCn": "删除的数据无法恢复，会影响设备显示。是否继续？",
			"zhTw": "",
			"enUs": "Deleted data cannot be restored and will impact device display. Continue anyway?",
			"thTh": "ข้อมูลที่ถูกลบไม่สามารถเรียกคืนได้ และจะส่งผลต่อการแสดงผลของอุปกรณ์ ดำเนินการต่อหรือไม่",
			"idId": "Data yang dihapus tidak dapat dipulihkan dan akan memengaruhi tampilan perangkat. Lanjutkan saja?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAddPoint",
			"classify": "Text",
			"zhCn": "添加测点",
			"zhTw": "",
			"enUs": "Add measurement point",
			"thTh": "การเพิ่มจุดตรวจวัด",
			"idId": "Menambahkan titik pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEditPoint",
			"classify": "Text",
			"zhCn": "编辑测点",
			"zhTw": "",
			"enUs": "Edit measurement point",
			"thTh": "การแก้ไขจุด",
			"idId": "Mengedit titik pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDelPoint",
			"classify": "Text",
			"zhCn": "删除测点",
			"zhTw": "",
			"enUs": "Delete measurement point",
			"thTh": "การลบจุดตรวจวัด",
			"idId": "Menghapus titik pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSearchOrg",
			"classify": "Text",
			"zhCn": "搜索组织名称或代码",
			"zhTw": "",
			"enUs": "Search organization name or code",
			"thTh": "ค้นหาชื่อหรือรหัสองค์กร",
			"idId": "Cari nama atau kode organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAddOrg",
			"classify": "Button",
			"zhCn": "添加组织",
			"zhTw": "",
			"enUs": "Add Organization",
			"thTh": "เพิ่มองค์กร",
			"idId": "Menambahkan Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgIncludeSub",
			"classify": "Text",
			"zhCn": "包括子组织的用户",
			"zhTw": "",
			"enUs": "Include users of sub-organizations",
			"thTh": "รวมผู้ใช้ขององค์กรย่อย",
			"idId": "Menyertakan pengguna sub-organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgExcludeSub",
			"classify": "Text",
			"zhCn": "排除子组织的用户",
			"zhTw": "",
			"enUs": "Exclude users of sub-organizations",
			"thTh": "ไม่รวมผู้ใช้ขององค์กรย่อย",
			"idId": "Mengecualikan pengguna sub-organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSearchName",
			"classify": "Text",
			"zhCn": "搜索名称/账号/用户编码",
			"zhTw": "",
			"enUs": "Search name /account/ user code",
			"thTh": "ค้นหาชื่อ /บัญชี/ รหัสผู้ใช้",
			"idId": "Cari nama / akun / kode pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAddUser",
			"classify": "Button",
			"zhCn": "添加用户",
			"zhTw": "",
			"enUs": "Add User",
			"thTh": "เพิ่มผู้ใช้",
			"idId": "Tambah Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgChangeOrg",
			"classify": "Button",
			"zhCn": "更换组织",
			"zhTw": "",
			"enUs": "Change Organization",
			"thTh": "เปลี่ยนองค์กร",
			"idId": "Ubah Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgStatus",
			"classify": "Title",
			"zhCn": "状态",
			"zhTw": "",
			"enUs": "Status",
			"thTh": "สถานะ",
			"idId": "Status",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgOrgan",
			"classify": "Title",
			"zhCn": "组织",
			"zhTw": "",
			"enUs": "Organization",
			"thTh": "องค์กร",
			"idId": "Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSex",
			"classify": "Title",
			"zhCn": "性别",
			"zhTw": "",
			"enUs": "Gender",
			"thTh": "เพศ",
			"idId": "Jenis Kelamin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgUnknow",
			"classify": "Text",
			"zhCn": "未知",
			"zhTw": "",
			"enUs": "Unkhown",
			"thTh": "ไม่ทราบ",
			"idId": "Tidak diketahui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgUpdateTime",
			"classify": "Title",
			"zhCn": "更新时间",
			"zhTw": "",
			"enUs": "Updated Time",
			"thTh": "เวลาที่อัปเดต",
			"idId": "Waktu yang diperbarui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgUpdateBy",
			"classify": "Title",
			"zhCn": "更新者",
			"zhTw": "",
			"enUs": "Updated By",
			"thTh": "อัปเดตโดย",
			"idId": "Diperbarui oleh",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAction",
			"classify": "Title",
			"zhCn": "操作",
			"zhTw": "",
			"enUs": "Action",
			"thTh": "ดำเนินการ",
			"idId": "Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDetail",
			"classify": "Button",
			"zhCn": "详细",
			"zhTw": "",
			"enUs": "Detail",
			"thTh": "รายละเอียด",
			"idId": "Detail",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgEnable",
			"classify": "Button",
			"zhCn": "启用",
			"zhTw": "",
			"enUs": "Enable",
			"thTh": "เปิดใช้งาน",
			"idId": "Aktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgResetPass",
			"classify": "Button",
			"zhCn": "重置密码",
			"zhTw": "",
			"enUs": "Reset Password",
			"thTh": "รีเซ็ตรหัสผ่าน",
			"idId": "Atur Ulang Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDisable",
			"classify": "Button",
			"zhCn": "禁用",
			"zhTw": "",
			"enUs": "Disable",
			"thTh": "ปิดใช้งาน",
			"idId": "Nonaktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDisabled",
			"classify": "Button",
			"zhCn": "已禁用",
			"zhTw": "",
			"enUs": "Disabled",
			"thTh": "ปิดใช้งานแล้ว",
			"idId": "Dinonaktifkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgActive",
			"classify": "Button",
			"zhCn": "活动",
			"zhTw": "",
			"enUs": "Active",
			"thTh": "ใช้งานได้",
			"idId": "Aktif",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAddOrg",
			"classify": "Title",
			"zhCn": "添加组织",
			"zhTw": "",
			"enUs": "Add Organization",
			"thTh": "เพิ่มองค์กร",
			"idId": "Tambah Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSequence",
			"classify": "Title",
			"zhCn": "序列",
			"zhTw": "",
			"enUs": "Sequence",
			"thTh": "ลำดับ",
			"idId": "Urutan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgOrgCodeExist",
			"classify": "Title",
			"zhCn": "组织编码已存在",
			"zhTw": "",
			"enUs": "Organization Code already exists.",
			"thTh": "รหัสองค์กรซ้ำกับที่มีอยู่",
			"idId": "Kode Organisasi sudah ada.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgCancel",
			"classify": "Button",
			"zhCn": "取消",
			"zhTw": "",
			"enUs": "Cancel",
			"thTh": "ยกเลิก",
			"idId": "Batal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgConfirm",
			"classify": "Button",
			"zhCn": "确认",
			"zhTw": "",
			"enUs": "Confirm",
			"thTh": "ยืนยัน",
			"idId": "Konfirmasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgCompany",
			"classify": "Text",
			"zhCn": "公司",
			"zhTw": "",
			"enUs": "Company",
			"thTh": "บริษัท",
			"idId": "Perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgRegion",
			"classify": "Text",
			"zhCn": "地区",
			"zhTw": "",
			"enUs": "Region",
			"thTh": "เขตพื้นที่",
			"idId": "Wilayah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgProject",
			"classify": "Text",
			"zhCn": "项目",
			"zhTw": "",
			"enUs": "Project",
			"thTh": "โครงการ",
			"idId": "Proyek",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgBuilding",
			"classify": "Text",
			"zhCn": "建筑",
			"zhTw": "",
			"enUs": "Building",
			"thTh": "อาคาร",
			"idId": "Bangunan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgFloor",
			"classify": "Text",
			"zhCn": "楼层",
			"zhTw": "",
			"enUs": "Floor",
			"thTh": "ชั้น",
			"idId": "Lantai",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgWorkspace",
			"classify": "Text",
			"zhCn": "工作区",
			"zhTw": "",
			"enUs": "Workspace",
			"thTh": "พื้นที่ทำงาน",
			"idId": "Ruang kerja",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDeleteOrg",
			"classify": "Title",
			"zhCn": "删除组织",
			"zhTw": "",
			"enUs": "Delete Organization",
			"thTh": "ลบองค์กร",
			"idId": "Menghapus Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSubOrgDel",
			"classify": "Text",
			"zhCn": "删除组织前必须先删除所有子组织。",
			"zhTw": "",
			"enUs": "All sub-organizations must be deleted before deleting the organization.",
			"thTh": "ต้องลบองค์กรย่อยทั้งหมดก่อนจึงจะลบองค์กรได้",
			"idId": "Semua sub-organisasi harus dihapus sebelum menghapus organisasi.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAllUserDel",
			"classify": "Text",
			"zhCn": "删除组织前必须先移除所有用户。",
			"zhTw": "",
			"enUs": "All users must be removed before deleting the organization.",
			"thTh": "ต้องลบผู้ใช้ทั้งหมดก่อนจะลบองค์กรได้",
			"idId": "Semua pengguna harus dihapus sebelum menghapus organisasi.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgOrgc",
			"classify": "Text",
			"zhCn": "组织：",
			"zhTw": "",
			"enUs": "Organization:",
			"thTh": "องค์กร:",
			"idId": "Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDelOrgCon",
			"classify": "Text",
			"zhCn": "已删除的组织无法恢复。是否继续？",
			"zhTw": "",
			"enUs": "Deleted organization cannot be restored. Continue anyway?",
			"thTh": "องค์กรที่ถูกลบจะไม่สามารถกู้คืนได้  ต้องการดำเนินการต่อหรือไม่",
			"idId": "Organisasi yang dihapus tidak dapat dipulihkan. Terus bagaimana?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDelete",
			"classify": "Button",
			"zhCn": "删除",
			"zhTw": "",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgEditOrg",
			"classify": "Title",
			"zhCn": "编辑组织",
			"zhTw": "",
			"enUs": "Edit Organization",
			"thTh": "แก้ไของค์กร",
			"idId": "Edit Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgOrgName",
			"classify": "Title",
			"zhCn": "组织名称",
			"zhTw": "",
			"enUs": "Organization Name",
			"thTh": "ชื่อองค์กร",
			"idId": "Nama Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgOrgType",
			"classify": "Title",
			"zhCn": "组织类型",
			"zhTw": "",
			"enUs": "Organization Type",
			"thTh": "ประเภทองค์กร",
			"idId": "Jenis Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgParentOrg",
			"classify": "Title",
			"zhCn": "上级组织",
			"zhTw": "",
			"enUs": "Parent Organization",
			"thTh": "องค์กรแม่",
			"idId": "Organisasi Induk",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSequnce",
			"classify": "Title",
			"zhCn": "序列",
			"zhTw": "",
			"enUs": "Sequence",
			"thTh": "ลำดับ",
			"idId": "Urutan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgOrgCode",
			"classify": "Title",
			"zhCn": "组织编码",
			"zhTw": "",
			"enUs": "Organization Code",
			"thTh": "รหัสองค์กร",
			"idId": "Kode Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgRegion",
			"classify": "Title",
			"zhCn": "地区",
			"zhTw": "",
			"enUs": "Region",
			"thTh": "เขตพื้นที่",
			"idId": "Wilayah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAddress",
			"classify": "Title",
			"zhCn": "地址",
			"zhTw": "",
			"enUs": "Address",
			"thTh": "ที่อยู่",
			"idId": "Alamat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgLat",
			"classify": "Title",
			"zhCn": "纬度",
			"zhTw": "",
			"enUs": "Latitude",
			"thTh": "ละติจูด",
			"idId": "Lintang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgLong",
			"classify": "Title",
			"zhCn": "经度",
			"zhTw": "",
			"enUs": "Longitude",
			"thTh": "ลองจิจูด",
			"idId": "Bujur",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgEdit",
			"classify": "Button",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAddUser",
			"classify": "Title",
			"zhCn": "添加用户",
			"zhTw": "",
			"enUs": "Add User",
			"thTh": "เพิ่มผู้ใช้",
			"idId": "Tambah Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgBasicInfo",
			"classify": "Title",
			"zhCn": "基本信息",
			"zhTw": "",
			"enUs": "Basic  Infomation",
			"thTh": "ข้อมูลพื้นฐาน",
			"idId": "Informasi Dasar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAccount",
			"classify": "Title",
			"zhCn": "账号",
			"zhTw": "",
			"enUs": "Account",
			"thTh": "บัญชี",
			"idId": "Akun",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgNotModify",
			"classify": "Title",
			"zhCn": "添加后无法修改。",
			"zhTw": "",
			"enUs": "Cannot be modified after adding.",
			"thTh": "ไม่สามารถแก้ไขหลังจากเพิ่มสำเร็จ",
			"idId": "Tidak dapat diubah setelah ditambahkan.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAccountExist",
			"classify": "Title",
			"zhCn": "账号已存在。",
			"zhTw": "",
			"enUs": "Account already exists.",
			"thTh": "บัญชีมีอยู่แล้ว",
			"idId": "Akun sudah ada.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgRole",
			"classify": "Title",
			"zhCn": "角色",
			"zhTw": "",
			"enUs": "Role",
			"thTh": "บทบาท",
			"idId": "Peran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAuthoOrg",
			"classify": "Title",
			"zhCn": "授权组织",
			"zhTw": "",
			"enUs": "Authorized Organization",
			"thTh": "องค์กรที่ได้รับอนุญาต",
			"idId": "Organisasi yang Berwenang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgViewSub",
			"classify": "Title",
			"zhCn": "查看所选组织及其子组织的所有数据。",
			"zhTw": "",
			"enUs": "View all data for the selected organization and its sub-organizations.",
			"thTh": "ดูข้อมูลทั้งหมดสำหรับองค์กรที่เลือกและองค์กรย่อย",
			"idId": "Melihat semua data untuk organisasi yang dipilih dan sub-organisasinya.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgName",
			"classify": "Title",
			"zhCn": "名称",
			"zhTw": "",
			"enUs": "Name",
			"thTh": "ชื่อ",
			"idId": "Nama",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgPassword",
			"classify": "Title",
			"zhCn": "密码",
			"zhTw": "",
			"enUs": "Password",
			"thTh": "รหัสผ่าน",
			"idId": "Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgPassLength",
			"classify": "Text",
			"zhCn": "密码长度应介于 6 到 18 个字符之间",
			"zhTw": "",
			"enUs": "Password length should be between 6 to 18 characters",
			"thTh": "ความยาวรหัสผ่านควรอยู่ระหว่าง 6 ถึง 18 อักขระ",
			"idId": "Panjang kata sandi harus antara 6 hingga 18 karakter",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgMoreInfo",
			"classify": "Title",
			"zhCn": "更多信息",
			"zhTw": "",
			"enUs": "More Infomation",
			"thTh": "ข้อมูลเพิ่มเติม",
			"idId": "Informasi Lebih Lanjut",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgPhoneNo",
			"classify": "Title",
			"zhCn": "电话号码",
			"zhTw": "",
			"enUs": "Phone Number",
			"thTh": "หมายเลขโทรศัพท์",
			"idId": "Nomor Telepon",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgEmail",
			"classify": "Title",
			"zhCn": "邮箱",
			"zhTw": "",
			"enUs": "Email",
			"thTh": "อีเมล",
			"idId": "Email",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgUserCode",
			"classify": "Title",
			"zhCn": "用户编码",
			"zhTw": "",
			"enUs": "User Code",
			"thTh": "รหัสผู้ใช้",
			"idId": "Kode Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgUserCodeExist",
			"classify": "Toast",
			"zhCn": "用户编码已存在。",
			"zhTw": "",
			"enUs": "User Code already exists.",
			"thTh": "รหัสผู้ใช้ซ้ำกับที่มีอยู่แล้ว",
			"idId": "Kode Pengguna sudah ada.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSex",
			"classify": "Text",
			"zhCn": "性别",
			"zhTw": "",
			"enUs": "Gender",
			"thTh": "เพศ",
			"idId": "Jenis Kelamin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgFemale",
			"classify": "Text",
			"zhCn": "女",
			"zhTw": "",
			"enUs": "Female",
			"thTh": "หญิง",
			"idId": "Perempuan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgMale",
			"classify": "Text",
			"zhCn": "男",
			"zhTw": "",
			"enUs": "Male",
			"thTh": "ชาย",
			"idId": "Laki-laki",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgUnknown",
			"classify": "Text",
			"zhCn": "未知",
			"zhTw": "",
			"enUs": "Unknown",
			"thTh": "ไม่ทราบ",
			"idId": "Tidak diketahui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgEditUser",
			"classify": "Title",
			"zhCn": "编辑用户",
			"zhTw": "",
			"enUs": "Edit User",
			"thTh": "แก้ไขผู้ใช้",
			"idId": "Edit Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgUserDetail",
			"classify": "Title",
			"zhCn": "用户详细信息",
			"zhTw": "",
			"enUs": "User Detail",
			"thTh": "รายละเอียดผู้ใช้",
			"idId": "Detail Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDeleteUser",
			"classify": "Title",
			"zhCn": "删除用户",
			"zhTw": "",
			"enUs": "Delete User",
			"thTh": "ลบผู้ใช้",
			"idId": "Hapus Pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAccountc",
			"classify": "Text",
			"zhCn": "账号：",
			"zhTw": "",
			"enUs": "Account:",
			"thTh": "บัญชี:",
			"idId": "Akun:",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgDelUseCon",
			"classify": "Text",
			"zhCn": "已删除的用户无法恢复。是否继续？",
			"zhTw": "",
			"enUs": "Deleted user cannot be restored. Continue anyway?",
			"thTh": "ผู้ใช้ที่ถูกลบจะไม่สามารถกู้คืนได้ ดำเนินการต่อหรือไม่",
			"idId": "Pengguna yang dihapus tidak dapat dipulihkan. Lanjutkan saja?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basicTosOpsSuccess",
			"classify": "Toast",
			"zhCn": "操作成功",
			"zhTw": "",
			"enUs": "Operation Successful",
			"thTh": "ดำเนินการสำเร็จ",
			"idId": "Operasi Berhasil",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgResetPass",
			"classify": "Title",
			"zhCn": "重置密码",
			"zhTw": "",
			"enUs": "Reset Password",
			"thTh": "รีเซ็ตรหัสผ่าน",
			"idId": "Atur Ulang Kata Sandi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgResetPassFor",
			"classify": "Text",
			"zhCn": "您正在重新设置 {邮箱} 的密码",
			"zhTw": "",
			"enUs": "You are resetting the password for {邮箱}",
			"thTh": "คุณกำลังรีเซ็ตรหัสผ่านสำหรับ {邮箱}",
			"idId": "Anda mengatur ulang kata sandi untuk {邮箱}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgNewPass",
			"classify": "Title",
			"zhCn": "新密码",
			"zhTw": "",
			"enUs": "New Password",
			"thTh": "รหัสผ่านใหม่",
			"idId": "Kata Sandi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgNewPassFor",
			"classify": "Text",
			"zhCn": "您正在重新设置 {数字} 个账号的密码，包括 {邮箱}",
			"zhTw": "",
			"enUs": "You are reSettings the password for {数字} accounts, including {邮箱}",
			"thTh": "คุณกำลังรีเซ็ตรหัสผ่านสำหรับ {数字} บัญชี รวมถึง {邮箱}",
			"idId": "Anda mengatur ulang kata sandi untuk akun {数字}, termasuk {邮箱}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgChangeOrg",
			"classify": "Title",
			"zhCn": "更换组织",
			"zhTw": "",
			"enUs": "Change Organization",
			"thTh": "เปลี่ยนองค์กร",
			"idId": "Ubah Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgChangeOrgFor",
			"classify": "Text",
			"zhCn": "您正在更改 {数字} 个账号的组织，包括 {邮箱}",
			"zhTw": "",
			"enUs": "You are changing the organizations  for {数字} accounts, including {邮箱}",
			"thTh": "คุณกำลังเปลี่ยนองค์กรสำหรับ {数字} บัญชี รวมถึง {邮箱}",
			"idId": "Anda mengubah organisasi untuk akun {数字}, termasuk {邮箱}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgNewOrg",
			"classify": "Title",
			"zhCn": "新组织",
			"zhTw": "",
			"enUs": "New Organization",
			"thTh": "องค์กรใหม่",
			"idId": "Organisasi Baru",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgEnterpriseNo",
			"classify": "Toast",
			"zhCn": "您的企业账号目前不可用。请联系服务提供商获取支持。",
			"zhTw": "",
			"enUs": "Your enterprise account is currently unavailable.  Please contact your service provider for support.",
			"thTh": "ขณะนี้บัญชีองค์กรของคุณไม่สามารถใช้งานได้ โปรดติดต่อผู้ให้บริการเพื่อขอรับการสนับสนุน",
			"idId": "Akun perusahaan Anda saat ini tidak tersedia.  Silakan hubungi penyedia layanan Anda untuk mendapatkan dukungan.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAccNotExist",
			"classify": "Toast",
			"zhCn": "账号不存在。",
			"zhTw": "",
			"enUs": "Account does not exist.",
			"thTh": "บัญชีไม่มีอยู่",
			"idId": "Akun tidak ada.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgWrongPass",
			"classify": "Toast",
			"zhCn": "账号或密码不正确。请重试。",
			"zhTw": "",
			"enUs": "Incorrect account or password. Please try again.",
			"thTh": "บัญชีหรือรหัสผ่านไม่ถูกต้อง โปรดลองอีกครั้ง",
			"idId": "Akun atau kata sandi salah. Silakan coba lagi.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgWrongVerfi",
			"classify": "Toast",
			"zhCn": "验证码不正确。",
			"zhTw": "",
			"enUs": "Incorrect verification code.",
			"thTh": "รหัสยืนยันไม่ถูกต้อง",
			"idId": "Kode verifikasi salah.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgAccDisable",
			"classify": "Toast",
			"zhCn": "您的账号已被禁用。请联系支持人员。",
			"zhTw": "",
			"enUs": "Your account has been disabled. Please contact support.",
			"thTh": "บัญชีของคุณถูกปิดใช้งาน โปรดติดต่อฝ่ายสนับสนุน",
			"idId": "Akun Anda telah dinonaktifkan. Silakan hubungi dukungan.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgNoAccess",
			"classify": "Toast",
			"zhCn": "您尚无权访问任何模块。",
			"zhTw": "",
			"enUs": "You don’t have access to any modules yet.",
			"thTh": "คุณยังไม่สามารถเข้าถึงโมดูลใดๆ ได้",
			"idId": "Anda belum memiliki akses ke modul apa pun.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "userOrgSessionExpired",
			"classify": "Toast",
			"zhCn": "您的Session已过期。请重新登录。",
			"zhTw": "",
			"enUs": "Your session has expired. Please log in again.",
			"thTh": "เซสชันของคุณหมดอายุแล้ว โปรดเข้าสู่ระบบอีกครั้ง",
			"idId": "Sesi Anda telah kedaluwarsa. Silakan masuk lagi.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAddOrg",
			"classify": "Text",
			"zhCn": "添加组织",
			"zhTw": "",
			"enUs": "Add organization",
			"thTh": "เพิ่มองค์กร",
			"idId": "Tambah organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEditOrg",
			"classify": "Text",
			"zhCn": "编辑组织",
			"zhTw": "",
			"enUs": "Edit organization",
			"thTh": "แก้ไของค์กร",
			"idId": "Edit organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDelOrg",
			"classify": "Text",
			"zhCn": "删除组织",
			"zhTw": "",
			"enUs": "Delete organization",
			"thTh": "ลบองค์กร",
			"idId": "Hapus organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAddUser",
			"classify": "Text",
			"zhCn": "添加用户",
			"zhTw": "",
			"enUs": "Add user",
			"thTh": "เพิ่มผู้ใช้",
			"idId": "Tambah pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEditUser",
			"classify": "Text",
			"zhCn": "编辑用户",
			"zhTw": "",
			"enUs": "Edit user",
			"thTh": "แก้ไขผู้ใช้",
			"idId": "Mengedit pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDisUser",
			"classify": "Text",
			"zhCn": "禁用用户",
			"zhTw": "",
			"enUs": "Disable user",
			"thTh": "ปิดการใช้งานผู้ใช้",
			"idId": "Menonaktifkan pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDelUser",
			"classify": "Text",
			"zhCn": "删除用户",
			"zhTw": "",
			"enUs": "Delete user",
			"thTh": "ลบผู้ใช้",
			"idId": "Menghapus pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissResetUsePass",
			"classify": "Text",
			"zhCn": "重置用户密码",
			"zhTw": "",
			"enUs": "Reset user password",
			"thTh": "รีเซ็ตรหัสผ่านผู้ใช้",
			"idId": "Mengatur ulang kata sandi pengguna",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAll",
			"classify": "Text",
			"zhCn": "全部",
			"zhTw": "",
			"enUs": "All",
			"thTh": "ทั้งหมด",
			"idId": "Semua",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelSearch",
			"classify": "Button",
			"zhCn": "搜索",
			"zhTw": "",
			"enUs": "Search",
			"thTh": "ค้นหา",
			"idId": "Cari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAddModel",
			"classify": "Button",
			"zhCn": "添加型号",
			"zhTw": "",
			"enUs": "Add Model",
			"thTh": "เพิ่มรุ่นอุปกรณ์",
			"idId": "Tambahkan Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelPic",
			"classify": "Title",
			"zhCn": "图片",
			"zhTw": "",
			"enUs": "Picture",
			"thTh": "รูปภาพ",
			"idId": "Gambar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelUpdatedBy",
			"classify": "Title",
			"zhCn": "更新者",
			"zhTw": "",
			"enUs": "Updated By",
			"thTh": "อัปเดตโดย",
			"idId": "Diperbarui oleh",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelUpdatedTime",
			"classify": "Title",
			"zhCn": "最后更新时间",
			"zhTw": "",
			"enUs": "Last Updated Time",
			"thTh": "เวลาที่อัปเดตล่าสุด",
			"idId": "Waktu Terakhir Diperbarui",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAlarm",
			"classify": "Title",
			"zhCn": "告警",
			"zhTw": "",
			"enUs": "Alarm",
			"thTh": "การเตือน",
			"idId": "Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelDetail",
			"classify": "Button",
			"zhCn": "详情",
			"zhTw": "",
			"enUs": "Detail",
			"thTh": "รายละเอียด",
			"idId": "Detail",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAlarm",
			"classify": "Button",
			"zhCn": "告警",
			"zhTw": "",
			"enUs": "Alarm",
			"thTh": "การเตือน",
			"idId": "Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelDuplicate",
			"classify": "Button",
			"zhCn": "复制",
			"zhTw": "",
			"enUs": "Duplicate",
			"thTh": "ทำซ้ำ",
			"idId": "Duplikat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelEdit",
			"classify": "Button",
			"zhCn": "编辑",
			"zhTw": "",
			"enUs": "Edit",
			"thTh": "แก้ไข",
			"idId": "Edit",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelDelete",
			"classify": "Button",
			"zhCn": "删除",
			"zhTw": "",
			"enUs": "Delete",
			"thTh": "ลบ",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAddModel",
			"classify": "Title",
			"zhCn": "添加型号",
			"zhTw": "",
			"enUs": "Add Model",
			"thTh": "เพิ่มรุ่นอุปกรณ์",
			"idId": "Tambahkan Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelBasicInfo",
			"classify": "Title",
			"zhCn": "基本信息",
			"zhTw": "",
			"enUs": "Basic Infomation",
			"thTh": "ข้อมูลพื้นฐาน",
			"idId": "Informasi Dasar",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelModel",
			"classify": "Title",
			"zhCn": "型号",
			"zhTw": "",
			"enUs": "Model",
			"thTh": "รุ่นอุปกรณ์",
			"idId": "Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelDeviceType",
			"classify": "Title",
			"zhCn": "设备类型",
			"zhTw": "",
			"enUs": "Device Type",
			"thTh": "ประเภทอุปกรณ์",
			"idId": "Jenis Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelCommuProtocol",
			"classify": "Title",
			"zhCn": "通信协议",
			"zhTw": "",
			"enUs": "Communication Protocol",
			"thTh": "โปรโตคอลการสื่อสาร",
			"idId": "Protokol Komunikasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelManufacturer",
			"classify": "Title",
			"zhCn": "制造商",
			"zhTw": "",
			"enUs": "Manufacturer",
			"thTh": "ผู้ผลิต",
			"idId": "Produsen",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelDescription",
			"classify": "Title",
			"zhCn": "说明",
			"zhTw": "",
			"enUs": "Description",
			"thTh": "คำอธิบาย",
			"idId": "Deskripsi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelSeachPoint",
			"classify": "Text",
			"zhCn": "搜索测量点或ID",
			"zhTw": "",
			"enUs": "Search Measurement Point or ID",
			"thTh": "ค้นหาจุดตรวจวัดหรือ ID",
			"idId": "Cari Titik Pengukuran atau ID",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelId",
			"classify": "Title",
			"zhCn": "ID",
			"zhTw": "",
			"enUs": "ID",
			"thTh": "ID",
			"idId": "ID",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelType",
			"classify": "Title",
			"zhCn": "类型",
			"zhTw": "",
			"enUs": "Type",
			"thTh": "ประเภท",
			"idId": "Ketik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelFormat",
			"classify": "Title",
			"zhCn": "格式",
			"zhTw": "",
			"enUs": "Format",
			"thTh": "รูปแบบ",
			"idId": "Format",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelUnit",
			"classify": "Title",
			"zhCn": "单位",
			"zhTw": "",
			"enUs": "Unit",
			"thTh": "หน่วย",
			"idId": "Satuan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelEnumDef",
			"classify": "Title",
			"zhCn": "枚举定义",
			"zhTw": "",
			"enUs": "Enumeration Definition",
			"thTh": "นิยาม Enum",
			"idId": "Definisi Pencacahan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelCommuAddress",
			"classify": "Title",
			"zhCn": "通信地址",
			"zhTw": "",
			"enUs": "Communication Address",
			"thTh": "ที่อยู่การสื่อสาร",
			"idId": "Alamat Komunikasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelCalFactir",
			"classify": "Title",
			"zhCn": "计算因子",
			"zhTw": "",
			"enUs": "Calculation Factor",
			"thTh": "ค่าสัมประสิทธิ์",
			"idId": "Faktor Perhitungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAddPoint",
			"classify": "Title",
			"zhCn": "添加测量点",
			"zhTw": "",
			"enUs": "Add Measurement Point",
			"thTh": "เพิ่มจุดตรวจวัด",
			"idId": "Menambahkan Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelSearchPoint",
			"classify": "Text",
			"zhCn": "搜索测量点",
			"zhTw": "",
			"enUs": "Search Measurement Point",
			"thTh": "ค้นหาจุดตรวจวัด",
			"idId": "Cari Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelSearchPointIds",
			"classify": "Text",
			"zhCn": "搜索测量点 ID（以英文逗号分隔）",
			"zhTw": "",
			"enUs": "Search Measurement Point IDs (separated by commas)",
			"thTh": "ค้นหา ID จุดตรวจวัด (คั่นด้วยเครื่องหมายจุลภาค)",
			"idId": "Cari ID Titik Pengukuran (dipisahkan dengan koma)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelEditEnumDef",
			"classify": "Title",
			"zhCn": "编辑枚举定义",
			"zhTw": "",
			"enUs": "Edit Enumeration Definition",
			"thTh": "แก้ไขนิยาม Enum",
			"idId": "Edit Definisi Enumerasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelModelDetail",
			"classify": "Title",
			"zhCn": "模型详细信息",
			"zhTw": "",
			"enUs": "Model Detail",
			"thTh": "รายละเอียดรุ่นอุปกรณ์",
			"idId": "Detail Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelEditModel",
			"classify": "Title",
			"zhCn": "编辑模型",
			"zhTw": "",
			"enUs": "Edit Model",
			"thTh": "แก้ไขรุ่นอุปกรณ์",
			"idId": "Edit Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelDelModel",
			"classify": "Title",
			"zhCn": "删除模型",
			"zhTw": "",
			"enUs": "Delete Model",
			"thTh": "ลบรุ่นอุปกรณ์",
			"idId": "Hapus Model",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelModelC",
			"classify": "Text",
			"zhCn": "模型：",
			"zhTw": "",
			"enUs": "Model:",
			"thTh": "รุ่น:อุปกรณ์",
			"idId": "Model:",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelMustNotlink",
			"classify": "Text",
			"zhCn": "删除前模型不得链接到任何设备。",
			"zhTw": "",
			"enUs": "The model must not be linked to any devices before deletion.",
			"thTh": "รุ่นอุปกรณ์ต้องไม่เชื่อมโยงรุ่นกับอุปกรณ์ใดๆ ก่อนลบ",
			"idId": "Model tidak boleh ditautkan ke perangkat apa pun sebelum dihapus.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelDelSure",
			"classify": "Text",
			"zhCn": "您确定要删除吗？",
			"zhTw": "",
			"enUs": "Are you sure to delete?",
			"thTh": "คุณแน่ใจว่าจะลบหรือไม่",
			"idId": "Apakah Anda yakin untuk menghapus?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAlarmSet",
			"classify": "Title",
			"zhCn": "告警设置",
			"zhTw": "",
			"enUs": "Alarm Settings",
			"thTh": "ตั้งค่าการเตือน",
			"idId": "Pengaturan Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAdd",
			"classify": "Button",
			"zhCn": "添加",
			"zhTw": "",
			"enUs": "Add",
			"thTh": "เพิ่ม",
			"idId": "Tambah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAlarmUpdate",
			"classify": "Text",
			"zhCn": "由{更新人}于{时间}更新",
			"zhTw": "",
			"enUs": "Updated by {更新人} on {时间} ",
			"thTh": "อัปเดตโดย {更新人} เมื่อ {时间}",
			"idId": "Diperbarui oleh {更新人} pada {时间} ",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelNo",
			"classify": "Title",
			"zhCn": "序号",
			"zhTw": "",
			"enUs": "No",
			"thTh": "ลำดับ",
			"idId": "Tidak",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelPoint",
			"classify": "Title",
			"zhCn": "测量点",
			"zhTw": "",
			"enUs": "Measurement Point",
			"thTh": "จุดตรวจวัด",
			"idId": "Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAlarmType",
			"classify": "Title",
			"zhCn": "警报类型",
			"zhTw": "",
			"enUs": "Alarm Type",
			"thTh": "ประเภทการเตือน",
			"idId": "Jenis Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelThreshold",
			"classify": "Title",
			"zhCn": "阈值",
			"zhTw": "",
			"enUs": "Threshold",
			"thTh": "ค่าเกณฑ์",
			"idId": "Ambang Batas",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAlarmLevel",
			"classify": "Title",
			"zhCn": "警报级别",
			"zhTw": "",
			"enUs": "Alarm Level",
			"thTh": "ระดับการเตือน",
			"idId": "Tingkat Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAction",
			"classify": "Title",
			"zhCn": "操作",
			"zhTw": "",
			"enUs": "Action",
			"thTh": "ดำเนินการ",
			"idId": "Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelExceedUp",
			"classify": "Text",
			"zhCn": "超上限",
			"zhTw": "",
			"enUs": "Exceed upper limit",
			"thTh": "เกินขีดจำกัดบน",
			"idId": "Melebihi batas atas",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelExceedUpUp",
			"classify": "Text",
			"zhCn": "超上上限",
			"zhTw": "",
			"enUs": "Exceed critical limit",
			"thTh": "เกินขีดจำกัดวิกฤต",
			"idId": "Melebihi batas kritis",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelBelowLow",
			"classify": "Text",
			"zhCn": "超下限",
			"zhTw": "",
			"enUs": "Below lower limit",
			"thTh": "ต่ำกว่าขีดจำกัดล่าง",
			"idId": "Di bawah batas bawah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelBelowLowLow",
			"classify": "Text",
			"zhCn": "超下下限",
			"zhTw": "",
			"enUs": "Below critical limit",
			"thTh": "ต่ำกว่าขีดจำกัดวิกฤต",
			"idId": "Di bawah batas kritis",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelAbStat",
			"classify": "Text",
			"zhCn": "状态异常",
			"zhTw": "",
			"enUs": "Status abnormal",
			"thTh": "สถานะผิดปกติ",
			"idId": "Status tidak normal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelMinor",
			"classify": "Text",
			"zhCn": "一般",
			"zhTw": "",
			"enUs": "Minor",
			"thTh": "ทั่วไป",
			"idId": "Kecil",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelCritical",
			"classify": "Text",
			"zhCn": "严重",
			"zhTw": "",
			"enUs": "Critical",
			"thTh": "รุนแรง",
			"idId": "Kritis",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "modelEmer",
			"classify": "Text",
			"zhCn": "紧急",
			"zhTw": "",
			"enUs": "Emergency",
			"thTh": "ฉุกเฉิน",
			"idId": "Darurat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissAddModel",
			"classify": "Text",
			"zhCn": "添加设备型号",
			"zhTw": "",
			"enUs": "Add device model",
			"thTh": "เพิ่มรุ่นอุปกรณ์",
			"idId": "Menambah model perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissEditModel",
			"classify": "Text",
			"zhCn": "编辑设备型号",
			"zhTw": "",
			"enUs": "Edit device model",
			"thTh": "แก้ไขรุ่นอุปกรณ์",
			"idId": "Mengedit model perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDelModel",
			"classify": "Text",
			"zhCn": "删除设备型号",
			"zhTw": "",
			"enUs": "Delete device model",
			"thTh": "ลบรุ่นอุปกรณ์",
			"idId": "Menghapus model perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecActive",
			"classify": "Button",
			"zhCn": "活动",
			"zhTw": "",
			"enUs": "Active",
			"thTh": "กำลังดำเนินการ",
			"idId": "Aktif",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecHistory",
			"classify": "Button",
			"zhCn": "历史记录",
			"zhTw": "",
			"enUs": "History",
			"thTh": "ประวัติ",
			"idId": "Sejarah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecStartTime",
			"classify": "Title",
			"zhCn": "开始时间",
			"zhTw": "",
			"enUs": "Start Time",
			"thTh": "เวลาเริ่มต้น",
			"idId": "Waktu Mulai",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAll",
			"classify": "Title",
			"zhCn": "全部",
			"zhTw": "",
			"enUs": "All",
			"thTh": "ทั้งหมด",
			"idId": "Semua",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecMinor",
			"classify": "Title",
			"zhCn": "一般",
			"zhTw": "",
			"enUs": "Minor",
			"thTh": "ทั่วไป",
			"idId": "Kecil",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecCritical",
			"classify": "Title",
			"zhCn": "严重",
			"zhTw": "",
			"enUs": "Critical",
			"thTh": "รุนแรง",
			"idId": "Kritis",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecEmer",
			"classify": "Title",
			"zhCn": "紧急",
			"zhTw": "",
			"enUs": "Emergency",
			"thTh": "ฉุกเฉิน",
			"idId": "Darurat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecSearch",
			"classify": "Button",
			"zhCn": "搜索",
			"zhTw": "",
			"enUs": "Search",
			"thTh": "ค้นหา",
			"idId": "Cari",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecExport",
			"classify": "Button",
			"zhCn": "导出",
			"zhTw": "",
			"enUs": "Export",
			"thTh": "ส่งออก",
			"idId": "Ekspor",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecActiveHeader",
			"classify": "Text",
			"zhCn": "进行中告警记录",
			"zhTw": "",
			"enUs": "Active Alarm Records",
			"thTh": "บันทึกการเตือนที่ดำเนินการอยู่",
			"idId": "Catatan Alarm Aktif",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAction",
			"classify": "Title",
			"zhCn": "操作",
			"zhTw": "",
			"enUs": "Action",
			"thTh": "ดำเนินการ",
			"idId": "Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecClear",
			"classify": "Button",
			"zhCn": "清除",
			"zhTw": "",
			"enUs": "Clear",
			"thTh": "ล้าง",
			"idId": "Hapus",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAlarmClear",
			"classify": "Title",
			"zhCn": "告警清除",
			"zhTw": "",
			"enUs": "Alarm Clearance",
			"thTh": "ล้างการเตือน",
			"idId": "Izin Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAlarmClearCon",
			"classify": "Text",
			"zhCn": "问题可能仍然存在，是否强制清除所选告警？",
			"zhTw": "",
			"enUs": "The issue may still be active. Do you want to forcibly clear the selected alarm(s)?",
			"thTh": "ปัญหาอาจยังคงเกิดขึ้นอยู่ คุณต้องการล้างการเตือนที่เลือกหรือไม่",
			"idId": "Masalah mungkin masih aktif. Apakah Anda ingin menghapus secara paksa alarm yang dipilih?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecCancel",
			"classify": "Button",
			"zhCn": "取消",
			"zhTw": "",
			"enUs": "Cancel",
			"thTh": "ยกเลิก",
			"idId": "Batal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecConfirm",
			"classify": "Button",
			"zhCn": "确认",
			"zhTw": "",
			"enUs": "Confirm",
			"thTh": "ยืนยัน",
			"idId": "Konfirmasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecHisAlarmRec",
			"classify": "Text",
			"zhCn": "历史告警记录",
			"zhTw": "",
			"enUs": "Historical Alarm Records",
			"thTh": "ประวัติการเตือน",
			"idId": "Catatan Alarm Historis",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecDeviceName",
			"classify": "Title",
			"zhCn": "设备名称",
			"zhTw": "",
			"enUs": "Device Name",
			"thTh": "ชื่ออุปกรณ์",
			"idId": "Nama Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAlarmLevel",
			"classify": "Title",
			"zhCn": "告警等级",
			"zhTw": "",
			"enUs": "Alarm Level",
			"thTh": "ระดับการเตือน",
			"idId": "Tingkat Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAlarmContent",
			"classify": "Title",
			"zhCn": "告警内容",
			"zhTw": "",
			"enUs": "Alarm Content",
			"thTh": "เนื้อหาการเตือน",
			"idId": "Konten Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAlarmTime",
			"classify": "Title",
			"zhCn": "告警起始时间",
			"zhTw": "",
			"enUs": "Alarm Start Time",
			"thTh": "เวลาเริ่มต้นการเตือน",
			"idId": "Waktu Mulai Alarm",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecClearTime",
			"classify": "Title",
			"zhCn": "清除时间",
			"zhTw": "",
			"enUs": "Clearance Time",
			"thTh": "เวลาล้างการเตือน",
			"idId": "Waktu Izin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecDeviceSn",
			"classify": "Title",
			"zhCn": "设备SN",
			"zhTw": "",
			"enUs": "Device SN",
			"thTh": "หมายเลข SN ของอุปกรณ์",
			"idId": "SN Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecDeviceType",
			"classify": "Title",
			"zhCn": "设备类型",
			"zhTw": "",
			"enUs": "Device Type",
			"thTh": "ประเภทอุปกรณ์",
			"idId": "Jenis Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecOrg",
			"classify": "Title",
			"zhCn": "组织",
			"zhTw": "",
			"enUs": "Organization",
			"thTh": "องค์กร",
			"idId": "Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecClearType",
			"classify": "Title",
			"zhCn": "清除类型",
			"zhTw": "",
			"enUs": "Clearance Type",
			"thTh": "ประเภทการล้าง",
			"idId": "Jenis Izin",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecFaultyRecov",
			"classify": "Text",
			"zhCn": "故障恢复",
			"zhTw": "",
			"enUs": "Faulty recovery",
			"thTh": "กู้คืนความผิดพลาด",
			"idId": "Pemulihan yang salah",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecManualRecov",
			"classify": "Text",
			"zhCn": "手动处理",
			"zhTw": "",
			"enUs": "Manual handling",
			"thTh": "การจัดการด้วยตนเอง",
			"idId": "Penanganan manual",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecManualBy",
			"classify": "Text",
			"zhCn": "由{处理人}手动处理",
			"zhTw": "",
			"enUs": "Manually handled by {处理人}",
			"thTh": "จัดการโดย {处理人}",
			"idId": "Ditangani secara manual oleh {处理人}",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecExceedUp",
			"classify": "Text",
			"zhCn": "{测点名称}超出上限。当前：{当前值}{测点单位}，阈值：{阈阈值}{测点单位}。",
			"zhTw": "",
			"enUs": "{测点名称}  exceeded the upper limit. Current: {当前值}{测点单位}, Threshold:  {告警阈值}{测点单位}.",
			"thTh": "{测点名称} เกินขีดจำกัดบน ปัจจุบัน: {当前值}{测点单位}, ขีดจำกัด: {告警阈值}{测点单位}.",
			"idId": "{测点名称} melebihi batas atas. Saat ini: {当前值} {测点单位}, Ambang batas:  {LAPORAN NILAI} {测点单位}.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecExceedUpUp",
			"classify": "Text",
			"zhCn": "{测点名称}超出上上限。当前：{当前值}{测点单位}，阈值：{阈阈值}{测点单位}。",
			"zhTw": "",
			"enUs": "{测点名称}  exceeded the critical limit. Current: {当前值}{测点单位}, Threshold:  {告警阈值}{测点单位}.",
			"thTh": "{测点名称} เกินขีดจำกัดวิกฤติ ปัจจุบัน: {当前值}{测点单位}, ขีดจำกัด: {告警阈值}{测点单位}.",
			"idId": "{测点名称} melebihi batas kritis. Saat ini: {当前值}{测点单位}, Ambang batas:  {LAPORAN NILAI} {测点单位}.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecExceedLow",
			"classify": "Text",
			"zhCn": "{测点名称}超出下限。当前：{当前值}{测点单位}，阈值：{阈阈值}{测点单位}。",
			"zhTw": "",
			"enUs": "{测点名称} dropped below the lower limit. Current: {当前值}{测点单位}, Threshold:  {告警阈值}{测点单位}.",
			"thTh": "{测点名称} ลดลงต่ำกว่าขีดจำกัดล่าง ปัจจุบัน: {当前值}{测点单位}, ขีดจำกัด: {告警阈值}{测点单位}.",
			"idId": "{测点名称} turun di bawah batas bawah. Saat ini: {当前值}{测点单位}, Ambang batas:  {LAPORAN NILAI} {测点单位}.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecExceedLowLow",
			"classify": "Text",
			"zhCn": "{测点名称}超出下下限。当前：{当前值}{测点单位}，阈值：{阈阈值}{测点单位}。",
			"zhTw": "",
			"enUs": "{测点名称}  dropped below the critical limit. Current: {当前值}{测点单位}, Threshold:  {告警阈值}{测点单位}.",
			"thTh": "{测点名称} ลดลงต่ำกว่าขีดจำกัดวิกฤต ปัจจุบัน: {当前值}{测点单位}, ขีดจำกัด: {告警阈值}{测点单位}.",
			"idId": "{测点名称} turun di bawah batas kritis. Saat ini: {当前值}{测点单位}, Ambang batas:  {LAPORAN NILAI} {测点单位}.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecAbnormalStat",
			"classify": "Text",
			"zhCn": "{测点名称}的状态异常。",
			"zhTw": "",
			"enUs": "{测点名称} status is abnormal.",
			"thTh": "{测点名称} มีสถานะผิดปกติ",
			"idId": "Status {测点名称} tidak normal.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "alarmRecCommuDisrupt",
			"classify": "Text",
			"zhCn": "{网关/设备}通信中断。",
			"zhTw": "",
			"enUs": "The {网关/设备} communication interrupted.",
			"thTh": "การสื่อสารของ {网关/设备} ถูกตัด",
			"idId": "Komunikasi {网关/设备} terputus.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDefault",
			"classify": "Text",
			"zhCn": "默认",
			"zhTw": "",
			"enUs": "Default",
			"thTh": "ค่าเริ่มต้น",
			"idId": "Default",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissExport",
			"classify": "Text",
			"zhCn": "导出",
			"zhTw": "",
			"enUs": "Export",
			"thTh": "ส่งออก",
			"idId": "Ekspor",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowDimension",
			"classify": "label",
			"zhCn": "维度",
			"zhTw": "",
			"enUs": "Dimension",
			"thTh": "มิติ",
			"idId": "Dimensi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowAreaEng",
			"classify": "label",
			"zhCn": "区域能耗",
			"zhTw": "",
			"enUs": "Area Energy Consumption",
			"thTh": "การใช้พลังงานตามพื้นที่",
			"idId": "Konsumsi Energi Area",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowPowerDis",
			"classify": "label",
			"zhCn": "配电",
			"zhTw": "",
			"enUs": "Power Distribution",
			"thTh": "การจ่ายไฟฟ้า",
			"idId": "Distribusi Daya",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowGrid",
			"classify": "label",
			"zhCn": "市电",
			"zhTw": "",
			"enUs": "Grid",
			"thTh": "ไฟฟ้าโครงข่าย",
			"idId": "Jaringan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowOrg",
			"classify": "label",
			"zhCn": "组织",
			"zhTw": "",
			"enUs": "Organization",
			"thTh": "องค์กร",
			"idId": "Organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowEditLoss",
			"classify": "label",
			"zhCn": "编辑损耗数值",
			"zhTw": "",
			"enUs": "Edit Loss Threshold",
			"thTh": "แก้ไขเกณฑ์การสูญเสีย",
			"idId": "Edit Ambang Kerugian",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowLossNo",
			"classify": "label",
			"zhCn": "损耗数值",
			"zhTw": "",
			"enUs": "Loss Threshold",
			"thTh": "เกณฑ์การสูญเสีย",
			"idId": "Ambang Kerugian",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowWrongLossNo",
			"classify": "label",
			"zhCn": "损耗数值应介于 0.01 - 100% 之间",
			"zhTw": "",
			"enUs": "Loss Threshold should be between 0.01 - 100%",
			"thTh": "เกณฑ์การสูญเสียควรอยู่ระหว่าง 0.01 - 100%",
			"idId": "Ambang Kerugian harus berada di antara 0,01 - 100%",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowNoLoss",
			"classify": "label",
			"zhCn": "无损耗",
			"zhTw": "",
			"enUs": "No Loss",
			"thTh": "ไม่สูญเสีย",
			"idId": "Tidak Ada Kerugian",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowNormalLoss",
			"classify": "label",
			"zhCn": "正常损耗",
			"zhTw": "",
			"enUs": "Normal Loss",
			"thTh": "สูญเสียปกติ",
			"idId": "Kerugian Normal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowExcessLoss",
			"classify": "label",
			"zhCn": "过大损耗",
			"zhTw": "",
			"enUs": "Excessive Loss",
			"thTh": "สูญเสียมากเกินไป",
			"idId": "Kerugian Berlebihan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowAbnormalLoss",
			"classify": "label",
			"zhCn": "数据异常",
			"zhTw": "",
			"enUs": "Abnormal Data",
			"thTh": "ข้อมูลผิดปกติ",
			"idId": "Data Abnormal",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowComsump",
			"classify": "label",
			"zhCn": "能耗",
			"zhTw": "",
			"enUs": "Consumption",
			"thTh": "การใช้พลังงาน",
			"idId": "Konsumsi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowProportion",
			"classify": "label",
			"zhCn": "占比",
			"zhTw": "",
			"enUs": "Proportion",
			"thTh": "สัดส่วน",
			"idId": "Proporsi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowLoss",
			"classify": "label",
			"zhCn": "损耗",
			"zhTw": "",
			"enUs": "Loss",
			"thTh": "สูญเสีย",
			"idId": "Kerugian",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowExcess",
			"classify": "label",
			"zhCn": "多余",
			"zhTw": "",
			"enUs": "Excess",
			"thTh": "ส่วนเกิน",
			"idId": "Kelebihan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "energyFlowBackPage",
			"classify": "label",
			"zhCn": "返回上一页",
			"zhTw": "",
			"enUs": "Back to previous page",
			"thTh": "กลับไปยังหน้าก่อนหน้า",
			"idId": "Kembali ke halaman sebelumnya",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permissDefault",
			"classify": "label",
			"zhCn": "默认",
			"zhTw": "",
			"enUs": "Default",
			"thTh": "ค่าเริ่มต้น",
			"idId": "Default",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "permisssSetLossNo",
			"classify": "label",
			"zhCn": "设置损耗数值",
			"zhTw": "",
			"enUs": "Set loss threshold",
			"thTh": "ตั้งค่าเกณฑ์การสูญเสีย",
			"idId": "Tetapkan ambang kerugian",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "dimensionAllAuthNode",
			"classify": "Text",
			"zhCn": "所有授权组织",
			"zhTw": "",
			"enUs": "All Authorized Organization",
			"thTh": "องค์กรที่มีสิทธิ์ทั้งหมด",
			"idId": "Semua otoritas",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "maxLength10Digits",
			"classify": "tips",
			"zhCn": "请填写10位以内数字字符",
			"zhTw": "請填寫10位以內數字字符",
			"enUs": "Please fill in 10 digits or less",
			"thTh": "กรุณากรอกตัวเลขภายใน10หลัก",
			"idId": "Silakan isi karakter angka dalam 10 digit",
			"esMx": "Por favor complete caracteres numéricos dentro de 10 dígitos",
			"viVi": "Vui lòng điền các ký tự số trong vòng 10 chữ số",
			"ptPt": "Preencha os caracteres numéricos dentro de 10 dígitos"
		},
		{
			"textKey": "endTime",
			"classify": "label",
			"zhCn": "结束时间",
			"zhTw": "結束時間",
			"enUs": "End Time",
			"thTh": "เวลาสิ้นสุด",
			"idId": "Waktu akhir",
			"esMx": "Tiempo de finalización",
			"viVi": "Thời gian kết thúc",
			"ptPt": "Hora do fim"
		},
		{
			"textKey": "plzInputValidateLatitude",
			"classify": "tips",
			"zhCn": "请输入正确的纬度",
			"zhTw": "請輸入正確的緯度",
			"enUs": "Please enter the correct latitude",
			"thTh": "กรุณาใส่ละติจูดที่ถูกต้อง",
			"idId": "Masukkan lintang yang benar",
			"esMx": "Introduzca la latitud correcta",
			"viVi": "Vui lòng nhập đúng vĩ độ",
			"ptPt": "Por favor, insira a latitude correta"
		},
		{
			"textKey": "plzInputValidateLongitude",
			"classify": "tips",
			"zhCn": "请输入正确的经度",
			"zhTw": "請輸入正確的經度",
			"enUs": "Please enter the correct longitude",
			"thTh": "โปรดป้อนลองจิจูดที่ถูกต้อง",
			"idId": "Masukkan garis bujur yang benar",
			"esMx": "Introduzca la longitud correcta",
			"viVi": "Vui lòng nhập kinh độ chính xác",
			"ptPt": "Por favor, insira a longitude correta"
		},
		{
			"textKey": "goToSetting",
			"classify": "btn",
			"zhCn": "去设置",
			"zhTw": "去設置",
			"enUs": "Go to Settings",
			"thTh": "ไปที่การตั้งค่า",
			"idId": "Pergi ke pengaturan",
			"esMx": "Ir a la configuración",
			"viVi": "Đi đến thiết lập",
			"ptPt": "Vá para as configurações"
		},
		{
			"textKey": "configNodeTypeFirst",
			"classify": "tips",
			"zhCn": "关联设备，请先配置节点类型。",
			"zhTw": "關聯設備,請先配置節點類型。",
			"enUs": "To associate a device, configure the node type first.",
			"thTh": "สำหรับอุปกรณ์ที่เกี่ยวข้องโปรดกำหนดค่าประเภทโหนดก่อน",
			"idId": "Untuk menghubungkan perangkat, konfigurasikan tipe node terlebih dahulu.",
			"esMx": "Para asociar el dispositivo, configure primero el tipo de nodo.",
			"viVi": "Để liên quan đến thiết bị, vui lòng cấu hình loại nút trước.",
			"ptPt": "Para associar o dispositivo, primeiro configure o tipo de nó."
		},
		{
			"textKey": "maxLength5Digits",
			"classify": "tips",
			"zhCn": "请填写5位以内数字字符",
			"zhTw": "請填寫5位以內數字字符",
			"enUs": "Please fill in 5 digits or less",
			"thTh": "กรุณากรอกตัวเลขภายใน5หลัก",
			"idId": "Silakan isi karakter angka dalam 5 digit",
			"esMx": "Por favor complete caracteres numéricos de 5 dígitos",
			"viVi": "Vui lòng điền các ký tự số trong vòng 5 chữ số",
			"ptPt": "Preencha os caracteres numéricos dentro de 5 dígitos"
		},
		{
			"textKey": "maxLength10Digits3points",
			"classify": "tips",
			"zhCn": "请填写10位以内数字字符，可包含3位小数。",
			"zhTw": "請填寫10位以內數字字符,可包含3位小數。",
			"enUs": "Please fill in the number characters within 10 digits, including 3 decimal places.",
			"thTh": "กรุณากรอกอักขระตัวเลขภายใน10หลักซึ่งสามารถรวมทศนิยมได้3หลัก",
			"idId": "Silakan isi karakter angka dalam 10 digit, yang dapat berisi 3 desimal.",
			"esMx": "Complete los caracteres numéricos de 10 dígitos, que pueden contener 3 decimales.",
			"viVi": "Vui lòng điền các ký tự số trong vòng 10 chữ số, có thể chứa 3 chữ số thập phân.",
			"ptPt": "Preencha os caracteres numéricos de menos de 10 dígitos, que podem conter 3 decimais."
		},
		{
			"textKey": "deviceTypeCode",
			"classify": "Title",
			"zhCn": "设备类型明细",
			"zhTw": "設備類型明細",
			"enUs": "Equipment Type Details",
			"thTh": "รายละเอียดประเภทอุปกรณ์",
			"idId": "Detail Jenis Peralatan",
			"esMx": "Detalles del tipo de equipo",
			"viVi": "Chi tiết loại thiết bị",
			"ptPt": "Detalhes do tipo de equipamento"
		},
		{
			"textKey": "deviceDataId",
			"classify": "Text",
			"zhCn": "数据ID",
			"zhTw": "數據ID",
			"enUs": "Data ID",
			"thTh": "ID ข้อมูล",
			"idId": "ID Data",
			"esMx": "ID de datos",
			"viVi": "ID dữ liệu",
			"ptPt": "ID dos dados"
		},
		{
			"textKey": "billingTenantBatchClosePromptA",
			"classify": "Text",
			"zhCn": "部分已选择的租户不支持“销户&quot;操作。只有处于“开户&quot;状态的租户才能被关闭",
			"zhTw": "",
			"enUs": "Some selected tenants do not support the 'Close Account' operation. Only tenants in the 'opened' status can be closed.",
			"thTh": "ผู้เช่าที่เลือกบางรายไม่รองรับการ\"ยกเลิกบัญชี\" สามารถยกเลิกได้เฉพาะผู้เช่าที่อยู่ในสถานะ \"เปิดบัญชีแล้ว\" เท่านั้น",
			"idId": "Beberapa penyewa yang terpilih tidak didukung untuk tindakan 'Penutupan Akun'. Hanya penyewa dengan status 'Terbuka' yang dapat ditutup.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenant",
			"classify": "Title",
			"zhCn": "租户管理",
			"zhTw": "",
			"enUs": "Tenant Management",
			"thTh": "การจัดการผู้เช่า",
			"idId": "Tenant Manaagement",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingRate",
			"classify": "Title",
			"zhCn": "费率方案",
			"zhTw": "",
			"enUs": "Rate Plan",
			"thTh": "การคิดอัตราราคา",
			"idId": "Rencana Tarif",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingDash",
			"classify": "Title",
			"zhCn": "电费看板",
			"zhTw": "",
			"enUs": "Electricity Bill Dashboard",
			"thTh": "แดชบอร์ดค่าไฟฟ้า",
			"idId": "Dasbor Tagihan Listrik",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingExclide",
			"classify": "Button",
			"zhCn": "不包括子组织的租户",
			"zhTw": "",
			"enUs": "Exclude tenant of sub-organizations",
			"thTh": "ไม่รวมผู้เช่าขององค์กรย่อย",
			"idId": "Keluarkan Tenant dari sub-organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingInclude",
			"classify": "Button",
			"zhCn": "包括子组织的租户",
			"zhTw": "",
			"enUs": "Include tenant of sub-organizations",
			"thTh": "รวมผู้เช่าขององค์กรย่อย",
			"idId": "Masukkan Tenant dari sub-organisasi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingBatchClose",
			"classify": "Button",
			"zhCn": "批量关闭",
			"zhTw": "",
			"enUs": "Batch Account Closing",
			"thTh": "ปิดบัญชีหลายรายการ",
			"idId": "Penutupan Akun Berkelompok",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingStatusNot",
			"classify": "Text",
			"zhCn": "未开户",
			"zhTw": "",
			"enUs": "Not opened",
			"thTh": "ยังไม่เปิดบัญชี",
			"idId": "Belum Dibuka",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingStatusOpen",
			"classify": "Text",
			"zhCn": "已开户",
			"zhTw": "",
			"enUs": "Opened",
			"thTh": "เปิดบัญชีแล้ว",
			"idId": "Telah Dibuka",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingStatusClosed",
			"classify": "Text",
			"zhCn": "已销户",
			"zhTw": "",
			"enUs": "Closed",
			"thTh": "ยกเลิกบัญชีแล้ว",
			"idId": "Ditutup",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAddTenant",
			"classify": "Title",
			"zhCn": "新增租户",
			"zhTw": "",
			"enUs": "Add Tenant",
			"thTh": "เพิ่มผู้เช่า",
			"idId": "Tambahkan Tenant",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantNo",
			"classify": "Text",
			"zhCn": "租户编号",
			"zhTw": "",
			"enUs": "Tenant No.",
			"thTh": "หมายเลขผู้เช่า",
			"idId": "Nomor Tenant",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantName",
			"classify": "Text",
			"zhCn": "名称",
			"zhTw": "",
			"enUs": "Name",
			"thTh": "ชื่อ",
			"idId": "Nama",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantCompany",
			"classify": "Text",
			"zhCn": "公司",
			"zhTw": "",
			"enUs": "Company",
			"thTh": "บริษัท",
			"idId": "Perusahaan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantTaxID",
			"classify": "Text",
			"zhCn": "税收ID",
			"zhTw": "",
			"enUs": "Taxpayer ID",
			"thTh": "หมายเลขประจำตัวผู้เสียภาษี",
			"idId": "NPWP",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantContractID",
			"classify": "Text",
			"zhCn": "合同ID",
			"zhTw": "",
			"enUs": "Contract ID",
			"thTh": "หมายเลขสัญญา",
			"idId": "Nomor Kontrak",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingEditTenant",
			"classify": "Title",
			"zhCn": "编辑租户",
			"zhTw": "",
			"enUs": "Edit Tenant",
			"thTh": "แก้ไขผู้เช่า",
			"idId": "Ubah Tenant",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDevice",
			"classify": "Title",
			"zhCn": "关联设备",
			"zhTw": "",
			"enUs": "Associated Device",
			"thTh": "เชื่อมโยงอุปกรณ์",
			"idId": "Perangkat yang Terhubung",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceTime",
			"classify": "Text",
			"zhCn": "关联时间",
			"zhTw": "",
			"enUs": "Associated Time",
			"thTh": "เวลาที่เชื่อมโยง",
			"idId": "Waktu yang Dihubungkan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceUnasso",
			"classify": "Title",
			"zhCn": "取消关联",
			"zhTw": "",
			"enUs": "Disassociate",
			"thTh": "ยกเลิกการเชื่อมโยง",
			"idId": "Lepaskan Hubungan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceAddAddPrompt",
			"classify": "Text",
			"zhCn": "已关联的设备不支持关联",
			"zhTw": "",
			"enUs": "Associated devices are not supported for association",
			"thTh": "อุปกรณ์ที่เชื่อมโยงแล้ว ไม่สามารถเชื่อมโยงได้อีก",
			"idId": "Perangkat ini sudah dihubungkan dan tidak dapat dihubungkan lagi.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceAddAdd",
			"classify": "Title",
			"zhCn": "新增关联设备",
			"zhTw": "",
			"enUs": "Add Associated Device",
			"thTh": "เพิ่มอุปกรณ์ที่เชื่อมโยง",
			"idId": "Tambahkan Perangkat yang Terhubung",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceNext",
			"classify": "Button",
			"zhCn": "下一步",
			"zhTw": "",
			"enUs": "Next",
			"thTh": "ถัดไป",
			"idId": "Berikutnya",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceBack",
			"classify": "Button",
			"zhCn": "上一步",
			"zhTw": "",
			"enUs": "Back",
			"thTh": "ย้อนกลับ",
			"idId": "Kembali",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceOpenPrompt",
			"classify": "Text",
			"zhCn": "设备绑定成功，是否对该租户进行开户操作？",
			"zhTw": "",
			"enUs": "The device binding was successful. Would you like to initiate the open process?",
			"thTh": "เชื่อมโยงอุปกรณ์สำเร็จ ต้องการเปืดบัญชีผู้เช่าเลยหรือไม่",
			"idId": "Pengikatan perangkat berhasil. Apakah Anda ingin memulai proses pembukaan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceNotOpen",
			"classify": "Button",
			"zhCn": "不开户",
			"zhTw": "",
			"enUs": "Not Open",
			"thTh": "ไม่เปิดบัญชี",
			"idId": "Tidak Dibuka",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceSelect",
			"classify": "Text",
			"zhCn": "测量点选择",
			"zhTw": "",
			"enUs": "Measurement Point Select",
			"thTh": "เลือกจุดตรวจวัด",
			"idId": "Pilih Titik Pengukuran",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDevicePrompt2",
			"classify": "Toast",
			"zhCn": "已选测量点已被绑定，请检查",
			"zhTw": "",
			"enUs": "The selected measurement points have been bound. Please check",
			"thTh": "จุดตรวจวัดที่เลือกถูกเชื่อมโยงแล้ว โปรดตรวจสอบ",
			"idId": "Titik pengukuran yang dipilih telah terhubung. Silakan periksa.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceAddAddAsso",
			"classify": "Text",
			"zhCn": "已关联",
			"zhTw": "",
			"enUs": "Associated",
			"thTh": "เชื่อมโยงแล้ว",
			"idId": "Terhubung",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingAssoDeviceAddAddPromptA",
			"classify": "Text",
			"zhCn": "取消关联后，此电表将不再包括在租户的电费帐单中，是否继续？",
			"zhTw": "",
			"enUs": "After the meter is disassociated, it will no longer be included in the tenant's electricity billing. Do you want to continue?",
			"thTh": "หลังจากยกเลิกการเชื่อมโยงแล้ว มิเตอร์นี้จะไม่ใช้คิดค่าไฟฟ้าของผู้เช่าอีกต่อไป คุณต้องการดำเนินการต่อหรือไม่",
			"idId": "Setelah pemutusan sambungan, alat ukur ini tidak akan dimasukkan ke dalam tagihan listrik penyewa. Lanjutkan?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantClose",
			"classify": "Title",
			"zhCn": "销户",
			"zhTw": "",
			"enUs": "Close",
			"thTh": "ยกเลิกบัญชี",
			"idId": "Tutup",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantOpen",
			"classify": "Button",
			"zhCn": "开户",
			"zhTw": "",
			"enUs": "Open",
			"thTh": "เปิดบัญชี",
			"idId": "Buka",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantCloseTenantName",
			"classify": "Text",
			"zhCn": "租户名称",
			"zhTw": "",
			"enUs": "Tenant Name:",
			"thTh": "ชื่อผู้เช่า",
			"idId": "Nama Penyewa:",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantClosePrompt",
			"classify": "Text",
			"zhCn": "确定销户该租户吗?",
			"zhTw": "",
			"enUs": "Are you sure you want to close this tenant?",
			"thTh": "คุณแน่ใจหรือไม่ว่าจะยกเลิกบัญชีผู้เช่ารายนี้",
			"idId": "Apakah Anda yakin ingin menutup tenant ini?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantOpenPrompt",
			"classify": "Text",
			"zhCn": "确定开户该租户吗？",
			"zhTw": "",
			"enUs": "Are you sure you want to open this tenant?",
			"thTh": "ยืนยันว่าต้องการเปิดบัญชีให้กับผู้เช่ารายนี้หรือไม่",
			"idId": "Apakah Anda yakin ingin membuka tenant ini?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantOpenPrompt2",
			"classify": "Text",
			"zhCn": "未开户的租户需要先关联设备才能进行开户操作",
			"zhTw": "",
			"enUs": "Not opened tenant must be associated with devices before open can proceed.",
			"thTh": "ผู้เช่าที่ยังไม่ได้เปิดบัญชีจะต้องเชื่อมโยงอุปกรณ์ก่อนเปิดบัญชีได้",
			"idId": "Tenant yang belum dibuka harus dihubungkan dengan perangkat terlebih dahulu sebelum proses pembukaan dapat dilanjutkan.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantBatchClose",
			"classify": "Text",
			"zhCn": "批量销户",
			"zhTw": "",
			"enUs": "Batch Close",
			"thTh": "ยกเลิกบัญชีหลายรายการ",
			"idId": "Tutup Secara Berkelompok",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantBatchOpen",
			"classify": "Button",
			"zhCn": "批量开户",
			"zhTw": "",
			"enUs": "Batch Open",
			"thTh": "เปิดบัญชีหลายรายการ",
			"idId": "Buka Secara Berkelompok",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantBatchClosePrompt",
			"classify": "Text",
			"zhCn": "确定销户这${number.select}个租户吗？",
			"zhTw": "",
			"enUs": "Are you sure you want to close these ${number.select} tenants?",
			"thTh": "คุณแน่ใจหรือไม่ว่าจะยกเลิกบัญชีผู้เช่า ${number.select} รายนี้",
			"idId": "Apakah Anda yakin ingin menutup ${number.select} penyewa ini?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantBatchOpenPrompt",
			"classify": "Text",
			"zhCn": "确定开户这${number.select}个租户吗？",
			"zhTw": "",
			"enUs": "Are you sure you want to open these ${number.select} tenants?",
			"thTh": "คุณแน่ใจหรือไม่ว่าต้องการเปิดบัญชีให้ผู้เช่า ${number.select} รายนี้?",
			"idId": "Apakah Anda yakin ingin membuka ${number.select} tenant ini?",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantBatchClosePrompt2",
			"classify": "Text",
			"zhCn": "部分已选择的租户不支持“销户&quot;操作。只有处于“开户&quot;状态的租户才能被关闭",
			"zhTw": "",
			"enUs": "Some selected tenants do not support the 'Close' operation. Only tenants in the 'opened' status can be closed.",
			"thTh": "ผู้เช่าที่เลือกบางรายไม่รองรับการ\"ยกเลิกบัญชี\" สามารถยกเลิกได้เฉพาะผู้เช่าที่อยู่ในสถานะ \"เปิดบัญชีแล้ว\" เท่านั้น",
			"idId": "Beberapa Tenant yang dipilih tidak mendukung operasi 'Penutupan Akun'. Hanya Tenant dengan status 'Open' yang dapat ditutup.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistro",
			"classify": "Text",
			"zhCn": "变更记录",
			"zhTw": "",
			"enUs": "Histrorical Record",
			"thTh": "ประวัติการเปลี่ยนแปลง",
			"idId": "Riwayat Aktivitas",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroTime",
			"classify": "Text",
			"zhCn": "操作时间",
			"zhTw": "",
			"enUs": "Action Time",
			"thTh": "เวลาดำเนินการ",
			"idId": "Waktu Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroBy",
			"classify": "Text",
			"zhCn": "操作人",
			"zhTw": "",
			"enUs": "Modified By",
			"thTh": "ผู้ดำเนินการ",
			"idId": "Diubah oleh",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroType",
			"classify": "Text",
			"zhCn": "操作类型",
			"zhTw": "",
			"enUs": "Action Type",
			"thTh": "ประเภทการดำเนินการ",
			"idId": "Jenis Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroCreate",
			"classify": "Text",
			"zhCn": "创建租户",
			"zhTw": "",
			"enUs": "Create Tenant",
			"thTh": "สร้างผู้เช่า",
			"idId": "Buat Tenant",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroOpen",
			"classify": "Text",
			"zhCn": "进行开户",
			"zhTw": "",
			"enUs": "Open",
			"thTh": "เปิดบัญชี",
			"idId": "Buka",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroAsso",
			"classify": "Text",
			"zhCn": "关联设备",
			"zhTw": "",
			"enUs": "Associate Device",
			"thTh": "เชื่อมโยงอุปกรณ์",
			"idId": "Menghubungkan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroUnasso",
			"classify": "Text",
			"zhCn": "取消关联设备",
			"zhTw": "",
			"enUs": "Disassociate Device",
			"thTh": "ยกเลิกเชื่อมโยงอุปกรณ์",
			"idId": "Lepaskan Hubungan Perangkat",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroModifyOrganization",
			"classify": "Text",
			"zhCn": "修改授权组织",
			"zhTw": "",
			"enUs": "Modify the Authorized Organization",
			"thTh": "แก้ไของค์กรที่ได้รับอนุญาต",
			"idId": "Mengubah Organisasi yang Berwenang",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroModifyRate",
			"classify": "Text",
			"zhCn": "修改费率方案",
			"zhTw": "",
			"enUs": "Modify the Rate Plan",
			"thTh": "แก้ไขการคิดอัตราราคา",
			"idId": "Ubah Rencana Tarif",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroClose",
			"classify": "Text",
			"zhCn": "进行销户",
			"zhTw": "",
			"enUs": "Close",
			"thTh": "ยกเลิกบัญชี",
			"idId": "Tutup",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingHistroContent",
			"classify": "Text",
			"zhCn": "操作内容",
			"zhTw": "",
			"enUs": "Action Content",
			"thTh": "เนื้อหาการดำเนินการ",
			"idId": "Konten Tindakan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingDashTotalEnergy",
			"classify": "Text",
			"zhCn": "${Date} 总电量",
			"zhTw": "",
			"enUs": "${Date} Total Energy",
			"thTh": "ปริมาณการใช้ไฟฟ้าทั้งหมด ${Date} ",
			"idId": "${Date} Total Energi",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingDashTotalElecCost",
			"classify": "Text",
			"zhCn": "${Date} 总电费",
			"zhTw": "",
			"enUs": "${Date} Total Elec.cost ",
			"thTh": "ค่าไฟฟ้าทั้งหมด ${Date} ",
			"idId": "${Date} Total Biaya Listrik ",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingDashBilingTrend",
			"classify": "Text",
			"zhCn": "电费趋势",
			"zhTw": "",
			"enUs": "Billing Trend",
			"thTh": "แนวโน้มค่าไฟฟ้า",
			"idId": "Tren Penagihan",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingDashUnit",
			"classify": "Text",
			"zhCn": "单位：",
			"zhTw": "",
			"enUs": "Unit:",
			"thTh": "หน่วย:",
			"idId": "Satuan:",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingDashEnergy",
			"classify": "Text",
			"zhCn": "电量 (kWh)",
			"zhTw": "",
			"enUs": "Energy(kWh)",
			"thTh": "ไฟฟ้า (kWh)",
			"idId": "Energi(kWh)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingDashElecCost",
			"classify": "Text",
			"zhCn": "电费 (${USD})",
			"zhTw": "",
			"enUs": "Elec.cost(${USD})",
			"thTh": "ค่าไฟฟ้า (${USD})",
			"idId": "Biaya Listrik(${USD})",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "billingTenantDetail",
			"classify": "Text",
			"zhCn": "租户详情",
			"zhTw": "",
			"enUs": "Tenant Detail",
			"thTh": "รายละเอียดผู้เช่า ",
			"idId": "Detail Tenant",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "deviceIdLengthLimit50",
			"classify": "tips",
			"zhCn": "设备ID长度不能超过50个字符",
			"zhTw": "設備ID長度不能超過50個字符",
			"enUs": "Device ID cannot be longer than 50 characters",
			"thTh": "ความยาวของอุปกรณ์ ID ต้องไม่เกิน50ตัวอักษร",
			"idId": "Perangkat ID panjang tidak dapat melebihi 50 karakter",
			"esMx": "La longitud del ID del dispositivo no puede exceder los 50 caracteres",
			"viVi": "Độ dài ID thiết bị không được vượt quá 20 ký tự",
			"ptPt": "O comprimento do ID do dispositivo não pode exceder 20 caracteres"
		},
		{
			"textKey": "maxLength7Digits",
			"classify": "tips",
			"zhCn": "请填写7位以内数字字符",
			"zhTw": "請填寫7位以內數字字符",
			"enUs": "Please fill in 7 digits or less",
			"thTh": "กรุณากรอกตัวเลขภายใน7หลัก",
			"idId": "Silakan isi karakter angka dalam 7 digit",
			"esMx": "Complete los caracteres numéricos de 7 dígitos",
			"viVi": "Vui lòng điền các ký tự số trong vòng 7 chữ số",
			"ptPt": "Por favor, preencha os caracteres numéricos dentro de 7 dígitos"
		},
		{
			"textKey": "assetsIdLengthLimit1To50",
			"classify": "tips",
			"zhCn": "1~50个字符",
			"zhTw": "1~ 50個字符",
			"enUs": "1~50 characters",
			"thTh": "1 ~ 50ตัวอักษร",
			"idId": "1 ~ 50 karakter",
			"esMx": "1 ~ 50 caracteres",
			"viVi": "8 ~ 50 ký tự",
			"ptPt": "8 ~ 50 caracteres"
		},
		{
			"textKey": "cnName",
			"classify": "Title",
			"zhCn": "中文名称",
			"zhTw": "中文名稱",
			"enUs": "Chinese name",
			"thTh": "ชื่อภาษาจีน",
			"idId": "Nama Cina",
			"esMx": "Nombre chino",
			"viVi": "Tên tiếng Trung",
			"ptPt": "Nome chinês"
		},
		{
			"textKey": "currentLanguageName",
			"classify": "Title",
			"zhCn": "当前语言名称",
			"zhTw": "當前語言名稱",
			"enUs": "Current Language Name",
			"thTh": "ชื่อภาษาปัจจุบัน",
			"idId": "Nama bahasa saat ini",
			"esMx": "Nombre del idioma actual",
			"viVi": "Tên ngôn ngữ hiện tại",
			"ptPt": "Nome do idioma atual"
		},
		{
			"textKey": "areaCode",
			"classify": "Title",
			"zhCn": "区号",
			"zhTw": "區號",
			"enUs": "Area Code",
			"thTh": "รหัสพื้นที่",
			"idId": "Kode Area",
			"esMx": "Código de área",
			"viVi": "Mã vùng",
			"ptPt": "Código de área"
		},
		{
			"textKey": "billingTenantBatchOpenPrompt2",
			"classify": "Text",
			"zhCn": "部分已选择的租户不支持“开户&quot;操作。只有处于“未开户&quot;状态的且已关联了设备的租户才能进行开户操作",
			"zhTw": "",
			"enUs": "Some of the selected tenants do not support the \"Open\" operation. Only tenants in the \"Not opened\" status and associated with devices are eligible for account opening.",
			"thTh": "ผู้เช่าบางรายที่เลือกไม่รองรับการดำเนินการ \"เปิดบัญชี\" มีเพียงผู้เช่าที่อยู่ในสถานะ \"ยังไม่เปิดบัญชี\" และมีอุปกรณ์ที่เชื่อมโยงแล้วเท่านั้นที่สามารถดำเนินการเปิดบัญชีได้",
			"idId": "Beberapa tenant yang dipilih tidak mendukung operasi 'Buka'. Hanya tenant dengan status 'Belum dibuka' dan yang telah dihubungkan dengan perangkat yang memenuhi syarat untuk pembukaan akun.",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "pvsttdbRtgenpower",
			"classify": "label",
			"zhCn": "实时发电功率（kW）",
			"zhTw": "",
			"enUs": "Real-time Generational Power (kW)",
			"thTh": "กำลังการผลิตไฟฟ้าเรียลไทม์ (kW)",
			"idId": "Daya Generasi Waktu Nyata (kW)",
			"esMx": "",
			"viVi": "",
			"ptPt": ""
		},
		{
			"textKey": "basictxSun",
			"classify": "label",
			"zhCn": "周日",
			"zhTw": "周日",
			"enUs": "Sunday",
			"thTh": "อา",
			"idId": "Minggu",
			"esMx": "Domingo",
			"viVi": "Chủ nhật",
			"ptPt": "Domingo"
		},
		{
			"textKey": "basictxThu",
			"classify": "label",
			"zhCn": "周四",
			"zhTw": "周四",
			"enUs": "Thursday",
			"thTh": "วันพฤหัสบดี",
			"idId": "Kamis",
			"esMx": "Jueves",
			"viVi": "Thứ năm",
			"ptPt": "Quinta-feira"
		}
	],
	"msg": "操作成功"
}